window.theme = window.theme || {};
window.slate = window.slate || {};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

(function($){
  var $ = jQuery = $;

  if (!window?.scCustom) window.scCustom = {};
  window.scCustom.debounceDelay = 250;

  var B2G1_CODE = 'Z5SK400SNC19';
  var buyMore = window.athBuyMore;

  // Manual vs Automatic coupon state tracking
  window.couponState = {
    isManual: false,              // Was the current coupon manually applied by customer?
    pendingManualCode: null,      // Code from URL param waiting to be applied
    currentCode: null,            // Currently applied coupon code
    systemIsApplying: false,      // Flag: is our system currently applying a coupon?
    systemIsRemoving: false,      // Flag: is our system currently removing a coupon (as part of switching)?
    showSuggestion: false,        // Flag: show BUYMORE suggestion after manual coupon removal?
    suggestionData: null,         // Data for BUYMORE suggestion {coupon, percent}
    manualOverride: false,        // Flag: customer manually removed a coupon (don't auto-apply until cart changes)
    cartOperationInProgress: false, // Flag: cart operation (add/remove/qty change) is in progress
    cartOperationTimeoutId: null, // Timeout ID for clearing cartOperationInProgress (for cleanup)
    b2g1Selected: false,          // Retain the chosen offer until the customer removes it
    b2g1Applying: false,
    b2g1Removing: false,
    b2g1ExplicitlyRemoved: false,
    b2g1SelectionRevision: 0,
    b2g1Error: false,
    b2g1LastAttempt: null
  };

  try {
    var storedB2G1Selection = sessionStorage.getItem('athB2G1Selected');
    window.couponState.b2g1Selected = storedB2G1Selection === 'true';
    window.couponState.b2g1ExplicitlyRemoved = storedB2G1Selection === 'false';
  } catch (e) {
    // The in-memory safeguard still works when browser storage is unavailable.
  }

  // Restore manualOverride state from sessionStorage (persists across page navigation)
  try {
    var storedOverride = sessionStorage.getItem('couponManualOverride');
    console.log('[Manual Override] Page load - checking sessionStorage:', storedOverride);

    if (storedOverride === 'true') {
      window.couponState.manualOverride = true;
      console.log('[Manual Override] ✓ Restored from sessionStorage - manualOverride=true');

      // Also restore suggestion data if available
      var storedSuggestion = sessionStorage.getItem('couponSuggestionData');
      console.log('[Manual Override] Checking stored suggestion:', storedSuggestion);

      if (storedSuggestion) {
        var suggestionData = JSON.parse(storedSuggestion);
        window.couponState.showSuggestion = true;
        window.couponState.suggestionData = suggestionData;
        console.log('[Manual Override] ✓ Restored suggestion - will show:', suggestionData);
      }
    } else {
      console.log('[Manual Override] No stored override found, starting fresh');
    }
  } catch (e) {
    console.log('[Manual Override] Error restoring state:', e);
  }

$(document).ready(function() {

  // Check for open-cart query parameter (redirect from /cart page)
  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('open-cart') === 'true') {
    // Clean the URL (remove query param) without adding to browser history
    window.history.replaceState({}, document.title, window.location.pathname);

    // Small delay to ensure cart drawer is initialized, then open it
    setTimeout(function() {
      var $cartTrigger = $('.js-drawer-open-cart').first();
      if ($cartTrigger.length) {
        $cartTrigger.click();
        console.log('[Cart Redirect] Opened cart drawer from /cart redirect');
      }
    }, 150);
  }

  // COLLECTION PRELOAD IMAGES
  if (window.location.pathname.includes('/collections/')) {
    // Preload the original image (same URL the theme uses on page load)
    if ('requestIdleCallback' in window) {
      requestIdleCallback(preloadOriginal);
    } else {
      window.addEventListener('load', () => setTimeout(preloadOriginal, 1500));
    }

    function preloadOriginal() {
      $('.collection-grid-product__options select option').each(function () {
        var url = $(this).data('image');
        if (url && !url.includes('no-image')) {
          new Image().src = url;   // ← exact same URL the theme uses
        }
      });
    }

    // Variant change – use the exact same original URL (already cached)
    $(document).off('change.variantOriginal');
    $(document).on('change.variantOriginal', '.collection-grid-product__options select', function () {
      var url = $(this).find('option:selected').data('image');
      if (!url || url.includes('no-image')) return;

      $(this)
        .closest('.grid-product')
        .find('.grid__image-ratio')
        .first()
        .css('background-image', 'url("' + url + '")');
    });
  }
  
    if (window.location.pathname === '/pages/landing-page') {
        $('.more-info').click(function() {
            $(this).siblings('.lp-modal').css('display', 'flex').fadeIn(200);
        });
        $('.lp-close-modal').click(function() {
            $(this).closest('.lp-modal').fadeOut(200);
        });
        $(document).on('click', '.lp-modal', function(event) {
            if ($(event.target).hasClass('lp-modal')) {
                $(this).fadeOut(200);
            }
        });
        $('.lp-modal-content').click(function(event) {
            event.stopPropagation();
        });
        $(document).on('keydown', function(event) {
            if (event.key === 'Escape') {
                $('.lp-modal:visible').fadeOut(200);
            }
        });
        // Removed hover functionality for landing-page-img-wrap
        function calculateTotalPrice() {
            const items = $('.landing-page-selection[data-variant-id!=""]');
            let prices = [];
            items.each(function() {
                const variantId = $(this).data('variant-id');
                const priceCents = parseInt($(this).data('price')) || 0;
                prices.push(priceCents);
            });
            const fullTotalCents = prices.reduce((sum, price) => sum + price, 0);
            const fullTotalDollars = (fullTotalCents / 100).toFixed(2);
            prices.sort((a, b) => b - a);
            const chargedPrices = prices.slice(0, 2);
            const discountedTotalCents = chargedPrices.reduce((sum, price) => sum + price, 0);
            const discountedTotalDollars = (discountedTotalCents / 100).toFixed(2);
            if (items.length === 3) {
                $('.full-price').text(`$${fullTotalDollars}`).show();
                $('.discounted-price').text(`$${discountedTotalDollars}`).show();
                const savingsDollars = ((fullTotalCents - discountedTotalCents) / 100).toFixed(2);
                $('.savings-badge').text(`SAVED $${savingsDollars}`).show();
                $('.landing-page-atc')
                    .prop('disabled', false)
                    .css('background-color', '#e12727')
                    .text('ADD TO CART');
                // Scroll to form with sticky header offset
                const $landingPageForm = $('.landing-page-form');
                if ($landingPageForm.length) {
                    const elementTop = $landingPageForm.offset().top;
                    const stickyHeaderHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-height')) || 0;
                    const $header = $('.site-header, .header, #shopify-section-header');
                    const headerHeight = $header.length ? $header.outerHeight() : 0;
                    const offset = Math.max(stickyHeaderHeight, headerHeight) + 200;
                    $('html, body').animate({
                        scrollTop: elementTop - offset
                    }, 500, 'swing');
                }
            } else {
                $('.full-price').hide();
                $('.discounted-price').text(`$${discountedTotalDollars}`).show();
                $('.savings-badge').hide();
                $('.landing-page-atc')
                    .prop('disabled', true)
                    .css('background-color', '')
                    .text('PICK YOUR FLAVORS');
            }
        }
        function updateLpProgress() {
            const count = $('.lp-selection[data-variant-id!=""]').length;
            $('.lp-progress-step').removeClass('active completed');
            $('.lp-progress-step').each(function() {
                const step = parseInt($(this).data('step'));
                // Keep step 3 active (not completed) when all 3 bags are selected
                if (count === 3 && step === 3) {
                    $(this).addClass('active');
                } else if (step < count + 1) {
                    $(this).addClass('completed');
                } else if (step === count + 1) {
                    $(this).addClass('active');
                }
            });
        }

        function addVariantToSelection(button) {
            const variantId = button.data('variant-id');
            const imgSrc = button.closest('.landing-page-product').find('.selection-img').attr('src');
            const variantTitle = button.siblings('.landing-page-product-title').find('.lp-meta-title').text().trim();
            const priceCents = parseInt(button.data('variant-price')) || 0;
            let availableSelection = $('#selection-one').filter(function() {
                return $(this).data('variant-id') === '';
            }).first();
            if (!availableSelection.length) {
                availableSelection = $('#selection-two').filter(function() {
                    return $(this).data('variant-id') === '';
                }).first();
            }
            if (!availableSelection.length) {
                availableSelection = $('#selection-three').filter(function() {
                    return $(this).data('variant-id') === '';
                }).first();
            }
            if (!availableSelection.length) {
                return;
            }
            availableSelection.data('variant-id', variantId);
            availableSelection.attr('data-variant-id', variantId);
            availableSelection.data('price', priceCents);
            availableSelection.attr('data-price', priceCents);

            let selectionImgWrap = availableSelection.find('.landing-page-selection-img-wrap');
            if (!selectionImgWrap.length) {
                selectionImgWrap = $('<div>').addClass('landing-page-selection-img-wrap');
                availableSelection.prepend(selectionImgWrap);
            }
            selectionImgWrap.empty();

            let closeButton = $('<div>').addClass('landing-page-selection-close').text('X');

            if (imgSrc) {
                const imgContainer = $('<div>').addClass('lp-img-container');
                const imgElement = $('<img>')
                    .attr('src', imgSrc)
                    .addClass('landing-page-selection-img-preview');
                imgContainer.append(imgElement);
                imgContainer.append(closeButton);
                selectionImgWrap.append(imgContainer);
            } else {
                selectionImgWrap.append(closeButton);
            }

            // Update title in sibling element
            availableSelection.closest('.lp-selection-item').find('.lp-selection-title').text(variantTitle);

            closeButton.show();
            const totalItems = $('.landing-page-selection[data-variant-id!=""]').length;
            if (totalItems === 3) {
                let freeBadge = $('#selection-three .free-product-tag');
                if (!freeBadge.length) {
                    freeBadge = $('<div>').addClass('free-product-tag').text('FREE');
                    $('#selection-three').append(freeBadge);
                }
                freeBadge.show();
            }
            updateQuantitySelector(button, variantId);
            ensureOrder();
            calculateTotalPrice();
            updateAllQuantitySelectors();
            updateLpProgress();
        }
        $('.landing-page-variant-add').on('click', function() {
            addVariantToSelection($(this));
        });
        // Initialize progress on page load
        updateLpProgress();
        $('.landing-page-atc').on('click', function() {
            if ($(this).prop('disabled')) return;
            const $button = $(this);
            const previouslySelectedB2G1 = isB2G1Protected();
            setB2G1Selection(true);
            window.couponState.b2g1Applying = true;
            window.couponState.systemIsApplying = true;
            $button.addClass('btn--loading').prop('disabled', true);
            const items = $('.landing-page-selection[data-variant-id!=""]').map(function() {
                return {
                    id: $(this).data('variant-id'),
                    quantity: 1
                };
            }).get();
            $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                dataType: 'json',
                data: {
                    items: items
                },
                success: function(response) {
                    function clearForm() {
                        $('.landing-page-selection').each(function() {
                            const $sel = $(this);
                            $sel.data('variant-id', '');
                            $sel.attr('data-variant-id', '');
                            $sel.data('price', '');
                            $sel.attr('data-price', '');
                            $sel.find('.landing-page-selection-img-wrap').empty();
                            $sel.find('.landing-page-selection-close').hide();
                            $sel.find('.free-product-tag').hide();
                            // Clear the sibling title
                            $sel.closest('.lp-selection-item').find('.lp-selection-title').text('');
                        });
                        $('.landing-page-quantity-selector').each(function() {
                            const $selector = $(this);
                            $selector.off('click');
                            $selector.empty()
                                     .removeClass('landing-page-quantity-selector')
                                     .addClass('landing-page-variant-add')
                                     .text('Add');
                            $selector.on('click', function() {
                                addVariantToSelection($(this));
                            });
                        });
                        calculateTotalPrice();
                    }
                    // The items are already in the cart; a discount failure must not add them twice.
                    clearForm();
                    applyB2G1Promotion().then(function() {
                        $('body').trigger('added.ajaxProduct');
                    }).catch(function(error) {
                        $('body').trigger('added.ajaxProduct');
                        alert('Your items were added, but the free-item offer could not be applied. Please try again in the cart.');
                    }).finally(function() {
                        $button.removeClass('btn--loading');
                    });
                },
                error: function(xhr, status, error) {
                    window.couponState.b2g1Applying = false;
                    window.couponState.systemIsApplying = false;
                    setB2G1Selection(previouslySelectedB2G1);
                    $button.removeClass('btn--loading').prop('disabled', false);
                    alert('There was an error adding items to your cart. Please try again.');
                }
            });
        });
        function updateQuantitySelector(addButton, variantId, totalItems = null) {
            const quantity = $('.landing-page-selection').filter(function() {
                return $(this).data('variant-id') === variantId;
            }).length;
            const formTotal = totalItems !== null ? totalItems : $('.landing-page-selection[data-variant-id!=""]').length;
            addButton.off('click');
            addButton.empty().removeClass('landing-page-variant-add').addClass('landing-page-quantity-selector');
            addButton.html(`
                <button class="landing-page-quantity-minus">-</button>
                <span class="landing-page-quantity-value">${quantity}</span>
                <button class="landing-page-quantity-plus">+</button>
            `);
            addButton.find('.landing-page-quantity-plus').on('click', function(e) {
                e.stopPropagation();
                handleQuantityChange(addButton, variantId, 'increase');
            });
            addButton.find('.landing-page-quantity-minus').on('click', function(e) {
                e.stopPropagation();
                handleQuantityChange(addButton, variantId, 'decrease');
            });
            if (formTotal >= 3) {
                addButton.find('.landing-page-quantity-plus').prop('disabled', true).css('opacity', '0.5');
            } else {
                addButton.find('.landing-page-quantity-plus').prop('disabled', false).css('opacity', '1');
            }
            if (quantity === 0) {
                addButton.find('.landing-page-quantity-minus').prop('disabled', true).css('opacity', '0.5');
            } else {
                addButton.find('.landing-page-quantity-minus').prop('disabled', false).css('opacity', '1');
            }
        }
        function updateAllQuantitySelectors() {
            const totalItems = $('.landing-page-selection[data-variant-id!=""]').length;
            $('.landing-page-quantity-selector').each(function() {
                const $selector = $(this);
                const variantId = $selector.data('variant-id');
                if (variantId) {
                    updateQuantitySelector($selector, variantId, totalItems);
                }
            });
        }
        function handleQuantityChange(selector, variantId, action) {
            const currentQuantity = $('.landing-page-selection').filter(function() {
                return $(this).data('variant-id') === variantId;
            }).length;
            if (action === 'increase' && currentQuantity < 3) {
                addVariantToSelection(selector);
            } else if (action === 'decrease' && currentQuantity > 0) {
                let lastSelection = $('#selection-three').filter(function() {
                    return $(this).data('variant-id') === variantId;
                }).first();
                if (!lastSelection.length) {
                    lastSelection = $('#selection-two').filter(function() {
                        return $(this).data('variant-id') === variantId;
                    }).first();
                }
                if (!lastSelection.length) {
                    lastSelection = $('#selection-one').filter(function() {
                        return $(this).data('variant-id') === variantId;
                    }).first();
                }
                if (lastSelection.length) {
                    lastSelection.data('variant-id', '');
                    lastSelection.attr('data-variant-id', '');
                    lastSelection.find('.landing-page-selection-img-wrap').empty();
                    lastSelection.find('.landing-page-selection-close').hide();
                    // Clear the sibling title
                    lastSelection.closest('.lp-selection-item').find('.lp-selection-title').text('');
                    if ($('.landing-page-selection[data-variant-id!=""]').length < 3) {
                        $('#selection-three .free-product-tag').hide();
                    }
                }
                ensureOrder();
                calculateTotalPrice();
                updateAllQuantitySelectors();
                updateLpProgress();
                const newQuantity = $('.landing-page-selection').filter(function() {
                    return $(this).data('variant-id') === variantId;
                }).length;
                const $quantitySelector = $(selector);
                if ($quantitySelector.length) {
                    $quantitySelector.find('.landing-page-quantity-value').text(newQuantity);
                    if (newQuantity === 0) {
                        $quantitySelector.empty().removeClass('landing-page-quantity-selector').addClass('landing-page-variant-add');
                        $quantitySelector.text('Add');
                        $quantitySelector.off('click');
                        $quantitySelector.on('click', function() {
                            addVariantToSelection($(this));
                        });
                    }
                }
            }
        }
        $('.landing-page-selection').on('click', function(e) {
            if ($(e.target).hasClass('landing-page-selection-close')) return;
            if ($(this).data('variant-id') !== '') {
                const variantId = $(this).data('variant-id');
                $(this).data('variant-id', '');
                $(this).attr('data-variant-id', '');
                $(this).find('.landing-page-selection-img-wrap').empty();
                $(this).find('.landing-page-selection-close').hide();
                // Clear the sibling title
                $(this).closest('.lp-selection-item').find('.lp-selection-title').text('');
                const selector = $('.landing-page-quantity-selector').filter(function() {
                    return $(this).closest('.landing-page-product').find('.landing-page-variant-add').data('variant-id') === variantId ||
                           $(this).data('variant-id') === variantId;
                });
                if (selector.length) {
                    // Check if this was the last item of this variant
                    const remainingQuantity = $('.landing-page-selection').filter(function() {
                        return $(this).data('variant-id') === variantId;
                    }).length;
                    if (remainingQuantity === 0) {
                        // Reset to Add button if no more items of this variant
                        selector.empty().removeClass('landing-page-quantity-selector').addClass('landing-page-variant-add');
                        selector.text('Add');
                        selector.off('click');
                        selector.on('click', function() {
                            addVariantToSelection($(this));
                        });
                    } else {
                        updateQuantitySelector(selector, variantId);
                    }
                }
                if ($('.landing-page-selection[data-variant-id!=""]').length < 3) {
                    $('#selection-three .free-product-tag').hide();
                }
                ensureOrder();
                calculateTotalPrice();
                updateAllQuantitySelectors();
                updateLpProgress();
            } else {
                // Scroll to .landing-page-products to ensure it's within viewport when selection is empty
                const $landingPageProducts = $('.landing-page-products');
                if ($landingPageProducts.length) {
                    const elementTop = $landingPageProducts.offset().top;
                    const stickyHeaderHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-height')) || 0;
                    const $header = $('.site-header, .header, #shopify-section-header');
                    const headerHeight = $header.length ? $header.outerHeight() : 0;
                    const offset = Math.max(stickyHeaderHeight, headerHeight) + 20;

                    $('html, body').animate({
                        scrollTop: elementTop - offset
                    }, 800, 'swing');
                }
            }
        });
        $(document).on('click', '.landing-page-selection-close', function(e) {
            e.stopPropagation();
            const $selection = $(this).closest('.landing-page-selection');
            if ($selection.data('variant-id') !== '') {
                const variantId = $selection.data('variant-id');
                $selection.data('variant-id', '');
                $selection.attr('data-variant-id', '');
                $selection.find('.landing-page-selection-img-wrap').empty();
                $selection.find('.landing-page-selection-close').hide();
                // Clear the sibling title
                $selection.closest('.lp-selection-item').find('.lp-selection-title').text('');
                const $quantitySelector = $('.landing-page-quantity-selector').filter(function() {
                    return $(this).closest('.landing-page-product').find('.landing-page-variant-add').data('variant-id') === variantId ||
                           $(this).data('variant-id') === variantId;
                });
                if ($quantitySelector.length) {
                    const newQuantity = $('.landing-page-selection').filter(function() {
                        return $(this).data('variant-id') === variantId;
                    }).length;
                    if (newQuantity === 0) {
                        $quantitySelector.empty().removeClass('landing-page-quantity-selector').addClass('landing-page-variant-add');
                        $quantitySelector.text('Add');
                        $quantitySelector.off('click');
                        $quantitySelector.on('click', function() {
                            addVariantToSelection($(this));
                        });
                    } else {
                        updateQuantitySelector($quantitySelector, variantId);
                    }
                }
                if ($('.landing-page-selection[data-variant-id!=""]').length < 3) {
                    $('#selection-three .free-product-tag').hide();
                }
                ensureOrder();
                calculateTotalPrice();
                updateAllQuantitySelectors();
                updateLpProgress();
            }
        });
        function ensureOrder() {
            const orderedIds = ['selection-one', 'selection-two', 'selection-three'];
            const $selections = $('.landing-page-selection').not('.tiered-selection');
            const filledSelections = $selections.filter(function() {
                return $(this).data('variant-id') !== '';
            }).map(function() {
                return {
                    variantId: $(this).data('variant-id'),
                    imageHtml: $(this).find('.landing-page-selection-img-wrap').html(),
                    title: $(this).closest('.lp-selection-item').find('.lp-selection-title').text() || '',
                    price: parseInt($(this).data('price')) || 0
                };
            }).get();
            $selections.each(function(index) {
                const $sel = $(this);
                const intendedId = orderedIds[index];
                if ($sel.attr('id') !== intendedId) {
                    $sel.attr('id', intendedId);
                }
                if (index < filledSelections.length) {
                    const filled = filledSelections[index];
                    $sel.data('variant-id', filled.variantId);
                    $sel.attr('data-variant-id', filled.variantId);
                    $sel.data('price', filled.price);
                    $sel.attr('data-price', filled.price);
                    $sel.find('.landing-page-selection-img-wrap').html(filled.imageHtml);
                    $sel.closest('.lp-selection-item').find('.lp-selection-title').text(filled.title);
                    $sel.find('.landing-page-selection-close').show();
                    if (index === 2 && filledSelections.length === 3) {
                        let freeBadge = $sel.find('.free-product-tag');
                        if (!freeBadge.length) {
                            freeBadge = $('<div>').addClass('free-product-tag').text('FREE');
                            $sel.append(freeBadge);
                        }
                        freeBadge.show();
                    }
                } else {
                    $sel.data('variant-id', '');
                    $sel.attr('data-variant-id', '');
                    $sel.data('price', '');
                    $sel.attr('data-price', '');
                    $sel.find('.landing-page-selection-img-wrap').empty();
                    $sel.find('.landing-page-selection-close').hide();
                    $sel.find('.free-product-tag').hide();
                    // Clear the sibling title
                    $sel.closest('.lp-selection-item').find('.lp-selection-title').text('');
                }
            });
        }
        calculateTotalPrice();
    }

    // DiscountHero's promise settles before its monitoring guards clear.
    // Reconcile campaign/bundle changes only once both boundaries are idle.
    function waitForBuyMoreIdle() {
        return buyMoreOperationPromise.then(function() {
            if (isProcessingBuyMore || window.couponState.systemIsApplying || window.couponState.systemIsRemoving) {
                return new Promise(function(resolve) { setTimeout(resolve, 100); }).then(waitForBuyMoreIdle);
            }
        });
    }

    // The cart may already contain other one-time items when a bundle is added.
    function applyTieredBundleDiscount() {
        return waitForBuyMoreIdle().then(function() {
            theme.cart.invalidateCache();
            return theme.cart.getCart();
        }).then(function(cart) {
            if (isB2G1Protected(cart)) return;
            window.couponState.isManual = false;
            window.couponState.manualOverride = false;
            window.couponState.showSuggestion = false;
            window.couponState.suggestionData = null;
            try {
                sessionStorage.removeItem('couponManualOverride');
                sessionStorage.removeItem('couponSuggestionData');
            } catch (e) { /* The in-memory state still works without storage. */ }
            // Bundle selection explicitly replaces the previous coupon, as before.
            currentBuyMoreCoupon = getStoredDiscountCode() || currentBuyMoreCoupon;
            applyBuyMoreCoupon(countOneTimeItems(cart).count);
            return buyMoreOperationPromise;
        });
    }

    // Tiered Landing Page - Buy More & Save
    if ($('.tiered-landing-page').length > 0) {
        const TIERED_SELECTION_IDS = ['tiered-selection-one', 'tiered-selection-two', 'tiered-selection-three', 'tiered-selection-four', 'tiered-selection-five'];
        const TIERED_SELECTION_LABELS = ['+', '+', '+', '+', '+'];
        document.addEventListener('ath:buy-more-change', tieredCalculateTotalPrice);
        const tieredFlavorPickerMedia = window.matchMedia('(max-width: 767px)');
        tieredFlavorPickerMedia.addEventListener('change', tieredCalculateTotalPrice);

        $('.more-info').click(function() {
            $(this).siblings('.lp-modal').css('display', 'flex').fadeIn(200);
        });
        $('.lp-close-modal').click(function() {
            $(this).closest('.lp-modal').fadeOut(200);
        });
        $(document).on('click', '.lp-modal', function(event) {
            if ($(event.target).hasClass('lp-modal')) {
                $(this).fadeOut(200);
            }
        });
        $('.lp-modal-content').click(function(event) {
            event.stopPropagation();
        });
        $(document).on('keydown', function(event) {
            if (event.key === 'Escape') {
                $('.lp-modal:visible').fadeOut(200);
            }
        });

        function tieredCalculateTotalPrice() {
            const items = $('.tiered-selection[data-variant-id!=""]');
            const itemCount = items.length;
            let totalCents = 0;

            items.each(function() {
                const priceCents = parseInt($(this).data('price')) || 0;
                totalCents += priceCents;
            });

            const discountRate = buyMore.percent(itemCount) / 100;
            const discountedTotalCents = buyMore.total(totalCents, itemCount);
            const fullTotalDollars = (totalCents / 100).toFixed(2);
            const discountedTotalDollars = (discountedTotalCents / 100).toFixed(2);

            // Update discount tier highlights
            $('.discount-tier').removeClass('active');
            if (itemCount >= 1) { // highlight from 1 bag (the 30 PACK tier) upward
                $(`.discount-tier[data-tier="${itemCount}"]`).addClass('active');
            }

            if (itemCount >= 1) {
                if (discountRate > 0) {
                    $('.full-price').text(`$${fullTotalDollars}`).show();
                    $('.discounted-price').text(`$${discountedTotalDollars}`).show();
                    const savingsDollars = ((totalCents - discountedTotalCents) / 100).toFixed(2);
                    $('.savings-badge').text(`SAVED $${savingsDollars}`).show();
                } else {
                    $('.full-price').hide();
                    $('.discounted-price').text(`$${fullTotalDollars}`).show();
                    $('.savings-badge').hide();
                }
                $('.tiered-atc')
                    .prop('disabled', false)
                    .css('background-color', '#e12727')
                    .text('ADD TO CART');
            } else {
                $('.full-price').hide();
                $('.discounted-price').text('$0.00').show();
                $('.savings-badge').hide();
                $('.tiered-atc')
                    .prop('disabled', !tieredFlavorPickerMedia.matches)
                    .css('background-color', '')
                    .text('PICK YOUR FLAVORS');
            }
        }

        function tieredAddVariantToSelection(button) {
            const variantId = button.data('variant-id');
            const imgSrc = button.closest('.landing-page-product').find('.selection-img').attr('src');
            const variantTitle = button.siblings('.landing-page-product-title').find('.lp-meta-title').text().trim();
            const priceCents = parseInt(button.data('variant-price')) || 0;

            let availableSelection = null;
            for (let i = 0; i < TIERED_SELECTION_IDS.length; i++) {
                const sel = $(`#${TIERED_SELECTION_IDS[i]}`).filter(function() {
                    return $(this).data('variant-id') === '';
                }).first();
                if (sel.length) {
                    availableSelection = sel;
                    break;
                }
            }

            if (!availableSelection) {
                return;
            }

            availableSelection.data('variant-id', variantId);
            availableSelection.attr('data-variant-id', variantId);
            availableSelection.data('price', priceCents);
            availableSelection.attr('data-price', priceCents);

            let selectionImgWrap = availableSelection.find('.landing-page-selection-img-wrap');
            if (!selectionImgWrap.length) {
                selectionImgWrap = $('<div>').addClass('landing-page-selection-img-wrap');
                availableSelection.prepend(selectionImgWrap);
            }
            selectionImgWrap.empty();

            let closeButton = $('<div>').addClass('landing-page-selection-close').text('X');

            if (imgSrc) {
                const imgContainer = $('<div>').addClass('tiered-img-container');
                const imgElement = $('<img>')
                    .attr('src', imgSrc)
                    .addClass('landing-page-selection-img-preview');
                imgContainer.append(imgElement);
                imgContainer.append(closeButton);
                selectionImgWrap.append(imgContainer);
            } else {
                selectionImgWrap.append(closeButton);
            }

            // Update title in sibling element
            availableSelection.closest('.tiered-selection-item').find('.tiered-selection-title').text(variantTitle);

            closeButton.show();

            tieredUpdateQuantitySelector(button, variantId);
            tieredEnsureOrder();
            tieredCalculateTotalPrice();
            tieredUpdateAllQuantitySelectors();
        }

        $('.tiered-landing-page .landing-page-variant-add').on('click', function() {
            tieredAddVariantToSelection($(this));
        });

        $('.tiered-atc').on('click', function() {
            if ($(this).prop('disabled')) return;
            const $button = $(this);

            const items = $('.tiered-selection[data-variant-id!=""]').map(function() {
                return {
                    id: $(this).data('variant-id'),
                    quantity: 1
                };
            }).get();

            if (!items.length) {
                if (!tieredFlavorPickerMedia.matches) return;
                const $products = $button.closest('.tiered-landing-page').find('.landing-page-products').first();
                if ($products.length) {
                    const stickyHeaderHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-height')) || 0;
                    const $header = $('.site-header, .header, #shopify-section-header');
                    const headerHeight = $header.length ? $header.outerHeight() : 0;
                    const offset = Math.max(stickyHeaderHeight, headerHeight) + 15;
                    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                    $('html, body').stop(true).animate({
                        scrollTop: Math.max(0, $products.offset().top - offset)
                    }, reducedMotion ? 0 : 400, 'swing');
                }
                return;
            }

            $button.addClass('btn--loading');

            function clearTieredForm() {
                $('.tiered-selection').each(function(index) {
                    const $sel = $(this);
                    $sel.data('variant-id', '');
                    $sel.attr('data-variant-id', '');
                    $sel.data('price', '');
                    $sel.attr('data-price', '');
                    $sel.find('.landing-page-selection-img-wrap').empty();
                    $sel.find('.landing-page-selection-close').hide();
                    // Clear the sibling title
                    $sel.closest('.tiered-selection-item').find('.tiered-selection-title').text('');
                });
                $('.tiered-landing-page .landing-page-quantity-selector').each(function() {
                    const $selector = $(this);
                    $selector.off('click');
                    $selector.empty()
                             .removeClass('landing-page-quantity-selector')
                             .addClass('landing-page-variant-add')
                             .text('Add');
                    $selector.on('click', function() {
                        tieredAddVariantToSelection($(this));
                    });
                });
                tieredCalculateTotalPrice();
            }

            $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                dataType: 'json',
                data: {
                    items: items
                },
                success: function() {
                    applyTieredBundleDiscount().then(function() {
                        $button.removeClass('btn--loading');
                        clearTieredForm();
                        $('body').trigger('added.ajaxProduct');
                    }).catch(function(error) {
                        $button.removeClass('btn--loading');
                        clearTieredForm();
                        $('body').trigger('added.ajaxProduct');
                        console.log('[Tiered Bundle] Coupon update failed:', error);
                    });
                },
                error: function() {
                    $button.removeClass('btn--loading');
                    alert('There was an error adding items to your cart. Please try again.');
                }
            });
        });

        function tieredUpdateQuantitySelector(addButton, variantId, totalItems = null) {
            const quantity = $('.tiered-selection').filter(function() {
                return $(this).data('variant-id') === variantId;
            }).length;
            const formTotal = totalItems !== null ? totalItems : $('.tiered-selection[data-variant-id!=""]').length;

            addButton.off('click');
            addButton.empty().removeClass('landing-page-variant-add').addClass('landing-page-quantity-selector');
            addButton.html(`
                <button class="landing-page-quantity-minus">-</button>
                <span class="landing-page-quantity-value">${quantity}</span>
                <button class="landing-page-quantity-plus">+</button>
            `);

            addButton.find('.landing-page-quantity-plus').on('click', function(e) {
                e.stopPropagation();
                tieredHandleQuantityChange(addButton, variantId, 'increase');
            });
            addButton.find('.landing-page-quantity-minus').on('click', function(e) {
                e.stopPropagation();
                tieredHandleQuantityChange(addButton, variantId, 'decrease');
            });

            if (formTotal >= 5) {
                addButton.find('.landing-page-quantity-plus').prop('disabled', true).css('opacity', '0.5');
            } else {
                addButton.find('.landing-page-quantity-plus').prop('disabled', false).css('opacity', '1');
            }
            if (quantity === 0) {
                addButton.find('.landing-page-quantity-minus').prop('disabled', true).css('opacity', '0.5');
            } else {
                addButton.find('.landing-page-quantity-minus').prop('disabled', false).css('opacity', '1');
            }
        }

        function tieredUpdateAllQuantitySelectors() {
            const totalItems = $('.tiered-selection[data-variant-id!=""]').length;
            $('.tiered-landing-page .landing-page-quantity-selector').each(function() {
                const $selector = $(this);
                const variantId = $selector.data('variant-id');
                if (variantId) {
                    tieredUpdateQuantitySelector($selector, variantId, totalItems);
                }
            });
        }

        function tieredHandleQuantityChange(selector, variantId, action) {
            const currentQuantity = $('.tiered-selection').filter(function() {
                return $(this).data('variant-id') === variantId;
            }).length;

            if (action === 'increase' && currentQuantity < 5) {
                tieredAddVariantToSelection(selector);
            } else if (action === 'decrease' && currentQuantity > 0) {
                // Find last selection with this variant (from end)
                let lastSelection = null;
                for (let i = TIERED_SELECTION_IDS.length - 1; i >= 0; i--) {
                    const sel = $(`#${TIERED_SELECTION_IDS[i]}`).filter(function() {
                        return $(this).data('variant-id') === variantId;
                    }).first();
                    if (sel.length) {
                        lastSelection = sel;
                        break;
                    }
                }

                if (lastSelection && lastSelection.length) {
                    const selIndex = TIERED_SELECTION_IDS.indexOf(lastSelection.attr('id'));
                    lastSelection.data('variant-id', '');
                    lastSelection.attr('data-variant-id', '');
                    lastSelection.find('.landing-page-selection-img-wrap').empty();
                    lastSelection.find('.landing-page-selection-close').hide();
                    // Clear the sibling title
                    lastSelection.closest('.tiered-selection-item').find('.tiered-selection-title').text('');
                }

                tieredEnsureOrder();
                tieredCalculateTotalPrice();
                tieredUpdateAllQuantitySelectors();

                const newQuantity = $('.tiered-selection').filter(function() {
                    return $(this).data('variant-id') === variantId;
                }).length;
                const $quantitySelector = $(selector);
                if ($quantitySelector.length) {
                    $quantitySelector.find('.landing-page-quantity-value').text(newQuantity);
                    if (newQuantity === 0) {
                        $quantitySelector.empty().removeClass('landing-page-quantity-selector').addClass('landing-page-variant-add');
                        $quantitySelector.text('Add');
                        $quantitySelector.off('click');
                        $quantitySelector.on('click', function() {
                            tieredAddVariantToSelection($(this));
                        });
                    }
                }
            }
        }

        $('.tiered-selection').on('click', function(e) {
            if ($(e.target).hasClass('landing-page-selection-close')) return;
            if ($(this).data('variant-id') !== '') {
                const variantId = $(this).data('variant-id');
                const selIndex = TIERED_SELECTION_IDS.indexOf($(this).attr('id'));
                $(this).data('variant-id', '');
                $(this).attr('data-variant-id', '');
                $(this).find('.landing-page-selection-img-wrap').empty();
                $(this).find('.landing-page-selection-close').hide();
                // Clear the sibling title
                $(this).closest('.tiered-selection-item').find('.tiered-selection-title').text('');

                const selector = $('.tiered-landing-page .landing-page-quantity-selector').filter(function() {
                    return $(this).closest('.landing-page-product').find('.landing-page-variant-add').data('variant-id') === variantId ||
                           $(this).data('variant-id') === variantId;
                });

                if (selector.length) {
                    const remainingQuantity = $('.tiered-selection').filter(function() {
                        return $(this).data('variant-id') === variantId;
                    }).length;
                    if (remainingQuantity === 0) {
                        selector.empty().removeClass('landing-page-quantity-selector').addClass('landing-page-variant-add');
                        selector.text('Add');
                        selector.off('click');
                        selector.on('click', function() {
                            tieredAddVariantToSelection($(this));
                        });
                    } else {
                        tieredUpdateQuantitySelector(selector, variantId);
                    }
                }

                tieredEnsureOrder();
                tieredCalculateTotalPrice();
                tieredUpdateAllQuantitySelectors();
            } else {
                // Scroll to top of products, accounting for sticky header
                const $landingPageProducts = $('.landing-page-products');
                if ($landingPageProducts.length) {
                    const elementTop = $landingPageProducts.offset().top;
                    const stickyHeaderHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-height')) || 0;
                    const $header = $('.site-header, .header, #shopify-section-header');
                    const headerHeight = $header.length ? $header.outerHeight() : 0;
                    const offset = Math.max(stickyHeaderHeight, headerHeight) + 15;
                    $('html, body').animate({
                        scrollTop: elementTop - offset
                    }, 400, 'swing');
                }
            }
        });

        $(document).on('click', '.tiered-selection .landing-page-selection-close', function(e) {
            e.stopPropagation();
            const $selection = $(this).closest('.tiered-selection');
            if ($selection.data('variant-id') !== '') {
                const variantId = $selection.data('variant-id');
                const selIndex = TIERED_SELECTION_IDS.indexOf($selection.attr('id'));
                $selection.data('variant-id', '');
                $selection.attr('data-variant-id', '');
                $selection.find('.landing-page-selection-img-wrap').empty();
                $selection.find('.landing-page-selection-close').hide();
                // Clear the sibling title
                $selection.closest('.tiered-selection-item').find('.tiered-selection-title').text('');

                const $quantitySelector = $('.tiered-landing-page .landing-page-quantity-selector').filter(function() {
                    return $(this).closest('.landing-page-product').find('.landing-page-variant-add').data('variant-id') === variantId ||
                           $(this).data('variant-id') === variantId;
                });

                if ($quantitySelector.length) {
                    const newQuantity = $('.tiered-selection').filter(function() {
                        return $(this).data('variant-id') === variantId;
                    }).length;
                    if (newQuantity === 0) {
                        $quantitySelector.empty().removeClass('landing-page-quantity-selector').addClass('landing-page-variant-add');
                        $quantitySelector.text('Add');
                        $quantitySelector.off('click');
                        $quantitySelector.on('click', function() {
                            tieredAddVariantToSelection($(this));
                        });
                    } else {
                        tieredUpdateQuantitySelector($quantitySelector, variantId);
                    }
                }

                tieredEnsureOrder();
                tieredCalculateTotalPrice();
                tieredUpdateAllQuantitySelectors();
            }
        });

        function tieredEnsureOrder() {
            const $selections = $('.tiered-selection');
            const filledSelections = $selections.filter(function() {
                return $(this).data('variant-id') !== '';
            }).map(function() {
                return {
                    variantId: $(this).data('variant-id'),
                    imageHtml: $(this).find('.landing-page-selection-img-wrap').html(),
                    title: $(this).closest('.tiered-selection-item').find('.tiered-selection-title').text() || '',
                    price: parseInt($(this).data('price')) || 0
                };
            }).get();

            $selections.each(function(index) {
                const $sel = $(this);
                const intendedId = TIERED_SELECTION_IDS[index];
                if ($sel.attr('id') !== intendedId) {
                    $sel.attr('id', intendedId);
                }

                if (index < filledSelections.length) {
                    const filled = filledSelections[index];
                    $sel.data('variant-id', filled.variantId);
                    $sel.attr('data-variant-id', filled.variantId);
                    $sel.data('price', filled.price);
                    $sel.attr('data-price', filled.price);
                    $sel.find('.landing-page-selection-img-wrap').html(filled.imageHtml);
                    $sel.closest('.tiered-selection-item').find('.tiered-selection-title').text(filled.title);
                    $sel.find('.landing-page-selection-close').show();
                } else {
                    $sel.data('variant-id', '');
                    $sel.attr('data-variant-id', '');
                    $sel.data('price', '');
                    $sel.attr('data-price', '');
                    $sel.find('.landing-page-selection-img-wrap').empty();
                    $sel.find('.landing-page-selection-close').hide();
                    // Clear the sibling title
                    $sel.closest('.tiered-selection-item').find('.tiered-selection-title').text('');
                }
            });
        }

        tieredCalculateTotalPrice();
    }
});

  function clearCart() {
    return $.post('/cart/clear/js');
  }
  // offer upsell modal sample-upsell-model product.sections.liquid
    $('.add-to-cart').on('click touchend', function(event) {
      event.stopImmediatePropagation();
      event.preventDefault();
      $(this).off(event);
      var variant = $(this).data('variantid');
      if (variant == 43162740621488 || variant == 4390869336081 || variant == 44019907428528 || variant == 44367445491888) {
          var modal = $('.sample-upsell-modal');
          var closeBtn = $('.sample-upsell-close-btn');
          var acceptUpsell = $('button#accept-upsell-offer');
          var rejectUpsell = $('button#reject-offer');
          var flavorSelector = $('#flavor-selector');
          var quantitySelector = $('#quantity-selector');
          var subscriptionToggle = $('#subscription-toggle');
  
          if (Cookies.get('sample-opt-out') != 'true') {
              modal.show();
  
              $(closeBtn).on('click touchend', function(event) {
                  modal.hide();
                  $(this).off(event);
                  $('.add-to-cart').click();
              });
  
              $(window).on('click touchend', function(event) {
                  if (event.target == modal[0]) {
                      if ($('input[type="checkbox"][name="opt-out"]').prop('checked')) {
                          Cookies.set('sample-opt-out', 'true', { expires: 90 });
                      }
                      modal.hide();
                      $(this).off(event);
                      $('.add-to-cart').click();
                  }
              });
  
              $(acceptUpsell).on('click touchend', function(event) {
                  var selectedFlavor = flavorSelector.val();
                  // #quantity-selector doesn't exist in this modal, so parseInt -> NaN.
                  // Default to 1 so we don't write quantity="NaN" into the (now present)
                  // pack-selector input[name="quantity"] and 422 the add-to-cart.
                  var quantity = parseInt(quantitySelector.val(), 10) || 1;
                  var isSubscription = subscriptionToggle.prop('checked');
  
                  // Set common variant selection
                  $('select.product-single__variants>option:eq(0)').prop('selected', true);
                  $('select.product-single__variants').trigger('change');
                  $('.variant-input-wrap>select#SingleOptionSelector-6800249913520-option-0>option:eq(0)').prop('selected', true);
  
                  // Set flavor-specific option
                  switch (selectedFlavor) {
                      case 'lemon-lime':
                          $('.variant-input-wrap>select#SingleOptionSelector-6800249913520-option-1>option:eq(0)').prop('selected', true);
                          break;
                      case 'orange':
                          $('.variant-input-wrap>select#SingleOptionSelector-6800249913520-option-1>option:eq(1)').prop('selected', true);
                          break;
                      case 'cocoa':
                          $('.variant-input-wrap>select#SingleOptionSelector-6800249913520-option-1>option:eq(2)').prop('selected', true);
                          break;
                      case 'strawberry-kiwi':
                          $('.variant-input-wrap>select#SingleOptionSelector-6800249913520-option-1>option:eq(3)').prop('selected', true);
                          break;
                  }
                  $('.variant-input-wrap>select').trigger('change');
  
                  // Set quantity and subscription properties
                  $('input[name="quantity"]').val(quantity);
                  if (isSubscription) {
                      $('input[name="properties[shipping_interval_frequency]"]').val('30'); // Example: 30-day subscription
                      $('input[name="properties[shipping_interval_unit_type]"]').val('Days');
                      $('input[name="properties[subscription_id]"]').val('your-subscription-id'); // Replace with actual subscription ID
                  } else {
                      $('input[name="properties[shipping_interval_frequency]"]').val('');
                      $('input[name="properties[shipping_interval_unit_type]"]').val('');
                      $('input[name="properties[subscription_id]"]').val('');
                  }
  
                  $(this).off(event);
                  $(document).one('addedToCart', function() {
                      console.log('addedToCart triggered');
                      var rawData = sessionStorage.getItem('scDiscountData');
                      var scDiscountData = $.parseJSON(rawData);
                      var code = scDiscountData ? scDiscountData['code'] : null;
                      if (code != null) {
                          window.DiscountHero.discount.remove(code).then(function() {
                              window.DiscountHero.discount.apply('UPGRADEME');
                          });
                      } else {
                          window.DiscountHero.discount.apply('UPGRADEME');
                      }
                      $(this).off(event);
                      $('body').trigger('added.ajaxProduct');
                  });
  
                  if ($('input[type="checkbox"][name="opt-out"]').prop('checked')) {
                      Cookies.set('sample-opt-out', 'true', { expires: 90 });
                  }
                  $('.add-to-cart').click();
                  modal.hide();
              });
  
              $(rejectUpsell).on('click touchend', function(event) {
                  if ($('input[type="checkbox"][name="opt-out"]').prop('checked')) {
                      Cookies.set('sample-opt-out', 'true', { expires: 90 });
                  }
                  modal.hide();
                  $(this).off(event);
                  $('.add-to-cart').click();
              });
          } else {
              $(this).off(event);
              $('.add-to-cart').click();
          }
      } else {
          $(this).off(event);
          $('.add-to-cart').click();
      }
  });

  //open loyalty
  $(document).ready(function() {
    $('.ohana-perks').on('click', function() {
      $('#appstle-loyalty-button').click();
    });
  })

  function calculateFSB() {
    var rawData = sessionStorage.getItem('scDiscountData');
    var scDiscountData = rawData ? $.parseJSON(rawData) : null;
    var cartTotal;
    var items;
    var discount = scDiscountData ? scDiscountData['discount'] : null;
    var discounts = scDiscountData ? scDiscountData['discounts'] : null;
    var stage = scDiscountData ? scDiscountData['stage'] : null;
    var has_shaker = false;
    var has_gut = false;
    var has_multi = false;
    var has_burn = false;
    var has_ebook = false;
    var eBookVariantId;
    var has_towel = false;
    var towelVariantId;
    var has_shaker = false;
    var has_gut = false;
    var has_krill = false;
    var extra_krill = false;
    var has_creatine = false;
    var has_lytes_lemon_lime = false;
    var has_lytes_orange = false;
    var has_lytes_cocoa = false;
    var has_strength_ebook = false;
    var extra_shaker = false;
    var extra_multi = false;
    var extra_gut = false;
    var has_gift = false;
    var extra_gift = false;

    console.log('[function] calculateFSB() calling getCartDetails()');
    getCartDetails();
    
  } //end calculateFSB()

  function getCartDetails() {
      
      theme.cart.getCart().then(function(cart){
        console.log('[function start] getCartDetails');
        var rawData = sessionStorage.getItem('scDiscountData');
        var scDiscountData = $.parseJSON(rawData);
        var cartTotal;
        var items;
        var discount = scDiscountData['discount'];
        var discounts = scDiscountData['discounts'];
        var stage = scDiscountData['stage'];
        
        var cartItems = [];

        if (!cart || !cart.items || cart.items.length == 0){
          // Create empty cart object for updateBar
          updateBar({ items: [], total_price: 0 });
          return
        }
        cartItems.push(...cart.items);
        // Pass full cart object to updateBar
        updateBar(cart);
      }) 
    } // getCartDetails()


  //free shipping progress updateBar & free item check
    //to prevent running twice
    let isRemovingGift = false;

    // Rates and coupon names come from the shared, expiring campaign policy.
    // Track currently applied Buy More coupon
    var currentBuyMoreCoupon = null;

    // Debounce and processing flags to prevent cascade calls
    var isProcessingBuyMore = false;
    var lastProcessedCartState = null;
    var updateBarDebounceTimer = null;

    // Expose lastProcessedCartState globally for manual coupon reset
    window.resetCartState = function() {
      lastProcessedCartState = null;
      console.log('[Cart State] Reset lastProcessedCartState');
    };

    // Promise that resolves when current coupon operation completes
    var buyMoreOperationPromise = Promise.resolve();
    var b2g1OperationPromise = Promise.resolve();

    function isB2G1Code(code) {
      return typeof code === 'string' && code.trim().toUpperCase() === B2G1_CODE;
    }

    function getStoredDiscountCode() {
      try {
        var data = JSON.parse(sessionStorage.getItem('scDiscountData') || '{}');
        return data && data.code;
      } catch (e) {
        return null;
      }
    }

    function setB2G1Selection(selected) {
      window.couponState.b2g1SelectionRevision++;
      window.couponState.b2g1Selected = selected;
      window.couponState.b2g1ExplicitlyRemoved = !selected;
      window.couponState.manualOverride = false;
      window.couponState.showSuggestion = false;
      window.couponState.suggestionData = null;
      window.couponState.pendingManualCode = null;
      window.couponState.b2g1Error = false;
      try {
        sessionStorage.setItem('athB2G1Selected', String(selected));
        sessionStorage.removeItem('couponManualOverride');
        sessionStorage.removeItem('couponSuggestionData');
        sessionStorage.removeItem('pendingManualDiscount');
      } catch (e) {
        // Keep the current page protected even without sessionStorage.
      }
    }

    function isB2G1Protected(cart) {
      if (window.couponState.b2g1Selected || window.couponState.b2g1Applying || window.couponState.b2g1Removing) {
        return true;
      }
      // A just-removed code can remain in cached app/cart data briefly.
      if (window.couponState.b2g1ExplicitlyRemoved) return false;
      var cartHasCode = cart && (cart.discount_codes || []).some(function(discount) {
        return isB2G1Code(discount.code);
      });
      if (isB2G1Code(getStoredDiscountCode()) || cartHasCode) {
        setB2G1Selection(true);
        return true;
      }
      return false;
    }

    function hasB2G1Discount(cart) {
      if ((cart.discount_codes || []).some(function(discount) {
        return isB2G1Code(discount.code) && discount.applicable;
      }) && cart.total_discount > 0) return true;
      return (cart.items || []).some(function(item) {
        return (item.line_level_discount_allocations || []).some(function(allocation) {
          return allocation.amount > 0 && isB2G1Code(allocation.discount_application.title);
        });
      });
    }

    function b2g1CartSignature(cart) {
      return JSON.stringify((cart.items || []).map(function(item) {
        return [item.variant_id, item.quantity, item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id];
      }));
    }

    function applyB2G1Promotion() {
      var selectionRevision = window.couponState.b2g1SelectionRevision;
      var previousOperation = b2g1OperationPromise;
      var shouldApply = false;
      window.couponState.b2g1Applying = true;
      window.couponState.b2g1Error = false;
      window.couponState.systemIsApplying = true;
      // Wait for an already-started BUYMORE operation, without its timeout fallback.
      // Its replacement application also checks the B2G1 lock before proceeding.
      b2g1OperationPromise = Promise.all([buyMoreOperationPromise, previousOperation.catch(function() {})]).then(function() {
        if (!window.couponState.b2g1Selected || selectionRevision !== window.couponState.b2g1SelectionRevision) return;
        shouldApply = true;
        if (!window.DiscountHero || !window.DiscountHero.discount) {
          throw new Error('The discount service is not available.');
        }
        var existingCode = getStoredDiscountCode() || currentBuyMoreCoupon;
        if (existingCode && !isB2G1Code(existingCode)) {
          window.couponState.systemIsRemoving = true;
          return window.DiscountHero.discount.remove(existingCode.trim().toLowerCase()).then(function() {
            theme.cart.invalidateCache();
            return theme.cart.getCart();
          }).then(function(cart) {
            var storedCode = getStoredDiscountCode();
            if ((storedCode && storedCode.toUpperCase() === existingCode.toUpperCase()) ||
                (cart.discount_codes || []).some(function(discount) {
                  return discount.code.toUpperCase() === existingCode.toUpperCase();
                })) {
              throw new Error('The previous discount could not be removed.');
            }
          });
        }
      }).then(function() {
        if (!shouldApply) return;
        return window.DiscountHero.discount.apply(B2G1_CODE);
      }).then(function() {
        if (shouldApply) {
          currentBuyMoreCoupon = null;
          window.couponState.currentCode = B2G1_CODE;
          window.couponState.isManual = false;
        }
        theme.cart.invalidateCache();
        return theme.cart.getCart();
      }).then(function(cart) {
        if (shouldApply && !hasB2G1Discount(cart) && !(cart.discount_codes || []).some(function(discount) {
          return isB2G1Code(discount.code);
        })) {
          throw new Error('The free-item offer could not be applied.');
        }
        if (selectionRevision === window.couponState.b2g1SelectionRevision || !window.couponState.b2g1Selected) {
          window.couponState.b2g1Applying = false;
          window.couponState.systemIsApplying = false;
          window.couponState.systemIsRemoving = false;
          window.couponState.b2g1LastAttempt = b2g1CartSignature(cart);
        }
        window.resetCartState();
        updateBar(cart);
        $('body').trigger('calculated.ajaxProduct');
        return cart;
      }).catch(function(error) {
        if (selectionRevision === window.couponState.b2g1SelectionRevision) {
          window.couponState.b2g1Applying = false;
          window.couponState.systemIsApplying = false;
          window.couponState.systemIsRemoving = false;
          window.couponState.b2g1Error = true;
        }
        theme.cart.invalidateCache();
        window.resetCartState();
        return theme.cart.getCart().then(function(cart) {
          window.couponState.b2g1LastAttempt = b2g1CartSignature(cart);
          updateBar(cart);
          $('body').trigger('calculated.ajaxProduct');
          throw error;
        }, function() { throw error; });
      });
      return b2g1OperationPromise;
    }

    function removeB2G1Promotion() {
      if (window.couponState.b2g1Removing) return b2g1OperationPromise;
      var selectionRevision = window.couponState.b2g1SelectionRevision;
      window.couponState.b2g1Removing = true;
      window.couponState.systemIsRemoving = true;
      var removal = b2g1OperationPromise.catch(function() {}).then(function() {
        if (!window.DiscountHero || !window.DiscountHero.discount) {
          throw new Error('The discount service is not available.');
        }
        // The app's native-cart removal path compares against lowercase active codes.
        return window.DiscountHero.discount.remove(B2G1_CODE.toLowerCase());
      }).then(function() {
        theme.cart.invalidateCache();
        return theme.cart.getCart();
      }).then(function(cart) {
        if (isB2G1Code(getStoredDiscountCode()) || (cart.discount_codes || []).some(function(discount) {
          return isB2G1Code(discount.code);
        }) || hasB2G1Discount(cart)) {
          throw new Error('The free-item offer could not be removed.');
        }
        // A later landing-page add is a newer customer choice than this removal.
        if (selectionRevision === window.couponState.b2g1SelectionRevision) {
          setB2G1Selection(false);
          window.couponState.isManual = false;
          window.couponState.currentCode = null;
          window.couponState.b2g1LastAttempt = null;
          currentBuyMoreCoupon = null;
        }
        return cart;
      }).then(function(cart) {
        window.couponState.b2g1Removing = false;
        window.couponState.systemIsRemoving = false;
        window.resetCartState();
        // Explicit removal resumes BUYMORE immediately, without a suggestion step.
        updateBarCore(cart);
        $('body').trigger('calculated.ajaxProduct');
        return cart;
      }).catch(function(error) {
        window.couponState.b2g1Removing = false;
        window.couponState.systemIsRemoving = false;
        throw error;
      });
      b2g1OperationPromise = removal;
      return removal;
    }

    function handleB2G1RemovalClick(event) {
      var target = event.target;
      var button = target && target.closest && target.closest('.sc-tag button.button, [data-b2g1-remove], [data-b2g1-retry]');
      if (!button) return;
      if (button.hasAttribute('data-b2g1-retry')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!window.couponState.b2g1Applying && !window.couponState.b2g1Removing) {
          return applyB2G1Promotion().catch(function(error) {
            console.log('[B2G1] Retry failed:', error);
          });
        }
        return;
      }
      var tag = button.closest('.sc-tag');
      var codeLabel = tag && tag.querySelector('.code-name');
      var code = codeLabel && (codeLabel.getAttribute('title') || codeLabel.textContent);
      if (!button.hasAttribute('data-b2g1-remove') && !isB2G1Code(code)) return;
      // Capture the actual customer click; app invalidation/removal events are not consent.
      event.preventDefault();
      event.stopImmediatePropagation();
      return removeB2G1Promotion().catch(function(error) {
        alert('The offer could not be removed. Please try again.');
      });
    }

    document.addEventListener('click', handleB2G1RemovalClick, true);

    // Expose for cart operations to wait on (with timeout fallback)
    window.waitForBuyMoreComplete = function(timeoutMs) {
      if (!isProcessingBuyMore) {
        return Promise.resolve(); // No operation in progress, resolve immediately
      }

      // Default 2 second timeout to prevent indefinite hangs
      timeoutMs = timeoutMs || 2000;

      return new Promise(function(resolve) {
        var resolved = false;

        // Resolve when operation completes
        buyMoreOperationPromise.then(function() {
          if (!resolved) {
            resolved = true;
            resolve();
          }
        });

        // Timeout fallback - proceed anyway after timeout
        setTimeout(function() {
          if (!resolved) {
            resolved = true;
            console.log('[BuyMore] Wait timeout - proceeding anyway after', timeoutMs, 'ms');
            resolve();
          }
        }, timeoutMs);
      });
    };

    // Count one-time items (non-subscription) in cart
    function countOneTimeItems(cart) {
      var oneTimeCount = 0;
      var subscriptionCount = 0;
      var oneTimeItems = [];

      if (!cart || !cart.items) {
        return { count: 0, items: [] };
      }

      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var isSubscription = !!item.selling_plan_allocation;

        if (!isSubscription) {
          oneTimeCount += item.quantity;
          oneTimeItems.push(item);
        } else {
          subscriptionCount += item.quantity;
        }
      }

      return {
        count: oneTimeCount,
        items: oneTimeItems
      };
    }

    // Check if cart has only subscription items
    function hasOnlySubscriptionItems(cart) {
      if (!cart || !cart.items || cart.items.length === 0) {
        return false;
      }

      for (var i = 0; i < cart.items.length; i++) {
        if (!cart.items[i].selling_plan_allocation) {
          return false;
        }
      }
      return true;
    }

    // Update text message for Buy More & Save
    function updateBuyMoreText(oneTimeCount, cartTotalCents) {
      console.log('[BuyMore Text] Called with oneTimeCount:', oneTimeCount, 'showSuggestion:', window.couponState.showSuggestion, 'manualOverride:', window.couponState.manualOverride);

      var $text = $('#CartDrawer .free-shipping-text');
      var $header = $('#CartDrawer .drawer__header');
      var $fixedHeader = $('#CartDrawer .drawer__fixed-header');
      var message = '';

      // Check if we should show BUYMORE suggestion instead of default text
      if (window.couponState.showSuggestion && window.couponState.suggestionData) {
        var data = window.couponState.suggestionData;
        data.coupon = buyMore.coupon(oneTimeCount);
        data.percent = buyMore.percent(oneTimeCount) + '%';
        message = '<strong style="cursor: pointer;" class="apply-buymore-suggestion" data-coupon="' + data.coupon + '">CLICK TO APPLY ' + data.coupon + ' FOR ' + data.percent + ' OFF</strong>';
        console.log('[BuyMore Text] Showing BUYMORE suggestion:', data.coupon);
      } else {
        message = buyMore.message(oneTimeCount, cartTotalCents);
      }

      // Toggle header height based on whether message is shown
      if (message === '') {
        console.log('[BuyMore Text] Setting empty message (hiding text)');
        $text.empty();
        $header.addClass('no-shipping-text');
        $fixedHeader.addClass('no-shipping-text');
      } else {
        console.log('[BuyMore Text] Setting message:', message.substring(0, 80) + '...');
        $text.html('<p>' + message + '</p>');
        $header.removeClass('no-shipping-text');
        $fixedHeader.removeClass('no-shipping-text');

        // If showing suggestion, attach click handler
        if (window.couponState.showSuggestion && window.couponState.suggestionData) {
          $('.apply-buymore-suggestion').off('click').on('click', function() {
            var couponToApply = $(this).data('coupon');
            console.log('[Manual Coupon] Customer clicked to apply suggested coupon:', couponToApply);

            // Clear suggestion state and manual override (customer has chosen to apply a coupon)
            window.couponState.showSuggestion = false;
            window.couponState.suggestionData = null;
            window.couponState.manualOverride = false;

            // Clear from sessionStorage
            sessionStorage.removeItem('couponManualOverride');
            sessionStorage.removeItem('couponSuggestionData');
            console.log('[Manual Override] Cleared - customer clicked suggestion to apply coupon');

            // Apply the BUYMORE coupon using the existing function
            if (typeof applyNewCoupon === 'function') {
              applyNewCoupon(couponToApply);

              // Refresh cart after a short delay to show updated discount and normal Buy More text
              setTimeout(function() {
                if (typeof theme !== 'undefined' && theme.cart && typeof theme.cart.getCart === 'function') {
                  // Force updateBar to reprocess by resetting cart state
                  if (typeof window.resetCartState === 'function') {
                    window.resetCartState();
                  }

                  theme.cart.invalidateCache();
                  theme.cart.getCart().then(function(updatedCart) {
                    updateBar(updatedCart);
                  });
                }
              }, 1000);
            }
          });
        }
      }
    }

    // Apply new coupon code
    function applyNewCoupon(couponCode, resolveOperation) {
      if (isB2G1Protected()) {
        isProcessingBuyMore = false;
        if (resolveOperation) resolveOperation();
        buyMoreOperationPromise = Promise.resolve();
        return;
      }
      console.log('[BuyMore] Applying coupon code:', couponCode);
      console.log('[BuyMore] Current cart state - oneTimeCount:', lastProcessedCartState);

      if (!window.DiscountHero || !window.DiscountHero.discount) {
        console.log('[BuyMore] ERROR: DiscountHero not available');
        isProcessingBuyMore = false;
        if (resolveOperation) {
          resolveOperation();
          buyMoreOperationPromise = Promise.resolve();
        }
        return;
      }

      // Resolve the code again: a pending removal can cross the campaign deadline.
      var automaticTier = /^BUYMORE([2-5])(?:EBF)?$/i.exec(couponCode || '');
      if (automaticTier) couponCode = buyMore.coupon(Number(automaticTier[1]));

      // MARK: Our system is applying this coupon
      window.couponState.systemIsApplying = true;

      window.DiscountHero.discount.apply(couponCode).then(function() {
        currentBuyMoreCoupon = couponCode;
        window.couponState.currentCode = couponCode;

        // Clear any suggestion state since a BUYMORE coupon is now applied
        window.couponState.showSuggestion = false;
        window.couponState.suggestionData = null;

        // Reset flag after short delay (to prevent detection as manual)
        setTimeout(function() {
          window.couponState.systemIsApplying = false;
        }, 1000);

        isProcessingBuyMore = false;
        console.log('[BuyMore] SUCCESS - Applied coupon:', couponCode);
        if (resolveOperation) {
          resolveOperation();
          buyMoreOperationPromise = Promise.resolve();
        }
      }).catch(function(error) {
        console.log('[BuyMore] FAILED - Could not apply coupon:', couponCode);
        console.log('[BuyMore] Error details:', error);
        window.couponState.systemIsApplying = false;
        isProcessingBuyMore = false;
        if (resolveOperation) {
          resolveOperation();
          buyMoreOperationPromise = Promise.resolve();
        }
      });
    }

    // Apply or remove Buy More coupon based on one-time item count
    // Coupon naming: BUYMORE{item_count} (e.g., BUYMORE2 = 2 items, BUYMORE5 = 5+ items)
    function applyBuyMoreCoupon(oneTimeCount) {
      if (isB2G1Protected() || window.couponState.systemIsApplying) return;
      // STOP if manual coupon is active
      if (window.couponState.isManual) {
        console.log('[BuyMore] SKIPPED - Manual coupon is active');
        return;
      }

      // STOP if customer manually removed a coupon (manualOverride)
      // Show suggestion only, don't auto-apply until cart changes
      if (window.couponState.manualOverride) {
        console.log('[BuyMore] SKIPPED - Customer manually removed coupon (manualOverride active)');
        console.log('[BuyMore] Suggestion will be shown, but no auto-apply until cart changes');
        return;
      }

      // Skip if already processing a coupon operation
      if (isProcessingBuyMore) {
        console.log('[BuyMore] SKIPPED - Already processing coupon operation');
        return;
      }

      var targetCoupon = buyMore.coupon(oneTimeCount);
      var storedCode = getStoredDiscountCode();
      if (storedCode && /^BUYMORE[2-5](?:EBF)?$/i.test(storedCode)) {
        currentBuyMoreCoupon = storedCode.toUpperCase();
      }

      // If same coupon already applied, do nothing
      if (currentBuyMoreCoupon === targetCoupon) {
        console.log('[BuyMore] No change needed:', targetCoupon);
        return;
      }

      console.log('[BuyMore] Coupon change: ' + currentBuyMoreCoupon + ' -> ' + targetCoupon);

      // Create promise that resolves when this operation completes
      var resolveOperation;
      buyMoreOperationPromise = new Promise(function(resolve) {
        resolveOperation = resolve;
      });

      // Set processing flag
      isProcessingBuyMore = true;

      // Remove existing coupon if different
      if (currentBuyMoreCoupon !== null) {
        if (!window.DiscountHero || !window.DiscountHero.discount) {
          console.log('[BuyMore] ERROR: DiscountHero not available for remove');
          currentBuyMoreCoupon = null;
          isProcessingBuyMore = false;
          resolveOperation();
          buyMoreOperationPromise = Promise.resolve();
          // Don't try to apply new coupon - DiscountHero isn't available
          return;
        }

        // MARK: Our system is removing this coupon (part of switching)
        window.couponState.systemIsRemoving = true;
        console.log('[BuyMore] System removing coupon:', currentBuyMoreCoupon, '(systemIsRemoving=true)');

        window.DiscountHero.discount.remove(currentBuyMoreCoupon).then(function() {
          console.log('[BuyMore] Removed:', currentBuyMoreCoupon);
          currentBuyMoreCoupon = null;

          // Reset flag after short delay
          setTimeout(function() {
            window.couponState.systemIsRemoving = false;
            console.log('[BuyMore] systemIsRemoving reset to false');
          }, 1000);

          if (targetCoupon) {
            applyNewCoupon(targetCoupon, resolveOperation);
          } else {
            isProcessingBuyMore = false;
            resolveOperation();
            buyMoreOperationPromise = Promise.resolve();
          }
        }).catch(function(error) {
          console.log('[BuyMore] Remove error:', error);
          currentBuyMoreCoupon = null;

          // Reset flag on error too (with same delay as success path)
          setTimeout(function() {
            window.couponState.systemIsRemoving = false;
            console.log('[BuyMore] systemIsRemoving reset to false (after error)');
          }, 1000);

          if (targetCoupon) {
            applyNewCoupon(targetCoupon, resolveOperation);
          } else {
            isProcessingBuyMore = false;
            resolveOperation();
            buyMoreOperationPromise = Promise.resolve();
          }
        });
      } else if (targetCoupon) {
        applyNewCoupon(targetCoupon, resolveOperation);
      } else {
        currentBuyMoreCoupon = null;
        isProcessingBuyMore = false;
        resolveOperation();
        buyMoreOperationPromise = Promise.resolve();
      }
    }

    // Remove any existing Buy More coupon (for subscription-only carts)
    function removeExistingBuyMoreCoupon() {
      if (isB2G1Protected()) return;
      var storedCode = getStoredDiscountCode();
      if (storedCode && /^BUYMORE[2-5](?:EBF)?$/i.test(storedCode)) currentBuyMoreCoupon = storedCode.toUpperCase();
      console.log('[BuyMore] removeExistingBuyMoreCoupon called');
      console.log('[BuyMore] currentBuyMoreCoupon:', currentBuyMoreCoupon);

      if (currentBuyMoreCoupon && window.DiscountHero && window.DiscountHero.discount) {
        if (isProcessingBuyMore) return;
        var couponToRemove = currentBuyMoreCoupon;
        isProcessingBuyMore = true;
        window.couponState.systemIsRemoving = true;
        console.log('[BuyMore] Removing coupon for subscription-only cart:', currentBuyMoreCoupon);
        buyMoreOperationPromise = window.DiscountHero.discount.remove(couponToRemove).then(function() {
          console.log('[BuyMore] SUCCESS: Removed coupon for subscription-only cart');
        }).catch(function(error) {
          console.log('[BuyMore] ERROR: Failed to remove coupon:', error);
        }).finally(function() {
          currentBuyMoreCoupon = null;
          isProcessingBuyMore = false;
          window.couponState.systemIsRemoving = false;
        });
      } else {
        console.log('[BuyMore] No coupon to remove or DiscountHero not available');
      }
    }

    // Core updateBar logic (called by debounced wrapper)
    function updateBarCore(cart) {
      var cartTotal = (cart.total_price / 100).toFixed(2);
      var oneTimeData = countOneTimeItems(cart);
      var oneTimeCount = oneTimeData.count;
      var subscriptionOnly = hasOnlySubscriptionItems(cart);
      var b2g1Selected = isB2G1Protected(cart);

      // Check scDiscountData for existing non-BUYMORE coupons BEFORE processing
      // This prevents race condition where monitoring code hasn't run yet on page load
      try {
        var rawData = sessionStorage.getItem('scDiscountData');
        if (rawData) {
          var scDiscountData = JSON.parse(rawData);
          var existingCode = scDiscountData['code'];
          if (existingCode && !existingCode.toUpperCase().startsWith('BUYMORE') && !window.couponState.isManual) {
            // Only set isManual if the cart actually has a discount applied
            // Prevents stale sessionStorage from keeping shipping mode after coupon invalidation
            if (cart.total_discount > 0) {
              console.log('[UpdateBar] Early detection - Found non-BUYMORE coupon in scDiscountData:', existingCode, '(cart discount:', cart.total_discount, ')');
              window.couponState.isManual = true;
              window.couponState.currentCode = existingCode;
            } else {
              console.log('[UpdateBar] Non-BUYMORE code in scDiscountData but cart has no discount — coupon is stale:', existingCode);
            }
          } else if (!existingCode && window.couponState.isManual && !window.couponState.systemIsApplying) {
            // Coupon removed/invalidated (e.g. Z5SK400SNC19 after items removed) — clear manual state so BUYMORE mode can resume
            console.log('[UpdateBar] Non-BUYMORE coupon no longer in scDiscountData, clearing manual state');
            window.couponState.isManual = false;
            window.couponState.currentCode = null;
          }
        } else if (window.couponState.isManual && !window.couponState.systemIsApplying) {
          console.log('[UpdateBar] No scDiscountData found, clearing manual state');
          window.couponState.isManual = false;
          window.couponState.currentCode = null;
        }
      } catch (e) {
        // Ignore errors reading sessionStorage
      }

      // Create cart state signature to detect changes
      var cartStateSignature = [oneTimeCount, subscriptionOnly, cart.item_count,
        cart.total_price, cart.total_discount, b2g1Selected, window.couponState.b2g1Applying, window.couponState.b2g1Error,
        getStoredDiscountCode(), buyMore.isActive(), b2g1CartSignature(cart), JSON.stringify(cart.discount_codes || [])].join('-');

      // Skip if cart state hasn't changed (prevents cascade from discount calculations)
      if (lastProcessedCartState === cartStateSignature && !isProcessingBuyMore) {
        console.log('[UpdateBar] SKIPPED - Cart state unchanged:', cartStateSignature);
        return;
      }

      console.log('[UpdateBar] ================================');
      console.log('[UpdateBar] SUMMARY:');
      console.log('[UpdateBar]   cartTotal: $' + cartTotal);
      console.log('[UpdateBar]   oneTimeCount: ' + oneTimeCount);
      console.log('[UpdateBar]   subscriptionOnly: ' + subscriptionOnly);
      console.log('[UpdateBar]   currentBuyMoreCoupon: ' + currentBuyMoreCoupon);
      console.log('[UpdateBar]   manualCoupon: ' + window.couponState.isManual);
      console.log('[UpdateBar]   cartStateSignature: ' + cartStateSignature);
      console.log('[UpdateBar] ================================');

      // Update last processed state
      lastProcessedCartState = cartStateSignature;

      // Hide old free gift offer elements (deprecated)
      $('#free_gift_offer').hide();
      $('#cart_gift_offer').hide();
      $('#free_multi_offer').hide();
      $('#cart_multi_offer').hide();

      // IF MANUAL COUPON IS ACTIVE: Switch to shipping mode
      if (window.couponState.isManual || b2g1Selected) {
        console.log('[UpdateBar] MODE: Manual Coupon Active (Shipping Progress)');
        $('#CartDrawer .progress-shipping-mode').show();
        $('#CartDrawer .progress-buymore-mode').hide();
        $('#CartDrawer .progress-unlocks').attr('data-mode', 'shipping');

        // Calculate shipping progress percentage (0-$99 = 0-100%)
        var manualShippingProgressPercent = Math.min((cart.total_price / 9900) * 100, 100);
        console.log('[UpdateBar] Manual coupon - Shipping progress: ' + manualShippingProgressPercent + '%');

        var $manualShippingFill = $('#CartDrawer .progress-shipping-mode .progress-container .progress-fill');
        $manualShippingFill.attr('style', 'width: ' + manualShippingProgressPercent + '%');
        $manualShippingFill.css('width', manualShippingProgressPercent + '%');

        var manualShippingMessage = cart.total_price >= 9900
          ? '<p><strong>YOUR ORDER SHIPS FREE, LOAD UP!</strong></p>'
          : '<p>YOU ARE <strong>$' + ((9900 - cart.total_price) / 100).toFixed(2) + '</strong> AWAY FROM FREE SHIPPING!</p>';

        if (b2g1Selected && !hasB2G1Discount(cart)) {
          manualShippingMessage = window.couponState.b2g1Applying
            ? '<p>APPLYING YOUR <strong>BUY 2, GET 1 FREE</strong> OFFER...</p>'
            : '<p>' + (window.couponState.b2g1Error
              ? 'WE COULD NOT APPLY YOUR FREE-ITEM OFFER. <button type="button" data-b2g1-retry style="color:inherit;background:none;border:0;text-decoration:underline;cursor:pointer">TRY AGAIN</button> '
              : 'ADD ANOTHER ELIGIBLE ITEM TO UNLOCK YOUR FREE ITEM. ') +
              '<button type="button" data-b2g1-remove style="color:inherit;background:none;border:0;text-decoration:underline;cursor:pointer">REMOVE OFFER</button></p>';
          var hasSelectedCode = (cart.discount_codes || []).some(function(discount) {
            return isB2G1Code(discount.code);
          });
          var attemptSignature = b2g1CartSignature(cart);
          if (cart.items && cart.items.length && !hasSelectedCode && !window.couponState.b2g1Applying && !window.couponState.b2g1Removing &&
              window.couponState.b2g1LastAttempt !== attemptSignature && window.DiscountHero && window.DiscountHero.discount) {
            window.couponState.b2g1LastAttempt = attemptSignature;
            applyB2G1Promotion().catch(function(error) {
              console.log('[B2G1] Offer remains selected:', error);
            });
          }
        }

        $('#CartDrawer .free-shipping-text').html(manualShippingMessage);
        $('#CartDrawer .drawer__header').removeClass('no-shipping-text');
        $('#CartDrawer .drawer__fixed-header').removeClass('no-shipping-text');

        console.log('[UpdateBar] END (manual coupon mode)');
        return; // DON'T apply Buy More & Save coupons
      }

      // Toggle display modes
      if (subscriptionOnly) {
        console.log('[UpdateBar] MODE: Subscription-Only (Free Shipping Progress)');
        $('#CartDrawer .progress-shipping-mode').show();
        $('#CartDrawer .progress-buymore-mode').hide();
        $('#CartDrawer .progress-unlocks').attr('data-mode', 'shipping');

        // Calculate shipping progress percentage (0-$99 = 0-100%)
        var shippingProgressPercent = Math.min((cart.total_price / 9900) * 100, 100);
        console.log('[UpdateBar] Shipping progress: ' + shippingProgressPercent + '% (cart total: ' + cart.total_price + ')');

        // Use more explicit targeting and attr() to ensure inline style is set
        var $shippingFill = $('#CartDrawer .progress-shipping-mode .progress-container .progress-fill');
        console.log('[UpdateBar] Shipping fill element found:', $shippingFill.length);

        // Set width using attr for more explicit control over inline style
        $shippingFill.attr('style', 'width: ' + shippingProgressPercent + '%');
        console.log('[UpdateBar] Set shipping fill width to:', shippingProgressPercent + '%');

        // Also set via css() as backup
        $shippingFill.css('width', shippingProgressPercent + '%');

        // Free shipping at $99 for subscription-only - put message in .free-shipping-text
        var shippingMessage = '';
        if (cart.total_price >= 9900) {
          shippingMessage = '<p><strong>YOUR ORDER SHIPS FREE, LOAD UP!</strong></p>';
        } else {
          var amountAway = ((9900 - cart.total_price) / 100).toFixed(2);
          shippingMessage = '<p>YOU ARE <strong>$' + amountAway + '</strong> AWAY FROM FREE SHIPPING!</p>';
        }
        $('#CartDrawer .free-shipping-text').html(shippingMessage);
        $('#CartDrawer .drawer__header').removeClass('no-shipping-text');
        $('#CartDrawer .drawer__fixed-header').removeClass('no-shipping-text');

        // Remove any existing BUYMORE coupon
        removeExistingBuyMoreCoupon();
        console.log('[UpdateBar] END (subscription mode)');
        return;
      }

      // Buy More & Save Mode
      console.log('[UpdateBar] MODE: Buy More & Save');
      $('#CartDrawer .progress-shipping-mode').hide();
      $('#CartDrawer .progress-buymore-mode').show();
      $('#CartDrawer .progress-unlocks').attr('data-mode', 'buymore');

      // Calculate progress percentage - align with stage text
      var progressPercent = 0;
      if (oneTimeCount >= 5) {
        progressPercent = 100; // Stage 5
      } else if (oneTimeCount >= 4) {
        progressPercent = 71;  // Stage 4
      } else if (oneTimeCount >= 3) {
        progressPercent = 47;  // Stage 3
      } else if (oneTimeCount >= 2) {
        progressPercent = 23;  // Stage 2
      } else if (oneTimeCount >= 1) {
        progressPercent = 5;   // Stage 1 (Level Up)
      }
      $('#CartDrawer .progress-buymore-mode .progress-fill').css('width', progressPercent + '%');

      // Update active stages
      $('#CartDrawer .progress-buymore-mode .progress li').removeClass('active done');

      if (oneTimeCount >= 5) {
        $('#CartDrawer .progress-buymore-mode .progress li:nth-child(1)').addClass('done');
        $('#CartDrawer .progress-buymore-mode .progress li:nth-child(2)').addClass('done');
        $('#CartDrawer .progress-buymore-mode .progress li:nth-child(3)').addClass('done');
        $('#CartDrawer .progress-buymore-mode .progress li:nth-child(4)').addClass('done');
        $('#CartDrawer .progress-buymore-mode .progress li:nth-child(5)').addClass('active');
      } else if (oneTimeCount >= 4) {
        $('#CartDrawer .progress-buymore-mode .progress li:nth-child(1)').addClass('done');
        $('#CartDrawer .progress-buymore-mode .progress li:nth-child(2)').addClass('done');
        $('#CartDrawer .progress-buymore-mode .progress li:nth-child(3)').addClass('done');
        $('#CartDrawer .progress-buymore-mode .progress li:nth-child(4)').addClass('active');
      } else if (oneTimeCount >= 3) {
        $('#CartDrawer .progress-buymore-mode .progress li:nth-child(1)').addClass('done');
        $('#CartDrawer .progress-buymore-mode .progress li:nth-child(2)').addClass('done');
        $('#CartDrawer .progress-buymore-mode .progress li:nth-child(3)').addClass('active');
      } else if (oneTimeCount >= 2) {
        $('#CartDrawer .progress-buymore-mode .progress li:nth-child(1)').addClass('done');
        $('#CartDrawer .progress-buymore-mode .progress li:nth-child(2)').addClass('active');
      } else {
        $('#CartDrawer .progress-buymore-mode .progress li:nth-child(1)').addClass('active');
      }

      // Update text message
      updateBuyMoreText(oneTimeCount, cart.total_price);

      // Apply/remove coupon based on count
      applyBuyMoreCoupon(oneTimeCount);

      console.log('[UpdateBar] END (buymore mode)');
    }

    // Debounced updateBar wrapper - prevents rapid successive calls
    function updateBar(cart) {
      // Clear any pending debounce timer
      if (updateBarDebounceTimer) {
        clearTimeout(updateBarDebounceTimer);
      }

      // Debounce by 150ms to batch rapid calls
      updateBarDebounceTimer = setTimeout(function() {
        console.log('[UpdateBar] Processing (debounced)...');
        updateBarCore(cart);
      }, 150);
    }// updateBar()

    // DEBUG: Expose cart state for console testing
    // Open tabs must restore ordinary coupons and messaging when EBF ends.
    function refreshBuyMoreCampaign() {
      return waitForBuyMoreIdle().then(function() {
        lastProcessedCartState = null;
        theme.cart.invalidateCache();
        return theme.cart.getCart();
      }).then(function(cart) {
        updateBarCore(cart);
        if (document.querySelector('.cart-page-progress')) updateCartPageProgress();
      }).catch(function(error) {
        console.log('[BuyMore] Campaign refresh failed:', error);
      });
    }
    document.addEventListener('ath:buy-more-change', refreshBuyMoreCampaign);

    // Usage: window.debugBuyMore() in browser console
    window.debugBuyMore = function() {
      console.log('=== BUY MORE & SAVE DEBUG ===');
      console.log('currentBuyMoreCoupon:', currentBuyMoreCoupon);
      console.log('isProcessingBuyMore:', isProcessingBuyMore);
      console.log('lastProcessedCartState:', lastProcessedCartState);

      // Fetch current cart and analyze (use cached version to avoid 429)
      theme.cart.getCart().then(function(cart) {
        var oneTimeCount = 0;
        var subCount = 0;
        cart.items.forEach(function(item) {
          if (item.selling_plan_allocation) {
            subCount += item.quantity;
          } else {
            oneTimeCount += item.quantity;
          }
        });

        var expectedCoupon = buyMore.coupon(oneTimeCount);
        console.log('--- Cart Analysis ---');
        console.log('Total items:', cart.item_count);
        console.log('One-time items:', oneTimeCount);
        console.log('Subscription items:', subCount);
        console.log('Cart total:', '$' + (cart.total_price / 100).toFixed(2));
        console.log('Expected coupon:', expectedCoupon);
        console.log('Subscription-only cart:', subCount > 0 && oneTimeCount === 0);
        console.log('--- DOM State ---');
        console.log('Progress mode attr:', $('.progress-unlocks').attr('data-mode'));
        console.log('Shipping mode visible:', $('.progress-shipping-mode').is(':visible'));
        console.log('Buymore mode visible:', $('.progress-buymore-mode').is(':visible'));
        console.log('Shipping fill width:', $('.progress-shipping-mode .progress-fill').css('width'));
        console.log('Buymore fill width:', $('.progress-buymore-mode .progress-fill').css('width'));
        console.log('Active progress step:', $('.progress-buymore-mode .progress li.active').index() + 1);
        console.log('=========================');
      });
    };

    // DEBUG: Cart drawer key state - call window.debugCartKeys() in console
    window.debugCartKeys = function() {
      console.log('=== CART DRAWER KEY DEBUG ===');
      console.log('Fetching fresh cart data...');
      theme.cart.invalidateCache();
      theme.cart.getCart().then(function(cart) {
        console.log('');
        console.log('API Cart State (' + cart.items.length + ' items):');
        console.log('─'.repeat(80));
        cart.items.forEach(function(item, index) {
          console.log('  Line ' + (index + 1) + ': ' + item.title.substring(0, 35).padEnd(35) + ' | variant: ' + item.variant_id + ' | key: ' + item.key.substring(0, 30) + '...');
        });

        console.log('');
        console.log('DOM State (.ajaxcart__item elements):');
        console.log('─'.repeat(80));
        var domItems = [];
        $('.ajaxcart__item').each(function(i) {
          var $el = $(this);
          var domLine = $el.attr('data-line');
          var domVariant = $el.attr('data-id');
          var domKey = $el.attr('data-key');
          domItems.push({ line: domLine, variant: domVariant, key: domKey });
          console.log('  Line ' + domLine + ': variant: ' + domVariant + ' | key: ' + (domKey ? domKey.substring(0, 30) + '...' : 'MISSING'));
        });

        console.log('');
        console.log('Key Comparison (DOM vs API):');
        console.log('─'.repeat(80));
        var issues = 0;
        domItems.forEach(function(domItem) {
          var lineIndex = parseInt(domItem.line) - 1;
          var apiItem = cart.items[lineIndex];
          if (apiItem) {
            var match = domItem.key === apiItem.key;
            var variantMatch = String(domItem.variant) === String(apiItem.variant_id);
            if (!match || !variantMatch) {
              issues++;
              console.log('  ⚠️  Line ' + domItem.line + ': KEY MISMATCH!');
              console.log('       DOM key: ' + (domItem.key ? domItem.key.substring(0, 40) : 'none'));
              console.log('       API key: ' + apiItem.key.substring(0, 40));
              console.log('       Variant match: ' + variantMatch);
            } else {
              console.log('  ✓  Line ' + domItem.line + ': Keys match');
            }
          } else {
            issues++;
            console.log('  ⚠️  Line ' + domItem.line + ': No API item at this index!');
          }
        });

        console.log('');
        if (issues === 0) {
          console.log('✅ All keys are in sync!');
        } else {
          console.log('❌ Found ' + issues + ' key mismatches - this can cause 400 errors!');
        }
        console.log('=========================');
      });
    };

    // cart page find free item
    var findItemNode = function(id) {
     var lineNodes = document.querySelectorAll('.cartItem');
     var cartItem = null;
     for (var i = 0; lineNodes.length > i; i++) {
       var lineNode = lineNodes[i].querySelector('[data-variant*="' + id + '"]');
       if (lineNode) {
         cartItem = lineNode.closest('.cartItem');  
       }
     }
     return cartItem;
    }

    // cart page remove free item
    var removeFreeItem = function(variant) {
      console.log('...attempting to remove free item from cart page');
      var cartItem = findItemNode(variant);
      if (cartItem) {
        console.log('removing matched item... ', cartItem);
        cartItem.remove();
        console.log('success! removed matched item... ', cartItem);
      }
    }

  var findPriceNode = function(line, key) {
     var priceNode = $('.ajaxcart__item[data-key="' + key + '"]').find('.ajaxcart__price').first();
     return priceNode;
  }
  
  var setItemDiscounts = function() {
     console.log('[setItemDiscounts] START - fetching cart to update keys...');
     theme.cart.getCart().then(function(cartData){
       if (!cartData || !cartData.items || cartData.items.length == 0) {
         console.log('[setItemDiscounts] Cart is empty or undefined, skipping');
         return
       }
       console.log('[setItemDiscounts] Updating keys for', cartData.items.length, 'items:');
       //subscription product key not getting updated
       $.each(cartData.items, function(index, cItem){
         var line = parseInt(index)+1;
         var $element = $(".ajaxcart__item[data-line='" + line + "']");
         var oldKey = $element.attr('data-key');
         $element.attr('data-key', cItem.key);
         console.log('[setItemDiscounts]   Line', line, ':', cItem.title.substring(0, 30), '| oldKey:', oldKey ? oldKey.substring(0, 20) + '...' : 'none', '| newKey:', cItem.key.substring(0, 20) + '...', '| changed?', oldKey !== cItem.key);
       });
       console.log('[setItemDiscounts] COMPLETE - all keys updated');
    });
  }

  var setProductKey = function() {
    console.log('***1200 ran setProductKey');
    theme.cart.getCart().then(function(cart){
      $.each(cart.items, function(index, cItem){
        var line = parseInt(index) + 1;
        $(".ajaxcart__item[data-line='" +line + "'] > div > input").attr('data-key', cItem.key);
      });
    });
  }

  function updateCartItemLines(){
    console.log('***1210 ran updateCartItemLines');
    theme.cart.getCart().then(function(cart){
      $.each(cart.items, function(index, cItem){
        var line = parseInt(index) + 1;
        $(".ajaxcart__item[data-key='" + cItem.key + "'] > div > input").attr('data-line', line);
      });
    });
  }
  
  window.addEventListener('sc:discount.remove', (event) => {
    event.stopPropagation();
    
    if(window.location.href.indexOf('/cart') > -1){
      $('body').trigger('ajaxCartUpdated');
    } 
  });

  window.addEventListener('sc:discount.init', (event) => {
    event.stopPropagation();
    $('input.sc-cube-text[name="code"]').attr('placeholder', 'Enter coupon');
  })

  const handleDiscountCalculated = $.debounce(250, function(event) {
    console.log('[event start] sc:discount.calculated trigger calculated.ajaxProduct');
    event.stopPropagation();
    
    setTimeout(function() {
      if (sessionStorage.getItem('scDiscountData')) {
        var rawData = sessionStorage.getItem('scDiscountData');
        var scDiscountData = $.parseJSON(rawData);
        if (scDiscountData['discounts'].length > 0) {
          $('input[name="code"]').prop('disabled', true);
          $('input.sc-cube-text').addClass('no-placeholder');
        } else {
          $('input[name="code"]').prop('disabled', false);
          $('input.sc-cube-text').removeClass('no-placeholder');
        }
      }
    }, 1000);
    $('body').trigger('calculated.ajaxProduct');
    if(window.location.href.indexOf('/cart') > -1){
      $('body').trigger('ajaxCartUpdated');
    } 
  });
  
  window.addEventListener('sc:discount.calculated', handleDiscountCalculated);
  
  // burn page exit intent 8/8/23
  function identifyProfileBurn(result) {
      console.log('klaviyoIdentify for Burn Exit ran');
      if (!result){
        console.log('klaviyo profile not found');
        if (!Cookies.get('exitIntentShown')){
          setTimeout(() => {
          document.addEventListener('mouseout', burnExitIntent);
          }, 5000)
        }
      } 
  }
  
  if (window.location.pathname == '/products/natural-fat-burner') {
      console.log('on burn page');
      klaviyo.isIdentified(identifyProfileBurn);
  }
  
  var burnExitIntent = e => {
      var shouldShowExitIntent = 
          !e.toElement &&
          !e.relatedTarget &&
          e.clientY < 10;
      
      if(shouldShowExitIntent){
          document.removeEventListener('mouseout', burnExitIntent);
          // close drawer
          $('body').trigger('closeDrawer');
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'Y8mZsg']);
          Cookies.set('exitIntentShown', 'true', { expires: 3 });
      }
  };

  // pre page exit intent
  function identifyProfilePre(result) {
      console.log('klaviyoIdentify for PRE Exit ran');
      if (!result){
        console.log('klaviyo profile not found');
        if (!Cookies.get('exitIntentShown')){
          setTimeout(() => {
          document.addEventListener('mouseout', preExitIntent);
          }, 5000)
        }
      } 
  }
  
  if (window.location.pathname == '/products/pre') {
      console.log('on pre page');
      klaviyo.isIdentified(identifyProfilePre);
  }
  
  var preExitIntent = e => {
      var shouldShowExitIntent = 
          !e.toElement &&
          !e.relatedTarget &&
          e.clientY < 10;
      
      if(shouldShowExitIntent){
          document.removeEventListener('mouseout', preExitIntent);
          // close drawer
          $('body').trigger('closeDrawer');
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'TmWawM']);
          Cookies.set('exitIntentShown', 'true', { expires: 3 });
      }
  };

  /* sliding-link animation */
  $(".sliding-link").click(function(e) {
    e.preventDefault();
    var aid = $(this).attr("href");
    $('html,body').animate({scrollTop: $(aid).offset().top - 150},'slow');
    console.log('okendo-reviews - 150: ' + $(aid).offset().top);
  });

  /* search page search type */
  if($('#search-type')) {
    $('#search-type').change(function() {
        localStorage.setItem('searchType', this.value);
    });
    if(localStorage.getItem('searchType')){
        $('#search-type').val(localStorage.getItem('searchType'));
    }
  }
  /* site header on click set product */
  $('.search-bar-mobile-button').on('click', function(){
    localStorage.setItem('searchType', "product");
  })

  /* blog on click set article */
  $('.blog-search-submit').on('click', function(){
    localStorage.setItem('searchType', "article");
  })

  /* cart page subscribe and save checkbox listener */
  if($(".cart-page-subscribe-checkbox")){
    $(".cart-page-subscribe-checkbox").on('change', function() {
      var handle = $(this).attr('data-product-handle');
      var sellingPlan;
      var checkbox = $(this);
      var line = $(this).closest('.cartItem').attr('data-line');
      var currentQuantity = $(this).attr('data-quantity');
      var subTotal_priceField = $('.cart__subtotal');
      var lineItem_priceField = $(this).closest('.cartItem_subscription').siblings('.cartItem_align').find('.cartItem_price');
      var lineKey;
      $.getJSON('/products/'+handle+'.js', function(product){
          sellingPlan = product.variants[0].selling_plan_allocations[0].selling_plan_id;
          if(checkbox.is(':checked')){
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
              'line': line,
              'quantity': currentQuantity,
              'selling_plan': sellingPlan
            },
            beforeSend: function(){
              $('.cartItem').append("<div class='cart-loading'></div>");
            },
            success: function(response) {     
              $('.cartItem').find($('.cart-loading')).remove();
              var totalPrice = ((response.total_price)/100).toFixed(2);
              var originalTotalPrice = (response.original_total_price/100).toFixed(2);
              var lineItem_price;
              var comparePrice;
              var items = response.items;
              $.each(items, function(index, item){
                var counter = index + 1;
                if (counter == line){
                  lineItem_price = item['line_price'];
                  comparePrice = item['selling_plan_allocation']['compare_at_price'];
                  lineKey = item['key'];
                  checkbox.closest('.cartItem_subscription').siblings('.cartItem_align').find('input.cart__product-qty').attr('id',lineKey);
                  return
                }  
              });
              var formatted_lineItemPrice = (lineItem_price/100).toFixed(2);
              var formatted_comparePrice = ((comparePrice/100)*currentQuantity).toFixed(2);
              subTotal_priceField.html('<span class="cart__price strong">$' + totalPrice + '</span>');
              lineItem_priceField.html('<span class="cart__price--strikethrough cartDiscount">$'+formatted_comparePrice+'</span><span class="cart__price strong">$'+formatted_lineItemPrice + '</span>');
              checkbox.closest('.cartItem_subscription').siblings('.cartItem_sellingPlan').show();
              updateCartPageProgress();
              $('body').trigger('added.closeDrawer');
            },
            error: function(error){
              console.log(error);
            }
          })// end ajax call
        } else {
          // remove subscription item
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
              'line': line,
              'quantity': currentQuantity,
              'selling_plan': null
            },
            beforeSend: function(){
              $('.cartItem').append("<div class='cart-loading'></div>");
            },
            success: function(response) { 
              var totalPrice = ((response.total_price)/100).toFixed(2);
              var lineItem_price;
              var items = response.items;
              $.each(items, function(index, item){
                var counter = index + 1;
                if (counter == line){
                  lineItem_price = item['line_price'];
                  lineKey = item['key'];
                  checkbox.closest('.cartItem_subscription').siblings('.cartItem_align').find('input.cart__product-qty').attr('id',lineKey);
                  return
                }  
              });
              var formatted_lineItemPrice = (lineItem_price/100).toFixed(2);
              subTotal_priceField.html('<span class="cart__price">$'+ totalPrice + '</span>');
              lineItem_priceField.html('<span class="cart__price">$'+formatted_lineItemPrice+'</span>');
              checkbox.closest('.cartItem_subscription').siblings('.cartItem_sellingPlan').hide();
              $('.cartItem').find($('.cart-loading')).remove();
              updateCartPageProgress();
              $('body').trigger('added.closeDrawer');
            },
            error: function(error){
              console.log(error);
            }
          })
        } //end if checkbox
      }) //getJSON
    }) //onChange  
  }// if checkbox
  
  /* selling plan for cart page */
  if ($('.cartItem_sellingPlan select[name="selling-plan"]')){
    $('.cartItem_sellingPlan select[name="selling-plan"]').on('change', function() {
      var sellingPlan= $(this).val();
      var line = $(this).closest('.cartItem').attr('data-line');
      var currentQuantity = $(this).closest('.cartItem_sellingPlan select[name="selling-plan"]').attr('data-quantity');
      var selected = $(this);
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
          'line': line,
          'quantity': currentQuantity,
          'selling_plan': sellingPlan
        },
        beforeSend: function(){
          $('.cartItem').append("<div class='cart-loading'></div>");
        },
        success: function(response) {
          var items = response.items;
          $.each(items, function(index, item){
            var counter = index + 1;
            if (counter === line){
              lineKey = item['key'];
              selected.closest('.cartItem_sellingPlan').siblings('.cartItem_align').find('input.cart__product-qty').attr('id',lineKey);
            }  
          });
          $('.cartItem').find($('.cart-loading')).remove();
          selected.prop('selected', true);
          $('body').trigger('added.closeDrawer');
        },
        error: function(error){
          console.log(error);
        }
      })// end ajax call
    })
  }

  function updateCartPageProgress() {
    console.log('[updateCartPageProgress] Buy More & Save mode');
    theme.cart.getCart().then(function(cart){
      var oneTimeData = countOneTimeItems(cart);
      var oneTimeCount = oneTimeData.count;
      var subscriptionOnly = hasOnlySubscriptionItems(cart);

      console.log('[updateCartPageProgress] oneTimeCount:', oneTimeCount, 'subscriptionOnly:', subscriptionOnly);

      // Hide old free gift offer elements (deprecated)
      $('#free_gift_offer').hide();
      $('#cart_gift_offer').hide();
      $('#free_multi_offer').hide();
      $('#cart_multi_offer').hide();

      // Toggle display modes
      if (subscriptionOnly) {
        $('.cart-page-progress .progress-shipping-mode').show();
        $('.cart-page-progress .progress-buymore-mode').hide();
        $('.cart-page-progress').attr('data-mode', 'shipping');

        // Calculate shipping progress percentage (0-$99 = 0-100%)
        var shippingProgressPercent = Math.min((cart.total_price / 9900) * 100, 100);
        console.log('[updateCartPageProgress] Shipping progress: ' + shippingProgressPercent + '%');

        // Use explicit targeting and attr() to ensure inline style is set
        var $cartPageShippingFill = $('.cart-page-progress .progress-shipping-mode .progress-container .progress-fill');
        console.log('[updateCartPageProgress] Shipping fill element found:', $cartPageShippingFill.length);
        $cartPageShippingFill.attr('style', 'width: ' + shippingProgressPercent + '%');
        $cartPageShippingFill.css('width', shippingProgressPercent + '%');

        // Free shipping at $99 for subscription-only
        if (cart.total_price >= 9900) {
          $('.cart-page-progress .subscription-shipping-text').html('<strong>YOUR ORDER SHIPS FREE, LOAD UP!</strong>');
        } else {
          var amountAway = ((9900 - cart.total_price) / 100).toFixed(2);
          $('.cart-page-progress .subscription-shipping-text').html('You are <strong>$' + amountAway + '</strong> away from FREE shipping!');
        }

        // Remove any existing BUYMORE coupon
        removeExistingBuyMoreCoupon();
        return;
      }

      // Buy More & Save Mode
      $('.cart-page-progress .progress-shipping-mode').hide();
      $('.cart-page-progress .progress-buymore-mode').show();
      $('.cart-page-progress').attr('data-mode', 'buymore');

      // Calculate progress percentage - align with cart page stage positions
      var progressPercent = 0;
      if (oneTimeCount >= 5) {
        progressPercent = 100; // Stage 5
      } else if (oneTimeCount >= 4) {
        progressPercent = 67;  // Stage 4
      } else if (oneTimeCount >= 3) {
        progressPercent = 48;  // Stage 3
      } else if (oneTimeCount >= 2) {
        progressPercent = 28;  // Stage 2
      } else if (oneTimeCount >= 1) {
        progressPercent = 5;   // Stage 1 (Level Up)
      }
      console.log('[updateCartPageProgress] Setting buymore progress to: ' + progressPercent + '%');
      var $cartPageBuymoreProgressFill = $('.cart-page-progress .cart-page-buymore-progress-container .progress-fill');
      console.log('[updateCartPageProgress] Buymore fill element found:', $cartPageBuymoreProgressFill.length);
      $cartPageBuymoreProgressFill.attr('style', 'width: ' + progressPercent + '%');
      $cartPageBuymoreProgressFill.css('width', progressPercent + '%');

      // Update active stages
      $('.cart-page-progress .progress li').removeClass('active done');

      if (oneTimeCount >= 5) {
        $('.cart-page-progress .progress li:nth-child(1)').addClass('done');
        $('.cart-page-progress .progress li:nth-child(2)').addClass('done');
        $('.cart-page-progress .progress li:nth-child(3)').addClass('done');
        $('.cart-page-progress .progress li:nth-child(4)').addClass('done');
        $('.cart-page-progress .progress li:nth-child(5)').addClass('active');
      } else if (oneTimeCount >= 4) {
        $('.cart-page-progress .progress li:nth-child(1)').addClass('done');
        $('.cart-page-progress .progress li:nth-child(2)').addClass('done');
        $('.cart-page-progress .progress li:nth-child(3)').addClass('done');
        $('.cart-page-progress .progress li:nth-child(4)').addClass('active');
      } else if (oneTimeCount >= 3) {
        $('.cart-page-progress .progress li:nth-child(1)').addClass('done');
        $('.cart-page-progress .progress li:nth-child(2)').addClass('done');
        $('.cart-page-progress .progress li:nth-child(3)').addClass('active');
      } else if (oneTimeCount >= 2) {
        $('.cart-page-progress .progress li:nth-child(1)').addClass('done');
        $('.cart-page-progress .progress li:nth-child(2)').addClass('active');
      } else {
        $('.cart-page-progress .progress li:nth-child(1)').addClass('active');
      }

      // Update text message for cart page
      var $text = $('.cart-page-free-shipping-text');
      var message = '';

      message = buyMore.message(oneTimeCount, cart.total_price);

      $text.html('<p>' + message + '</p>');

      // Apply/remove coupon based on count
      applyBuyMoreCoupon(oneTimeCount);
    }) // getCart callback
  } //updateCartPageProgress() function

  if(window.location.href.indexOf("/cart") > -1){
    
    var findCartPagePriceNode = function(key) {
     var priceNode = $('.cartItem[data-key="' + key + '"]').find('.cartItem_price').first();
     return priceNode;
    }
  
   function cartPageSetItemDiscounts() {
     console.log('[event start] 1860 cartPageSetItemDiscounts');
     theme.cart.getCart().then(function(cartData){
     var discountData = JSON.parse(sessionStorage.getItem('scDiscountData'));
     var subscriptions = [];
     var hasSubscription = false;
     if (cartData != null) {
       if (cartData.items != null){
         cartData.items.map(function(item){
           if(item.selling_plan_allocation){
             subscriptions.push(item.variant_id);
           }
         })
       }
     }
     $.each(cartData.items, function(index, cItem){
       var line = parseInt(index)+1;
       $(".cartItem[data-line='" + line + "']").attr('data-key', cItem.key);
     })
       
     if (discountData != null) {
         if (discountData.stage) {
           var discountType;
           var discountValue;
           var discountTitle;
           var discountApplicationType;
      
           if (discountData != null && discountData.discount != null) {
             if (discountData.discount.applicationType == 'automatic') {
                discountApplicationType = discountData.discount.applicationType;
                discountType = discountData.discount.type;
                discountValue = discountData.discount.value;
                discountTitle = discountData.discount.title;
             }
           }
           
           if (cartData && cartData.items) {
             cartData.items.map(function(item, index) {
               var id = item.variant_id;
               var line = parseInt(index)+1;
               var key = item.key;
               var quantity = item.quantity;
               var price = item.price;
               var discounts = item.discounts;
               var oldPrice = (item.original_line_price/100).toFixed(2);
               if (price == 0.00){
                 return
               }
               var returnNow = false;
               if (item.selling_plan_allocation != null || item.product_id == '7500717457584') {
                 returnNow = true;
               }
               if (returnNow) {
                 return
               }
               var priceNode = findCartPagePriceNode(key);

               if (priceNode){
                 if (typeof discountApplicationType != 'undefined'){
                   if (discountApplicationType == 'automatic') {
                     if (discountType == 'percentage') {
                       $(".discounted").hide();
                       var newPrice = Shopify.scFormatMoney(parseFloat(oldPrice * ((100-discountValue)/10000)).toFixed(2));
                       console.log('newPrice 2298: ', newPrice);
                       if (newPrice == '$0.00'){
                         newPrice = 'FREE'
                       }
                       priceNode.html('<span class="cart__price--strikethrough cartDiscount"">' + Shopify.scFormatMoney(oldPrice) + '</span></s><span class="cart__price strong">' + Shopify.scFormatMoney(newPrice) + '</span>');
                     } else {
                       console.log('line 1121, needs added discountType');
                     }
                   }
                 } else if (discounts && discounts.length > 0 && discounts[0].amount > 0 && discounts[0].amount != null) {
                   $(".discounted").hide();
                   // final_line_price only working with product discounts, updated to line_price
                   var newPrice = Shopify.scFormatMoney((item.line_price/100).toFixed(2));
                   if (newPrice == '$0.00'){
                     newPrice = 'FREE'
                   }
                   priceNode.html('<span class="cart__price--strikethrough cartDiscount">' + Shopify.scFormatMoney(oldPrice) + '</span></s><span class="cart__price strong">' + newPrice + '</span>');
                 } else {
                   $(".discounted").hide();
                   $('.ajaxcart__savings').remove();
                   priceNode.html('<span class="money">' + Shopify.scFormatMoney(oldPrice) + '</span>');
                 }
               } else {
                 console.log('1107 priceNode not found');
               }
             });
           }
         } 
     }
       
     if (cartData.original_total_price != cartData.total_price ){
     // discounted subtotal
     $('.cart__subtotal').html('<span class="cart__price--strikethrough cartDiscount">' + Shopify.scFormatMoney((cartData.original_total_price/100).toFixed(2)) + '</span><span class="cart__price strong">' + Shopify.scFormatMoney((cartData.total_price/100).toFixed(2)) + '</span>')
     } else {
     // non-discount
     $('.cart__subtotal .cartDiscount').remove(); 
     $('.cart__subtotal').html('<span class="cart__price">' + Shopify.scFormatMoney((cartData.total_price/100).toFixed(2)) + '</span>');
     }
     
   }); // end cartData ajax
 };

  function cartPageSetProductKey(){
    theme.cart.getCart().then(function(cart){
      var cartItems = cart.items;
      //update key
      $.each(cartItems, function(index, cItem){
        var line = parseInt(index) + 1;
        $(".cartItem[data-line='" + line + "']").attr('data-key', cItem.key);
      });
    })
  }
  
  function cartPageRemoveDiscounts() {
      console.log('[event start] 1920 cartPageremoveDiscounts');
      var data = JSON.parse(sessionStorage.getItem('scDiscountData'));
      if (data && data.items) {
       data.items.map(function(item) {
         var id = item.variantId;
         var quantity = item.quantity;
         var price = item.price;
         var priceNode = findCartPagePriceNode(id);
         var calculatedPrice = price * quantity;
         if (priceNode != null) {
           priceNode.innerHTML = '<span class="money">' + Shopify.scFormatMoney(calculatedPrice*100) + '</span>';
         }
       });
      }
      if(data.subtotal){
        $('.cart__subtotal').text('$'+data.subtotal)      
      }
      $('.cart__savings').hide();
    }
  
    window.addEventListener('sc:discount.init', (event) => {
      console.log('[event start] 1949 cart page sc:discount.init...');
      event.stopPropagation();
      //cartPageSetItemDiscounts();
    });
  
    window.addEventListener('sc:discount.remove', (event) => {
      console.log('[event start] 1955 cart page sc:discount.remove...');
      event.stopPropagation();
      //cartPageSetItemDiscounts();
      //cartPageRemoveDiscounts();
      //setTimeout(cartPageSetProductKey, 600);
    });
    
    window.addEventListener('sc:discount.calculated', (event) => {
      console.log('[event start] 1961 cart page sc:discount.calculated...');
      event.stopPropagation();
      cartPageSetItemDiscounts();
      setTimeout(cartPageSetProductKey, 600);
    });

    // Initialize cart page progress bar on load (wait for theme.cart to be ready)
    $(document).ready(function() {
      // Small delay to ensure theme.cart is initialized
      setTimeout(function() {
        if (typeof theme !== 'undefined' && theme.cart && typeof theme.cart.getCart === 'function') {
          console.log('[Cart Page] Initializing progress bar on load');
          updateCartPageProgress();
        } else {
          console.log('[Cart Page] theme.cart not ready, retrying...');
          setTimeout(function() {
            if (typeof theme !== 'undefined' && theme.cart && typeof theme.cart.getCart === 'function') {
              updateCartPageProgress();
            }
          }, 500);
        }
      }, 100);
    });
  }

  /* cart page keep synced with ajax cart commenting out this 12-10-25 */
  if(window.location.href.indexOf("/cart") > -1){
    $('body').on('ajaxCartUpdated', function(event, cart) {
      //reload page if ajaxCartUpdated
      //location.reload();
    })
  }
  
  /* cart page trash */
  var trashClickInProgress = false;
  $('.cartItem_trash').on('click', function(e){
    e.preventDefault();

    // Prevent double-clicks
    if (trashClickInProgress) {
      console.log('[Cart Page Trash] Click already in progress, ignoring');
      return;
    }
    trashClickInProgress = true;

    var cartItem = $(this).closest('.cartItem');
    var variantId = $(this).attr('data-variant');
    var subTotal_priceField = $('.cart__subtotal');
    var comparePrice;
    if(sessionStorage.getItem('scDiscountData')){
      var rawData = sessionStorage.getItem('scDiscountData');
      var scDiscountData = $.parseJSON(rawData);
      code = scDiscountData['code'];
    }
    var lineKey = $(this).closest('.cartItem').attr('data-key');
    var line = $(this).closest('.cartItem').attr('data-line');

    // Invalidate cart cache before fetching fresh data
    theme.cart.invalidateCache();
    
    var trashGift = false;
    if (variantId == 44048170057904 || variantId == 44048170090672 || variantId == 44841756983472) {
      trashGift = true;
    }
    var has_free_gift = 0;
    var regular_item = 0;
    theme.cart.getCart().then((cart) => {
      $.each(cart.items, function(index, item){
        if (item.id == 43194932592816 || item.id == 44841756983472 || item.id == 44048170057904 || item.id == 44048170090672){
          has_free_gift += 1;
        } else {
          regular_item += 1;
        }
      });
      
      // 1 item in cart + discount - shipping protection * working
      if(regular_item == 1 && code != null && trashGift == false){
        $('.cartItem').append("<div class='cart-loading'></div>");
        window.DiscountHero.discount.remove().then(function(){
          $.ajax ({
            type: "POST",
            url: '/cart/change.js',
            dataType: 'json',
            data: {
               id: lineKey,
               quantity : 0,
            },
            beforeSend: function() {
              $('#CartDrawer').append("<div class='cart-loading'></div>");
            },
            success: function(cart) {
              theme.cart.invalidateCache();
              location.reload();
            },
            error: function(xhr, status, error) {
              console.log('[Cart Page Trash] Error:', error);
              trashClickInProgress = false;
              theme.cart.invalidateCache();
              // 400 means item already removed, just reload
              if (xhr.status === 400) {
                location.reload();
              }
            }
          })
        })
        // 1 cart item - discount and + or - shipping protection * working
      } else if (regular_item == 1 && code == null && trashGift == false) {
        $('.cartItem').append("<div class='cart-loading'></div>");
        clearCart().then(setTimeout(function(){location.reload()}, 250));
      } else if (regular_item > 1) {
        console.log('line 2142 regular_item > 1: ', regular_item);
        $.ajax ({
          type: "POST",
          url: window.Shopify.routes.root + 'cart/change.js',
          dataType: 'json',
          data: {
             id: lineKey,
             quantity : 0,
          },
          beforeSend: function() {
            $('.cartItem').append("<div class='cart-loading'></div>");
          },
          success: function(cart) {
            theme.cart.invalidateCache();
            trashClickInProgress = false;
            if(regular_item == 0) {
              removeExistingBuyMoreCoupon();
              window.location.reload();
            } else {
              var cartItems = cart.items;
              //update keys
              $.each(cartItems, function(index, cItem){
                var line = parseInt(index)+1;
                $(".cartItem[data-key='" + cItem.key + "']").attr('data-line', line);
                $(".ajaxcart__item[data-key='" + cItem.key + "']").attr('data-line', line);
              });
              $('.cartItem').find($('.cart-loading')).remove();
              cartItem.remove();
              calculateFSB();
              // Update Buy More & Save coupon
              updateBar(cart);
              updateCartPageProgress();
              var totalPrice = ((cart.total_price)/100).toFixed(2);
              subTotal_priceField.html('$'+totalPrice);
              $('body').trigger('added.closeDrawer');
            }
          },
          error: function(xhr, status, error) {
            console.log('[Cart Page Trash] Error:', error);
            trashClickInProgress = false;
            theme.cart.invalidateCache();
            if (xhr.status === 400) {
              location.reload();
            }
          }
        })
      } else {
        console.log('else line 2187');
        $.ajax ({
          type: "POST",
          url: window.Shopify.routes.root + 'cart/change.js',
          dataType: 'json',
          data: {
             id: lineKey,
             quantity : 0,
          },
          beforeSend: function() {
            $('.cartItem').append("<div class='cart-loading'></div>");
          },
          success: function(cart) {
            theme.cart.invalidateCache();
            trashClickInProgress = false;
            if(regular_item == 0) {
              removeExistingBuyMoreCoupon();
              window.location.reload();
            } else {
              var cartItems = cart.items;
              //update lines for cartItem
              $.each(cartItems, function(index, cItem){
                var line = parseInt(index)+1;
                $(".cartItem[data-key='" + cItem.key + "']").attr('data-line', line);
                $(".ajaxcart__item[data-key='" + cItem.key + "']").attr('data-line', line);
              });
              $('.cartItem').find($('.cart-loading')).remove();
              cartItem.remove();
              calculateFSB();
              // Update Buy More & Save coupon
              updateBar(cart);
              updateCartPageProgress();
              var totalPrice = ((cart.total_price)/100).toFixed(2);
              subTotal_priceField.html('$'+totalPrice);
              $('body').trigger('added.closeDrawer');
            }
          },
          error: function(xhr, status, error) {
            console.log('[Cart Page Trash] Error:', error);
            trashClickInProgress = false;
            theme.cart.invalidateCache();
            if (xhr.status === 400) {
              location.reload();
            }
          }
        })
      }
    }) // end getCart
  }); // end cart page trash can listener
  
  /* cart page minus qty listener */
  $('.cart-minus').on('click', function(event){
    event.stopPropagation();
    var cartItem = $(this).closest('.cartItem');
    var inputField = $(this).siblings('.cart__product-qty')[0];
    var currentValue = parseInt(inputField.value);
    var lineKey = $(cartItem).attr('data-key');
    var line = $(cartItem).attr('data-line');
    var quantityField = $(this).closest('.cartItem_quantity');
    var lineItem_priceField = $(quantityField).siblings('.cartItem_price');
    var subTotal_priceField = $('.cart__subtotal');
    var comparePrice;
    let variantId = $(inputField).data('variant-id');

    console.log('[event start] cart-minus click lineKey: '+ lineKey + ' line: ' + line);

    if (currentValue > 1) {
      var result = currentValue - 1;
      $.ajax ({
        type: "POST",
        url: window.Shopify.routes.root + 'cart/change.js',
        dataType: 'json',
        data: {
           id: lineKey,
           quantity : result,
        },
        beforeSend: function() {
          $('.cartItem').append("<div class='cart-loading'></div>");
        },
        success: function(cart) {
          inputField.value = result;
          $('.cartItem').find($('.cart-loading')).remove();
          var totalPrice = ((cart.total_price)/100).toFixed(2);
          var lineItem_price;
          var items = cart.items;

          $(cartItem).one('keyUpdated-minus', function(e){
            e.stopPropagation();
            var newLineKey = $(cartItem).attr('data-key');

            $.each(items, function(index, item){
              if (item.key == newLineKey){
                lineItem_price = item.line_price;
                if (item['selling_plan_allocation']){
                  comparePrice = item['selling_plan_allocation']['compare_at_price'];
                }
                return
              }
            });
            var formatted_lineItemPrice = (lineItem_price/100).toFixed(2);
            var formatted_comparePrice = ((comparePrice/100)*result).toFixed(2);
            subTotal_priceField.html('$'+totalPrice);
            quantityField.closest('.cartItem_align').siblings('.cartItem_subscription').find('input[name="cart-page-subscribe-checkbox"]').data('quantity', result);
            if (comparePrice != null){
              lineItem_priceField.html('<span class="cart__price--strikethrough cartDiscount"><s>$'+formatted_comparePrice+'</s></span><span class="cart__price strong">$'+formatted_lineItemPrice+'</span>');
            } else {
              lineItem_priceField.html('<span class="cart__price">$'+formatted_lineItemPrice+'</span>');
            }
            $('body').trigger('added.closeDrawer');
          })

          // Update line numbers and keys based on current cart state
          $.each(cart.items, function(index, item){
            if (item.variant_id == 43285849637040){
              return
            }
            var newLine = parseInt(index) + 1;
            // Update by key (more reliable) and set new line number
            var $item = $('.cartItem[data-key="' + item.key + '"]');
            if ($item.length) {
              $item.attr('data-line', newLine).trigger('keyUpdated-minus');
            }
          });

          // Update Buy More & Save coupon
          updateBar(cart);
          updateCartPageProgress();
        }
      })
    // remove coupon as well
    } else {
      $.ajax ({
        type: "POST",
        url: window.Shopify.routes.root + 'cart/change.js',
        dataType: 'json',
        data: {
           id: lineKey,
           quantity : 0,
        },
        beforeSend: function() {
          $('.cartItem').append("<div class='cart-loading'></div>");
        },
        success: function(cart) {
          if (cart.items.length > 0){
            $('.cartItem').find($('.cart-loading')).remove();
            cartItem.remove();
            var totalPrice = ((cart.total_price)/100).toFixed(2);
            subTotal_priceField.html('$'+totalPrice);
            // Update line numbers after removal
            $.each(cart.items, function(index, item){
              var newLine = parseInt(index) + 1;
              $('.cartItem[data-key="' + item.key + '"]').attr('data-line', newLine);
            });
            // Update Buy More & Save coupon
            updateBar(cart);
            updateCartPageProgress();
            $('body').trigger('added.closeDrawer');
          } else {
            // Remove coupon before reloading
            removeExistingBuyMoreCoupon();
            console.log('reload page');
            window.location.reload();
          }
        }
      })
    }
  });

  /* cart page qty plus listener */
  $('.cart-plus').on('click', function(event){
    event.stopPropagation();
    var cartItem = $(this).closest('.cartItem');
    var inputField = $(this).siblings('.cart__product-qty')[0];
    var currentValue = parseInt(inputField.value);
    var lineKey = $(cartItem).attr('data-key');
    var line = $(cartItem).attr('data-line');
    var quantityField = $(this).closest('.cartItem_quantity');
    var lineItem_priceField = $(quantityField).siblings('.cartItem_price');
    var subTotal_priceField = $('.cart__subtotal');
    var comparePrice;
    
    console.log('[event start] cart-plus click, lineKey: ', lineKey, 'currentValue', currentValue);

    if (currentValue > 0) {
      var result = currentValue + 1;
      $.ajax ({
        type: "POST",
        url: window.Shopify.routes.root + 'cart/change.js',
        dataType: 'json',
        data: {
           id: lineKey,
           quantity : result,
        },
        beforeSend: function() {
          $('.cartItem').append("<div class='cart-loading'></div>");
        },
        success: function(cart) {
          inputField.value = result;
          $('.cartItem').find($('.cart-loading')).remove();
          var totalPrice = ((cart.total_price)/100).toFixed(2);
          var lineItem_price;
          var items = cart.items;
          
          $(cartItem).one('keyUpdated-plus', function(e){
            e.stopPropagation();
            var newLineKey = $(cartItem).attr('data-key');
            $.each(items, function(index, item){
              if (item.key == newLineKey){
                lineItem_price = item.line_price;
                if (item['selling_plan_allocation']){
                  comparePrice = item['selling_plan_allocation']['compare_at_price'];  
                }
                return
              }  
            })
            var formatted_lineItemPrice = (lineItem_price/100).toFixed(2);
            var formatted_comparePrice = ((comparePrice/100)*result).toFixed(2);
            subTotal_priceField.html('$'+totalPrice);
            quantityField.closest('.cartItem_align').siblings('.cartItem_subscription').find('input[name="cart-page-subscribe-checkbox"]').data('quantity', result);
            if (comparePrice != null){
              lineItem_priceField.html('<span class="cart__price--strikethrough cartDiscount"><s>$'+formatted_comparePrice+'</s></span><span class="cart__price strong">$'+formatted_lineItemPrice+'</span>');
            } else {
              lineItem_priceField.html('<span class="cart__price">$'+formatted_lineItemPrice+'</span>');
            }
            $('body').trigger('added.closeDrawer');
          });

          // Update line numbers and keys based on current cart state
          $.each(cart.items, function(index, item){
            if (item.variant_id == 43285849637040){
              return
            }
            var newLine = parseInt(index) + 1;
            // Update by key (more reliable) and set new line number
            var $item = $('.cartItem[data-key="' + item.key + '"]');
            if ($item.length) {
              $item.attr('data-line', newLine).trigger('keyUpdated-plus');
            }
          });

          // Update Buy More & Save coupon
          updateBar(cart);
          updateCartPageProgress();
        }
      })
    } else {
      calculateFSB();
    }
  });

  /* additional custom code signup form */
  setTimeout(function(){
    if( !$('.klaviyo-form-KQm2J6').is(':empty') ) {
      $('#klaviyo-about-us').css({"padding":"40px 0px","background": "#EFC04C", "display":"block"});
    } else {
      if (window.location.pathname == '/'){
        $('#shopify-section-1552425211591').remove();
      }
    }
  },1000);
  
  // sticky sign up popup theme.liquid/theme.scss.liquid

  function klaviyoIdentify(result) {
    console.log('klaviyoIdentify ran');
    if (!result){
      console.log('klaviyo profile not found');
      $('.sticky-popup').fadeIn(); 
      $(document).off('scroll');  
    } else {
      console.log('klaviyo profile found, disable scroll');
      $(document).off('scroll');
    }
  }

  $(document).on('scroll',function() {
    var y = $(this).scrollTop();
    if (y>300) {
      klaviyo.isIdentified(klaviyoIdentify);
    }
  });
  
  $('.sticky-popup').on('click touchend', function(event){
    event.stopPropagation();
    $(this).fadeOut();
  });
  
  // countdown timer for sitewide sale: products, catalog, homepage, and announcements.
  function makeTimer() {
    var now = Date.now();
    $('[data-prime-day-ends-at]').not('.slick-cloned').each(function() {
      var $promotion = $(this);
      var deadline = Date.parse($promotion.attr('data-prime-day-ends-at'));
      if (!isFinite(deadline)) return;
      var timeLeft = Math.ceil((deadline - now) / 1000);

      if (timeLeft <= 0) {
        var $slider = $promotion.closest('.announcement-slider');
        var $bar = $promotion.closest('.announcement-bar');
        if ($slider.hasClass('slick-initialized')) {
          var visibleSlides = $slider.slick('getSlick').options.slidesToShow;
          $slider.slick('slickRemove', Number($promotion.attr('data-slick-index')));
          var slideCount = $slider.slick('getSlick').slideCount;
          $slider.data('block-count', slideCount).attr('data-block-count', slideCount);
          if (slideCount > 0) {
            $slider.slick('slickSetOption', 'slidesToShow', Math.min(visibleSlides, slideCount), true);
          }
        } else if ($promotion.hasClass('coupon-flash-container')) {
          $promotion.hide().removeAttr('data-prime-day-ends-at').removeClass('prime-day-coupon');
        } else {
          $promotion.remove();
        }
        if ($bar.length) {
          $bar.removeClass('announcement-bar--prime-day');
          if (!$bar.find('.announcement-slider__slide').length) $bar.hide();
          $(window).trigger('resize');
        }
        return;
      }

      var days = Math.floor(timeLeft / 86400);
      var hours = Math.floor((timeLeft % 86400) / 3600);
      var minutes = Math.floor((timeLeft % 3600) / 60);
      var seconds = timeLeft % 60;
      function pad(value) { return value < 10 ? '0' + value : '' + value; }
      $promotion.find('[data-prime-day-clock]').text('Ends in ' + days + ':' + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds));
    });
  }

  makeTimer();
  setInterval(makeTimer, 1000);
  document.addEventListener('visibilitychange', makeTimer);

// collection add to cart ajax product-grid-item.liquid
if ($('.collection-grid-product__options')){
  $('.collection-grid-product__options').on('change', function() {
      var selectedVariantTitle = $(this).find("option:selected").data('title');
      var selectedVariantId = $(this).find(':selected').val();
      $(this).siblings('.collection-add-to-cart-button').attr('data-variant-id', selectedVariantId);
      var selectedPrice = $(this).find(':selected').data('price');

      // Update checkbox and price display for subscribe & save
      var $meta = $(this).closest('.grid-product__meta');
      var $checkbox = $meta.find('.collection-subscribe-checkbox');
      var $priceContainer = $meta.find('.collection-product-price');
      var selectedPriceCents = parseFloat(selectedPrice.replace(/[^0-9.-]+/g, '')) * 100;

      if ($checkbox.length) {
        $checkbox.data('variant-id', selectedVariantId);
        $checkbox.data('original-price', selectedPriceCents);
        $checkbox.attr('id', 'subscribe-' + $(this).closest('.grid-product__content').find('.collection-add-to-cart-button').data('product-id') + '-' + selectedVariantId);

        // Update price display based on checkbox state
        if ($checkbox.is(':checked')) {
          var subPriceCents = Math.round(selectedPriceCents * 0.8);
          var savingsCents = selectedPriceCents - subPriceCents;
          var subPrice = '$' + (subPriceCents / 100).toFixed(2);
          var savingsFormatted = '$' + (savingsCents / 100).toFixed(2);
          $priceContainer.find('.collection-price-original').text(selectedPrice);
          $priceContainer.find('.collection-price-subscription').text(subPrice);
          $priceContainer.find('.collection-price-savings').text('SAVED ' + savingsFormatted);
        } else {
          $priceContainer.find('.collection-price-subscription').text(selectedPrice);
        }
      }
  });
}

// Collection subscribe checkbox - toggle price display
if ($('.collection-subscribe-checkbox').length) {
  $(document).on('change', '.collection-subscribe-checkbox', function() {
    var $checkbox = $(this);
    var $priceContainer = $checkbox.closest('.grid-product__meta').find('.collection-product-price');
    var originalPrice = $checkbox.data('original-price');

    console.log('[Subscribe Toggle] Checkbox changed, checked:', $checkbox.is(':checked'), 'originalPrice:', originalPrice);

    if ($checkbox.is(':checked')) {
      // Show subscription pricing (strikethrough + savings)
      $priceContainer.find('.collection-price-original').show();
      $priceContainer.find('.collection-price-subscription').show();
      $priceContainer.find('.collection-price-savings').show();
      // Restore subscription price and savings amount
      var subPriceCents = Math.round(originalPrice * 0.8);
      var savingsCents = originalPrice - subPriceCents;
      var subPrice = '$' + (subPriceCents / 100).toFixed(2);
      var savingsFormatted = '$' + (savingsCents / 100).toFixed(2);
      $priceContainer.find('.collection-price-subscription').text(subPrice);
      $priceContainer.find('.collection-price-savings').text('SAVED ' + savingsFormatted);
      console.log('[Subscribe Toggle] Showing subscription pricing, savings:', savingsFormatted);
    } else {
      // Hide subscription elements, show original as regular price
      $priceContainer.find('.collection-price-original').hide();
      $priceContainer.find('.collection-price-savings').hide();
      // Update the subscription span to show regular price without strikethrough
      var regularPriceFormatted = '$' + (originalPrice / 100).toFixed(2);
      $priceContainer.find('.collection-price-subscription').text(regularPriceFormatted).show();
      console.log('[Subscribe Toggle] Showing regular pricing:', regularPriceFormatted);
    }
  });
}

  // home add to cart button
  var collectionATCVariantId, collectionATCProductId;

  function collectionAtcUpdate() {
    // DEPRECATED: This function uses old tier-based logic and interferes with the new Buy More & Save system.
    // The new progress bar is now managed by updateBar() function.
    console.log('[collectionAtcUpdate] DEPRECATED - skipping old progress bar logic');
    return;

    theme.cart.getCart().then(function(cart){
      if (cart.total_price >= 20000){
        $('.progress-fill').css('width', '100%');
        $('.free-shipping-text').html('<strong>Load up! Your entire order ships FREE!</strong>');
        $('.progress li:nth-child(4)').addClass('active');
        $('.progress li:nth-child(3)').removeClass();
        $('.progress li:nth-child(3)').addClass('done');
        $('.progress li:nth-child(2)').removeClass();
        $('.progress li:nth-child(2)').addClass('done');
        $('.progress li:first-child').removeClass();
        $('.progress li:first-child').addClass('done');
      } else if ((cart.total_price > 15000) && (cart.total_price < 20000)){
        var a = 20000 - cart.total_price;
        var b = a/100;
        var c = b.toFixed(2);
        var d = (cart.total_price/20000)*100;
        $('.progress-fill').css('width', d+'%');
        $('.free-shipping-text').html("You are <strong><span class='free-shipping-amount'>$"+c+"</span></strong> away from a FREE Gift!");
        $('.progress li:nth-child(4)').removeClass();
        $('.progress li:nth-child(3)').removeClass();
        $('.progress li:nth-child(3)').addClass('active');
        $('.progress li:nth-child(2)').removeClass();
        $('.progress li:nth-child(2)').addClass('done');
        $('.progress li:first-child').removeClass();
        $('.progress li:first-child').addClass('done');	              

      } else if ((cart.total_price > 9900) && (cart.total_price < 15000)){
        var a = 15000 - cart.total_price;
        var b = a/100;
        var c = b.toFixed(2);
        var d = ((cart.total_price/20000)*100);
        $('.progress-fill').css('width', d+'%');
        $('.free-shipping-text').html("You are <strong><span class='free-shipping-amount'>$"+c+"</span></strong> away from a FREE Multi!");
        $('.progress li:nth-child(4)').removeClass();
        $('.progress li:nth-child(3)').removeClass();
        $('.progress li:nth-child(2)').removeClass();
        $('.progress li:nth-child(2)').addClass('active');
        $('.progress li:first-child').removeClass();
        $('.progress li:first-child').addClass('done');	 
      } else if (cart.total_price < 9900) {
        var a = 9900 - cart.total_price;
        var b = a/100;
        var c = b.toFixed(2);
        var d = ((cart.total_price/20000)*100);
        $('.progress-fill').css('width', d+'%');
        $('.free-shipping-text').html("You are <strong><span class='free-shipping-amount'>$"+c+"</span></strong> away from FREE Shipping.");
        $('.progress li:nth-child(4)').removeClass();
        $('.progress li:nth-child(3)').removeClass();
        $('.progress li:nth-child(2)').removeClass();
        $('.progress li:first-child').removeClass();
        $('.progress li:first-child').addClass('active');	 
      }
      //if cart is < $150, remove multi and free gift
      if (cart.total_price < 15000) {
        $.each(cart.items, function(index, product) {
          if(product.product_id == 7974457508016){
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              dataType: 'json',
              data: {
                quantity: 0,
                id: 44841756983472
              },
              beforeSend: function() {
                $('#CartDrawer').append("<div class='cart-loading'></div>");
              },
              success: function() {
                if (has_gift == true) {
                  console.log('...removing gift...');
                  $.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: '/cart/change.js',
                    data: {
                      quantity: 0,
                      id: 44858524663984
                    },
                    beforeSend: function() {
                      $('#CartDrawer').append("<div class='cart-loading'></div>");
                    },
                    success: function() {
                      $('body').trigger('added.ajaxProduct');
                      $('#CartDrawer').find($('.cart-loading')).remove();
                    },
                    error: function(error) {
                      console.log(error);
                      $('body').trigger('added.ajaxProduct');
                      $('#CartDrawer').find($('.cart-loading')).remove();
                    }
                  });
                } else {
                 $('body').trigger('added.ajaxProduct');
                 $('#CartDrawer').find($('.cart-loading')).remove(); 
                }                    
              },
              error: function(error){
                console.log(error)
              }
            });
          } // if has multi
        }); 
      }
      // if cart > $150, trigger update
      if (cart.total_price >= 15000) {
        var has_multi = false;
        $.each(cart.items, function(index, product) {
            if(product.product_id == 7974457508016) {
                has_multi = true;
            } // end if product.product_id
        }); // end each
      } // end if cart.total_price > 15000
      
      // if cart is < $200, remove gift
      if (cart.total_price < 20000) {
        $.each(cart.items, function(index, product) {
          //remove gift
          if(product.variant_id == 44858524663984){
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              dataType: 'json',
              data: {
                quantity: 0,
                id: 44858524663984
              },
              beforeSend: function() {
                $('#CartDrawer').append("<div class='cart-loading'></div>");
              },
              success: function() {
                $('body').trigger('added.ajaxProduct');
                $('#CartDrawer').find($('.cart-loading')).remove(); 
              },
              error: function(error){
                console.log(error);
              }
            }); //ajax
          }
        }); // each
      } else {
        $('body').trigger('added.ajaxProduct');
      } // if $200
    }); // getCart
  } //end collectionAtcUpdate() function

  // collection add to cart with subscription support
  if ($('.collection-add-to-cart-button').length) {
    $(document).on('click', '.collection-add-to-cart-button', function() {
      var $button = $(this);
      var collectionATCVariantId = $button.data('variant-id');
      var collectionATCProductId = $button.data('product-id');
      var productHandle = $button.data('product-handle');
      var hasSubscription = $button.data('has-subscription') === true || $button.data('has-subscription') === 'true';

      // Find the subscribe checkbox for this product
      var $subscribeCheckbox = $button.siblings('.collection-subscribe-row').find('.collection-subscribe-checkbox');
      var isSubscription = $subscribeCheckbox.length > 0 && $subscribeCheckbox.is(':checked');

      console.log('[Collection ATC] Click - variantId:', collectionATCVariantId, 'productHandle:', productHandle, 'hasSubscription:', hasSubscription, 'isSubscription:', isSubscription);

      function addToCart(sellingPlanId) {
        var cartData = {
          quantity: 1,
          id: collectionATCVariantId
        };

        if (sellingPlanId) {
          cartData.selling_plan = sellingPlanId;
          console.log('[Collection ATC] Adding with selling_plan:', sellingPlanId);
        } else {
          console.log('[Collection ATC] Adding as one-time purchase');
        }

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: cartData,
          beforeSend: function() {
            $button.append("<div class='cart-loading'></div>");
          },
          success: function(cart) {
            console.log('[Collection ATC] Success - item added:', cart);
            $('body').trigger('added.ajaxProduct');
            $button.find('.cart-loading').remove();
          },
          error: function(error) {
            console.log('[Collection ATC] Error:', error);
            $button.find('.cart-loading').remove();
          }
        });
      }

      if (isSubscription && hasSubscription && productHandle) {
        // Fetch product to get selling plan ID
        console.log('[Collection ATC] Fetching product for selling plan:', productHandle);
        $.getJSON('/products/' + productHandle + '.js', function(product) {
          var sellingPlanId = null;
          // Find the selling plan for the specific variant
          if (product.variants) {
            for (var i = 0; i < product.variants.length; i++) {
              if (product.variants[i].id == collectionATCVariantId) {
                if (product.variants[i].selling_plan_allocations && product.variants[i].selling_plan_allocations.length > 0) {
                  sellingPlanId = product.variants[i].selling_plan_allocations[0].selling_plan_id;
                }
                break;
              }
            }
            // Fallback to first variant's selling plan
            if (!sellingPlanId && product.variants[0].selling_plan_allocations && product.variants[0].selling_plan_allocations.length > 0) {
              sellingPlanId = product.variants[0].selling_plan_allocations[0].selling_plan_id;
            }
          }

          if (sellingPlanId) {
            console.log('[Collection ATC] Found selling_plan_id:', sellingPlanId);
            addToCart(sellingPlanId);
          } else {
            console.log('[Collection ATC] No selling plan found, adding as one-time');
            addToCart(null);
          }
        }).fail(function(error) {
          console.log('[Collection ATC] Failed to fetch product:', error);
          addToCart(null);
        });
      } else {
        addToCart(null);
      }
    });
  }//if collection button

  

  // home-page add to cart ajax home-product-grid-item.liquid
  if ($('.home-collection-grid-product__options')){
    $('.home-collection-grid-product__options').on('change', function() {
        var selectedVariantTitle = $(this).find("option:selected").data('title');
    	var selectedVariantId = $(this).find(':selected').val();
      	var selectedImage = $(this).find(':selected').data('image');
      	if( selectedImage.indexOf('no-image') == -1 ){
         $(this).parent('.grid-product__meta').prev('.grid-product__link').find('.grid-product__image-mask').find('.grid__image-ratio').css('background-image', "url('"+selectedImage+"')");
      	}
        $(this).siblings('.home-collection-add-to-cart-button').attr('data-variant-id', selectedVariantId);
        var selectedPrice = $(this).find(':selected').data('price');

        // Update checkbox and price display for subscribe & save
        var $meta = $(this).closest('.grid-product__meta');
        var $checkbox = $meta.find('.collection-subscribe-checkbox');
        var $priceContainer = $meta.find('.collection-product-price');
        var selectedPriceCents = parseFloat(selectedPrice.replace(/[^0-9.-]+/g, '')) * 100;

        if ($checkbox.length) {
          $checkbox.data('variant-id', selectedVariantId);
          $checkbox.data('original-price', selectedPriceCents);
          $checkbox.attr('id', 'subscribe-' + $(this).closest('.grid-product__content').find('.home-collection-add-to-cart-button').data('product-id') + '-' + selectedVariantId);

          // Update price display based on checkbox state
          if ($checkbox.is(':checked')) {
            var subPriceCents = Math.round(selectedPriceCents * 0.8);
            var savingsCents = selectedPriceCents - subPriceCents;
            var subPrice = '$' + (subPriceCents / 100).toFixed(2);
            var savingsFormatted = '$' + (savingsCents / 100).toFixed(2);
            $priceContainer.find('.collection-price-original').text(selectedPrice);
            $priceContainer.find('.collection-price-subscription').text(subPrice);
            $priceContainer.find('.collection-price-savings').text('SAVED ' + savingsFormatted);
          } else {
            $priceContainer.find('.collection-price-subscription').text(selectedPrice);
          }
        }
    });
  }
      
  // home add to cart button
  var homeATCVariantId, homeATCProductId;

  // home page add to cart with subscription support
  if ($('.home-collection-add-to-cart-button').length) {
    $(document).on('click', '.home-collection-add-to-cart-button', function() {
      var $button = $(this);
      var homeATCVariantId = $button.data('variant-id');
      var homeATCProductId = $button.data('product-id');
      var productHandle = $button.data('product-handle');
      var hasSubscription = $button.data('has-subscription') === true || $button.data('has-subscription') === 'true';

      // Find the subscribe checkbox for this product
      var $subscribeCheckbox = $button.siblings('.collection-subscribe-row').find('.collection-subscribe-checkbox');
      var isSubscription = $subscribeCheckbox.length > 0 && $subscribeCheckbox.is(':checked');

      console.log('[Home ATC] Click - variantId:', homeATCVariantId, 'productHandle:', productHandle, 'hasSubscription:', hasSubscription, 'isSubscription:', isSubscription);

      function addToCart(sellingPlanId) {
        var cartData = {
          quantity: 1,
          id: homeATCVariantId
        };

        if (sellingPlanId) {
          cartData.selling_plan = sellingPlanId;
          console.log('[Home ATC] Adding with selling_plan:', sellingPlanId);
        } else {
          console.log('[Home ATC] Adding as one-time purchase');
        }

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: cartData,
          beforeSend: function() {
            $button.append("<div class='cart-loading'></div>");
          },
          success: function(cart) {
            console.log('[Home ATC] Success - item added:', cart);
            $('body').trigger('added.ajaxProduct');
            $button.find('.cart-loading').remove();
          },
          error: function(error) {
            console.log('[Home ATC] Error:', error);
            $button.find('.cart-loading').remove();
          }
        });
      }

      if (isSubscription && hasSubscription && productHandle) {
        // Fetch product to get selling plan ID
        console.log('[Home ATC] Fetching product for selling plan:', productHandle);
        $.getJSON('/products/' + productHandle + '.js', function(product) {
          var sellingPlanId = null;
          // Find the selling plan for the specific variant
          if (product.variants) {
            for (var i = 0; i < product.variants.length; i++) {
              if (product.variants[i].id == homeATCVariantId) {
                if (product.variants[i].selling_plan_allocations && product.variants[i].selling_plan_allocations.length > 0) {
                  sellingPlanId = product.variants[i].selling_plan_allocations[0].selling_plan_id;
                }
                break;
              }
            }
            // Fallback to first variant's selling plan
            if (!sellingPlanId && product.variants[0].selling_plan_allocations && product.variants[0].selling_plan_allocations.length > 0) {
              sellingPlanId = product.variants[0].selling_plan_allocations[0].selling_plan_id;
            }
          }

          if (sellingPlanId) {
            console.log('[Home ATC] Found selling_plan_id:', sellingPlanId);
            addToCart(sellingPlanId);
          } else {
            console.log('[Home ATC] No selling plan found, adding as one-time');
            addToCart(null);
          }
        }).fail(function(error) {
          console.log('[Home ATC] Failed to fetch product:', error);
          addToCart(null);
        });
      } else {
        addToCart(null);
      }
    }); // on click
  } //if home button
  
  // cart-page add to cart ajax cart-related-product-item.liquid
  //variant selector for cart-page
  if ($('.cart-related-grid-product__options')){
    $(document).on('change', '.cart-related-grid-product__options select', function() {
        var selectedVariantTitle = $(this).find("option:selected").data('title');
        var selectedVariantId = $(this).find(':selected').val();
        var selectedImage = $(this).find(':selected').data('image');
        var selectedPrice = $(this).find(':selected').data('price');

        // Update image if available
        if (selectedImage && selectedImage.indexOf('no-image') == -1) {
          $(this).closest('.grid-product__meta').prev('.grid-product__link').find('.grid-product__image-mask').find('.grid__image-ratio').css('background-image', "url('" + selectedImage + "')");
        }

        // Update variant ID on both old and new button classes
        var $addButton = $(this).closest('.grid-product__meta').find('.cart-related-add-to-cart-button, .cart-related-add-to-cart-btn');
        $addButton.attr('data-variant-id', selectedVariantId);
        $addButton.data('variant-id', selectedVariantId);

        // Update price display if exists
        $addButton.find('.add-on-price').text(selectedPrice);

        // Update subscribe checkbox data attribute
        var $subscribeCheckbox = $(this).closest('.grid-product__meta').find('.cart-related-subscribe-checkbox');
        if ($subscribeCheckbox.length) {
          $subscribeCheckbox.attr('data-variant-id', selectedVariantId);
          $subscribeCheckbox.data('variant-id', selectedVariantId);
        }

        console.log('[Cart Related Select] Changed to variant:', selectedVariantId);
    });
  }
  
  // cart-page prohibit changing quantity of free items and hide quantity button
  if (window.location.pathname == "/cart") {
    $('input[data-id]').each(function(){
      if((this.id.split(':')[0] == 40609122910384) || (this.id.split(':')[0] == 40609122943152) || (this.id.split(':')[0] == 40609122975920) ||(this.id.split(':')[0] == 40609123008688) || (this.id.split(':')[0] == 44841756983472) || (this.id.split(':')[0] == 42692913037488) || (this.id.split(':')[0] == 42710331097264) || (this.id.split(':')[0] == 42733356122288) || (this.id.split(':')[0] == 42745518588080) || (this.id.split(':')[0] == 43065469993136) || (this.id.split(':')[0] == 43194932592816) || (this.id.split(':')[0] == 44048170057904) || (this.id.split(':')[0] == 44048170090672) || (this.id.split(':')[0] == 44858524663984)){
        $(this).css("display", "none");
        $(this).closest('.cartItem_quantity').css("display","none");
      }
    });
  }

  if($('.product-options-button').length){
    $('.product-options').on('change', function(){
      var selectedVariantId = $(this).val();
      console.log('product-options-button: ', selectedVariantId);
      $(this).closest('.cart-drawer-product__options').next('.product-options-button').data('variant-id', selectedVariantId);
    });
  }
  
  var cartPageUnlockVariantId;
  if($('.product-options-button').length){
    $('.product-options-button').one('click', function() {
      console.log('click product options');
      //cartPageUnlockVariantId = this.dataset.variantId;
      cartPageUnlockVariantId = $(this).data('variant-id');
      console.log('cartPageUnlockVariantId: ' + cartPageUnlockVariantId);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
          id: cartPageUnlockVariantId,
          quantity: 1    
        },
        success: function() {
          console.log('success added add on');
          $("button[name='update']").click(); 
        },
        error: function(XMLHttpRequest, textStatus, errorThrown){
          console.log(XMLHttpRequest, textStatus, errorThrown); 
        }
      });
    });
  }
  var cartPageAddOnVariantId;
  
  function addItemToCartPage(image, url, qty, variantTitle, productTitle){
  }
  
  if ($('.cart-related-add-to-cart-button, .cart-related-add-to-cart-btn')) {
     $(document).on('click', '.cart-related-add-to-cart-button, .cart-related-add-to-cart-btn', function() {
       var $button = $(this);
       cartPageAddOnVariantId = $button.data('variant-id');
       var productHandle = $button.data('product-handle');
       var hasSubscription = $button.data('has-subscription') === true || $button.data('has-subscription') === 'true';

       // Selling plan is embedded on the button at render time (data-selling-plan),
       // so the subscription path needs no /products/.js fetch and can't silently
       // downgrade to one-time on a failed fetch.
       var relatedEmbeddedPlan = $button.data('selling-plan');

       console.log('[Cart Related ATC] variantId:', cartPageAddOnVariantId, 'handle:', productHandle, 'hasSubscription:', hasSubscription, 'embeddedPlan:', relatedEmbeddedPlan);

       // Check if subscribe checkbox is checked. Scope to the whole .grid-product so the
       // lookup survives the anchor/meta nesting in cart-related-product-item.liquid.
       var $relatedContainer = $button.closest('.grid-product');
       if (!$relatedContainer.length) { $relatedContainer = $button.closest('.grid-product__meta'); }
       var $subscribeCheckbox = $relatedContainer.find('.cart-related-subscribe-checkbox');
       var isSubscription = hasSubscription && $subscribeCheckbox.length > 0 && $subscribeCheckbox.is(':checked');

       console.log('[Cart Related ATC] isSubscription:', isSubscription);

       function addToCartPage(sellingPlanId) {
         var cartData = {
           quantity: 1,
           id: cartPageAddOnVariantId
         };

         if (sellingPlanId) {
           cartData.selling_plan = sellingPlanId;
           console.log('[Cart Related ATC] Adding with selling_plan:', sellingPlanId);
         }

         $.ajax({
           type: 'POST',
           url: '/cart/add.js',
           dataType: 'json',
           data: cartData,
           beforeSend: function() {
             $button.append("<div class='cart-loading'></div>");
           },
           success: function() {
             location.reload();
           },
           error: function(error) {
             console.log('[Cart Related ATC] Error:', error);
             $button.find('.cart-loading').remove();
           }
         });
       }

       if (isSubscription && relatedEmbeddedPlan) {
         // Subscription with a known plan — direct add, no fetch, no silent fallback.
         addToCartPage(relatedEmbeddedPlan);
       } else if (isSubscription && productHandle) {
         // Legacy fallback only when the plan wasn't embedded: look it up.
         $.getJSON('/products/' + productHandle + '.js', function(product) {
           var sellingPlanId = null;

           if (product.selling_plan_groups && product.selling_plan_groups.length > 0) {
             var sellingPlans = product.selling_plan_groups[0].selling_plans;
             if (sellingPlans && sellingPlans.length > 0) {
               sellingPlanId = sellingPlans[0].id;
             }
           }

           console.log('[Cart Related ATC] Found selling_plan:', sellingPlanId);
           if (sellingPlanId) {
             addToCartPage(sellingPlanId);
           } else {
             // Subscription requested but no plan resolved — don't silently add one-time.
             console.warn('[Cart Related ATC] Subscription requested but no plan resolved; not adding.');
             $button.find('.cart-loading').remove();
           }
         }).fail(function(error) {
           // Same: never silently downgrade a requested subscription to one-time.
           console.warn('[Cart Related ATC] Fetch failed for a subscription add; not adding one-time:', error);
           $button.find('.cart-loading').remove();
         });
       } else {
         addToCartPage(null);
       }
     });
    }
  
  // SFP zoom ** turned off **
    
//   if ($(".magnify")){
//     // on load > 767
//       var native_width = 0;
//       var native_height = 0;

//       $(".magnify").on("mousemove", function(e){
//         if ($(window).width() > 767) {
//           if (!native_width && !native_height) {
//             var image_object = new Image();
//             var image_source = $(".magnify-small").attr("src");

//             $(image_object).on('load', function(){
//               native_width = image_object.width;
//               native_height = image_object.height;
//               $(".magnify-large").css('background', 'url(' + image_object.src + ') no-repeat');
//             }).attr('src', image_source);

//           } else {
//             var magnify_offset = $(this).offset();
//             var mx = e.pageX - magnify_offset.left;
//             var my = e.pageY - magnify_offset.top;

//             if (mx < $(this).width() && my < $(this).height() && mx > 0 && my > 0) {
//               $(".magnify-large").fadeIn(100);  
//             } else {
//               $(".magnify-large").fadeOut(100); 
//             }
//             if ($(".magnify-large").is(":visible")) {
//               var rx = Math.round(mx / $(".magnify-small").width() * native_width - $(".magnify-large").width() / 2) * -1;
//               var ry = Math.round(my / $(".magnify-small").height() * native_height - $(".magnify-large").height() / 2) * -1;
//               var bgp = rx + "px" + " " + ry + "px";

//               var px = mx - $(".magnify-large").width() / 2;
//               var py = my - $(".magnify-large").height() / 2;
//               $(".magnify-large").css({
//                 left: px,
//                 top: py,
//                 backgroundPosition: bgp
//               });
//             }
//           }
//         };    
// 	});
//   }
         
  // SFP modal
	var sfpModal = document.querySelector(".sfp-modal");
    var sfpOpenModal = document.querySelector(".sfp-open-btn");
	if (sfpModal && sfpOpenModal) {
      var sfpCloseBtn = document.querySelector(".sfp-close-btn");
      var stickyPopup = document.querySelector(".sticky-popup");
      
      //open
      sfpOpenModal.onclick = function() {
        var scrollBarWidth = window.innerWidth - document.body.offsetWidth;
        $('body')
        	.css('margin-right', scrollBarWidth)
        	.addClass('showing-modal');
        sfpModal.style.display = "block";
        stickyPopup.style.display = "none";
        // button close
        sfpCloseBtn.onclick = function() {
          sfpModal.style.display = "none";
          stickyPopup.style.display = "block";
          $('body')
          	.css('margin-right', '')
          	.removeClass('showing-modal');
        }
        //window click close modal
        window.onclick = function(e) {
          if(e.target == sfpModal){
			$(this).off(event);
          	sfpModal.style.display = "none";
            stickyPopup.style.display = "block";
            $('body')
              .css('margin-right', '')
          	  .removeClass('showing-modal');
          }
        }
      }
    }
  
  //protein-calculator
  if ((window.location.pathname == '/protein-calculator') || (window.location.pathname == '/pages/protein-calculator')) {
    
    $('.take-quiz').on('click', function(e) {
      $('html, body').animate({scrollTop: '0px'}, 300);
      console.log('click');
    });
    
    $('.toggle-hidden-data').on('click', function(e) {
    	e.preventDefault();
    	$(this).parent().toggleClass('visible-data');
  	});
    
    //get started button
    $('.pc-get-started').on('click', 'button.btn', function(e) {
      e.preventDefault();
      $('.pc-get-started').hide();
      $('.pc-get-started-article').hide();
      $('#pc-banner-image').hide();
      
      if($('.pc-steps.active').data('step')==0) {
        $('.pc-steps[data-step="0"]').removeClass('active');
        $('.pc-steps[data-step="2"]').addClass('active');
        $('.pc-steps[data-step="2"]').show();
        $(window).scrollTop(0);
      }

  	});
    
    //listener for sources
    $('#sources-for-all-data').on('click', function() {
      $(this).toggleClass('open')
  	})
    
    //next button logic
    $('.pc-form a.btn').on('click', function(e) {
    e.preventDefault();
    var calculatorError = false;
    var step = $(this).closest('.pc-form').data('step');
    var generalStep = $('.pc-steps.active').data('step');

    //calculate errors
    if(generalStep==2) {

      error1 = true
      error2 = true

      if ($('input#weight').val()=="" || $('input#weight').val() == "-" || $('input#weight').val() == "0") {
        $('input#weight').addClass('error');
      } else {
        $('input#weight').removeClass('error');
        error1 = false
      }

      if ($('input#routine').val()=="") {
        $('input#routine').siblings('.pc-choice').addClass('error');
      } else {
        $('input#routine').siblings('.pc-choice').removeClass('error');
        error2 = false
      }

      if (error1 || error2) {
        calculatorError = true;
      }
    }

    if(generalStep==3) {
      if ($('input#goals').val()=="") {
        $('input#goals').siblings('.pc-choice').addClass('error');
        calculatorError = true;
      } else {
        $('input#goals').siblings('.pc-choice').removeClass('error');
      }
    }

    if(generalStep==4) {
      if ($('input#restrictions').val()=="") {
        $('input#restrictions').siblings('.pc-choice').addClass('error');
        calculatorError = true;
      } else {
        $('input#restrictions').siblings('.pc-choice').removeClass('error');
      }
    }

    if(generalStep==41) {
      if ($('input#how').val()=="") {
        $('input#how').siblings('.pc-choice').addClass('error');
        calculatorError = true;
      } else {
        $('input#how').siblings('.pc-choice').removeClass('error');
        setTimeout(() => {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'Rdbm34']);
        }, 3000);
      }
    }

    //if no errors

    if(!calculatorError) {

      $('.pc-form').addClass('hide');
      notpre = true

      if((step==4 && ($('input#restrictions').val().indexOf('Vegan') > -1 || $('input#restrictions').val().indexOf('Dairy') > -1) ) || step == 41) {
        //$('.pc-form[data-step="' + (step+2) + '"]').removeClass('hide');
        $('.pc-form[data-step="' + (step+2) + '"]').addClass('active');
      } else {
         if (step == 4) {
            $('.pc-form[data-step="41"]').removeClass('hide');
            notpre = false
          } else {
            $('.pc-form[data-step="' + (step+1) + '"]').removeClass('hide');
          }
      }

      if (notpre) {
        $('.pc-app ul.steps li.step').removeClass('active');
        $('.pc-app ul.steps li.step[data-step="' + (step+1) + '"]').addClass('active');
      }

      if($('.pc-steps.active').data('step')!=0) {
        // if plant-based or non-dairy go straight to results
        if((step==4 && ($('input#restrictions').val().indexOf('Vegan') > -1 || $('input#restrictions').val().indexOf('Dairy') > -1) ) || step == 41) {
          $('.pc-steps.active').data('step', 5); 
          $('.pc-form[data-step="6"]').removeClass('hide');
          $('.pc-app ul.steps li.step[data-step="5"]').addClass('active');
        } else  {
          if (step == 4) {
            $('.pc-steps.active').data('step', 41); 
          } else {
            $('.pc-steps.active').data('step', $('.pc-steps.active').data('step')+1); 
          }
        }
        // calculate protein
        if($('.pc-steps.active').data('step')==5) {
            $('.pc-steps[data-step="5"]').addClass('active');
            $('.pc-steps.active').addClass('final-step');
          	$('.pc-results').fadeIn();
            $('.header-wrapper').removeClass('is-light');

            var score = $('input[name="weight"]').val();
//            score = score * $('input[name="routine"]').val();
            if($('input[name="goals"]').val()!="") {
              var goals = $('input[name="goals"]').val();
              goals = parseFloat(goals)
              var routine = $('input[name="routine"]').val();
              routine = parseFloat(routine);
              score = score * (goals + routine);
//              var goals = $('input[name="goals"]').val().split(",");
              
//              if(goals.length == 1) {
//                score = score * 1.15;
//              } else if (goals.length == 2) {
//                score = score * 1.15;
//                score = score * 1.10;
//              } else if (goals.length == 3) {
//                score = score * 1.15;
//                score = score * 1.10;
//                score = score * 1.05;
//              } else if (goals.length == 4) {
//                score = score * 1.15;
//               score = score * 1.10;
//                score = score * 1.05;
//                score = score * 1.01;
//              }
            } 

//           if($('input[name="weight"]').val() < score) {
//             score = $('input[name="weight"]').val();
//             alert('weight is less than score');
//           }
            
            $('p.amount').text(Math.round(score));

            how = $('input#how').val()
            
            // show products

            if (how=="") {
              $('#o-plant-based-protein-powder').show();
              $('#scoop1').show();
              $('#scoop2').show();
            } else {
              if (how.indexOf('Smoothie') > -1 || how.indexOf('After') > -1 || how.indexOf('Before-After') > -1 || how.indexOf('Before') > -1) {
                $('#o-whey-protein, #o-plant-based-protein-powder').show()
              }
            }
          }
        }
      }
    }); // end next button logic

    // add listener to calculator page
    window.addEventListener("klaviyoForms", function(e) { 
        if ((e.detail.formId == 'VQXc9r' || e.detail.formId == 'Rdbm34') && e.detail.type == 'submit') {
            fbq('trackCustom', 'CompleteProteinQuiz');
        }
    });
    
    // back button logic
    $('.back-btn a').on('click', function(e) {
      e.preventDefault();

      var step = $(this).closest('.pc-form').data('step');
      $('.pc-form').addClass('hide');
      $('.pc-form[data-step="' + (step-1) + '"]').removeClass('hide');
      $('.pc-app ul.steps li.step').removeClass('active');
      $('.pc-app ul.steps li.step[data-step="' + (step-1) + '"]').addClass('active');

      $('.pc-steps.active').data('step', step-1); 
    });
    
    // pc choice logic highlight choice
    $('.pc-choice').on('click', function(e) {
      e.preventDefault();

      $(this).parent('.pc-form').find('.pc-choice').removeClass('error');

      if(($(this).closest('.pc-form').data('step')== 2) || ($(this).closest('.pc-form').data('step')== 3)) {
        $(this).siblings('.pc-choice').not(this).removeClass('selected');
      }
      $(this).toggleClass('selected');

      var valA = [];
      $( $(this).closest('.pc-form').find('.pc-choice.selected') ).each(function() {
        valA.push( $(this).data('value') );
      });
      var valS = valA.join( "," );

      $(this).closest('.pc-form').find('input[type="hidden"]').val(valS);
    });
    
    
    // pc add to cart logic
    $('.protein-calculator-product button.add-to-cart').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      var varId = $(this).siblings('select.product_select').val();    
      var qty = 1;
      $.post('/cart/add.js', 'id='+ varId + '&quantity='+qty).then(function() {
          $('.js-drawer-open-cart')[0].click();
          $('body').trigger('added.ajaxProduct');
               
      });
    });
    
  } // end protein calculator
  
  //postscript notify when out of stock
  waitForStockNotification('#ps-bis-widget-bubble__close-text', function(){
    $('#ps-text-stock').css('display', 'block');
    $('#ps-text-stock').on('click', function() {
      $('#ps-bis-widget-bubble__close-text').click();
      $('#ps-text-stock').css('display','none');
    });
  });
  
  function waitForStockNotification(elementPath, callBack){
    window.setTimeout(function(){
      if($(elementPath).length){
       callBack();
      } else {
       waitForStockNotification(elementPath, callBack); 
      }
    }, 500)
  }
  
//     var sfpOpenModal = document.querySelector(".sfp-open-btn");
//     var sfpCloseBtn = document.querySelector(".sub-save-close-btn");
//   	$('.sfp-open-btn').on('click', function(event)) {
//     	sfpModal.style.display = 'block';
//     	sfpCloseBtn.onclick = function() {
//       		sfpModal.style.display = 'none';
//       		$(this).off(event);
//     	}
//   	}
//   }
  
  
  // offer subscription modal sub-save-modal product.sections.liquid REMOVED
  
  // $('.add-to-cart').on('click', function(event){
  //   if ($('.rc_label__autodeliver').length == 1) {
  //     event.preventDefault(); 
  //   }
    
  //   var cbd_check = false;
  //   var has_coupon = false;
  //   var has_sale = false;
  //   console.log('modal click: ' + has_coupon);
  //   var couponObject = sessionStorage.getItem('scDiscountData');
  //   var couponJSON = JSON.parse(couponObject);
  //   console.log('couponJSON.code: ' + couponJSON.code);
  //   console.log('couponObject: ' + couponObject);
    
  //   theme.cart.getCart().then(function(cart){
  //     $.each(cart.items, function(index, product) {
		// if ((product.product_id == '4407148281930') || (product.product_id == '4587274862666')){
		//  cbd_check = true;
		// }
	 //  });
  //     if (couponJSON.code != null){
  //      has_coupon = true; 
  //     }
  //   }).then(function() {
  //     // if cart contains CBD, don't offer
  //     if (cbd_check == true || has_coupon == true || has_sale == true){
  //       $(this).off(event);
  //       $('.add-to-cart').click();
  //     } else if ($('.rc_label__autodeliver').length == 1){
  //       event.preventDefault();

  //       var modal = document.querySelector(".sub-save-modal");
  //       var closeBtn = document.querySelector(".sub-save-close-btn");
  //       var regularPrice = $("#rc_price_onetime").html().split('$')[1];
  //       var regularFloat = parseFloat(regularPrice).toFixed(2);
  //       var discountPrice = $("#rc_price_autodeliver").html().split('$')[1];  
  //       var discountFloat = parseFloat(discountPrice).toFixed(2);
  //       var discount = (regularFloat - discountFloat).toFixed(2);
  //       var acceptSub = document.querySelector('button#accept-subscription');
  //       var rejectSub = document.querySelector('button#reject-subscription');

  //       if(($('input[name="purchase_type"][type="radio"][value="onetime"]').is(':checked')) && (Cookies.get('opt-out') != 'true') && ($('.on-sale[itemprop="price"]').length == 0)) {

  //           ga('send','event','ecommerce','sub-modal-display');

  //           $('#sub-save-discount-value').html(discount);
  //           modal.style.display = "block";

  //           closeBtn.onclick = function() {
  //               if($('input[type="checkbox"][name="opt-out"]').prop("checked") == true){
  //                   Cookies.set('opt-out', 'true', { expires: 90 });
  //                   ga('send','event','ecommerce','sub-modal-opt-out');
  //               }
  //               modal.style.display = "none";
  //               $(this).off(event);
  //               $('.add-to-cart').click();
  //           }

  //           window.onclick = function(e){
  //               if(e.target == modal){
  //                   if($('input[type="checkbox"][name="opt-out"]').prop("checked") == true){
  //                       Cookies.set('opt-out', 'true', { expires: 90 });
  //                       ga('send','event','ecommerce','sub-modal-opt-out');
  //                   }
  //                   modal.style.display = "none";
  //                   $(this).off(event);
  //                   $('.add-to-cart').click();
  //               }
  //           }

  //           acceptSub.onclick = function() {
  //               if($('input[type="checkbox"][name="opt-out"]').prop("checked") == true){
  //                   Cookies.set('opt-out', 'true', { expires: 90 });
  //                   ga('send','event','ecommerce','sub-modal-opt-out');
  //               }
  //               ga('send','event','ecommerce','sub-modal-accept');
  //               $('.rc_radio__autodeliver').click();
  //               $(this).off(event);
  //               $('.add-to-cart').click();
  //               modal.style.display = "none";
  //           }

  //           rejectSub.onclick = function() {
  //               if($('input[type="checkbox"][name="opt-out"]').prop("checked") == true){
  //                   Cookies.set('opt-out', 'true', { expires: 90 });
  //                   ga('send','event','ecommerce','sub-modal-opt-out');
  //               }
  //               ga('send','event','ecommerce','sub-modal-reject');
  //               modal.style.display = "none";  	
  //               $(this).off(event);
  //               $('.add-to-cart').click(); 
  //           }
  //       } else {
  //           $(this).off(event);
  //           $('.add-to-cart').click();  
  //       }
  //     }
      
  //   }); // end then

  // }); // end popup

  // afterpay paragraph on product page
//   var url = document.location.href;
//   if (url.match('products')) {
//       setTimeout(function(){
//         $('.afterpay-paragraph').fadeIn('slow');
//       }, 100);
//   }
  
   // trigger open cart drawer for abandoned carts 
  
   (function() {
    /* Begin flash Autofill Code */
    /* Read the Query String value from the URL */    
    /* Link: http://stackoverflow.com/a/2880929 - Notes: No clue how this regex stuff works. Probably fairy magic.  */
        var urlParams;
        (window.onpopstate = function () {
            var match,
                pl     = /\+/g,  // Regex for replacing addition symbol with a space
                search = /(cart)=?([^&]*)/g,
                decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
                query  = window.location.search.substring(1);

        urlParams = {};
        while (match = search.exec(query))
        urlParams[decode(match[1])] = decode(match[2]);
        })();

    /* If the value of the hidden discount input field is blank, undefined or null then set the contents of localstorage discount to be the result of our Query String function above */    
        if ($("#cart_drawer_hidden").val() == ('' || undefined || null || 'undefined')) {
        /* Set sessionStorage variable "discount" to the result of our Query string function above */
           sessionStorage.setItem("cart", urlParams["cart"]);
        }

    /* If the value in our hidden input field doesn’t match the result of our Query String function above then clear the current sessionStorage value for "discount" and replace it with the new one */
    /* Link: http://stackoverflow.com/q/19844750 */
        else if ($("#cart_drawer_hidden").val() != urlParams["cart"]) {
           sessionStorage.removeItem("cart");
           sessionStorage.setItem("cart", urlParams["cart"]);
        }    
    /* End Message Autofill Code */
    }());
  
	var cartDrawer = sessionStorage.getItem('cart');
    if (cartDrawer == 'true') {
      setTimeout(function() {
        $('.js-drawer-open-cart')[0].click();
        sessionStorage.removeItem("cart");
      }, 3000);
		
    }
  
  /* sticky atc light weight 2 of 2 theme.js.liquid */
  $(window).scroll(function() {
        if($(window).width() < 768) {
          if($(window).scrollTop() > 1200) {
            $('#sticky-add-to-cart').fadeIn('slow');
          } else {
            $('#sticky-add-to-cart').fadeOut('slow');
          };
        } else {
          if($(window).scrollTop() > 600) {
            $('#sticky-add-to-cart').fadeIn('slow');
          } else {
            $('#sticky-add-to-cart').fadeOut('slow');
          };
        }
  });

  $('#sticky-add-to-cart').on("click touchend", function(event){
    event.stopPropagation();
    $('html, body').animate({ scrollTop: 0 }, 'slow');
    $('#sticky-add-to-cart').fadeOut('slow');
  });
  
  
  if($('#horizontal-tabs')){
  	
    $('#horizontal-tabs li a:not(:first)').addClass('inactive');
    $('.tab-container').hide();
    $('.tab-container:first').show();
    
    $('#horizontal-tabs li a').click(function(){
      var t = $(this).attr('id');
      if($(this).hasClass('inactive')){
       $('#horizontal-tabs li a').addClass('inactive');
       $(this).removeClass('inactive');
       $('.tab-container').hide();
       $('#'+t+'C').fadeIn('slow');
      }
    });
    
  }
  
  if(window.location.pathname == '/pages/loyalty-program') {
    setTimeout(function() {
      $('.vip-tier-goal-value').eq(0).html('Spend $0');
      $('.vip-tier-goal-value').eq(1).html('Spend $500');
      $('.vip-tier-goal-value').eq(2).html('Spend $1000');
    }, 500);
    
  }
  
  // ADA
  if(window.location.pathname.indexOf("products") > -1){
    setTimeout(function(){
      $(".image-wrap").each(function () {    
        var $slide = $(this).parent();
        if ($slide.attr("aria-describedby") != undefined) { // ignore extra/cloned slides        
          $(this).attr("id", $slide.attr("aria-describedby"));    
        }
      }
      );
      $('.product-image-main').each(function () {
        var main = $(this).parent();
        if (main.attr("aria-describedby") != undefined) {
          $(this).attr("id", main.attr("aria-describedby")); 
        }
      });
    }, 500);
  
  }
  
  
  /* end additional custom code */
  
  slate.utils = {
    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }
  };
  
  slate.a11y = {
  
    /**
     * For use when focus shifts to a container rather than a link
     * eg for In-page links, after scroll, focus shifts to content area so that
     * next `tab` is where user expects if focusing a link, just $link.focus();
     *
     * @param {JQuery} $element - The element to be acted upon
     */
    pageLinkFocus: function($element) {
      var focusClass = 'js-focus-hidden';
  
      $element.first()
        .attr('tabIndex', '-1')
        .focus()
        .addClass(focusClass)
        .one('blur', callback);
  
      function callback() {
        $element.first()
          .removeClass(focusClass)
          .removeAttr('tabindex');
      }
    },
  
    /**
     * If there's a hash in the url, focus the appropriate element
     */
    focusHash: function() {
      var hash = window.location.hash;
  
      // is there a hash in the url? is it an element on the page?
      if (hash && document.getElementById(hash.slice(1))) {
        this.pageLinkFocus($(hash));
      }
    },
  
    /**
     * When an in-page (url w/hash) link is clicked, focus the appropriate element
     */
    bindInPageLinks: function() {
      $('a[href*=#]').on('click', function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this));
    },
  
    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (!options.$elementToFocus) {
        options.$elementToFocus = options.$container;
      }
  
      options.$container.attr('tabindex', '-1');
      options.$elementToFocus.focus();
  
      $(document).off('focusin');
  
      $(document).on(eventName, function(evt) {
        if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
          options.$container.focus();
        }
      });
    },
  
    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (options.$container && options.$container.length) {
        options.$container.removeAttr('tabindex');
      }
  
      $(document).off(eventName);
    },
  
  
    // Not from Slate, but fit in the a11y category
    lockMobileScrolling: function(namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.on('touchmove' + namespace, function () {
        return false;
      });
    },
  
    unlockMobileScrolling: function(namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.off(namespace);
    }
  };
  
  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    $(document)
      .on('shopify:section:load', this._onSectionLoad.bind(this))
      .on('shopify:section:unload', this._onSectionUnload.bind(this))
      .on('shopify:section:select', this._onSelect.bind(this))
      .on('shopify:section:deselect', this._onDeselect.bind(this))
      .on('shopify:block:select', this._onBlockSelect.bind(this))
      .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {
    createInstance: function(container, constructor) {
      var $container = $(container);
      var id = $container.attr('data-section-id');
      var type = $container.attr('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      var instance = $.extend(new constructor(container), {
        id: id,
        type: type,
        container: container
      });
  
      this.instances.push(instance);
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (AOS) {
        AOS.refreshHard();
      }
      var container = subSection ? subSection : $('[data-section-id]', evt.target)[0];
  
      if (!container) {
        return;
      }
  
      this.createInstance(container);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      if (!subSection) {
        this._loadSubSections();
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
    },
  
    _loadSubSections: function() {
      if (AOS) {
        AOS.refreshHard();
      }
      $('[data-subsection]').each(function(evt, el) {
        this._onSectionLoad(null, el, $(el).data('section-id'));
      }.bind(this));
    },
  
    _onSectionUnload: function(evt) {
      var instance = this._removeInstance(evt.detail.sectionId);
      if (instance && typeof instance.onUnload === 'function') {
        instance.onUnload(evt);
      }
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onSelect === 'function') {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onDeselect === 'function') {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(evt);
      }
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    register: function(type, constructor) {
      this.constructors[type] = constructor;
      var $sections = $('[data-section-type=' + type + ']');
  
      $sections.each(function(index, container) {
        this.createInstance(container, constructor);
      }.bind(this));
    }
  });
  
  /* contact us text footer */
  
  if (window.innerWidth < 768) {
  	$('#Footer-1494301487049').find('.site-footer__linklist').append('<li><a href="sms:+18083783696">Text Us</a></li>');  
  }

  /* discount coupon */

  (function() {
    /* Begin Discount Autofill Code */
    /* Read the Query String value from the URL */
    /* Link: http://stackoverflow.com/a/2880929 - Notes: No clue how this regex stuff works. Probably fairy magic.  */
        var urlParams;
        (window.onpopstate = function () {
            var match,
                pl     = /\+/g,  // Regex for replacing addition symbol with a space
                search = /(discount)=?([^&]*)/g,
                decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
                query  = window.location.search.substring(1);

        urlParams = {};
        while (match = search.exec(query))
        urlParams[decode(match[1])] = decode(match[2]);
        })();

    /* Store discount code in sessionStorage and cookie */
        if ($("#discount_input").val() == ('' || undefined || null || 'undefined')) {
           sessionStorage.setItem("discount", urlParams["discount"]);
           Cookies.set('discount_code', urlParams["discount"]);
        }
        else if ($("#discount_input").val() != urlParams["discount"]) {
           sessionStorage.removeItem("discount");
           sessionStorage.setItem("discount", urlParams["discount"]);
           Cookies.set('discount_code', urlParams["discount"]);
        }

    /* Apply manual coupon from URL parameter */
    if (urlParams["discount"] && urlParams["discount"] !== 'undefined') {
      var discountCode = urlParams["discount"];
      console.log('[Manual Coupon] URL param detected:', discountCode);

      // IMMEDIATELY set as manual to prevent Buy More & Save from applying
      window.couponState.isManual = true;
      window.couponState.pendingManualCode = discountCode;
      console.log('[Manual Coupon] Set isManual=true to block Buy More & Save');

      // Check if discount is already applied
      var rawData = sessionStorage.getItem('scDiscountData');
      var scDiscountData = rawData ? JSON.parse(rawData) : {};
      var existingCode = scDiscountData['code'];

      if (existingCode && existingCode.toLowerCase() === discountCode.toLowerCase()) {
        console.log('[Manual Coupon] Discount already applied:', existingCode);
        window.couponState.currentCode = existingCode;
        window.couponState.pendingManualCode = null;

        // Just open the drawer, don't try to apply again
        setTimeout(function() {
          var $cartTrigger = $('.js-drawer-open-cart').first();
          if ($cartTrigger.length) {
            $cartTrigger.click();
            console.log('[Manual Coupon] Cart drawer opened (discount already applied)');
          }
        }, 500);
        return;
      }

      // Wait for theme.cart to be available, then check cart state
      function checkAndApplyDiscount() {
        if (typeof theme !== 'undefined' && theme.cart && typeof theme.cart.getCart === 'function') {
          console.log('[Manual Coupon] theme.cart is ready, checking cart state');
          theme.cart.getCart().then(function(cart) {
            if (cart.items.length === 0) {
              console.log('[Manual Coupon] Cart empty, storing pending discount for later:', discountCode);
              // Store in sessionStorage so it persists across page navigations
              sessionStorage.setItem('pendingManualDiscount', discountCode);
            } else {
              console.log('[Manual Coupon] Cart has items, applying now');
              applyManualCouponFromURL(discountCode);
            }
          }).catch(function(error) {
            console.log('[Manual Coupon] Error checking cart:', error);
          });
        } else {
          console.log('[Manual Coupon] Waiting for theme.cart to initialize...');
          setTimeout(checkAndApplyDiscount, 100);
        }
      }

      checkAndApplyDiscount();
    }
    /* End Discount Autofill Code */
    }());

  /* Helper function to apply manual coupon from URL */
  function applyManualCouponFromURL(code) {
    if (isB2G1Protected() && !isB2G1Code(code)) return;
    // Wait for DiscountHero to be available first
    function waitAndApply() {
      if (!window.DiscountHero || !window.DiscountHero.discount) {
        console.log('[Manual Coupon] Waiting for DiscountHero before removing existing coupon...');
        setTimeout(waitAndApply, 100);
        return;
      }

      // DiscountHero is ready, check for existing coupon
      var rawData = sessionStorage.getItem('scDiscountData');
      var scDiscountData = rawData ? JSON.parse(rawData) : {};
      var existingCode = scDiscountData['code'];

      if (existingCode) {
        console.log('[Manual Coupon] Removing existing coupon:', existingCode);
        window.DiscountHero.discount.remove(existingCode).then(function() {
          applyManualCoupon(code);
        }).catch(function() {
          applyManualCoupon(code);
        });
      } else {
        applyManualCoupon(code);
      }
    }

    waitAndApply();
  }

  function applyManualCoupon(code) {
    if (isB2G1Protected() && !isB2G1Code(code)) return;
    if (isB2G1Code(code)) setB2G1Selection(true);
    // Wait for DiscountHero to be available
    function waitForDiscountHero() {
      if (!window.DiscountHero || !window.DiscountHero.discount) {
        console.log('[Manual Coupon] Waiting for DiscountHero to load...');
        setTimeout(waitForDiscountHero, 100);
        return;
      }

      // DiscountHero is ready, proceed with application
      console.log('[Manual Coupon] DiscountHero ready, applying:', code);

      // Mark as manual application (NOT system application)
      window.couponState.isManual = true;
      window.couponState.systemIsApplying = false;

      window.DiscountHero.discount.apply(code).then(function() {
        console.log('[Manual Coupon] Successfully applied:', code);
        window.couponState.currentCode = code;
        window.couponState.pendingManualCode = null;

        // Remove discount param from URL to prevent re-applying on reload
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location);
          url.searchParams.delete('discount');
          window.history.replaceState({}, document.title, url);
          console.log('[Manual Coupon] Removed discount param from URL');
        }

        // Open cart drawer using the proper method
        console.log('[Manual Coupon] Opening cart drawer...');
        var $cartTrigger = $('.js-drawer-open-cart').first();
        if ($cartTrigger.length) {
          $cartTrigger.click();
          console.log('[Manual Coupon] Cart drawer opened');
        } else {
          console.log('[Manual Coupon] WARNING: Cart drawer trigger not found');
        }

        // Refresh cart UI to show shipping mode
        if (typeof theme !== 'undefined' && theme.cart && typeof theme.cart.getCart === 'function') {
          console.log('[Manual Coupon] Refreshing cart to show shipping mode...');

          // Force updateBar to process by resetting last processed state
          if (typeof window.resetCartState === 'function') {
            window.resetCartState();
          }

          theme.cart.invalidateCache();
          theme.cart.getCart().then(function(cart) {
            updateBar(cart);
          });
        }
      }).catch(function(error) {
        console.log('[Manual Coupon] Failed to apply:', error);
        window.couponState.isManual = false;
      });
    }

    waitForDiscountHero();
  }

  /* Monitor scDiscountData for manual coupon application/removal */
  (function() {
    var lastCode = null;

    function checkDiscountState() {
      if (!window.DiscountHero || !window.DiscountHero.discount) {
        return; // DiscountHero not available yet
      }

      var rawData = sessionStorage.getItem('scDiscountData');
      var scDiscountData = rawData ? JSON.parse(rawData) : {};
      var currentCode = scDiscountData['code'] || null;

      if (isB2G1Protected() || (isB2G1Code(lastCode) && window.couponState.b2g1ExplicitlyRemoved)) {
        lastCode = currentCode;
        return;
      }

      // Coupon was added
      if (!lastCode && currentCode) {
        // If our system didn't apply it, check if it's a BUYMORE code or truly manual
        if (!window.couponState.systemIsApplying) {
          // BUYMORE codes should never be treated as manual, even if cached from a previous session
          if (currentCode.toUpperCase().startsWith('BUYMORE')) {
            console.log('[Manual Coupon] Detected cached BUYMORE code, treating as system-applied:', currentCode);
            // Don't mark as manual, just update currentCode
            window.couponState.currentCode = currentCode;
            window.couponState.isManual = false;
          } else {
            console.log('[Manual Coupon] Detected existing/customer-applied discount:', currentCode);
            handleCustomerAppliedCoupon(currentCode);
          }
        }
      }

      // Coupon was removed
      if (lastCode && !currentCode) {
        console.log('[Manual Coupon Monitoring] Coupon removed - lastCode:', lastCode, 'isManual:', window.couponState.isManual, 'systemIsRemoving:', window.couponState.systemIsRemoving, 'cartOperationInProgress:', window.couponState.cartOperationInProgress);

        // Check if this was a system removal (part of BUYMORE switching) OR during cart operation
        if (window.couponState.systemIsRemoving) {
          console.log('[Manual Coupon Monitoring] System is removing coupon (part of switching), no action needed');
        } else if (window.couponState.cartOperationInProgress) {
          console.log('[Manual Coupon Monitoring] Cart operation in progress, ignoring coupon removal (not manual)');
        } else {
          // User manually clicked X to remove this coupon
          // Show BUYMORE suggestion regardless of whether it was a BUYMORE or manual coupon
          console.log('[Manual Coupon Monitoring] User manually removed coupon, showing BUYMORE suggestion');
          handleManualCouponRemoved();
        }
      }

      lastCode = currentCode;
    }

    // Run initial check immediately
    checkDiscountState();

    // Then check every 500ms
    setInterval(checkDiscountState, 500);
  }());

  function handleCustomerAppliedCoupon(code) {
    if (isB2G1Code(code)) setB2G1Selection(true);
    // Mark as manual
    window.couponState.isManual = true;
    window.couponState.currentCode = code;

    console.log('[Manual Coupon] Switching to shipping mode for customer-applied coupon');

    // Force updateBar to process
    if (typeof window.resetCartState === 'function') {
      window.resetCartState();
    }

    // Switch to shipping mode
    if (typeof theme !== 'undefined' && theme.cart && typeof theme.cart.getCart === 'function') {
      theme.cart.invalidateCache();
      theme.cart.getCart().then(function(cart) {
        updateBar(cart);
      });
    }
  }

  function handleManualCouponRemoved() {
    console.log('[Manual Coupon] Removed, customer manually removed coupon');

    // Clear manual coupon state
    window.couponState.isManual = false;
    window.couponState.currentCode = null;

    // Set manual override flag - customer explicitly removed a coupon
    // Don't auto-apply BUYMORE until they change cart (respects their choice)
    window.couponState.manualOverride = true;

    // Persist to sessionStorage so it survives page navigation
    sessionStorage.setItem('couponManualOverride', 'true');
    console.log('[Manual Coupon] Set manualOverride=true and persisted to sessionStorage - will show suggestion only until cart changes');

    // Force updateBar to reprocess by resetting cart state
    if (typeof window.resetCartState === 'function') {
      window.resetCartState();
    }

    // Refresh cart to re-enable Buy More & Save
    if (typeof theme !== 'undefined' && theme.cart && typeof theme.cart.getCart === 'function') {
      console.log('[Manual Coupon] Refreshing cart to apply Buy More & Save...');
      theme.cart.invalidateCache();
      theme.cart.getCart().then(function(cart) {
        console.log('[Manual Coupon] Cart refreshed, calling updateBar (should show Buy More mode)');

        // Calculate one-time item count and suggest BUYMORE coupon
        var oneTimeCount = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (!item.selling_plan_allocation) {
            oneTimeCount += item.quantity;
          }
        }
        console.log('[Manual Coupon] Cart has', oneTimeCount, 'one-time items');

        // Determine which BUYMORE coupon to suggest and the discount percentage
        var suggestedCoupon = buyMore.coupon(oneTimeCount);
        var discountPercent = buyMore.percent(oneTimeCount) + '%';

        console.log('[Manual Coupon] Determined suggestion:', suggestedCoupon, discountPercent);

        // If there's a suggested coupon, set suggestion state for updateBuyMoreText to display
        if (suggestedCoupon) {
          window.couponState.showSuggestion = true;
          window.couponState.suggestionData = {
            coupon: suggestedCoupon,
            percent: discountPercent
          };

          // Persist suggestion data to sessionStorage so it survives page navigation
          sessionStorage.setItem('couponSuggestionData', JSON.stringify(window.couponState.suggestionData));
          console.log('[Manual Coupon] Set suggestion state - showSuggestion=true, suggestionData:', window.couponState.suggestionData, '(persisted to sessionStorage)');
        } else {
          console.log('[Manual Coupon] No suggestion (cart has less than 2 items)');
        }

        // Now call updateBar which will check the suggestion flags in updateBuyMoreText
        updateBar(cart);
      });
    }
  }

  /* Listen for first item added to empty cart (apply pending manual coupon) */
  $(document).on('added.ajaxProduct', function() {
    if (window.couponState.pendingManualCode && typeof theme !== 'undefined' && theme.cart && typeof theme.cart.getCart === 'function') {
      theme.cart.getCart().then(function(cart) {
        if (cart.items.length > 0) {
          console.log('[Manual Coupon] Applying pending coupon from URL');
          applyManualCouponFromURL(window.couponState.pendingManualCode);
        }
      });
    }
  });

  /* flash message */
  
  (function() {
    /* Begin flash Autofill Code */
    /* Read the Query String value from the URL */    
    /* Link: http://stackoverflow.com/a/2880929 - Notes: No clue how this regex stuff works. Probably fairy magic.  */
        var urlParams;
        (window.onpopstate = function () {
            var match,
                pl     = /\+/g,  // Regex for replacing addition symbol with a space
                search = /(msg)=?([^&]*)/g,
                decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
                query  = window.location.search.substring(1);

        urlParams = {};
        while (match = search.exec(query))
        urlParams[decode(match[1])] = decode(match[2]);
        })();

    /* If the value of the hidden discount input field is blank, undefined or null then set the contents of localstorage discount to be the result of our Query String function above */    
        if ($("#msg_input").val() == ('' || undefined || null || 'undefined')) {
        /* Set sessionStorage variable "discount" to the result of our Query string function above */
           sessionStorage.setItem("msg", urlParams["msg"]);
        }

    /* If the value in our hidden input field doesn’t match the result of our Query String function above then clear the current sessionStorage value for "discount" and replace it with the new one */
    /* Link: http://stackoverflow.com/q/19844750 */
        else if ($("#msg_input").val() != urlParams["msg"]) {
           sessionStorage.removeItem("msg");
           sessionStorage.setItem("msg", urlParams["msg"]);
        }    
    /* End Message Autofill Code */
    }());
  
  /* set discount_code cookie & set up flash message */
  
  if (Cookies.get.length > 0) {
    
	var counter = sessionStorage.getItem("counter");
    var code = Cookies.get('discount_code');
    
    if ((code == "PREPOG" || code == "WINNING" || code == "JABDPHG0B857" || code == "SHIPITFREE") && (counter ==  null)) {
      // sessionStorage.setItem("counter", 1);
      $('.coupon-flash-inner').html('Your order ships FREE! <i class="fas fa-thumbs-up"></i>' );
      setTimeout(function(){
        $('.coupon-flash-container').slideDown();
        $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      }, 1000);
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
      }, 20000);
    } else if (code == "EXTINGUISH") {
       $('.coupon-flash-inner').html('<strong>LYTES 20% OFF</strong>! Discount taken at checkout <i class="fas fa-bolt"></i>' );
      setTimeout(function(){
        $('.coupon-flash-container').slideDown();
        $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      }, 1000);
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
      }, 20000); 
    } else if (code == "GRASSFEDWHEY") {
       $('.coupon-flash-inner').html('<strong>BUILD 20% OFF</strong>! Discount taken at checkout <i class="fas fa-bolt"></i>' );
      setTimeout(function(){
        $('.coupon-flash-container').slideDown();
        $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      }, 1000);
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
      }, 20000); 
    } else if (code == "WINTERISHERE") {
       $('.coupon-flash-inner').html('<strong>WINTER SALE 20% OFF</strong>! Discount taken at checkout <i class="fas fa-bolt"></i>' );
      setTimeout(function(){
        $('.coupon-flash-container').slideDown();
        $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      }, 1000);
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
      }, 20000);
    } else if (code == "WODAPALOOZA") {
       $('.coupon-flash-inner').html('<strong>WODAPALOOZA 20% OFF</strong>! Discount taken at checkout <i class="fas fa-bolt"></i>' );
      setTimeout(function(){
        $('.coupon-flash-container').slideDown();
        $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      }, 1000);
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
      }, 20000);
    } else if (code == "SPRINGSAVINGS") {
       $('.coupon-flash-inner').html('<strong>SPRING SAVINGS 15% OFF</strong>! Discount taken at checkout <i class="fas fa-bolt"></i>' );
      setTimeout(function(){
        $('.coupon-flash-container').slideDown();
        $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      }, 1000);
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
      }, 40000);
    } else if (code == "BURN") {
       $('.coupon-flash-inner').html('<strong><a href="/products/natural-fat-burner/">BURN 20% OFF</strong>! Discount taken at checkout <i class="fas fa-bolt"></i></a>' );
      setTimeout(function(){
        $('.coupon-flash-container').slideDown();
        $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      }, 1000);
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
      }, 40000);
    } else if (code == "DEEPERSLEEP") {
       $('.coupon-flash-inner').html('<strong><a href="/products/pm-burn/">PM BURN 20% OFF</strong>! Discount taken at checkout <i class="fas fa-bolt"></i></a>' );
      setTimeout(function(){
        $('.coupon-flash-container').slideDown();
        $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      }, 1000);
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
      }, 40000);
    } else if (code == "TURBO") {
       $('.coupon-flash-inner').html('Your order is now TURBO charged! (for FREE!) <i class="fas fa-bolt"></i>' );
      setTimeout(function(){
        $('.coupon-flash-container').slideDown();
        $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      }, 1000);
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
      }, 20000);
    } else if (code == "PRIME20" && document.querySelector('[data-prime-day-ends-at]')) {
      $('.coupon-flash-inner').html('<strong>PRIME DAY 20% OFF</strong>! CODE: PRIME20 <i class="fas fa-bolt"></i>');
      setTimeout(function() {
        var promotion = document.querySelector('[data-prime-day-ends-at]');
        if (!promotion || Date.now() >= Date.parse(promotion.getAttribute('data-prime-day-ends-at'))) return;
        $('.coupon-flash-container').addClass('prime-day-coupon')
          .attr('data-prime-day-ends-at', promotion.getAttribute('data-prime-day-ends-at'))
          .slideDown().css({"position":"relative","z-index":"999","width":"100%"});
      }, 1000);
      setTimeout(function() { $('.coupon-flash-container').slideUp(); }, 20000);
    } else if (code == "CYBERDEALS") {
       $('.coupon-flash-inner').html('<strong>CYBER MONDAY 20% OFF SITEWIDE</strong>! CODE:CYBERDEALS <i class="fas fa-bolt"></i>' );
      setTimeout(function(){
        var rawData = sessionStorage.getItem('scDiscountData');
        var scDiscountData = $.parseJSON(rawData);
        var code = scDiscountData ? scDiscountData['code'] : null;
        if (code != null) {
            window.DiscountHero.discount.remove(code).then(function() {
                window.DiscountHero.discount.apply('CYBERDEALS');
            });
        } else {
            window.DiscountHero.discount.apply('CYBERDEALS');
        }
        $('.coupon-flash-container').slideDown();
        $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      }, 1000);
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
      }, 20000);
    } else if (code == "ATHBLKFRIDAY90" || code == "ATHBLKFRIDAY50" || code == "ATHBLKFRIDAY15" ) {
       $('.coupon-flash-inner').html('<strong>BLACK FRIDAY IS LIVE!</strong>! Discount taken at checkout <i class="fas fa-bolt"></i>' );
      setTimeout(function(){
        $('.coupon-flash-container').slideDown();
        $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      }, 1000);
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
      }, 20000);
    } else if (code == "EARLYBFCM") {
       $('.coupon-flash-inner').html('<strong>BUY ONE GET ONE 40% OFF</strong>! Discount taken at checkout <i class="fas fa-bolt"></i>' );
      setTimeout(function(){
        $('.coupon-flash-container').slideDown();
        $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      }, 1000);
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
      }, 20000);
    } else if (code == "BFCM50") {
       $('.coupon-flash-inner').html('<strong>BUY ONE GET ONE 50% OFF</strong>! Discount taken at checkout <i class="fas fa-bolt"></i>' );
      setTimeout(function(){
        $('.coupon-flash-container').slideDown();
        $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      }, 1000);
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
      }, 20000);
    } else if (counter == null && code != null ) {
      sessionStorage.setItem("counter", 1);
      var counter = sessionStorage.getItem("counter");
      $('.coupon-flash-inner').html('Sweet! Coupon applied. Load up! <i class="fas fa-thumbs-up"></i>' );
      setTimeout(function() {
        window.chCouponCode = code;
        $('.coupon-flash-container').slideDown();
        $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      }, 1000);
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
      }, 20000);
      console.log('code: ' + code);
    }
    
    $(window).resize(function() {
      if($(window).width() > 480 && $('.coupon-flash-container').is(':hidden')) {
        $('#shopify-section-header').css("padding-top", "0px");
      }
    });
  }
  
  if (sessionStorage.getItem("msg") != null) {
    var msg = sessionStorage.getItem("msg");
    if (msg == "email") {
      $('.coupon-flash-inner').html("Subscribed! Get 10% off with coupon ATHOHANA <i class='fas fa-thumbs-up'></i>" );
      $('.coupon-flash-container').slideDown();
      $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
        sessionStorage.removeItem("msg");
      }, 5000);
    } else if (msg == "vitamind") {
      $('.coupon-flash-inner').html("We'll email you when our Vitamin D is ready! <i class='fas fa-thumbs-up'></i>" );
      $('.coupon-flash-container').slideDown();
      $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
        sessionStorage.removeItem("msg");
      }, 8000);
    } else if (msg == "vitc") {
      $('.coupon-flash-inner').html("We'll email you when our Vitamin C is ready! <i class='fas fa-thumbs-up'></i>" );
      $('.coupon-flash-container').slideDown();
      $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
        sessionStorage.removeItem("msg");
      }, 8000);
    } else if (msg == "booty") {
      $('.coupon-flash-inner').html("You're subscribed! <i class='fas fa-thumbs-up'></i>" );
      $('.coupon-flash-container').slideDown();
      $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
        sessionStorage.removeItem("msg");
      }, 8000);
    } else if (msg == "pdf") {
      $('.coupon-flash-inner').html("Check your email for your Strength PDF! <i class='fas fa-envelope-open-text'></i>" );
      $('.coupon-flash-container').slideDown();
      $('.coupon-flash-container').css({"position":"relative","z-index":"999","width":"100%"});
      setTimeout(function(){
        $('.coupon-flash-container').slideUp();
        sessionStorage.removeItem("msg");
      }, 8000);
      
    }
    
    $(window).resize(function() {
      if($(window).width() > 480 && $('.coupon-flash-container').is(':hidden')) {
        $('#shopify-section-header').css("padding-top", "0px");
      }
    });
  }

  
  
  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *
   * Alternatives
   * - Accounting.js - http://openexchangerates.github.io/accounting.js/
   *
   */
  
  theme.Currency = (function() {
    var moneyFormat = '$';
  
    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = slate.utils.defaultTo(precision, 2);
        thousands = slate.utils.defaultTo(thousands, ',');
        decimal = slate.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    return {
      formatMoney: formatMoney
    }
  })();
  
  
  /**
   * Image Helper Functions
   * -----------------------------------------------------------------------------
   * A collection of functions that help with basic image operations.
   *
   */
  
  theme.Images = (function() {
  
    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }
  
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
  
      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }
  
    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
      if (size == null) {
        return src;
      }
  
      if (size === 'master') {
        return this.removeProtocol(src);
      }
  
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
  
        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }
  
      return null;
    }
  
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
  
    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol
    };
  })();
  
  slate.Variants = (function() {
  
    function Variants(options) {
      this.$container = options.$container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();

      //this._filterThumbnails(this.currentVariant);
  
      $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }
    
    
    Variants.prototype = $.extend({}, Variants.prototype, {
  
      _getCurrentOptions: function() {
        var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};
  
          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');
  
              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
  
            return currentOption;
          }
        });
  
        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = this._compact(currentOptions);
  
        return currentOptions;
      },
  
      _getVariantFromOptions: function() {
        var selectedValues = this._getCurrentOptions();
        var variants = this.variants;
        var found = false;
  
        variants.forEach(function(variant) {
          var match = true;
          var options = variant.options;
  
          selectedValues.forEach(function(option) {
  
            if (match) {
              match = (variant[option.index] === option.value);
            }
          });
  
          if (match) {
            found = variant;
          }
        });
  
        return found || null;
      },
  
      _onSelectChange: function() {
        var variant = this._getVariantFromOptions();

        console.log('[DEBUG _onSelectChange] variant:', variant ? {
          id: variant.id,
          title: variant.title,
          featured_image: variant.featured_image ? {
            id: variant.featured_image.id,
            src: variant.featured_image.src,
            alt: variant.featured_image.alt
          } : null
        } : null);
        console.log('[DEBUG _onSelectChange] currentVariant:', this.currentVariant ? {
          id: this.currentVariant.id,
          title: this.currentVariant.title,
          featured_image: this.currentVariant.featured_image ? {
            id: this.currentVariant.featured_image.id,
            src: this.currentVariant.featured_image.src
          } : null
        } : null);

        this.$container.trigger({
          type: 'variantChange',
          variant: variant
        });

        if (!variant) {
          console.log('[DEBUG _onSelectChange] No variant found, returning early');
          return;
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);

        //custom filterThumbnails
        //this._filterThumbnails(variant);

        this._updatePrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;
        
  
        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
        
        //add fade in on product page for afterpay snippet
//         if($('.afterpay-paragraph')){
//             setTimeout(function(){
//               $('.afterpay-paragraph').fadeIn('slow');
//             }, 1500);
//           }
      },

      // custom function to filter thumbnails
      _filterThumbnails: function(variant){

      if(variant != null && variant.featured_image != null && variant.featured_image.alt != null) {

        $('[data-thumbnail-flavor]').hide();
          
        //show thumbnails for selected flavor
        var selected_flavor = variant.featured_image.alt;
        
        $('[data-thumbnail-flavor]').filter('[data-thumbnail-flavor]:contains(' + selected_flavor + ')').show();

        if ($('.product-supplement-facts')){
          $('.product-supplement-facts').off();
          $('.product-supplement-facts').on('click', function() {
            $('[data-thumbnail-flavor]').filter('[data-thumbnail-flavor]:contains(' + selected_flavor + ' SFP)').click();
            window.scrollTo({top: 0, behavior: 'smooth'});
          })
        }

        // var thumbnail_selector = '[data-thumbnail-flavor="' + selected_flavor + '"]';
        // $(thumbnail_selector).show();    
        
        if($('[data-thumbnail-flavor="Key Benefits"')){
          $('[data-thumbnail-flavor="Key Benefits"').show();  
        }
        if($('[data-thumbnail-flavor="Review"')){
          $('[data-thumbnail-flavor="Review"').show();  
        }
        if($('[data-thumbnail-flavor="Aminos"')){
          $('[data-thumbnail-flavor="Aminos"').show();  
        }
        if($('[data-thumbnail-flavor="Spotlight"')){
          $('[data-thumbnail-flavor="Spotlight"').show();  
        }
        
      } else {
        //show all thumbnails
        $('[data-thumbnail-flavor]').show();
      }
      
    },
  
      _updateImages: function(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = (this.currentVariant && this.currentVariant.featured_image) || {};

        console.log('[DEBUG _updateImages] variant.featured_image:', variant.featured_image ? {
          id: variant.featured_image.id,
          src: variant.featured_image.src,
          alt: variant.featured_image.alt
        } : 'NULL/UNDEFINED');
        console.log('[DEBUG _updateImages] currentVariant.featured_image:', currentVariantImage.src ? {
          src: currentVariantImage.src
        } : 'NULL/UNDEFINED');
        console.log('[DEBUG _updateImages] same src?', variantImage.src === currentVariantImage.src);

        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          console.log('[DEBUG _updateImages] BAILING EARLY — no featured_image or same src. variantImageChange will NOT fire.');
          return;
        }

        console.log('[DEBUG _updateImages] Firing variantImageChange event');
        this.$container.trigger({
          type: 'variantImageChange',
          variant: variant
        });
      },
  
      _updatePrice: function(variant) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantPriceChange',
          variant: variant
        });
      },
  
      _updateSKU: function(variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantSKUChange',
          variant: variant
        });
      },
  
      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }
  
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
      },
  
      _updateMasterSelect: function(variant) {
        $(this.originalSelectorId, this.$container).val(variant.id);
      },
  
      // _.compact from lodash
      // https://github.com/lodash/lodash/blob/4d4e452ade1e78c7eb890968d851f837be37e429/compact.js
      _compact: function(array) {
        var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];
  
        while (++index < length) {
          var value = array[index];
          if (value) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
    });
  
    return Variants;
  })();
  
  // subscribe & save hide when toggle on product page
  if(window.location.pathname.indexOf('bundle') == -1){
    $('.rc_radio__autodeliver').on('click', function() {
      $('input[name=Quantity]:nth(0)').trigger('click');
      $('.variant-wrapper').eq(0).css("display","none");
    });
    $('.rc_radio__onetime').on('click', function() {
      $('input[name=Quantity]:nth(0)').trigger('click');
      $('.variant-wrapper').eq(0).css("display", "block");
    });
  }
  
  
  
  // Handbars helpers
  
  Handlebars.registerHelper('if_eq', function(a, b, opts) {
    if(a == b) // Or === depending on your needs
        return opts.fn(this);
    else
        return opts.inverse(this);
  });

  Handlebars.registerHelper('option', function(value, label, selectedValue) {
    var selectedProperty = value == selectedValue ? 'selected="selected"' : '';
    return new Handlebars.SafeString('<option value="' + value + '"' +  selectedProperty + '>' + label + "</option>");
  });

  Handlebars.registerHelper('or', function (a, b, options) {
    return a || b ? options.fn(this) : options.inverse(this);
  });
  
  /**
   * iFrames
   * -----------------------------------------------------------------------------
   * Wrap videos in div to force responsive layout.
   *
   * @namespace iframes
   */
  
  slate.rte = {
    wrapTable: function() {
      $('.rte table').wrap('<div class="table-wrapper"></div>');
    },
  
    wrapVideo: function() {
      var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
      var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');
  
      $iframeVideo.each(function () {
        // Add wrapper to make video responsive
        if (!$(this).parents('.video-wrapper').length) {
          $(this).wrap('<div class="video-wrapper"></div>');
        }
      });
  
      $iframeReset.each(function () {
        // Re-set the src attribute on each iframe after page load
        // for Chrome's "incorrect iFrame content on 'back'" bug.
        // https://code.google.com/p/chromium/issues/detail?id=395791
        // Need to specifically target video and admin bar
        this.src = this.src;
      });
    }
  };
  

  theme.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: 'modal-open',
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };
  
      this.id = id;
      this.$modal = $('#' + id);
  
      if (!this.$modal.length) {
        return false;
      }
  
      this.nodes = {
        $parent: $('html').add('body'),
        $modalContent: this.$modal.find('.modal__inner')
      };
  
      this.config = $.extend(defaults, options);
      this.modalIsOpen = false;
      this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
      this.isSolid = this.config.solid;
  
      this.init();
    }
  
    Modal.prototype.init = function() {
      var $openBtn = $(this.config.open);
  
      // Add aria controls
      $openBtn.attr('aria-expanded', 'false');
  
      $(this.config.open).on('click', this.open.bind(this));
      this.$modal.find(this.config.close).on('click', this.close.bind(this));
  
      // Close modal if a drawer is opened
      $('body').on('drawerOpen', function() {
        this.close();
      }.bind(this));
    };
  
    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
  
      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }
  
      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
  
      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget);
      }
  
      if (this.modalIsOpen && !externalCall) {
        this.close();
      }
  
      this.$modal
        .prepareTransition()
        .addClass(this.config.openClass);
      this.nodes.$parent.addClass(this.config.bodyOpenClass);
  
      if (this.isSolid) {
        this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = true;
  
      slate.a11y.trapFocus({
        $container: this.$modal,
        $elementToFocus: this.$focusOnOpen,
        namespace: 'modal_focus'
      });
  
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      }
  
      $('body').trigger('modalOpen.' + this.id);
  
      this.bindEvents();
    };
  
    Modal.prototype.close = function() {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }
  
      // deselect any focused form elements
      $(document.activeElement).trigger('blur');
  
      this.$modal
        .prepareTransition()
        .removeClass(this.config.openClass)
        .addClass(this.config.closingClass);
      this.nodes.$parent.removeClass(this.config.bodyOpenClass);
      this.nodes.$parent.addClass(this.config.bodyClosingClass);
      var o = this;
      window.setTimeout(function() {
        o.nodes.$parent.removeClass(o.config.bodyClosingClass);
        o.$modal.removeClass(o.config.closingClass);
      }, 500); // modal close css transition
  
      if (this.isSolid) {
        this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = false;
  
      slate.a11y.removeTrapFocus({
        $container: this.$modal,
        namespace: 'modal_focus'
      });
  
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'false').focus();
      }
  
      $('body').trigger('modalClose.' + this.id);
  
      this.unbindEvents();
    };
  
    Modal.prototype.bindEvents = function() {
      // Pressing escape closes modal
      this.nodes.$parent.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
  
      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.$modal.on('click.modal', this.close.bind(this));
  
        // Exception to above: clicking anywhere on the modal content will NOT close it
        this.nodes.$modalContent.on('click.modal', function(evt) {
          evt.stopImmediatePropagation();
        });
      }
    };
  
    Modal.prototype.unbindEvents = function() {
      this.nodes.$parent.off('.modal');
  
      if (this.config.closeOffContentClick) {
        this.$modal.off('.modal');
        this.nodes.$modalContent.off('.modal');
      }
    };
  
    return Modal;
  })();
  
  theme.Drawers = (function() {
    function Drawer(id, name, ignoreScrollLock) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };
  
      this.$nodes = {
        parent: $(document.documentElement).add('body'),
        page: $('#MainContent')
      };
  
      this.$drawer = $('#' + id);
  
      if (!this.$drawer.length) {
        return false;
      }
  
      this.isOpen = false;
      this.ignoreScrollLock = ignoreScrollLock;
      this.init();
    };
  
    Drawer.prototype = $.extend({}, Drawer.prototype, {
      init: function() {
        var $openBtn = $(this.config.open);
  
        // Add aria controls
        $openBtn.attr('aria-expanded', 'false');
  
        $openBtn.on('click', this.open.bind(this));
        this.$drawer.find(this.config.close).on('click', this.close.bind(this));
      },
  	  //open Drawer
      open: function(evt) {
        if (evt) {
          evt.preventDefault();
          $('#sticky-add-to-cart').fadeOut('slow');
          if ($('.site-nav--has-dropdown-hover')){
            $('.site-nav--has-dropdown-hover').removeClass('site-nav--has-dropdown-hover');
          }
        }
  
        if (this.isOpen) {
          return;
        }
  
        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          this.$activeSource = $(evt.currentTarget);
        }
  
        this.$drawer.prepareTransition().addClass(this.config.activeDrawer);
  
        this.$nodes.parent.addClass(this.config.openClass);
        this.isOpen = true;
  
        slate.a11y.trapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });
  
        $('body').trigger('drawerOpen.' + this.config.id);
  
        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
          this.$activeSource.attr('aria-expanded', 'true');
        }
  
        this.bindEvents();
      },
  
      close: function() {
        if (!this.isOpen) {
          return;
        }
  
        // deselect any focused form elements
        $(document.activeElement).trigger('blur');
  
        this.$drawer.prepareTransition().removeClass(this.config.activeDrawer);
  
        this.$nodes.parent.removeClass(this.config.openClass);
        this.$nodes.parent.addClass(this.config.closingClass);
        var o = this;
        window.setTimeout(function() {
          o.$nodes.parent.removeClass(o.config.closingClass);
        }, 500);
  
        this.isOpen = false;
  
        slate.a11y.removeTrapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });
  
        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
          this.$activeSource.attr('aria-expanded', 'false');
        }
  
        this.unbindEvents();
      },
  
      bindEvents: function() {
        if (!this.ignoreScrollLock) {
          slate.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page);
        }
  
        // Clicking out of drawer closes it.
        // Check to see if clicked on element in drawer
        // because of any drawer built witin #MainContent
        this.$nodes.page.on('click' + this.config.namespace, function (evt) {
          var $target = $(evt.target);
          var doNotClose = this.elementInsideDrawer($target);
          if (!doNotClose) {
            this.close();
            return false;
          }
  
        }.bind(this));
  
        // Pressing escape closes drawer
        this.$nodes.parent.on('keyup' + this.config.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));

        // $('body').trigger('closeDrawer') closes drawer
        this.$nodes.parent.on('closeDrawer' + this.config.namespace, function(evt) {
          this.close();
          console.log('closeDrawer');
        }.bind(this));
      },
  
      unbindEvents: function() {
        if (!this.ignoreScrollLock) {
          slate.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page);
        }
        this.$nodes.parent.off(this.config.namespace);
        this.$nodes.page.off(this.config.namespace);
      },
  
      // Check if clicked element is inside the drawer
      elementInsideDrawer: function($el) {
        return this.$drawer.find($el).length;
      }
    });
  
    return Drawer;
  })();
  
  theme.CartAvailability = (function() {
    var pending = null;
    var checkedState = null;
    var checkedAt = 0;
    var generation = 0;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    function signature(cart) {
      return JSON.stringify([cart.token, cart.total_price, cart.items.map(function(item) {
        return [item.key, item.quantity];
      })]);
    }

    function request(path, data) {
      var options = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
      if (data) {
        options.method = 'POST';
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(data);
      }
      return fetch(root + path, options).then(function(response) {
        if (!response.ok) throw new Error('Cart availability request failed: ' + response.status);
        return response.json();
      });
    }

    function isCart(cart) {
      return cart && Array.isArray(cart.items) && typeof cart.item_count === 'number';
    }

    function clean(cart) {
      if (pending) return pending;
      if (!isCart(cart) || !cart.items.length) return Promise.resolve(cart);
      if (checkedState === signature(cart) && Date.now() - checkedAt < 30000) {
        return Promise.resolve(cart);
      }

      function checkAvailability() {
        var requestGeneration = generation;
        return request('cart?view=availability').then(function(snapshot) {
          // A cart operation may finish while this read is in flight. Get new
          // keys and availability before deleting or returning the old snapshot.
          if (requestGeneration !== generation) return null;
          if (!snapshot || !isCart(snapshot.cart) || !Array.isArray(snapshot.items)) {
            throw new Error('Invalid cart availability response');
          }
          var unavailable = snapshot.items.filter(function(item) {
            return item.available === false && snapshot.cart.items.some(function(line) {
              return line.key === item.key && line.variant_id === item.variant_id;
            });
          });
          if (!unavailable.length) return snapshot.cart;

          // Live keys distinguish subscription, one-time, and custom-property lines.
          // Only zero the unavailable lines; leave all other quantities unchanged.
          var updates = {};
          unavailable.forEach(function(item) { updates[item.key] = 0; });
          return request('cart/update.js', { updates: updates }).then(function(updatedCart) {
            if (!isCart(updatedCart) || unavailable.some(function(item) {
              return updatedCart.items.some(function(line) { return line.variant_id === item.variant_id; });
            })) {
              throw new Error('Sold-out cart items were not removed');
            }
            // Refresh server-rendered cart rows and totals. The drawer uses its
            // normal empty-cart message when the final item is removed.
            if (window.location.pathname.replace(/\/+$/, '') === root.replace(/\/+$/, '') + '/cart') {
              window.location.reload();
            }
            return updatedCart;
          });
        }).then(function(updatedCart) {
          return requestGeneration === generation ? updatedCart : checkAvailability();
        });
      }

      pending = checkAvailability().then(function(updatedCart) {
        checkedState = signature(updatedCart);
        checkedAt = Date.now();
        pending = null;
        return updatedCart;
      }, function(error) {
        pending = null;
        checkedState = null;
        throw error;
      });
      return pending;
    }

    return {
      clean: clean,
      invalidate: function() {
        checkedState = null;
        generation++;
      }
    };
  })();

  theme.cart = {
    _cartCache: null,
    _cartCacheTime: 0,
    _cartCacheTTL: 1000, // Cache cart for 1 second to prevent 429 errors
    _pendingCartRequest: null,
    _cartRequestVersion: 0,

    getCart: function() {
      var now = Date.now();
      var self = this;
      var requestVersion = this._cartRequestVersion;

      // Return cached cart if still valid
      if (this._cartCache && (now - this._cartCacheTime) < this._cartCacheTTL) {
        return $.Deferred().resolve(this._cartCache).promise();
      }

      // If there's already a pending request, return that promise
      if (this._pendingCartRequest) {
        return this._pendingCartRequest;
      }

      // Make new request and cache result
      this._pendingCartRequest = $.getJSON('/cart.js').then(function(cart) {
        return theme.CartAvailability.clean(cart).catch(function(error) {
          console.warn('[Cart Availability] Could not validate saved cart:', error);
          return cart;
        });
      }).then(function(cart) {
        // Invalidated requests must not overwrite a newer cart or pending read.
        if (requestVersion !== self._cartRequestVersion) return self.getCart();
        self._cartCache = cart;
        self._cartCacheTime = Date.now();
        self._pendingCartRequest = null;
        return cart;
      }).fail(function() {
        if (requestVersion === self._cartRequestVersion) self._pendingCartRequest = null;
      });

      return this._pendingCartRequest;
    },

    // Force fresh fetch (bypasses cache)
    getCartFresh: function() {
      this.invalidateCache();
      return this.getCart();
    },

    // Invalidate cache (call after cart modifications)
    invalidateCache: function() {
      this._cartCache = null;
      this._cartCacheTime = 0;
      this._pendingCartRequest = null;
      this._cartRequestVersion++;
      theme.CartAvailability.invalidate();
    },
  
    changeItem: function(key, qty) {
      return this._updateCart({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + qty + '&id=' + key,
        dataType: 'json'
      });
    },
  
    addItemFromForm: function(data) {
      var self = this;
      // Invalidate cache before adding - /cart/add.js returns product, not cart
      self.invalidateCache();
      return $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json'
      }).then(function(product) {
        // Invalidate cache again after add to ensure fresh cart fetch
        self.invalidateCache();
        return product;
      });
    },

    _updateCart: function(params) {
      var self = this;
      // Invalidate cache before making changes
      self.invalidateCache();
      return $.ajax(params)
        .then(function(response) {
          // Reads started during this mutation must also discard their old state.
          self.invalidateCache();
          // Only cache if response looks like a cart (has items array)
          if (response && response.items && Array.isArray(response.items)) {
            self._cartCache = response;
            self._cartCacheTime = Date.now();
          }
          return response;
        }.bind(this))
    },
  
    updateNote: function(note) {
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + theme.cart.attributeToString(note),
        dataType: 'json',
        success: function(cart) {},
        error: function(XMLHttpRequest, textStatus) {}
      };
  
      $.ajax(params);
    },
  
    attributeToString: function(attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return $.trim(attribute);
    }
  }
  
  $(function() {
    // Add a loading indicator on the cart checkout button (/cart and drawer)
    $('body').on('click', '.cart__checkout', function(e) {
      $(this).addClass('btn--loading');
    });
  
    $('body').on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();
      theme.cart.updateNote(newNote);
    });
  
  
    // Custom JS to prevent checkout without confirming terms and conditions
    $('body').on('click', '.cart__checkout--ajax', function(evt) {
      console.log('cart checkout clicked 4447');
      if ($('#CartAgree').is(':checked')) {
      } else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });
  
    $('body').on('click', '.cart__checkout--page', function(evt) {
      if ($('#CartPageAgree').is(':checked')) {
      } else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });

    // Handle cart drawer checkout button (footer is moved outside form by sizeFooter)
    $('body').on('click', '.cart-checkout-button-drawer', function(evt) {
      // Check terms if enabled
      if ($('#CartAgree').length && !$('#CartAgree').is(':checked')) {
        evt.preventDefault();
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }

      // Add loading state
      $(this).addClass('btn--loading');

      // Submit the cart form to checkout
      var $form = $('#ajax_cart_drawer');
      if ($form.length) {
        // Create a hidden input for checkout action
        if (!$form.find('input[name="checkout"]').length) {
          $form.append('<input type="hidden" name="checkout" value="true">');
        }
        $form.submit();
      } else {
        // Fallback: redirect to checkout directly
        window.location.href = '/checkout';
      }
    });
  });
  
  theme.QtySelector = (function() {
    var classes = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };
  
    function QtySelector($el, options) {
      this.$wrapper = $el;
      this.$originalInput = $el.find('input[type="number"]');
      this.minValue = this.$originalInput.attr('min') || 1;
  
      var defaults = {
        namespace: null
      };
  
      this.options = $.extend(defaults, options);
  
      this.source = $('#JsQty').html();
      this.template = Handlebars.compile(this.source);
  
      var quantities = {
        current: this._getOriginalQty(),
        add: this._getOriginalQty() + 1,
        minus: this._getOriginalQty() - 1
      };
  
      this.data = {
        key: this._getProductKey(),
        itemQty: quantities.current,
        itemAdd: quantities.add,
        itemMinus: quantities.minus,
        inputName: this._getInputName(),
        inputId: this._getId()
      }
  
      // Append new quantity selector then remove original
      this.$originalInput.after(this.template(this.data)).remove();
      this.$input = this.$wrapper.find(classes.input);
      this.$input.prop("readonly", true);
      this.$plus = this.$wrapper.find(classes.plus);
      this.$minus = this.$wrapper.find(classes.minus);
  
      this.initEventListeners();
    };
  
    QtySelector.prototype = $.extend({}, QtySelector.prototype, {
      _getProductKey: function() {
        return this.$originalInput.data('id') || null;
      },
  
      _getOriginalQty: function() {
        return parseInt(this.$originalInput.val());
      },
  
      _getInputName: function() {
        return this.$originalInput.attr('name');
      },
  
      _getId: function() {
        return this.$originalInput.attr('id');
      },
  
      initEventListeners: function() {
        this.$plus.on('click', function() {
          // Prevent rapid clicks while processing
          if (this.isProcessing) {
            console.log('[QtySelector] Ignoring plus click - already processing');
            return;
          }
          var qty = this.validateQty(this.$input.val());
          this.addQty(qty);
        }.bind(this));
  
        this.$minus.on('click touchend', function() {
          // Prevent rapid clicks while processing
          if (this.isProcessing) {
            console.log('[QtySelector] Ignoring minus click - already processing');
            return;
          }
          var qty = this.validateQty(this.$input.val());
          this.subtractQty(qty);
        }.bind(this));
  
        this.$input.on('change', function() {
          var qty = this.validateQty(this.$input.val());
          this.changeQty(qty);
        }.bind(this));
      },
  
      addQty: function(number) {
        this.isProcessing = true;
        // Failsafe: reset processing flag after 5 seconds in case of stuck state
        var self = this;
        setTimeout(function() { self.isProcessing = false; }, 5000);
        var qty = number + 1;
        this.changeQty(qty);
      },
  
      subtractQty: function(number) {
        console.log('[event start] subtractQty 4991');
        this.isProcessing = true;
        // Failsafe: reset processing flag after 5 seconds in case of stuck state
        var self = this;
        setTimeout(function() { self.isProcessing = false; }, 5000);
        var qty = number - 1;
        if (qty <= this.minValue) {
          qty = this.minValue;
        }
        var code;
        if(sessionStorage.getItem('scDiscountData')){
          var rawData = sessionStorage.getItem('scDiscountData');
          var scDiscountData = $.parseJSON(rawData);
          code = scDiscountData['code'];
        }
        theme.cart.getCart().then((cart) => {
          if(cart.items.length == 1 && code != null && cart.item_count == 1 ){
            window.DiscountHero.discount.remove().then(() => {
              console.log('line 5415');
              //this.changeQty(qty);
              clearCart().then(function(){
                $('.free-shipping-amount').text('$99.00');
                $('.progress-fill').css('width', '0%');
                $('#CartContainer').empty();
                $('#CartContainer').append('<p class="empty-notice">Oops your cart is empty.<br />You can fix that - <a href="/collections/all">shop now!</a></p>');
                if($('.cart-loading')){
                    $('#CartDrawer').find('.cart-loading').remove();
                }
                $('.cart-link__bubble--visible').hide();
              })
            })
          } else if (cart.items.length == 1 && cart.item_count == 1){
            this.changeQty(qty);
            console.log('last item in cart');
            $('.free-shipping-amount').text('$99.00');
            $('.progress-fill').css('width', '0%');
            $('#CartContainer').empty();
            $('#CartContainer').append('<p class="empty-notice">Oops your cart is empty.<br />You can fix that - <a href="/collections/all">shop now!</a></p>');
            if($('.cart-loading')){
                $('#CartDrawer').find('.cart-loading').remove();
            }
            $('.cart-link__bubble--visible').hide();
          } else {
            this.changeQty(qty);
          }
        })
      },
  
      changeQty: function(qty) {
        $('#CartDrawer').append("<div class='cart-loading'></div>");
        this.$input.val(qty);
        this.$input.closest('.ajaxcart__item').attr('data-qty', qty);
        // FIX: Pass line number and variant ID along with key for reliable item lookup
        var $item = this.$input.closest('.ajaxcart__item');
        var domKey = $item.attr('data-key');
        var line = $item.attr('data-line');
        var variantId = $item.attr('data-id');
        console.log('[QtySelector] changeQty - line:', line, 'variantId:', variantId, 'domKey:', domKey, 'qty:', qty);
        $('body').trigger('qty' + this.options.namespace, [domKey, qty, line, variantId]);
      },
  
      validateQty: function(number) {
        if((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          number = 1;
        }
        return parseInt(number);
      }
    });
  
    return QtySelector;
  })();
  
  theme.CartDrawer = (function() {
    var config = {
      namespace: '.ajaxcart'
    };
  
    var selectors = {
      drawer: '#CartDrawer',
      container: '#CartContainer',
      template: '#CartTemplate',
      fixedFooter: '.drawer__footer--fixed',
      fixedInnerContent: '.drawer__inner--has-fixed-footer',
      cartBubble: '.cart-link__bubble'
    };
  
    function CartDrawer() {
      this.status = {
        loaded: false,
        loading: false
      };
  
      this.qtySelectors = [];
  
      this.drawer = new theme.Drawers('CartDrawer', 'cart');
  
      // Prep handlebars template
      var source = $(selectors.template).html();

      // DEBUG: Check template source
      console.log('[CartDrawer Init] Template source length:', source ? source.length : 'null');
      console.log('[CartDrawer Init] Source contains drawer__footer?', source ? source.indexOf('drawer__footer') > -1 : false);
      console.log('[CartDrawer Init] Source contains checkout button?', source ? source.indexOf('cart-checkout-button') > -1 : false);

      this.template = Handlebars.compile(source);

      // Build cart on page load so it's ready in the drawer
      theme.cart.getCart().then(this.buildCart.bind(this));
  
      this.initEventListeners();
    };
  
    // Track last cart state to prevent redundant rebuilds
    var lastBuildCartState = null;
    var calculatedDebounceTimer = null;

    CartDrawer.prototype = $.extend({}, CartDrawer.prototype, {
      initEventListeners: function() {
        $('body').on('updateCart' + config.namespace, this.initQtySelectors.bind(this));
        //$('body').on('updateCart' + config.namespace, this.sizeFooter.bind(this));
        $('body').on('updateCart' + config.namespace, this.updateCartNotification.bind(this));
        $('body').on('drawerOpen.CartDrawer', this.sizeFooter.bind(this));
        $('body').on('drawerOpen.CartDrawer', function() {
          theme.cart.invalidateCache();
          theme.cart.getCart().then(function(cart) {
            this.buildCart(cart, false, 'drawerOpen.CartDrawer');
          }.bind(this));
        }.bind(this));

        $(window).on('resize' + config.namespace, $.debounce(150, this.sizeFooter.bind(this)));

        // Debounced handler for calculated.ajaxProduct to batch rapid discount recalculations
        var self = this;
        $('body').on('calculated.ajaxProduct', function() {
          console.log('[REBUILD TRIGGER] calculated.ajaxProduct fired at', new Date().toISOString());

          // Clear any pending debounce timer
          if (calculatedDebounceTimer) {
            clearTimeout(calculatedDebounceTimer);
            console.log('[REBUILD TRIGGER] Debouncing - cleared previous timer');
          }

          // Debounce by 300ms to batch rapid fires from discount recalculations
          calculatedDebounceTimer = setTimeout(function() {
            theme.cart.getCart().then(function(cart) {
              // Create cart state signature
              var cartState = cart.item_count + '-' + cart.total_price;

              // Skip rebuild if cart state hasn't changed
              if (lastBuildCartState === cartState) {
                console.log('[REBUILD TRIGGER] SKIPPED calculated.ajaxProduct - cart unchanged:', cartState);
                return;
              }

              console.log('[REBUILD TRIGGER] Processing calculated.ajaxProduct - cart changed:', lastBuildCartState, '->', cartState);
              self.buildCart(cart, false, 'calculated.ajaxProduct');
            });
          }, 300);
        });

        $('body').on('added.ajaxProduct', function() {
          console.log('[REBUILD TRIGGER] added.ajaxProduct fired at', new Date().toISOString());

          // Mark cart operation in progress
          window.couponState.cartOperationInProgress = true;
          console.log('[Cart Operation] Set cartOperationInProgress=true (item added)');

          // Clear any existing timeout to prevent premature flag clearing
          if (window.couponState.cartOperationTimeoutId) {
            clearTimeout(window.couponState.cartOperationTimeoutId);
            console.log('[Cart Operation] Cleared previous timeout (item added)');
          }

          // Clear with delay to ensure monitoring code sees the flag
          window.couponState.cartOperationTimeoutId = setTimeout(function() {
            window.couponState.cartOperationInProgress = false;
            window.couponState.cartOperationTimeoutId = null;
            console.log('[Cart Operation] Cleared cartOperationInProgress=false (after item added)');
          }, 1500);

          // Clear manual override flag when cart changes - customer added item
          if (window.couponState.manualOverride) {
            console.log('[Manual Override] Cleared - cart changed (item added), resuming auto-apply');
            window.couponState.manualOverride = false;
            window.couponState.showSuggestion = false;
            window.couponState.suggestionData = null;

            // Clear from sessionStorage
            sessionStorage.removeItem('couponManualOverride');
            sessionStorage.removeItem('couponSuggestionData');
            console.log('[Manual Override] Cleared from sessionStorage');
          }

          theme.cart.getCart().then(function(cart) {
            // Check for pending manual discount from URL param (persists across page navigations)
            var pendingDiscount = sessionStorage.getItem('pendingManualDiscount');
            if (pendingDiscount && cart.items.length > 0) {
              console.log('[Manual Coupon] Found pending manual discount after item added:', pendingDiscount);
              // Clear from sessionStorage so it's only applied once
              sessionStorage.removeItem('pendingManualDiscount');
              // Apply the manual coupon
              window.couponState.isManual = true;
              window.couponState.pendingManualCode = pendingDiscount;
              applyManualCouponFromURL(pendingDiscount);
            }

            // Don't open drawer if on cart page - just rebuild cart in background
            // Exact match only — a substring test also matched /collections/cart-recommender
            // (and any handle starting with "cart"), silently suppressing the drawer there.
            var isCartPage = window.location.pathname === '/cart' || window.location.pathname.indexOf('/cart/') === 0;
            this.buildCart(cart, !isCartPage, 'added.ajaxProduct');
          }.bind(this));
        }.bind(this));

        $('body').on('added.closeDrawer', function() {
          console.log('[REBUILD TRIGGER] added.closeDrawer fired at', new Date().toISOString());
          theme.cart.getCart().then(function(cart) {
            this.buildCart(cart, false, 'added.closeDrawer');
          }.bind(this));
        }.bind(this));

        // FIX: Bind qty.cart-drawer listener ONCE here instead of in initQtySelectors
        // This prevents duplicate listeners from stacking on each cart rebuild
        console.log('[CartDrawer] Binding qty.cart-drawer listener ONCE in initEventListeners');
        $('body').on('qty.cart-drawer', this.updateItem.bind(this));
      },

      buildCart: function(cart, openDrawer, triggerSource) {
        // Safety check - if cart is invalid, refetch it
        if (!cart || typeof cart.item_count === 'undefined' || typeof cart.items === 'undefined') {
          console.log('[BUILD CART] Invalid cart object received, refetching...');
          var self = this;
          theme.cart.getCart().then(function(freshCart) {
            if (freshCart && typeof freshCart.item_count !== 'undefined') {
              self.buildCart(freshCart, openDrawer, triggerSource + ' (refetched)');
            } else {
              console.log('[BUILD CART] Refetch also failed, aborting');
            }
          });
          return;
        }

        // Update last cart state for deduplication
        lastBuildCartState = cart.item_count + '-' + cart.total_price;

        console.log('[BUILD CART] ========================================');
        console.log('[BUILD CART] Triggered by:', triggerSource || 'unknown');
        console.log('[BUILD CART] Time:', new Date().toISOString());
        console.log('[BUILD CART] Cart items:', cart.item_count, 'Total:', cart.total_price);
        console.log('[BUILD CART] State:', lastBuildCartState);
        console.log('[BUILD CART] ========================================');
        this.loading(true);

        // Cart-drawer display titles only: strip SEO-only words (kept in the real
        // product titles for search) so titles fit on one line without wrapping.
        // Idempotent, so safe to re-apply on every rebuild.
        function trimCartTitle(t) {
          return String(t || '')
            .replace(/\bZERO[-\s]?SUGAR\b/gi, '')
            .replace(/\bGRASSFED\b/gi, '')
            .replace(/\bPROBIOTICS\b/gi, '')
            .replace(/\bELECTROLYTES\b/gi, '') // "LYTES ELECTROLYTES" -> "LYTES" (staple flavors); "LYTES LIMITED FLAVORS" is untouched
            .replace(/\s{2,}/g, ' ')
            .trim();
        }

        // Preserve the FBT recommendations block with its rendered Okendo stars before
        // emptying the cart (the old fixed #add_on_* blocks no longer exist —
        // #cart_recommendations is the single dynamic rec block now).
        var $savedAddons = {};
        $('#cart_recommendations').each(function() {
          var id = $(this).attr('id');
          // Only save if it has rendered stars
          if ($(this).find('.oke-sr').length) {
            $savedAddons[id] = $(this).clone(true);
          }
        });

        this.emptyCart();
        var rawData = sessionStorage.getItem('scDiscountData');
        var scDiscountData = rawData ? $.parseJSON(rawData) : null;
        var code = scDiscountData ? scDiscountData['code'] : null;
              
        if (cart.item_count === 0) {
          $('#CartDrawer').addClass('cart-empty');
          $(selectors.container).append('<p class="empty-notice">Oops your cart is empty.<br />You can fix that - <a href="/collections/all">shop now!</a></p>');
          if($('.cart-loading')){
            $('#CartDrawer').find('.cart-loading').remove();
          }
          $('.cart-link__bubble--visible').hide();
          this.loading(false);
          return;
        } else {
          $('#CartDrawer').removeClass('cart-empty');
          var items = [];
          var item = {};
          var data = {};
          var animation_row = 1;
          var has_multi = false, has_burn = false, has_ebook = false;
          var isSubscription = false;
          var subscriptionSavings;
          var subscriptionOriginalTotal = 0;
          var subscriptionCart = false;
          var offerShirt = false;
          var offerTowel = false;
          var offerShaker = false;
          var offerMulti = false;
          var showFatLossEbook = false;
          var has_shirt = false;
          var has_towel = false;
          var has_gut = false;
          var showStrongerEbook = false;
          var has_creatine = false;
          var has_lytes_lemon_lime = false;
          var has_lytes_orange = false;
          var has_lytes_cocoa = false;
          var has_strength_ebook = false;
          var has_krill = false;
          var has_fat_loss_ebook = false;
          var has_gift = false;
          
          $.each(cart.items, function(index, product) {
            var showQty = true;
            var price = 'FREE';
            var show_subscription = false;
            var compareAt = false;
            var productUrl = product.url;

            // check for shipping protection product, if so return

            if (productUrl.indexOf('unlocked') >= 0) {
              productUrl = "/collections/all"
            }
            if (product.product_type == "Supplements" || product.product_type == "Bundle" || product.product_type == "Protein Powders"){
              show_subscription = true;
            }
            if (product.id == 43162740621488 || product.id == 43908693360816 || product.id == 44019907428528){
              show_subscription = false;
            }
            if (product.product_id == 6873391071408) {
              has_shirt = true;
            }
            if (product.product_id == 7974457508016) {
              has_multi = true;
            }
            if (product.product_id == 576615415842) {
              has_krill = true;
            }
            if (product.product_id == 7220226425008) {
              has_burn = true;
            }
            if (product.product_id == 7343778005168 || product.product_id == 7343772762288) {
              has_ebook = true;
            }
            if (product.product_id == 7355144077488 || product.product_id == 7355642642608){
              has_strength_ebook = true;
            }
            if (product.product_id == 1561770426402 || product.product_id == 7352388518064) {
              has_gut = true;
            }
            if (product.product_id == 7347476594864) {
              has_towel = true;
            }
            if (product.product_id == 3759094399010) {
              has_creatine = true;
            }
            if (product.product_id == 6800249913520) {
              if (product.variant_id == 40290744959152) {
                has_lytes_lemon_lime = true;
              } else if (product.variant_id == 43908689789104) {
                has_lytes_orange = true;
              } else if (product.variant_id == 44128273399984) {
                has_lytes_cocoa = true;
              }
            }
            if (product.product_id == 7475705479344 || product.product_id == 7974457508016 || product.product_id == 7978641686704) {
              has_gift = true;
            }
            var flavor;
            if (product.variant_title){
              if (product.variant_title.indexOf('/') != -1) {
                flavor = ' / ' + product.variant_title.split("/")[1];
              } else {
                flavor = '';
              }
            } else {
              flavor = '';
            }
            var prodImg;
            if (product.image !== null) {
              prodImg = product.image.replace(/(\.[^.]*)$/, "_180x180_crop_center$1");
            } else {
              prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
            }
            var selling_plans_arr = [];            
            if (product.selling_plan_allocation == null) {
              isSubscription = false;
              subscriptionOriginalTotal += parseFloat((product.original_line_price).toFixed(2));
            } else {
              var currentSellingPlan = product.selling_plan_allocation.selling_plan.id;
              $.ajax({
                url: '/products/'+product.handle+'.js',
                dataType: 'json',
                type: 'GET',
                async: false,
                success: function(product){
                  $.each(product.variants[0].selling_plan_allocations, function(index, d){
                    selling_plans_obj = {};
                    selling_plans_obj.selling_plan_id = d.selling_plan_id;
                    var interval = index + 1;
                    selling_plans_obj.delivery= "Delivery every " + interval + " month(s)";
                    selling_plans_obj.currentSellingPlan = currentSellingPlan; 
                    selling_plans_arr.push(selling_plans_obj);
                  })
                }
              })
              isSubscription = true;
              subscriptionCart = true;
              subscriptionOriginalTotal += parseFloat((product.quantity * product.selling_plan_allocation.compare_at_price).toFixed(2));
            }
            animation_row+=2;
            var linePrice = '$' + ((product.line_price)/100).toFixed(2);
            if (product.product_id == 6873519587504 || product.product_id == 6873391071408 || product.product_id == 7343778005168 || product.product_id == 7347476594864 || product.product_id == 7352388518064 || product.product_id == 7355144077488 || product.product_id == 7475705479344 || product.product_id == 7974457508016 || product.product_id == 7978641686704){
              showQty = false;
            }
            if (product.product_id == 7352388518064 || product.product_id == 7448846074032){
              compareAt = '29.95';
            }
            if (product.product_id == 7343778005168 || product.product_id == 7355144077488){
              compareAt = '49.95';
            }
            if (product.product_id == 6873519587504){
              compareAt = '15.00';
            }
            if (product.product_id == 7475705479344){
              compareAt = '24.95';
            }
            if (product.product_id == 7974457508016 || product.product_id == 7978641686704 ){
              compareAt = '49.95';
            }
            if (linePrice == '$0.00') {
              linePrice = 'FREE';
            }

            //hide sample pack flavor in cart
            var variation;
            if (product.variant_id == 43162740621488 || product.variant_id == 43908693360816 || product.variant_id == 44019907428528 || product.variant_id == 44128282214576 || product.variant_id == 44367445491888) {
              variation = 'MIXED SAMPLE PACK OF 6 STICKS';
            } else {
              variation = product.variant_title;
            }

            // Sticks/servings count for this line — from the global map rendered in
            // cart-drawer.liquid (since /cart.js carries no product metafields).
            var servingsInfo = window.productServings && window.productServings[product.variant_id];
            var servingsLine = '';
            if (servingsInfo && servingsInfo.count) {
              servingsLine = (servingsInfo.count * product.quantity) + ' ' + (servingsInfo.unit || 'servings');
            }
            // Per-line dollar savings for the SAVED badge (mirrors the strikethrough logic:
            // subscriptions use compare-at, everything else uses original_line_price).
            var savedCents;
            if (product.selling_plan_allocation && product.selling_plan_allocation.compare_at_price) {
              savedCents = (product.selling_plan_allocation.compare_at_price * product.quantity) - product.line_price;
            } else {
              savedCents = product.original_line_price - product.line_price;
            }
            var savedAmount = savedCents > 0 ? theme.Currency.formatMoney(savedCents, theme.settings.moneyFormat) : '';

            item = {
                sellingPlans: selling_plans_arr,
                index: index,
                showSubscription: show_subscription,
                handle: product.handle,
                line: index+1,
                key: product.key,
                url: productUrl,
                img: prodImg,
                animationRow: animation_row,
                name: trimCartTitle(product.product_title),
                variation: variation,
                properties: product.properties,
                itemQty: product.quantity,
                linePrice: linePrice,
                originalLinePrice: theme.Currency.formatMoney(product.original_line_price, theme.settings.moneyFormat),
                discountedPrice: theme.Currency.formatMoney((product.price - (product.total_discount/product.quantity)), theme.settings.moneyFormat),
                discounts: product.discounts,
                discountsApplied: product.price === (product.price - product.total_discount) ? false : true,
                vendor: product.vendor,
                showQty: showQty,
                servingsLine: servingsLine,
                savedAmount: savedAmount,
                variant_id: product.variant_id
            };

            if(compareAt) {
              item.regularLine = '$'+compareAt;
            }
            if (theme.Currency.formatMoney(product.price, theme.settings.moneyFormat) == '$0.00'){
              price = 'FREE';
              item.price = price;
            } else {
              item.price = theme.Currency.formatMoney(product.price, theme.settings.moneyFormat);
            }
            if (isSubscription == true) {
              item['sellingPlan'] = product.selling_plan_allocation.selling_plan.name;
              item['subscription'] = true;
              item['regularLine'] = '$'+((product.selling_plan_allocation.compare_at_price*product.quantity)/100).toFixed(2);
            } else {
              item['sellingPlan'] = false;
              item['subscription'] = false;
            }
          items.push(item);
          isSubscription = false;
        });
  
        animation_row+=2; 
         
        // end cart item count check

        // fix for cart page wrong total set cartSub
        var cartSub;
        
        cartSub = cart.total_price;

      // set cart Data for ajax-cart-template
      var last_animation_row = animation_row+2;

      data = {
        items: items,
        note: cart.note,
        lastAnimationRow: last_animation_row,
        totalPrice: theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat),
        subscriptionCart: subscriptionCart,
        addOnAnimation: animation_row,
        //subscriptionOriginalTotal: theme.Currency.formatMoney(subscriptionOriginalTotal, theme.settings.moneyFormat);
        //subscriptionSavings: Math.ceil((parseFloat((subscriptionOriginalTotal - (cart.total_price/100).toFixed(2))/subscriptionOriginalTotal)*100).toFixed(2));
      }
      if (subscriptionCart){
        data.subscriptionOriginalTotal = '$'+(subscriptionOriginalTotal/100).toFixed(2);
        data.totalOriginalPrice = theme.Currency.formatMoney(subscriptionOriginalTotal, theme.settings.moneyFormat);
        // Dollar savings for the footer SAVED badge (was a percent). Empty string
        // hides the badge via the conditional savings block in ajax-cart-template.
        var subSavedCents = subscriptionOriginalTotal - cart.total_price;
        data.totalSavings = subSavedCents > 0 ? theme.Currency.formatMoney(subSavedCents, theme.settings.moneyFormat) : '';
        data.totalCartDiscount = false;
      } else {
        data.totalOriginalPrice = theme.Currency.formatMoney(cart.original_total_price, theme.settings.moneyFormat);
        data.totalSavings = cart.total_discount > 0 ? theme.Currency.formatMoney(cart.total_discount, theme.settings.moneyFormat) : '';
        data.totalCartDiscount = cart.total_discount === 0 ? 0 : theme.strings.cartSavings.replace('[savings]', theme.Currency.formatMoney(cart.total_discount, theme.settings.moneyFormat));
      }
      // Free gift offers removed - replaced with Buy More & Save discount system
      // Show add-on recommendations in priority order (only show ONE at a time)
      // Priority: Lytes Lemon Lime → Lytes Orange → Lytes Cocoa → Creatine → Krill → Gut Health
      // --- Frequently bought together (data-driven from custom.frequently_bought) ---
      // window.cartRecs[sourceProductId] = [{id,handle,title,url,img,regularPrice,subPrice,priceCents,variantId,sellingPlan}]
      (function() {
        var recsMap = window.cartRecs || {};
        var inCartProducts = {}, inCartVariants = {};
        $.each(cart.items, function(i, p) {
          inCartProducts[p.product_id] = true;
          inCartVariants[p.variant_id] = true;
        });
        // Union every cart item's rec list, counting how many cart items suggest each rec.
        var scored = {};
        $.each(cart.items, function(i, p) {
          var list = recsMap[p.product_id];
          if (!list) return;
          for (var r = 0; r < list.length; r++) {
            var rec = list[r];
            if (inCartVariants[rec.variantId]) continue;             // this exact variant already in cart
            if (!rec.variantRec && inCartProducts[rec.id]) continue; // whole-product rec already in cart
            var key = rec.variantId;                                 // dedup by variant (distinguishes flavors)
            var pri = (rec.priority == null) ? 999 : rec.priority;
            if (!scored[key]) scored[key] = { rec: rec, count: 0, priority: pri };
            scored[key].count++;
            if (pri < scored[key].priority) scored[key].priority = pri; // best (earliest) list position wins
          }
        });
        // Store-wide fallback recs (window.cartRecsDefault, priority 5000+): always
        // candidates, but the priority-first sort below means they only surface when
        // no cart item contributed a surviving rec of its own — e.g. a cart of only
        // apparel/ebook/no-metafield products would otherwise show no FBT at all.
        var defaultRecs = window.cartRecsDefault || [];
        for (var df = 0; df < defaultRecs.length; df++) {
          var drec = defaultRecs[df];
          if (inCartVariants[drec.variantId]) continue;
          if (!drec.variantRec && inCartProducts[drec.id]) continue;
          var dkey = drec.variantId;
          if (!scored[dkey]) {
            scored[dkey] = { rec: drec, count: 0, priority: (drec.priority == null) ? 9999 : drec.priority };
          }
        }
        var ranked = [];
        for (var k in scored) { if (scored.hasOwnProperty(k)) ranked.push(scored[k]); }
        ranked.sort(function(a, b) {
          if (a.priority !== b.priority) return a.priority - b.priority;  // merchant's list order first
          if (b.count !== a.count) return b.count - a.count;             // then most-recommended
          return (b.rec.priceCents || 0) - (a.rec.priceCents || 0);      // then higher value
        });
        var RECS_TO_SHOW = 1; // bump this to show more
        data.recommendations = ranked.slice(0, RECS_TO_SHOW).map(function(s) {
          s.rec.title = trimCartTitle(s.rec.title); // idempotent; display-only
          return s.rec;
        });
        data.showRecommendations = data.recommendations.length > 0;
      })();
      
      // show ebook offer if have burn
      if ((has_burn == true) && (has_ebook == false)) {
        data.showFatLossEbook = true;
      }
      if ((has_creatine == true) && (has_strength_ebook == false)){
          data.showStrongerEbook = true;
      }
          
      // send template data
      var renderedHtml = this.template(data);
      $(selectors.container).append(renderedHtml);

      // Restore saved add-ons with their stars (prevents flash on cart updates)
      if ($savedAddons && Object.keys($savedAddons).length > 0) {
        $.each($savedAddons, function(id, $savedElement) {
          var $freshElement = $('#' + id);
          if ($freshElement.length) {
            // Only restore if the add-on visibility state matches
            var savedVisible = $savedElement.hasClass('display_offer');
            var freshVisible = $freshElement.hasClass('display_offer');
            // ...and only when it shows the SAME recommendation(s): the rec set changes
            // with the cart, and restoring a stale node would resurrect an outdated
            // product/price. Keyed by the add buttons' variant ids in order.
            var recKey = function($el) {
              return $el.find('.addon-atc-btn').map(function() { return $(this).data('variant'); }).get().join(',');
            };
            if (savedVisible === freshVisible && recKey($savedElement) === recKey($freshElement)) {
              $freshElement.replaceWith($savedElement);
            }
          }
        });
      }

      // Default the add-on "Subscribe & Save" checkbox to match cart composition:
      // checked only when the cart has zero one-time items (all-subscription or empty);
      // unchecked when there is any one-time item, so the add-on stacks with the
      // BUYMORE coupon instead of conflicting with it. A shopper's explicit toggle
      // (window.addonSubscribeIntent, keyed by add-on id) is honored OVER this default so
      // a rebuild between toggling and clicking Add can't revert their choice. Runs after
      // the saved-add-on restore so it applies to the final DOM.
      try {
        var addOnOneTimeCount = 0;
        if (cart && cart.items) {
          for (var aci = 0; aci < cart.items.length; aci++) {
            if (!cart.items[aci].selling_plan_allocation) {
              addOnOneTimeCount += cart.items[aci].quantity;
            }
          }
        }
        var addOnDefaultChecked = addOnOneTimeCount === 0;
        var addOnIntent = window.addonSubscribeIntent || {};
        $(selectors.container).find('.addon-subscribe-checkbox').each(function() {
          var addOnKey = $(this).data('product-handle');
          // Honor an explicit user choice for this product if one was recorded;
          // otherwise apply the cart-composition default.
          var shouldCheck = addOnIntent.hasOwnProperty(addOnKey) ? addOnIntent[addOnKey] : addOnDefaultChecked;
          $(this).prop('checked', shouldCheck);
          var $row = $(this).closest('.addon-content-wrapper');
          if (!$row.length) { $row = $(this).closest('.add_on'); }
          var $priceDisplay = $row.find('.addon-price-display');
          if (shouldCheck) {
            $priceDisplay.removeClass('one-time');
          } else {
            $priceDisplay.addClass('one-time');
          }
        });
        console.log('[AddOn] one-time items in cart:', addOnOneTimeCount, '| default checked:', addOnDefaultChecked, '| intent:', addOnIntent);
      } catch (addOnErr) {
        console.log('[AddOn] default-checkbox error:', addOnErr);
      }

      // DEBUG: Check what was rendered
      console.log('[buildCart] Template appended to container');
      console.log('[buildCart] Container HTML length:', $(selectors.container).html().length);
      console.log('[buildCart] Contains drawer__footer?', renderedHtml.indexOf('drawer__footer') > -1);
      console.log('[buildCart] Contains checkout button?', renderedHtml.indexOf('cart-checkout-button') > -1);

      var $footerCheck = $('#CartDrawer').find('.drawer__footer--fixed');
      console.log('[buildCart] Footer in drawer:', $footerCheck.length);

      // Also check with different selectors
      var $footerById = $('#drawer_footer');
      console.log('[buildCart] Footer by ID (global):', $footerById.length);
      if ($footerById.length) {
        console.log('[buildCart] Footer current parent tag:', $footerById.parent().prop('tagName'));
        console.log('[buildCart] Footer current parent id:', $footerById.parent().attr('id'));
        console.log('[buildCart] Footer current parent class:', $footerById.parent().attr('class'));
      }

      var $checkoutBtn = $('.cart-checkout-button-drawer');
      console.log('[buildCart] Checkout button found:', $checkoutBtn.length);

      // Immediately call sizeFooter to move footer to correct position
      this.sizeFooter();

      console.log('[buildCart] Calling updateBar...');
      updateBar(cart);
      console.log('[buildCart] Calling setItemDiscounts (ASYNC - will complete later)...');
      setItemDiscounts();
      console.log('[buildCart] Setting loading=false, removing loading spinner');
      this.loading(false);
      $('#CartDrawer').find($('.cart-loading')).remove();
      $('.cart-link__bubble--visible').show();

      // Log current DOM state for debugging
      console.log('[buildCart] Current DOM data-key values:');
      $('.ajaxcart__item').each(function(i) {
        var $el = $(this);
        console.log('[buildCart]   Item', i+1, '- line:', $el.attr('data-line'), 'variantId:', $el.attr('data-id'), 'key:', $el.attr('data-key') ? $el.attr('data-key').substring(0, 25) + '...' : 'none');
      });

      // Clone cached Okendo star ratings into the dynamic recommendation rows, matched by
      // product id (data-oke-reviews-product-id="shopify-<id>" -> #okendo-cache-<id>).
      function cloneOkendoStars(retryCount) {
        retryCount = retryCount || 0;
        var maxRetries = 10;

        var $recReviews = $('#cart_recommendations .addon-reviews');
        if (!$recReviews.length) return;

        // Wait until Okendo has actually rendered stars into the cache.
        var $cache = $('#okendo-stars-cache');
        var hasRenderedStars = $cache.find('.okeReviews-starRating-indicator, .oke-sr').length > 0;
        if (!hasRenderedStars && retryCount < maxRetries) {
          setTimeout(function() { cloneOkendoStars(retryCount + 1); }, 200);
          return;
        }

        $recReviews.each(function() {
          var $r = $(this);
          if ($r.find('.oke-sr').length) return; // already cloned
          var pid = String($r.attr('data-oke-reviews-product-id') || '').replace('shopify-', '');
          var cacheHtml = $('#okendo-cache-' + pid).html();
          if (cacheHtml) { $r.html(cacheHtml); }
        });
      }

      setTimeout(function() {
        cloneOkendoStars(0);
      }, 100);
    } 
        
    // Handle subscribe checkbox toggle for add-on products
    // FIX: Use .off().on() pattern to prevent duplicate handlers on cart rebuild
    if ($('.addon-subscribe-checkbox').length) {
      $(document).off('change.addonSubscribe', '.addon-subscribe-checkbox').on('change.addonSubscribe', '.addon-subscribe-checkbox', function() {
        var productHandle = $(this).data('product-handle');
        var $row = $(this).closest('.addon-content-wrapper');
        if (!$row.length) { $row = $(this).closest('.add_on'); }
        var $priceDisplay = $row.find('.addon-price-display');

        // Remember the shopper's explicit choice, keyed by PRODUCT HANDLE. Recommendations now
        // share one #cart_recommendations block, so an id-based key would leak across products.
        window.addonSubscribeIntent = window.addonSubscribeIntent || {};
        window.addonSubscribeIntent[productHandle] = $(this).is(':checked');

        if ($(this).is(':checked')) {
          $priceDisplay.removeClass('one-time');
        } else {
          $priceDisplay.addClass('one-time');
        }
      });
    }

    // Handle add-on add to cart with subscription support
    // Unbind first to prevent duplicate handlers
    $(document).off('click.addonHandler', '.ajaxcart__add_to_cart__button.addon-atc-btn');
    $(document).on('click.addonHandler', '.ajaxcart__add_to_cart__button.addon-atc-btn', function(e) {
       e.stopPropagation();
       e.preventDefault();

       var $button = $(this);

       // Prevent double-clicks
       if ($button.hasClass('processing')) {
         console.log('[AddOn] Click already in progress, ignoring');
         return;
       }
       $button.addClass('processing');

       var addOnVariantId = $button.data('variant');
       var productHandle = $button.data('product-handle');

       console.log('[AddOn DEBUG] ========================================');
       console.log('[AddOn DEBUG] Button clicked:', $button);
       console.log('[AddOn DEBUG] Variant ID:', addOnVariantId);
       console.log('[AddOn DEBUG] Product Handle:', productHandle);

       // Non-addon buttons: just add to cart.
       if (!productHandle) {
         addItemToCart(addOnVariantId, $button);
         return;
       }

       // Resolve subscription intent from the checkbox in THIS add-on block.
       // Scope to the add-on container so we never match another block's box;
       // fall back to .add_on if the wrapper markup ever changes.
       var $container = $button.closest('.addon-content-wrapper');
       if (!$container.length) { $container = $button.closest('.add_on'); }
       var $checkbox = $container.find('.addon-subscribe-checkbox');
       var isSubscription = $checkbox.length > 0 && $checkbox.prop('checked');

       // The selling plan is embedded on the button at render time
       // (data-selling-plan), so the common path needs NO /products/.js round-trip
       // and can never silently downgrade a subscription to one-time on a failed fetch.
       var embeddedPlan = $button.data('selling-plan');

       console.log('[AddOn] handle:', productHandle, '| variant:', addOnVariantId,
                   '| checkbox found:', $checkbox.length, '| checked:', isSubscription,
                   '| embeddedPlan:', embeddedPlan);

       // The shopper has committed by clicking Add, so drop any recorded toggle intent;
       // if this add-on is ever re-offered it should default to cart composition again.
       if (window.addonSubscribeIntent && productHandle) { delete window.addonSubscribeIntent[productHandle]; }

       if (!isSubscription) {
         // One-time purchase (the default when the cart has any one-time item)
         addItemToCart(addOnVariantId, $button);
         return;
       }

       if (embeddedPlan) {
         // Subscription with a known plan — direct add, no fetch, no silent fallback.
         addItemToCart(addOnVariantId, $button, embeddedPlan);
         return;
       }

       // Legacy fallback only for add-ons without an embedded plan: look it up.
       $.getJSON('/products/' + productHandle + '.js', function(product) {
         var sellingPlanId = null;
         var targetVariant = product.variants.find(function(v) { return v.id == addOnVariantId; });
         if (targetVariant && targetVariant.selling_plan_allocations && targetVariant.selling_plan_allocations.length > 0) {
           sellingPlanId = targetVariant.selling_plan_allocations[0].selling_plan_id;
         }
         if (sellingPlanId) {
           addItemToCart(addOnVariantId, $button, sellingPlanId);
         } else {
           // Subscription was requested but no plan resolved — abort rather than
           // silently adding a one-time line the shopper didn't choose.
           console.warn('[AddOn] Subscription requested but no selling plan resolved; not adding.');
           $button.removeClass('processing');
           $('#CartDrawer').find('.cart-loading').remove();
         }
       }).fail(function(error) {
         // Same: never silently downgrade a requested subscription to one-time.
         console.warn('[AddOn] Product fetch failed for a subscription add; not adding one-time:', error);
         $button.removeClass('processing');
         $('#CartDrawer').find('.cart-loading').remove();
       });
     });

    // Helper function to add item to cart. Pass sellingPlanId to add as a subscription.
    function addItemToCart(variantId, $button, sellingPlanId) {
      var cartData = {
        quantity: 1,
        id: variantId
      };
      if (sellingPlanId) {
        cartData.selling_plan = sellingPlanId;
      }
      console.log('[AddOn] add.js cartData:', cartData);

      function finishAddSuccess() {
        if ($button) $button.removeClass('processing');
        theme.cart.invalidateCache();
        calculateFSB();
        $('body').trigger('added.ajaxProduct');
        $('#CartDrawer').find($('.cart-loading')).remove();
        if(window.location.href.indexOf('/cart') > -1){
          $('body').trigger('ajaxCartUpdated');
        }
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: cartData,
        beforeSend: function() {
          $('#CartDrawer').append("<div class='cart-loading'></div>");
        },
        success: function(item) {
          // The Appstle PDP widget intercepts /cart/add.js for ITS OWN product while
          // its Subscribe option is selected and injects that selling plan — turning a
          // deliberate one-time add (rec checkbox unchecked) into a subscription.
          // Verify the line that actually landed and strip an uninvited plan.
          var gotPlan = !!(item && item.selling_plan_allocation);
          if (!sellingPlanId && gotPlan && item.key) {
            console.warn('[AddOn] One-time add came back with a selling plan (widget interception) — stripping it. key:', item.key);
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              dataType: 'json',
              data: { id: item.key, quantity: item.quantity, selling_plan: '' },
              complete: finishAddSuccess
            });
            return;
          }
          finishAddSuccess();
        },
        error: function(error) {
          if ($button) {
            $button.removeClass('processing');
            // Surface the failure — availability is snapshotted at page render, so a rec
            // can sell out intraday and /cart/add.js will 422; a silent spinner-and-nothing
            // leaves the shopper clicking a dead button.
            var failMsg = (error && error.status === 422) ? 'SOLD OUT' : "COULDN'T ADD — TRY AGAIN";
            var origText = $button.text();
            $button.text(failMsg);
            setTimeout(function() { $button.text(origText); }, 3000);
          }
          console.log(error);
          $('#CartDrawer').find($('.cart-loading')).remove();
        }
      });
    }
        
     // cart drawer options for free gift add-on
    // FIX: Use .off().on() pattern to prevent duplicate handlers on cart rebuild
    if ($('.cart-drawer-product__options').length) {
      $('.cart-drawer-product__options').off('change.cartDrawerOptions').on('change.cartDrawerOptions', function() {
        var selectedVariantId = $(this).find(':selected').val();
        $(this).siblings('.ajaxcart__add_to_cart__button').attr('data-variant', selectedVariantId);
      });
    }

    // cart drawer options for eBook add-on
    // FIX: Use .off().on() pattern to prevent duplicate handlers on cart rebuild
    if ($('.cart-drawer-product__options_three').length) {
      $('.cart-drawer-product__options_three').off('change.cartDrawerOptionsThree').on('change.cartDrawerOptionsThree', function() {
        var selectedVariantId = $(this).find(':selected').val();
        $(this).siblings('#ajaxcart__add_to_cart__button_three').attr('data-variant', selectedVariantId);
      });
    }

    // eBook add-on button handler
    // FIX: Use .off().on() pattern instead of .one() for consistency and to prevent issues after cart rebuild
    if ($('#ajaxcart__add_to_cart__button_three').length) {
     $("#ajaxcart__add_to_cart__button_three").off('click.eBookAddon').on('click.eBookAddon', function(e) {
       e.preventDefault();
       var $button = $(this);

       // Prevent double-clicks
       if ($button.hasClass('processing')) {
         return;
       }
       $button.addClass('processing');

       var eBookAddOnVariantId = this.dataset.variant;
       console.log('eBookAddOnVariantId: ' + eBookAddOnVariantId);
       $.ajax({
         type: 'POST',
         url: '/cart/add.js',
         dataType: 'json',
         data: {
           quantity: 1,
           id: eBookAddOnVariantId
         },
         beforeSend: function() {
           $('#CartDrawer').append("<div class='cart-loading'></div>");
         },
         success: function() {
           $button.removeClass('processing');
           calculateFSB();
           $('body').trigger('added.ajaxProduct');
           $('#CartDrawer').find($('.cart-loading')).remove();
           if(window.location.href.indexOf('/cart') > -1){
             $('body').trigger('ajaxCartUpdated');
           }
         },
         error: function(error) {
           $button.removeClass('processing');
           console.log(error);
           $('#CartDrawer').find($('.cart-loading')).remove();
         }
       });
     });
    }

    /* cart drawer trashcan */
    // FIX: Use .off() before .on() to prevent duplicate handlers stacking on each cart rebuild
    // Also removed 'touchend' - jQuery handles touch via 'click' automatically
    if($('.cd-trashcan').length){
      $('.cd-trashcan').off('click.cdTrashcan').on('click.cdTrashcan', function(e){
        e.stopPropagation();
        e.preventDefault();

        var $item = $(this).closest('.ajaxcart__item');
        var line = $item.attr('data-line');
        var variantId = $item.attr('data-id');
        var domKey = $item.attr('data-key');

        console.log('[CartDrawer Trash] Click detected - line:', line, 'variantId:', variantId);

        // Wait for coupon operation ONLY if one is in progress
        var waitPromise = window.waitForBuyMoreComplete ? window.waitForBuyMoreComplete() : Promise.resolve();

        waitPromise.then(function() {
          var rawData = sessionStorage.getItem('scDiscountData');
          var scDiscountData = $.parseJSON(rawData);
          var code = scDiscountData ? scDiscountData['code'] : null;

          console.log('[CartDrawer Trash] Proceeding with delete');

          // FIX: Invalidate cache before fetching to ensure fresh cart data
          theme.cart.invalidateCache();

          theme.cart.getCart().then(function(cart){
          // FIX: Get the correct key from cart API by matching LINE NUMBER (not variant ID)
          // Line number = index + 1, so line 1 = cart.items[0], line 2 = cart.items[1], etc.
          // This handles cases where same variant appears multiple times with different selling plans
          var lineIndex = parseInt(line) - 1;
          var key = null;
          var matchedItem = null;

          if (lineIndex >= 0 && lineIndex < cart.items.length) {
            matchedItem = cart.items[lineIndex];
            key = matchedItem.key;

            // Verify the variant ID matches as a sanity check
            if (String(matchedItem.variant_id) !== String(variantId)) {
              console.log('[CartDrawer Trash] WARNING: Line', line, 'variant mismatch! DOM:', variantId, 'API:', matchedItem.variant_id);
              // Cart may have changed, try to find by variant ID as fallback
              for (var i = 0; i < cart.items.length; i++) {
                if (String(cart.items[i].variant_id) === String(variantId)) {
                  key = cart.items[i].key;
                  matchedItem = cart.items[i];
                  console.log('[CartDrawer Trash] Fallback: Found by variant ID at line', i + 1);
                  break;
                }
              }
            }
          }

          console.log('[CartDrawer Trash] Line:', line, '| Matched item:', matchedItem ? matchedItem.title : 'NOT FOUND');
          console.log('[CartDrawer Trash] DOM key:', domKey, '| API key:', key);
          console.log('[CartDrawer Trash] Keys match?', domKey === key);
          console.log('[CartDrawer Trash] Cart has', cart.items.length, 'items, code:', code);

          // If no matching item found, item may already be deleted
          if (!key) {
            console.log('[CartDrawer Trash] Item not found in cart - may already be deleted. Refreshing cart.');
            $('body').trigger('added.ajaxProduct');
            return;
          }

          // Helper function to perform delete with retry logic
          var attemptDelete = function(deleteKey, attemptNum) {
            console.log('[CartDrawer Trash] Delete attempt', attemptNum, 'with key:', deleteKey);
            $.ajax ({
              type: "POST",
              url: '/cart/change.js',
              dataType: 'json',
              data: {
                 id: deleteKey,
                 quantity: 0,
              },
              beforeSend: function() {
                if (attemptNum === 1) {
                  $('#CartDrawer').append("<div class='cart-loading'></div>");
                }
              },
              success: function(cart) {
                console.log('[CartDrawer Trash] Delete SUCCESS on attempt', attemptNum, '- cart now has', cart.items.length, 'items');
                // Reset manual coupon state after item removal — updateBarCore will
                // re-detect it from scDiscountData if the coupon is still valid
                if (window.couponState.isManual) {
                    console.log('[CartDrawer Trash] Clearing isManual state for re-evaluation');
                    window.couponState.isManual = false;
                    window.couponState.currentCode = null;
                }
                theme.cart.invalidateCache();
                calculateFSB();
                $('body').trigger('added.ajaxProduct');
                $('#CartDrawer').find($('.cart-loading')).remove();
                if(window.location.href.indexOf('/cart') > -1){
                  $('body').trigger('ajaxCartUpdated');
                }
              },
              error: function(xhr, status, error) {
                console.log('[CartDrawer Trash] Delete ERROR on attempt', attemptNum, ':', error, 'Status:', xhr.status);
                console.log('[CartDrawer Trash] Response:', xhr.responseText);
                theme.cart.invalidateCache();

                // If 400 error and first attempt, retry with fresh key lookup
                if (xhr.status === 400 && attemptNum === 1) {
                  console.log('[CartDrawer Trash] 400 error - fetching fresh cart to retry...');
                  theme.cart.getCart().then(function(freshCart) {
                    var newKey = null;
                    var newLineIndex = parseInt(line) - 1;

                    // Try to find by line number first
                    if (newLineIndex >= 0 && newLineIndex < freshCart.items.length) {
                      var freshItem = freshCart.items[newLineIndex];
                      if (String(freshItem.variant_id) === String(variantId)) {
                        newKey = freshItem.key;
                        console.log('[CartDrawer Trash] RETRY - Found by line', line, '| new key:', newKey);
                      }
                    }

                    // Fallback: search by variant ID
                    if (!newKey) {
                      for (var i = 0; i < freshCart.items.length; i++) {
                        if (String(freshCart.items[i].variant_id) === String(variantId)) {
                          newKey = freshCart.items[i].key;
                          console.log('[CartDrawer Trash] RETRY - Fallback found by variant at line', i + 1, '| new key:', newKey);
                          break;
                        }
                      }
                    }

                    if (newKey && newKey !== deleteKey) {
                      console.log('[CartDrawer Trash] RETRY - Key changed! Old:', deleteKey, '| New:', newKey);
                      attemptDelete(newKey, 2);
                    } else if (!newKey) {
                      // Item not found - it may have already been deleted
                      console.log('[CartDrawer Trash] RETRY - Item no longer in cart (already deleted?)');
                      $('#CartDrawer').find($('.cart-loading')).remove();
                      $('body').trigger('added.ajaxProduct');
                    } else {
                      console.log('[CartDrawer Trash] RETRY - Key unchanged, giving up');
                      $('#CartDrawer').find($('.cart-loading')).remove();
                      $('body').trigger('added.ajaxProduct');
                    }
                  }).catch(function(err) {
                    console.log('[CartDrawer Trash] RETRY - Failed to fetch fresh cart:', err);
                    $('#CartDrawer').find($('.cart-loading')).remove();
                    $('body').trigger('added.ajaxProduct');
                  });
                } else {
                  // Second attempt failed or non-400 error
                  $('#CartDrawer').find($('.cart-loading')).remove();
                  $('body').trigger('added.ajaxProduct');
                }
              }
            });
          };

          if(cart.items.length == 1 && code != null) {
            window.DiscountHero.discount.remove().then(function(){
              console.log('[CartDrawer Trash] Removed discount, now deleting item key:', key);
              attemptDelete(key, 1);
            });
          } else {
            attemptDelete(key, 1);
          }
        });
        }); // end waitPromise.then()
      });
    }

    /* subscribe label click handler for cart drawer */
    // FIX: Use .off().on() pattern to prevent duplicate handlers on cart rebuild
    $(document).off('click.subscribeLabel', '.subscribe-checkbox-label').on('click.subscribeLabel', '.subscribe-checkbox-label', function(e) {
      e.preventDefault();
      var $checkbox = $(this).siblings("input[name='subscribe-checkbox']");
      if ($checkbox.length) {
        $checkbox.prop('checked', !$checkbox.prop('checked')).trigger('change');
      }
    });

    /* subscribe and save listener for cart drawer */
    // FIX: Use .off().on() pattern to prevent duplicate handlers on cart rebuild
    if($("input[name='subscribe-checkbox']").length){
      $("input[name='subscribe-checkbox']").off('change.subscribe').on('change.subscribe', function() {
        // FIX: Prevent concurrent subscription operations
        if (window.isProcessingSubscription) {
          console.log('[Subscribe] SKIPPED - Already processing subscription change');
          return;
        }

        var handle = $(this).data('product-handle');
        var checkbox = $(this);
        var $item = $(this).closest('.ajaxcart__item');
        var line = $item.attr('data-line');
        var variantId = $item.attr('data-id');
        var currentQuantity = $item.attr('data-qty');
        var closest = $(this).closest('.cart-subscribe-row');
        var cartItem = $item;

        console.log('[Subscribe] Change triggered - line:', line, 'variantId:', variantId, 'checked:', checkbox.is(':checked'));

        // Set processing flag
        window.isProcessingSubscription = true;

        // Wait for coupon operation ONLY if one is in progress
        var waitPromise = window.waitForBuyMoreComplete ? window.waitForBuyMoreComplete() : Promise.resolve();

        waitPromise.then(function() {
          console.log('[Subscribe] Proceeding after wait');

          $.getJSON('/products/'+handle+'.js', function(product){
            var sellingPlan = product.variants[0].selling_plan_allocations[0].selling_plan_id;
            var newSellingPlan = checkbox.is(':checked') ? sellingPlan : null;

            // Helper function to perform the subscription change with retry logic
            var attemptSubscriptionChange = function(useLine, attemptNum) {
              console.log('[Subscribe] Attempt', attemptNum, '- line:', useLine, 'sellingPlan:', newSellingPlan);

              $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                dataType: 'json',
                data: {
                  'line': useLine,
                  'quantity': currentQuantity,
                  'selling_plan': newSellingPlan
                },
                beforeSend: function(){
                  if (attemptNum === 1) {
                    $('#CartDrawer').append("<div class='cart-loading'></div>");
                  }
                },
                success: function() {
                  console.log('[Subscribe] SUCCESS on attempt', attemptNum);
                  window.isProcessingSubscription = false; // Clear flag
                  theme.cart.invalidateCache();
                  $('body').trigger('added.ajaxProduct');
                  if (newSellingPlan) {
                    cartItem.find('.cartDiscount').hide();
                  }
                  $('#CartDrawer').find($('.cart-loading')).remove();
                  if(window.location.href.indexOf('/cart') > -1){
                    $('body').trigger('ajaxCartUpdated');
                  }
                },
                error: function(xhr, status, error){
                  console.log('[Subscribe] ERROR on attempt', attemptNum, '- status:', xhr.status, error);
                  theme.cart.invalidateCache();

                  // If 409 Conflict or 400 error and first attempt, retry with fresh line lookup
                  if ((xhr.status === 409 || xhr.status === 400) && attemptNum === 1) {
                    console.log('[Subscribe] Conflict/error - fetching fresh cart to retry...');

                    theme.cart.getCart().then(function(freshCart) {
                      var newLine = null;

                      // Find item by variant ID
                      for (var i = 0; i < freshCart.items.length; i++) {
                        if (String(freshCart.items[i].variant_id) === String(variantId)) {
                          newLine = i + 1; // Line numbers are 1-indexed
                          console.log('[Subscribe] RETRY - Found variant at line', newLine);
                          break;
                        }
                      }

                      if (newLine) {
                        attemptSubscriptionChange(newLine, 2);
                      } else {
                        console.log('[Subscribe] RETRY - Item no longer in cart');
                        window.isProcessingSubscription = false; // Clear flag
                        $('#CartDrawer').find($('.cart-loading')).remove();
                        $('body').trigger('added.ajaxProduct');
                      }
                    }).catch(function(err) {
                      console.log('[Subscribe] RETRY - Failed to fetch fresh cart:', err);
                      window.isProcessingSubscription = false; // Clear flag
                      $('#CartDrawer').find($('.cart-loading')).remove();
                      $('body').trigger('added.ajaxProduct');
                    });
                  } else {
                    // Second attempt failed or other error
                    console.log('[Subscribe] Giving up after attempt', attemptNum);
                    window.isProcessingSubscription = false; // Clear flag
                    $('#CartDrawer').find($('.cart-loading')).remove();
                    $('body').trigger('added.ajaxProduct');
                  }
                }
              });
            };

            // Start first attempt
            attemptSubscriptionChange(line, 1);
          }).fail(function() {
            console.log('[Subscribe] Failed to fetch product JSON');
            window.isProcessingSubscription = false; // Clear flag on getJSON failure
            $('#CartDrawer').find($('.cart-loading')).remove();
          }); //getJSON
        }); // end waitPromise.then()
      }); //onChange
    }// if checkbox
        
    // ajax cart selling plan drop down
    // FIX: Use .off().on() pattern to prevent duplicate handlers on cart rebuild
    if ($('.cart-subscribe-row select[name="selling-plan"]').length){
      $('.cart-subscribe-row select[name="selling-plan"]').off('change.sellingPlan').on('change.sellingPlan', function() {
        // FIX: Prevent concurrent operations (share flag with subscribe checkbox)
        if (window.isProcessingSubscription) {
          console.log('[SellingPlanDropdown] SKIPPED - Already processing subscription change');
          return;
        }

        var sellingPlan = $(this).val();
        var $item = $(this).closest('.ajaxcart__item');
        var line = $item.attr('data-line');
        var variantId = $item.attr('data-id');
        var currentQuantity = $item.attr('data-qty');
        var selected = $(this);

        console.log('[SellingPlanDropdown] Change - line:', line, 'variantId:', variantId, 'sellingPlan:', sellingPlan);

        // Set processing flag
        window.isProcessingSubscription = true;

        // Wait for coupon operation ONLY if one is in progress
        var waitPromise = window.waitForBuyMoreComplete ? window.waitForBuyMoreComplete() : Promise.resolve();

        waitPromise.then(function() {
          console.log('[SellingPlanDropdown] Proceeding after wait');

          // Helper function with retry logic
          var attemptPlanChange = function(useLine, attemptNum) {
            console.log('[SellingPlanDropdown] Attempt', attemptNum, '- line:', useLine);

            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              dataType: 'json',
              data: {
                'line': useLine,
                'quantity': currentQuantity,
                'selling_plan': sellingPlan
              },
              beforeSend: function(){
                if (attemptNum === 1) {
                  $('#CartDrawer').append("<div class='cart-loading'></div>");
                }
              },
              success: function() {
                console.log('[SellingPlanDropdown] SUCCESS on attempt', attemptNum);
                window.isProcessingSubscription = false; // Clear flag
                theme.cart.invalidateCache();
                $('body').trigger('added.ajaxProduct');
                $('#CartDrawer').find($('.cart-loading')).remove();
                selected.prop('selected', true);
                if(window.location.href.indexOf('/cart') > -1){
                  $('body').trigger('ajaxCartUpdated');
                }
              },
              error: function(xhr, status, error){
                console.log('[SellingPlanDropdown] ERROR on attempt', attemptNum, '- status:', xhr.status, error);
                theme.cart.invalidateCache();

                // If 409 Conflict or 400 error and first attempt, retry with fresh line lookup
                if ((xhr.status === 409 || xhr.status === 400) && attemptNum === 1) {
                  console.log('[SellingPlanDropdown] Conflict/error - fetching fresh cart to retry...');

                  theme.cart.getCart().then(function(freshCart) {
                    var newLine = null;

                    // Find item by variant ID
                    for (var i = 0; i < freshCart.items.length; i++) {
                      if (String(freshCart.items[i].variant_id) === String(variantId)) {
                        newLine = i + 1;
                        console.log('[SellingPlanDropdown] RETRY - Found variant at line', newLine);
                        break;
                      }
                    }

                    if (newLine) {
                      attemptPlanChange(newLine, 2);
                    } else {
                      console.log('[SellingPlanDropdown] RETRY - Item no longer in cart');
                      window.isProcessingSubscription = false; // Clear flag
                      $('#CartDrawer').find($('.cart-loading')).remove();
                      $('body').trigger('added.ajaxProduct');
                    }
                  }).catch(function(err) {
                    console.log('[SellingPlanDropdown] RETRY - Failed to fetch fresh cart:', err);
                    window.isProcessingSubscription = false; // Clear flag
                    $('#CartDrawer').find($('.cart-loading')).remove();
                    $('body').trigger('added.ajaxProduct');
                  });
                } else {
                  console.log('[SellingPlanDropdown] Giving up after attempt', attemptNum);
                  window.isProcessingSubscription = false; // Clear flag
                  $('#CartDrawer').find($('.cart-loading')).remove();
                  $('body').trigger('added.ajaxProduct');
                }
              }
            });
          };

          // Start first attempt
          attemptPlanChange(line, 1);
        }); // end waitPromise.then()
      });
    }
        
    this.status.loaded = true;
    this.loading(false);

    if ($('body').hasClass('currencies-enabled')) {
      theme.currencySwitcher.ajaxrefresh();
    }

    $('body').trigger('updateCart' + config.namespace, cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
      // Resize footer after arbitrary delay for buttons to load
      setTimeout(function() {
        this.sizeFooter();
      }.bind(this), 800);
    }

    // fix resize for payment badges
    //$('body').trigger('resize');

    // If specifically asked, open the cart drawer (only happens after product added from form)
    if (openDrawer === true) {
      this.drawer.open();
    }
  }, //end buildCart

      initQtySelectors: function() {
        console.log('[CartDrawer] initQtySelectors called - initializing qty selectors (listener already bound in initEventListeners)');
        this.qtySelectors = [];

        $(selectors.container).find('.js-qty').each(function(index, el) {
          var selector = new theme.QtySelector($(el), {
            namespace: '.cart-drawer'
          });
          this.qtySelectors.push(selector);
        }.bind(this));

        // FIX: REMOVED duplicate listener binding that was causing 429 errors
        // The qty.cart-drawer listener is now bound ONCE in initEventListeners()
        // Previously this line added a NEW listener on every cart rebuild, causing exponential API calls
        console.log('[CartDrawer] initQtySelectors complete - found', this.qtySelectors.length, 'qty selectors');
      },
  
      updateItem: function(evt, domKey, qty, line, variantId) {
        console.log('[CartDrawer] updateItem called - domKey:', domKey, 'qty:', qty, 'line:', line, 'variantId:', variantId, 'time:', new Date().toISOString());
        evt.stopPropagation();
        if (this.status.loading) {
          console.log('[CartDrawer] updateItem SKIPPED - already loading');
          return;
        }

        // Mark cart operation in progress (prevents monitoring code from treating coupon removals as manual)
        window.couponState.cartOperationInProgress = true;
        console.log('[Cart Operation] Set cartOperationInProgress=true');

        // Clear manual override flag when cart changes - customer changed quantity
        if (window.couponState.manualOverride) {
          console.log('[Manual Override] Cleared - cart changed (quantity updated), resuming auto-apply');
          window.couponState.manualOverride = false;
          window.couponState.showSuggestion = false;
          window.couponState.suggestionData = null;

          // Clear from sessionStorage
          sessionStorage.removeItem('couponManualOverride');
          sessionStorage.removeItem('couponSuggestionData');
          console.log('[Manual Override] Cleared from sessionStorage');
        }

        var self = this;

        // Wait for coupon operation ONLY if one is in progress
        var waitPromise = window.waitForBuyMoreComplete ? window.waitForBuyMoreComplete() : Promise.resolve();

        waitPromise.then(function() {
          self.loading(true);

          // FIX: Extract variantId from domKey if not passed (backwards compatibility)
          if (!variantId && domKey) {
            variantId = domKey.split(':')[0];
          }

          // if unlocked item -- don't allow changing of quantity
          if ((variantId == 40609122910384) || (variantId == 40609122943152) || (variantId == 40609122975920) || (variantId == 40609123008688) || (variantId == 44841756983472) || (variantId == 42692913037488) || (variantId == 42710331097264) || (variantId == 42733356122288)) {
            alert('You cannot change the quantity of this item!');
            self.loading(false);
          } else {
            // FIX: Get fresh cart data and look up correct key by line number
            theme.cart.invalidateCache();
            theme.cart.getCart().then(function(cart) {
            var lineIndex = parseInt(line) - 1;
            var key = null;
            var matchedItem = null;

            if (lineIndex >= 0 && lineIndex < cart.items.length) {
              matchedItem = cart.items[lineIndex];
              key = matchedItem.key;

              // Verify variant ID matches
              if (String(matchedItem.variant_id) !== String(variantId)) {
                console.log('[CartDrawer] updateItem WARNING: Line', line, 'variant mismatch! DOM:', variantId, 'API:', matchedItem.variant_id);
                // Fallback to searching by variant ID
                for (var i = 0; i < cart.items.length; i++) {
                  if (String(cart.items[i].variant_id) === String(variantId)) {
                    key = cart.items[i].key;
                    matchedItem = cart.items[i];
                    console.log('[CartDrawer] updateItem Fallback: Found by variant ID at line', i + 1);
                    break;
                  }
                }
              }
            }

            console.log('[CartDrawer] updateItem - DOM key:', domKey, '| API key:', key, '| Match?', domKey === key);
            console.log('[CartDrawer] updateItem - Cart has', cart.items.length, 'items. API cart keys:', cart.items.map(function(item) { return item.key.substring(0, 20) + '...'; }));

            if (!key) {
              console.log('[CartDrawer] updateItem ERROR - Item not found in cart!');
              console.log('[CartDrawer] updateItem - Requested line:', line, 'variantId:', variantId);
              console.log('[CartDrawer] updateItem - Available items:', cart.items.map(function(item, i) { return 'Line ' + (i+1) + ': ' + item.variant_id; }));
              self.loading(false);
              $('body').trigger('added.ajaxProduct');
              return;
            }

            console.log('[CartDrawer] updateItem - Calling changeItem with key:', key, 'qty:', qty);

            // Helper function to perform the actual cart change with retry logic
            var attemptCartChange = function(attemptKey, attemptNum) {
              console.log('[CartDrawer] updateItem - Attempt', attemptNum, 'with key:', attemptKey);

              theme.cart.changeItem(attemptKey, qty)
              .then(function(cart) {
                console.log('[CartDrawer] updateItem SUCCESS - cart updated on attempt', attemptNum);
                self.loading(false);
                self.updateSuccess(cart);
              })
              .catch(function(XMLHttpRequest) {
                console.log('[CartDrawer] updateItem FAILED - Attempt', attemptNum, '- API error:', XMLHttpRequest.status, XMLHttpRequest.responseText);

                // If 400 error and this is the first attempt, retry with fresh key lookup
                if (XMLHttpRequest.status === 400 && attemptNum === 1) {
                  console.log('[CartDrawer] updateItem - 400 error detected, retrying with fresh key lookup...');

                  // Invalidate cache and fetch fresh cart
                  theme.cart.invalidateCache();
                  theme.cart.getCart().then(function(freshCart) {
                    console.log('[CartDrawer] updateItem RETRY - Fresh cart fetched, looking up new key...');

                    var newKey = null;
                    var newLineIndex = parseInt(line) - 1;

                    // First try: Look up by line number
                    if (newLineIndex >= 0 && newLineIndex < freshCart.items.length) {
                      var freshItem = freshCart.items[newLineIndex];
                      // Verify variant ID still matches this line
                      if (String(freshItem.variant_id) === String(variantId)) {
                        newKey = freshItem.key;
                        console.log('[CartDrawer] updateItem RETRY - Found by line', line, '| new key:', newKey);
                      }
                    }

                    // Fallback: Search by variant ID
                    if (!newKey) {
                      for (var i = 0; i < freshCart.items.length; i++) {
                        if (String(freshCart.items[i].variant_id) === String(variantId)) {
                          newKey = freshCart.items[i].key;
                          console.log('[CartDrawer] updateItem RETRY - Fallback found by variant at line', i + 1, '| new key:', newKey);
                          break;
                        }
                      }
                    }

                    if (newKey && newKey !== attemptKey) {
                      console.log('[CartDrawer] updateItem RETRY - Key changed! Old:', attemptKey, '| New:', newKey);
                      attemptCartChange(newKey, 2);
                    } else if (newKey) {
                      console.log('[CartDrawer] updateItem RETRY - Key unchanged, likely a different error. Giving up.');
                      self.loading(false);
                      self.updateError(XMLHttpRequest);
                      // Rebuild cart to refresh UI
                      $('body').trigger('added.ajaxProduct');
                    } else {
                      console.log('[CartDrawer] updateItem RETRY - Item no longer in cart (qty=0 race condition?)');
                      self.loading(false);
                      // Rebuild cart since item was removed
                      $('body').trigger('added.ajaxProduct');
                    }
                  }).catch(function(err) {
                    console.log('[CartDrawer] updateItem RETRY - Failed to fetch fresh cart:', err);
                    self.loading(false);
                    self.updateError(XMLHttpRequest);
                  });
                } else {
                  // Second attempt failed or non-400 error, give up
                  console.log('[CartDrawer] updateItem - Giving up after attempt', attemptNum);
                  self.loading(false);
                  self.updateError(XMLHttpRequest);
                }
              });
            };

            // Start first attempt
            attemptCartChange(key, 1);
          });
          }
        }); // end waitPromise.then()
      },
  
      loading: function(state) {
        this.status.loading = state;
  
        if (state) {
          $(selectors.container).addClass('is-loading');
        } else {
          $(selectors.container).removeClass('is-loading');
        }
      },
  
      emptyCart: function() {
        $(selectors.container).empty();
        // Also remove any footers that were moved to drawer root
        $(selectors.drawer).children('.drawer__footer--fixed').remove();
      },
  
      updateSuccess: function(cart) {
        console.log('[event start] updateSuccess 5421...');

        // Clear any existing timeout to prevent premature flag clearing
        if (window.couponState.cartOperationTimeoutId) {
          clearTimeout(window.couponState.cartOperationTimeoutId);
          console.log('[Cart Operation] Cleared previous timeout');
        }

        // Clear cart operation flag with a delay to ensure monitoring code sees it
        window.couponState.cartOperationTimeoutId = setTimeout(function() {
          window.couponState.cartOperationInProgress = false;
          window.couponState.cartOperationTimeoutId = null;
          console.log('[Cart Operation] Cleared cartOperationInProgress=false (after updateSuccess)');
        }, 1500);

        $('body').trigger('ajaxCartUpdated', cart);
        //calculateFSB();
        this.buildCart(cart);
      }, //updateSuccess
  
      updateError: function(XMLHttpRequest) {
        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          console.warn(XMLHttpRequest.responseJSON.description);
        }
      },
  
      // Update elements after cart is updated
      sizeFooter: function() {
        // Stop if our drawer doesn't have a fixed footer
        if (!$(selectors.drawer).hasClass('drawer--has-fixed-footer')) {
          console.log('[sizeFooter] stopping - no fixed footer class');
          return;
        }

        var $drawer = $(selectors.drawer);

        // Find the new footer inside the cart container (if any)
        var $newFooter = $('#CartContainer').find('#drawer_footer');
        if (!$newFooter.length) {
          $newFooter = $('#CartContainer').find(selectors.fixedFooter);
        }

        // Only remove existing and move new if we found a new footer
        if ($newFooter.length) {
          // Remove any existing footers that are direct children of drawer (prevents duplicates)
          $drawer.children('.drawer__footer--fixed').remove();
          // Move new footer to be direct child of drawer
          $newFooter.appendTo($drawer);
        }

        // Get reference to footer (either moved or already at drawer root)
        var $cartFooter = $drawer.children('#drawer_footer');
        if (!$cartFooter.length) {
          $cartFooter = $drawer.children('.drawer__footer--fixed');
        }

        if (!$cartFooter.length) {
          // No footer found anywhere, nothing to size
          return;
        }

        $cartFooter.removeAttr('style');

        var $cartInner = $drawer.find('.drawer__inner_cart');
        var cartFooterHeight = 0;

        // Measure footer height
        var $cartWrapper = $('.drawer');
        var previousCss = $cartFooter.attr("style");

        $cartWrapper.css({
          position: 'absolute',
          visibility: 'hidden',
          display: 'block'
        });

        cartFooterHeight = $cartFooter.outerHeight();
        console.log('[sizeFooter] cartFooterHeight:', cartFooterHeight);
        $cartWrapper.attr("style", previousCss ? previousCss : "");

        // Set the scrollable area to stop above the footer
        if (cartFooterHeight) {
          $cartInner.css('bottom', cartFooterHeight);
          $cartFooter.css('height', cartFooterHeight);
        }

        console.log('[sizeFooter] Applied bottom:', cartFooterHeight, 'to .drawer__inner_cart');
      },
  
      updateCartNotification: function(evt, cart) {
        if (cart && cart.items && cart.items.length > 0) {
          $(selectors.cartBubble).addClass('cart-link__bubble--visible');
        } else {
          $(selectors.cartBubble).removeClass('cart-link__bubble--visible');
        }
      }
    });
  
    return CartDrawer;
  })();

  
  theme.AjaxProduct = (function() {
    var status = {
      loading: false
    };

    //wait for load ajax add to cart fix line 5092 mobile click
    //removed back to original
    function waitForLoad(status){
      window.setTimeout(function(){
        if(status){
          console.log('waiting for status.loading');
          waitForLoad(status);
        }else{
          console.log('waitForLoad loaded 5330');
        }
      }, 500)
    }
    
    function ProductForm($form) {
      this.$form = $form;
      this.$addToCart = this.$form.find('.add-to-cart');

      // mobile fixed for on click listener, touchend added
      if (this.$form.length) {
        this.$addToCart.on('click touchend', this.addItemFromForm.bind(this));
      }
    };
  
    ProductForm.prototype = $.extend({}, ProductForm.prototype, {
      addItemFromForm: function(evt, callback){
        evt.stopPropagation();
        evt.preventDefault();
        // check if subscription
        var hasSubscription = false;
        var that = $(this);
        var productId = $('select[name=id]').data("productid");
        // check cart value to prohibit free gift
        var freeGiftOne = false;
    	  var freeGiftTwo = false;
        var cartLessThan150 = false;
        var cartLessThan200 = false;
        var has_burn = false;
        var has_gut = false;
        var has_krill = false;
        var has_creatine = false;
        var has_gift = false;
        theme.cart.getCart().then(function(cart) {
          $.each(cart.items, function(index, product) {
            if (product.product_id == 7974457508016) {
              freeGiftOne = true;
            } else if ((product.product_id == 6873391071408) || (product.product_id == 7347476594864) || (product.product_id == 7448846074032) || (product.product_id == 7475705479344) || (product.product_id == 7974457508016)) {
              freeGiftTwo = true;
            } else if (product.product_id == 7352388518064) {
              has_gut = true;
            } else if (product.product_id == 3759094399010) {
              has_creatine = true;
            } else if (product.product_id == 576615415842) {
              has_krill = true;
            } 
          });
            if (cart.total_price < 15000) {
              cartLessThan150 = true;
            } 
            if (cart.total_price < 20000) {
              cartLessThan200 = true;
            }
        }).then(function(){
          if ((freeGiftOne == true) && (productId == 7974457508016)) {
            alert("Your cart already contains a free multi!"); 
          } else if ((freeGiftTwo == true) && ((productId == 6873391071408) || (productId == 7347476594864) || (productId == 7448846074032) || (productId == 7475705479344) || (productId == 7974457508016))) {
            alert("Your cart already contains a free gift!");
          } else if ((cartLessThan150 == true) && (productId == 7974457508016)) {
            alert("Sorry, your cart doesn't qualify for a free multi.");
          } else if ((cartLessThan200 == true) && ((productId == 6873391071408) || (productId == 7347476594864) || (productId == 7352388518064) || (productId == 7448846074032) || (productId == 7475705479344) || (productId == 7974457508016))) {
            alert("Sorry, your cart doesn't qualify for a free gift.");
          } else if ((has_burn == false) && (productId == 7343778005168)){
            alert("Sorry, your cart doesn't qualify for a free fat loss guide.")
          } else if ((has_creatine == false) && (productId == 7355144077488)){
            alert("Sorry, your cart doesn't qualify for a free strength guide.")
          } else {
            // original
            if (status.loading) {
              return;
            }
            // Loading indicator on add to cart button
            that[0].$addToCart.addClass('btn--loading');
            status.loading = true;
            var data = that[0].$form.serialize();
            theme.cart.addItemFromForm(data)
            .then(function(product) {
              that[0].success(product);
              $(document).trigger('addedToCart');
            }.bind(this))
            .catch(function(XMLHttpRequest) {
              that[0].error(XMLHttpRequest)
            }.bind(that[0]))
            .always(function() {
              status.loading = false;
              that[0].$addToCart.removeClass('btn--loading');
            }.bind(that[0]));

          } // end else
        }); // end then
      },
      success: function(product) {
        this.$form.find('.errors').remove();
        $('body').trigger('added.ajaxProduct');
      }, // success
      error: function(XMLHttpRequest) {
        this.$form.find('.errors').remove();
        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          console.warn(XMLHttpRequest.responseJSON.description);
          this.$form.prepend('<div class="errors text-center">' + XMLHttpRequest.responseJSON.description + '</div>');
        }
      }
    }); // ProductForm.prototype extend
    return ProductForm;
  })();
  
  // product convert custom script
    if ($('.product-convert-button')) {
         $(".product-convert-button").on('click', function() {
           var variantId = $(this).closest('.product-convert').data('variant');
		   $.ajax({
               type: 'POST',
               url: '/cart/add.js',
               dataType: 'json',
               data: {
                 quantity: 1,
                 id: variantId  
               },
               beforeSend: function() {
                 $('#CartDrawer').append("<div class='cart-loading'></div>");
               },
               success: function() {
                 $('body').trigger('added.ajaxProduct');
                 $('#CartDrawer').find($('.cart-loading')).remove();
               },
               error: function(XMLHttpRequest, textStatus, errorThrown) {
                 if (errorThrown === "Unprocessable Entity") {
                   $('.product-convert-button').text('Sold Out');
                 }
               }
           });
         });
     }

  
  theme.collapsibles = (function() {
  
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height'
    };
  
    var isTransitioning = false;
  
    function init() {
      $(selectors.trigger).each(function() {
        var $el = $(this);
        var state = $el.hasClass(classes.open);
        $el.attr('aria-expanded', state);
      });
  
      // Event listeners (hack for modals)
      $('body, .modal__inner').on('click', selectors.trigger, function() {
        if (isTransitioning) {
          return;
        }
  
        isTransitioning = true;
  
        var $el = $(this);
        var isOpen = $el.hasClass(classes.open);
        var moduleId = $el.attr('aria-controls');
        var $module = $('#' + moduleId);
        var height = $module.find(selectors.moduleInner).outerHeight();
        var isAutoHeight = $el.hasClass(classes.autoHeight);
  
        // If isAutoHeight, set the height to 0 just after setting the actual height
        // so the closing animation works nicely
        if (isOpen && isAutoHeight) {
          setTimeout(function() {
            height = 0;
            setTransitionHeight($module, height, isOpen, isAutoHeight);
          }, 0);
        }
  
        if (isOpen && !isAutoHeight) {
          height = 0;
        }
  
        $el
          .attr('aria-expanded', !isOpen)
          .toggleClass(classes.open, !isOpen);
  
        setTransitionHeight($module, height, isOpen, isAutoHeight);
      });
    }
  
    function setTransitionHeight($module, height, isOpen, isAutoHeight) {
      $module
        .removeClass(classes.hide)
        .prepareTransition()
        .css('height', height)
        .toggleClass(classes.open, !isOpen);
  
      if (!isOpen && isAutoHeight) {
        var o = $module;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 350);
      } else {
        isTransitioning = false;
      }
    }
  
    return {
      init: init
    };
  })();
  
  theme.headerNav = (function() {
  
    var $parent = $(document.documentElement).add('body');
    var $page = $('#MainContent');
    var selectors = {
      wrapper: '.header-wrapper',
      siteHeader: '.site-header',
      searchBtn: '.js-search-header',
      closeSearch: '.js-search-header-close',
      searchContainer: '.site-header__search-container',
      logoContainer: '.site-header__logo',
      logo: '.site-header__logo img',
      navigation: '.site-navigation',
      navContainerWithLogo: '.header-item--logo',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level'
    };
  
    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused'
    };
  
    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      stickyEnabled: false,
      stickyActive: false,
      stickyClass: 'site-header--stuck',
      openTransitionClass: 'site-header--opening',
      animatedClass: 'site-header--animated',
      lastScroll: 0
    };
  
    // Elements used in resize functions, defined in init
    var $window;
    var $navContainerWithLogo;
    var $logoContainer;
    var $nav;
    var $wrapper;
    var $siteHeader;
  
    function init() {
      $window = $(window);
      $navContainerWithLogo = $(selectors.navContainerWithLogo);
      $logoContainer = $(selectors.logoContainer);
      $nav = $(selectors.navigation);
      $wrapper = $(selectors.wrapper);
      $siteHeader = $(selectors.siteHeader);
  
      config.wrapperOverlayed = $wrapper.hasClass(config.overlayedClass);
      config.stickyEnabled = $siteHeader.data('sticky');
      if (config.stickyEnabled) {
        theme.config.stickyHeader = true;
        stickyHeader();
      }
  
      if (config.wrapperOverlayed) {
        $('body').addClass('overlaid-header');
      }
  
      accessibleDropdowns();
      searchDrawer();
    }
  
    function unload() {
      $(window).off(config.namespace);
      $(selectors.searchBtn).off(config.namespace);
      $(selectors.closeSearch).off(config.namespace);
      $parent.off(config.namespace);
      $(selectors.navLinks).off(config.namespace);
      $(selectors.navDropdownLinks).off(config.namespace);
      // Clean up ESC key handler
      $parent.off('keyup' + config.namespace);
    }
  
    function searchDrawer() {
      $(selectors.searchBtn).on('click' + config.namespace, function(evt) {
        evt.preventDefault();
        openSearchDrawer();
      });
  
      $(selectors.closeSearch).on('click' + config.namespace, function() {
        closeSearchDrawer();
      });
    }
  
    function openSearchDrawer() {
      $(selectors.searchContainer).addClass('is-active');
      $parent.addClass('js-drawer-open js-drawer-open--search');
  
      slate.a11y.trapFocus({
        $container: $(selectors.searchContainer),
        namespace: 'header_search',
        $elementToFocus: $(selectors.searchContainer).find('input')
      });
  
      // If sticky is enabled, scroll to top on mobile when close to it
      // so you don't get an invisible search box
      if (theme.config.bpSmall && config.stickyEnabled && config.lastScroll < 300) {
        window.scrollTo(0,0);
      }
  
      // Bind events
      slate.a11y.lockMobileScrolling(config.namespace);
  
      // Clicking out of container closes it
      $page.on('click' + config.namespace, function () {
        closeSearchDrawer();
        return false;
      });
  
      $parent.on('keyup' + config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          closeSearchDrawer();
        }
      });
    }
  
    function closeSearchDrawer() {
      // deselect any focused form elements
      $(document.activeElement).trigger('blur');
  
      $parent.removeClass('js-drawer-open js-drawer-open--search').off(config.namespace);
      $(selectors.searchContainer).removeClass('is-active');
  
      slate.a11y.removeTrapFocus({
        $container: $(selectors.searchContainer),
        namespace: 'header_search'
      });
  
      slate.a11y.unlockMobileScrolling(config.namespace);
      $page.off('click' + config.namespace);
      $parent.off('keyup' + config.namespace);
    }
  
    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;
  
      // Touch devices open dropdown on first click, navigate to link on second
      if (theme.config.isTouch) {
        $(selectors.navLinksWithDropdown).on('touchend' + config.namespace, function(evt) {
          var $el = $(this);
          var $parentItem = $el.parent();
          if (!$parentItem.hasClass(classes.dropdownActive)) {
            evt.preventDefault();
            closeDropdowns();
            openFirstLevelDropdown($el);
          } else {
            window.location.replace($el.attr('href'));
          }
        });
  
        $(selectors.navDropdownLinks).on('touchend' + config.namespace, function(evt) {
          var $el = $(this);
          var $parentItem = $el.parent();
  
          // Open third level menu or go to link based on active state
          if ($parentItem.hasClass(classes.hasSubDropdownClass)) {
            if (!$parentItem.hasClass(classes.dropdownActive)) {
              evt.preventDefault();
              closeThirdLevelDropdown();
              openSecondLevelDropdown($el);
            } else {
              window.location.replace($el.attr('href'));
            }
          } else {
            // No third level nav, go to link
            window.location.replace($el.attr('href'));
          }
        });
      }

      // **Modified to turn off hover megamenu activate
      $(selectors.navLinks).on('focusin mouseover' + config.namespace, function() {
        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }
  
        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }
      });

      // Clicking outside megamenu dropdown closes it
      $parent.on('click' + config.namespace, function (evt) {
        var $target = $(evt.target);
        var $megamenuDropdown = $('.site-nav__dropdown.megamenu');
        var $navItemWithDropdown = $('.site-nav--has-dropdown-hover');
        
        // Check if click is outside the megamenu dropdown and not on a nav item that has dropdown
        if ($megamenuDropdown.length && 
            !$target.closest('.site-nav__dropdown.megamenu').length && 
            !$target.closest('.site-nav--has-dropdown-hover').length) {
          $('.site-nav--has-dropdown-hover').removeClass('site-nav--has-dropdown-hover');
        }
      });

      $('#shopify-section-footer').on('click', function() {
        $('.site-nav--has-dropdown-hover').removeClass('site-nav--has-dropdown-hover');
      })

      // ESC key handler for megamenu dropdown
      $parent.on('keyup' + config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          // Close megamenu dropdown if open
          if ($('.site-nav--has-dropdown-hover').length) {
            $('.site-nav--has-dropdown-hover').removeClass('site-nav--has-dropdown-hover');
            return;
          }
        }
      });

      // ** Modified Open menu
      $(selectors.navLinks).on('click' + config.namespace, function(e) {
        openFirstLevelDropdown($(this));
      });
  
      // Force remove focus on sitenav links because focus sometimes gets stuck
      $(selectors.navLinks).on('mouseleave' + config.namespace, function() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      });
  
      // Open/hide sub level dropdowns
      $(selectors.navDropdownLinks).on('focusin' + config.namespace, function() {
        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }
  
        openSecondLevelDropdown($(this), true);
      });
  
      // Private dropdown methods
      function openFirstLevelDropdown($el) {
        var $parentItem = $el.parent();
        if ($parentItem.hasClass(classes.hasDropdownClass)) {
          $parentItem.addClass(classes.dropdownActive);
          $parentItem.toggleClass('site-nav--has-dropdown-hover');
          hasActiveDropdown = true;
        }
  
        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? 'touchend' : 'click';
            closeOnClickActive = true;
            $('body').on(eventType + config.namespace, function() {
              closeDropdowns();
              $('body').off(config.namespace);
              closeOnClickActive = false;
            });
          }
        }
      }
  
      function openSecondLevelDropdown($el, skipCheck) {
        var $parentItem = $el.parent();
        if ($parentItem.hasClass(classes.hasSubDropdownClass) || skipCheck) {
          $parentItem.addClass(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }
  
      function closeDropdowns() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }
  
      function closeSecondLevelDropdown() {
        $(selectors.navItems).removeClass(classes.dropdownActive);
      }
  
      function closeThirdLevelDropdown() {
        $(selectors.navDropdownLinks).parent().removeClass(classes.dropdownActive);
      }
    }
  
    function stickyHeader() {
      config.lastScroll = $window.scrollTop();
      $siteHeader.wrap('<div class="site-header-sticky"></div>');
  
      stickyHeaderHeight();
      setTimeout(function() {
        stickyHeaderHeight();
      }, 200)
      $window.on('resize' + config.namespace, $.debounce(50, stickyHeaderHeight));
      $window.on('scroll' + config.namespace, $.throttle(15, stickyHeaderScroll));
    }
  
    function stickyHeaderHeight() {
      // Ceil to a whole pixel: the SVG logo gives the header a fractional height
      // (e.g. 75.12px), and a fractional wrapper height leaves a subpixel sliver
      // under the fixed header where the page content shows through as a colored
      // hairline while scrolling.
      var headerHeight = Math.ceil($siteHeader.outerHeight(true));
      var $stickyHeader = $('.site-header-sticky').css('height', headerHeight);
      document.documentElement.style.setProperty('--sticky-header-height', headerHeight + 'px');
      // Document scroll position at which a fixed (top:0) header lines up with
      // its normal in-flow slot. Used to release the sticky header while
      // scrolling back up so it hands off seamlessly with no invisible gap.
      var stickyOffset = $stickyHeader.offset();
      config.unstickAt = stickyOffset ? stickyOffset.top : headerHeight;
    }
  
    function stickyHeaderScroll() {
      var scroll = $window.scrollTop();
      // How far the user must scroll down before the header sticks.
      var threshold = 250;
      // Ignore tiny scroll jitters so the header doesn't flicker.
      var delta = 5;
      // Release point: where a fixed (top:0) header lines up exactly with its
      // in-flow slot, so the hand-off on scroll-up is seamless (no "dead zone").
      var releaseAt = config.unstickAt || 0;
      // Stick a hysteresis gap past the release point (and at least `threshold`
      // down the page) so the stick/release states can never flicker into each
      // other when a tall bar pushes the header far down the document.
      var stickAt = Math.max(threshold, releaseAt + delta);

      // Back near the top: hand the header back to its normal in-flow position
      // (and restore the overlay style if used). Only once the in-flow header
      // would actually be visible, so it stays put the whole way up.
      if (scroll <= releaseAt) {
        if (config.stickyActive) {
          config.stickyActive = false;
          $siteHeader
            .removeClass(config.openTransitionClass)
            .removeClass(config.animatedClass)
            .removeClass(config.stickyClass);
          if (config.wrapperOverlayed) {
            $wrapper.addClass(config.overlayedClass);
          }
        }
        config.lastScroll = scroll;
        return;
      }

      // First time past the threshold: fix the header in place but keep it
      // hidden (translated up). It only reveals once the user scrolls up.
      if (!config.stickyActive) {
        if (scroll <= stickAt) {
          config.lastScroll = scroll;
          return;
        }

        config.stickyActive = true;

        $siteHeader.addClass(config.stickyClass);
        if (config.wrapperOverlayed) {
          $wrapper.removeClass(config.overlayedClass);
        }

        // Enable transitions one frame later so the initial hide snaps
        // into place instead of animating down from the top.
        setTimeout(function() {
          $siteHeader.addClass(config.animatedClass);
        }, 50);

        config.lastScroll = scroll;
        return;
      }

      // Already stuck: reveal on scroll up, hide on scroll down.
      if (Math.abs(scroll - config.lastScroll) > delta) {
        if (scroll < config.lastScroll) {
          $siteHeader.addClass(config.openTransitionClass);
        } else {
          $siteHeader.removeClass(config.openTransitionClass);
        }
        config.lastScroll = scroll;
      }
    }
  
    return {
      init: init,
      unload: unload
    };
  })();
  
  // =require modules/back-button.js
  theme.Slideshow = (function() {
    this.$slideshow = null;
  
    var classes = {
      next: 'is-next',
      init: 'is-init',
      animateOut: 'animate-out',
      wrapper: 'slideshow-wrapper',
      slideshow: 'slideshow',
      allSlides: 'slick-slide',
      currentSlide: 'slick-current',
      pauseButton: 'slideshow__pause',
      isPaused: 'is-paused'
    };
  
    function slideshow(el, args) {
      this.$slideshow = $(el);
      this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
      this.$pause = this.$wrapper.find('.' + classes.pauseButton);
  
      this.settings = {
        accessibility: false,
        arrows: args.arrows ? true : false,
        dots: args.dots ? true : false,
        fade: args.fade ? true : false,
        speed: args.speed ? args.speed : 500,
        draggable: true,
        touchThreshold: 5,
        pauseOnHover: false,
        autoplay: args.autoplay ? true : false,
        autoplaySpeed: this.$slideshow.data('speed')
      };
  
      this.$slideshow.off('beforeChange');
      this.$slideshow.off('afterSlideChange');
      this.$slideshow.on('init', this.init.bind(this));
      this.$slideshow.on('beforeChange', this.beforeSlideChange.bind(this));
      this.$slideshow.on('afterChange', this.afterSlideChange.bind(this));
  
      this.$slideshow.slick(this.settings);
  
      this.$pause.on('click', this._togglePause.bind(this));
    }
  
    slideshow.prototype = $.extend({}, slideshow.prototype, {
      init: function(event, obj) {
        this.$slideshowList = obj.$list;
        this.$slickDots = obj.$dots;
        this.$allSlides = obj.$slides;
        this.slideCount = obj.slideCount;
  
        this.$slideshow.addClass(classes.init);
        this._a11y();
        this._clonedLazyloading();
      },
      beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find('.' + classes.currentSlide).addClass(classes.animateOut);
      },
      afterSlideChange: function(event, slick, currentSlide) {
        var $slider = slick.$slider;
        var $allSlides = $slider.find('.' + classes.allSlides).removeClass(classes.animateOut);
      },
      destroy: function() {
        this.$slideshow.slick('unslick');
      },
  
      // Playback
      _play: function() {
        this.$slideshow.slick('slickPause');
        $(classes.pauseButton).addClass('is-paused');
      },
      _pause: function() {
        this.$slideshow.slick('slickPlay');
        $(classes.pauseButton).removeClass('is-paused');
      },
      _togglePause: function() {
        var slideshowSelector = this._getSlideshowId(this.$pause);
        if (this.$pause.hasClass(classes.isPaused)) {
          this.$pause.removeClass(classes.isPaused);
          $(slideshowSelector).slick('slickPlay');
        } else {
          this.$pause.addClass(classes.isPaused);
          $(slideshowSelector).slick('slickPause');
        }
      },
  
      // Helpers
      _getSlideshowId: function($el) {
        return '#Slideshow-' + $el.data('id');
      },
      _activeSlide: function() {
        return this.$slideshow.find('.slick-active');
      },
      _currentSlide: function() {
        return this.$slideshow.find('.slick-current');
      },
      _nextSlide: function(index) {
        return this.$slideshow.find('.slideshow__slide[data-slick-index="' + index + '"]');
      },
  
      // a11y fixes
      _a11y: function() {
        var $list = this.$slideshowList;
        var autoplay = this.settings.autoplay;
  
        if (!$list) {
          return;
        }
  
        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');
  
        // When an element in the slider is focused
        // pause slideshow and set aria-live
        $(classes.wrapper).on('focusin', function(evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }
  
          $list.attr('aria-live', 'polite');
          if (autoplay) {
            this._pause();
          }
        }.bind(this));
  
        // Resume autoplay
        $(classes.wrapper).on('focusout', function(evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }
  
          $list.removeAttr('aria-live');
          if (autoplay) {
            this._play();
          }
        }.bind(this));
      },
  
      // Make sure lazyloading works on cloned slides
      _clonedLazyloading: function() {
        var $slideshow = this.$slideshow;
  
        $slideshow.find('.slick-slide').each(function(index, el) {
          var $slide = $(el);
          if ($slide.hasClass('slick-cloned')) {
            var slideId = $slide.data('id');
            var $slideImg = $slide.find('.hero__image').removeClass('lazyloading').addClass('lazyloaded');
  
            // Get inline style attribute from non-cloned slide with arbitrary timeout
            // so the image is loaded
            setTimeout(function() {
              var loadedImageStyle = $slideshow.find('.slideshow__slide--' + slideId + ':not(.slick-cloned) .hero__image').attr('style');
  
              if (loadedImageStyle) {
                $slideImg.attr('style', loadedImageStyle);
              }
  
            }, this.settings.autoplaySpeed / 1.5);
  
          }
        }.bind(this));
      }
    });
  
    return slideshow;
  })();
  
  theme.announcementBar = (function() {
    var $slider, $sliderDesktop;
    var defaults = {
      accessibility: false,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 3000,
      touchThreshold: 20,
      slidesToShow: 1
    };

    function sliders() { return [$slider, $sliderDesktop]; }
    function isInitialized($current) {
      return $current && $current.length && $current.hasClass('slick-initialized');
    }

    function updateAppearance($current, index) {
      var $slide = $current.find('[data-announcement-background][data-index="' + index + '"]').first();
      $current.closest('.announcement-bar').css({
        'background-color': $slide.attr('data-announcement-background') || '#000000',
        'padding-top': ($slide.attr('data-announcement-padding-top') || '10') + 'px',
        'padding-bottom': ($slide.attr('data-announcement-padding-bottom') || '10') + 'px'
      });
    }

    function refresh() {
      sliders().forEach(function($current) {
        if (!$current || !$current.length) return;
        if (isInitialized($current)) $current.slick('unslick');
        // Unslick first, so original slides and clones cannot leave empty slots.
        $current.children('[data-ebf-announcement][hidden]').remove();
        $current.children('.announcement-slider__slide').each(function(index) {
          $(this).attr('data-index', index);
        });
        var count = $current.children('.announcement-slider__slide').length;
        $current.data('block-count', count).attr('data-block-count', count);
        var $bar = $current.closest('.announcement-bar');
        $bar.prop('hidden', count === 0).toggleClass('announcement-bar--ebf',
          $current.children('[data-ebf-announcement]').length > 0);
        if (!count) return;
        updateAppearance($current, 0);
        var desktop = $current.attr('id') === 'AnnouncementSliderDesktop';
        if (desktop === theme.config.bpSmall) return;
        var compact = $current.data('compact-style');
        $current.off('beforeChange.announcementColors').on('beforeChange.announcementColors', function(event, slick, current, next) {
          updateAppearance($current, next);
        });
        $current.slick($.extend({}, defaults, {
          slidesToShow: desktop && !compact ? count : 1,
          slidesToScroll: 1
        }));
      });
      $(window).trigger('resize');
    }

    function init() {
      $slider = $('#AnnouncementSlider');
      $sliderDesktop = $('#AnnouncementSliderDesktop');
      if (!$slider.length && !$sliderDesktop.length) return;
      refresh();
      $('body').off('matchSmall.announcementBar matchLarge.announcementBar')
        .on('matchSmall.announcementBar matchLarge.announcementBar', refresh);
    }

    function onBlockSelect(id) {
      sliders().forEach(function($current) {
        if (!isInitialized($current)) return;
        var $slide = $current.find('[data-announcement-block-id="' + id + '"]').not('.slick-cloned').first();
        $current.slick('slickPause');
        if ($slide.length) $current.slick('slickGoTo', Number($slide.attr('data-index')), true);
      });
    }

    function onBlockDeselect() {
      sliders().forEach(function($current) {
        if (isInitialized($current)) $current.slick('slickPlay');
      });
    }

    function unload() {
      sliders().forEach(function($current) {
        if (isInitialized($current)) $current.slick('unslick');
      });
      $('body').off('matchSmall.announcementBar matchLarge.announcementBar');
    }

    document.addEventListener('ath:buy-more-change', refresh);
    return { init: init, refresh: refresh, onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect, unload: unload };
  })();

  theme.currencySwitcher = (function() {
  
    var selectors = {
      dataDiv: '#CurrencyData',
      picker: '.currency-input'
    };
  
    var data = {};
  
    function init() {
      var $dataDiv = $(selectors.dataDiv);
  
      if (!$dataDiv.length) {
        return;
      }
  
      $primaryPicker = $('#CurrencyPicker-header');
      $drawerPicker = $('#CurrencyPicker-drawer');
  
      // Keep all currency pickers in sync
      $primaryPicker.on('change', function() {
        $drawerPicker.val($(this).val());
      });
  
      $drawerPicker.on('change', function() {
        $primaryPicker.val($(this).val());
      });
  
      data = {
        currency: $dataDiv.data('shop-currency'),
        default: $dataDiv.data('default-currency'),
        format: $dataDiv.data('format'),
        moneyFormat: $dataDiv.data('money-format'),
        moneyCurrencyFormat: $dataDiv.data('money-currency-format')
      };
  
      Currency.format = data.format;
  
      // Rely on the shop's currency format, not Shopify defaults (in case merchant changes it)
      Currency.money_format[data.currency] = data.moneyFormat;
      Currency.money_with_currency_format[data.currency] = data.moneyCurrencyFormat;
  
      // Fix for customer account page
      $('span.money span.money').each(function() {
        $(this).parents('span.money').removeClass('money');
      });
  
      // Save current price
      $('span.money').each(function() {
        $(this).attr('data-currency-' + data.currency, $(this).html());
      });
  
      checkCookie();
  
      $(selectors.picker).val(Currency.currentCurrency).on('change', refresh);
    }
  
    function refresh() {
      var newCurrency = $(selectors.picker).val();
      Currency.convertAll(Currency.currentCurrency, newCurrency);
    }
  
    function ajaxrefresh() {
      var newCurrency = $(selectors.picker).val();
      // Ajax cart always returns shop's currency, not what theme settings defines
      Currency.convertAll(data.currency, newCurrency);
    }
  
    function checkCookie() {
      var cookieCurrency = Currency.cookie.read();
  
      if (cookieCurrency == null) {
        if (data.currency !== data.default) {
          Currency.convertAll(data.currency, data.default);
        }
        else {
          Currency.currentCurrency = data.default;
        }
      } else if ($(selectors.picker).length && $(selectors.picker).find('option[value=' + cookieCurrency + ']').length === 0) {
        // If the cookie value does not correspond to any value in the currency dropdown
        Currency.currentCurrency = data.currency;
        Currency.cookie.write(data.currency);
      }
      else if (cookieCurrency === data.currency) {
        Currency.currentCurrency = data.currency;
      }
      else {
        Currency.convertAll(data.currency, cookieCurrency);
      }
    }
  
    return {
      init: init,
      refresh: refresh,
      ajaxrefresh: ajaxrefresh
    };
  })();
  
  theme.initQuickShop = function(reinit) {
    var ids = [];
    var $buttons = $('.quick-product__btn');
  
    $buttons.each(function() {
      var id = $(this).data('product-id');
      var modalId = 'QuickShopModal-' + id;
      var name = 'quick-modal-' + id;
  
      // If another identical modal exists, remove duplicates
      if (ids.indexOf(id) > -1) {
        $('.modal--quick-shop[data-product-id="'+ id +'"]').each(function(i) {
          if (i > 0) {
            $(this).remove();
          }
        });
        return;
      }
  
      new theme.Modals(modalId, name);
      ids.push(id);
    });
  };
  
  theme.videoModal = function() {
    var videoModalPlayer = null;
    var videoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        branding: 0,
        cc_load_policy: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      }
    };
  
    var selectors = {
      triggers: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]'
    };
  
    if (!$(selectors.triggers).length) {
      return;
    }
  
    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      solid: true
    });
  
    $(selectors.triggers).on('click', triggerYouTubeModal);
  
    function triggerYouTubeModal(evt) {
      evt.preventDefault();
      window.loadYouTube();
  
      if (theme.config.youTubeReady) {
        startVideoOnClick(evt);
      } else {
        $('body').on('youTubeReady', function() {
          startVideoOnClick(evt);
        });
      }
    }
  
    function startVideoOnClick(evt) {
      var $el = $(evt.currentTarget);
      var videoId = getYoutubeVideoId($el.attr('href'));
  
      var args = $.extend({}, videoOptions, {
        videoId: videoId
      });
  
      // Disable plays inline on mobile
      args.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;
  
      var videoModalPlayer = new YT.Player('VideoHolder', args);
      modal.open();
  
      $('body').on('modalClose.VideoModal', function() {
        // Slight timeout so it is destroyed after the modal closes
        setTimeout(function() {
          videoModalPlayer.destroy();
        }, 500); // modal close css transition
      });
    }
  
    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }
  };
  
  
  theme.RecentlyViewed = (function() {
    var selectors = {
      template: '#RecentlyViewedProduct',
      outputContainer: '#RecentlyViewed-'
    };
  
    var init = false;
  
    function RecentlyViewed(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      this.namespace = '.recently-viewed' + sectionId;
  
      if (!$(selectors.template).length) {
        return;
      }
  
      // Lazyload API
      this.checkVisibility();
      $(window).on('scroll' + this.namespace, $.throttle(200, this.checkVisibility.bind(this)));
    };
  
    RecentlyViewed.prototype = $.extend({}, RecentlyViewed.prototype, {
      init: function() {
        if (init) {
          return;
        }
  
        init = true;
  
        if ($.isEmptyObject(theme.recentlyViewed.recent)) {
          // No previous history on page load, so bail
          return;
        }
  
        this.outputContainer = $(selectors.outputContainer + this.sectionId);
        this.handle = this.$container.attr('data-product-handle');
  
        // Request new product info via JS API
        var promises = [];
        for (handle in theme.recentlyViewed.recent) {
          promises.push(this.getProductInfo(handle));
        }
  
        Promise.all(promises).then(function(result) {
          this.setupOutput(result);
          this.captureProductDetails(result);
          
          console.log('recently viewed items set up');
		  
          //setTimeout(function(){StampedFn.loadBadges(); console.log('ran loadBages');},500);
          
        }.bind(this), function(error) {
          console.log('Theme | recently viewed products failed to load');
          console.log(error);
        });
      },
  
      checkVisibility: function() {
        if (theme.isElementVisible(this.$container, 600)) {
          this.init();
          $(window).off('scroll' + this.namespace);
        }
      },
  
      getProductInfo: function(handle) {
        return new Promise(function(resolve, reject) {
          if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
            resolve(theme.recentlyViewed.productInfo[handle]);
          } else {
            jQuery.getJSON('/products/'+ handle +'.js', function(product) {
              resolve(product);
            });
          }
        });
      },
  
      setupOutput: function(products) {
        var allProducts = [];
        var data = {};
        var limit = this.$container.attr('data-recent-count');
  
        var i = 0;
        for (key in products) {
          var product = products[key];
          // Ignore current product
          if (product.handle === this.handle) {
            continue;
          }
  
          i++;
          // New or formatted properties
          product.product_id = product.id;
          product.url_formatted = theme.recentlyViewed.recent[product.handle] ? theme.recentlyViewed.recent[product.handle].url : product.url;
          product.image_responsive_url = theme.recentlyViewed.recent[product.handle].featuredImage;
          product.image_aspect_ratio = theme.recentlyViewed.recent[product.handle].aspectRatio;
          // product.on_sale = product.compare_at_price > product.price;
          product.on_sale = false;
          product.sold_out = !product.available;
          product.price_formatted = theme.Currency.formatMoney(product.price, theme.settings.moneyFormat);
          product.compare_at_price_formatted = theme.Currency.formatMoney(product.compare_at_price, theme.settings.moneyFormat);
          product.price_min_formatted = theme.Currency.formatMoney(product.price_min, theme.settings.moneyFormat);
          product.money_saved = theme.Currency.formatMoney((product.compare_at_price - product.price), theme.settings.moneyFormat);
  
          allProducts.unshift(product);
        }
  
        data = {
          items: allProducts.slice(0, limit),
          grid_item_width: this.$container.attr('data-grid-item-class')
        };
  
        if (allProducts.length === 0) {
          return;
        }
  
        // Prep handlebars template
        var source = $(selectors.template).html();
        var template = Handlebars.compile(source);
        this.outputContainer.append(template(data));
  
        if (AOS) {
          AOS.refreshHard();
        }
      },
  
      captureProductDetails: function(products) {
        for (var i = 0; i < products.length; i++) {
          var product = products[i];
          theme.recentlyViewed.productInfo[product.handle] = product;
        }
  
        // Add data to session storage to reduce API requests later
        if (theme.config.hasSessionStorage) {
          sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
        }
      },
  
      onUnload: function() {
        init = false;
        $('window').off(this.namespace);
      }
    });
  
    return RecentlyViewed;
  })();
  
  theme.parallaxSections = {};
  
  theme.Parallax = (function() {
    var speed = 7; // higher is slower
  
    function parallax(el, args) {
      this.$container = $(el);
      this.namespace = args.namespace;
  
      if (!this.$container.length) {
        return;
      }
  
      if (args.desktopOnly) {
        this.desktopInit();
      } else {
        this.init(this.$container, args)
      }
    }
  
    parallax.prototype = $.extend({}, parallax.prototype, {
      init: function(desktopOnly) {
        var $window = this.$window = $(window);
        var elTop = this.$container.offset().top;
  
        $window.on('scroll' + this.namespace, function(evt) {
          var scrolled = $window.scrollTop();
          var shiftDistance = (elTop - scrolled) / speed;
          this.$container.css({
            'transform': 'translate3d(0, ' + shiftDistance + 'px, 0)'
          });
        }.bind(this));
  
        // Reinit on resize
        $window.on('resize' + this.namespace, $.debounce(350, function() {
          $window.off(this.namespace);
  
          if (desktopOnly) {
            if (!theme.config.bpSmall) {
              this.init(true);
              return;
            }
          }
  
          this.init();
        }.bind(this)));
      },
  
      desktopInit: function() {
        if (!theme.config.bpSmall) {
          this.init(true);
        }
  
        $('body').on('matchSmall', function() {
          this.destroy();
        }.bind(this));
  
        $('body').on('matchLarge', function() {
          this.init(true);
        }.bind(this));
      },
  
      destroy: function() {
        this.$container.removeAttr('style');
        this.$window.off(this.namespace);
      }
    });
  
    return parallax;
  })();
  

  theme.collectionTemplate = (function() {
    var isAnimating = false;
  
    var selectors = {
      collectionGrid: '.grid--collection',
      sidebar: '#CollectionSidebar',
      tags: '.tag-list a',
      removeTag: '.tag--remove a',
      oosCheckbox: '.js-show-oos-checkbox',
      ajaxResult: '#CollectionAjaxResult'
    };
  
    var settings = {
      combineTags: $(selectors.sidebar).data('combine-tags')
    };
  
    var classes = {
      activeTag: 'tag--active'
    };
  
    function init() {
      // Ajax pagination
      $(window).on('popstate', function(state) {
        if (state) {
          getNewCollectionContent(location.href);
        }
      });
  
      initTagClicks();
      initOutOfStockToggle();
      syncOutOfStockToggle();
    }

    function initTagClicks() {
      $('body').on('click', selectors.tags, function(evt) {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
  
        if ($(this).hasClass('no-ajax')) {
          return;
        }
  
        evt.preventDefault();
        if (isAnimating) {
          return;
        }
  
        isAnimating = true;
  
        var $el = $(evt.currentTarget);
        var $parent = $el.parent();
        var newUrl = $el.attr('href');
  
        if (settings.combineTags) {
          if ($parent.hasClass(classes.activeTag)) {
            $parent.removeClass(classes.activeTag);
          } else {
            $parent.addClass(classes.activeTag);
          }
        } else {
          $(selectors.tags).parent().removeClass(classes.activeTag);
          $parent.addClass(classes.activeTag);
        }
  
        updateScroll(true);
  
        history.pushState({}, '', newUrl);
        $(selectors.collectionGrid).addClass('unload');
        getNewCollectionContent(newUrl);
      });
  
      // Immediately remove the remove tag button before ajax kicks in
      $('body').on('click', selectors.removeTag, function() {
        $(this).parent('li').remove();
      });
    }
  
    function initOutOfStockToggle() {
      // "Show out of stock" filter. Delegated + idempotent so it survives the
      // sidebar being re-rendered by ajax. The toggle class lives on
      // #CollectionAjaxResult (.collection-content), which is NOT replaced by
      // ajax (only its inner HTML is), so the choice persists across filtering.
      $('body').off('change.showoos').on('change.showoos', selectors.oosCheckbox, function() {
        var show = $(this).prop('checked');
        $(selectors.ajaxResult).toggleClass('show-oos', show);
        // Keep the drawer + sidebar checkboxes in sync when both are present.
        $(selectors.oosCheckbox).prop('checked', show);
      });
    }

    function syncOutOfStockToggle() {
      // Re-check freshly-rendered checkboxes against the persistent toggle class.
      var show = $(selectors.ajaxResult).hasClass('show-oos');
      $(selectors.oosCheckbox).prop('checked', show);
    }

    function updateScroll(animate) {
      var scrollTo;
      if (theme.config.bpSmall) {
        scrollTo = $('.collection-filter').offset().top - 10;
      } else {
        scrollTo = $('#CollectionAjaxResult').offset().top + 1;
      }
  
      if (theme.config.stickyHeader) {
        var heightOfStickyNav = $('.site-header').outerHeight(true);
        scrollTo = scrollTo - heightOfStickyNav;
      }
  
      if (animate) {
        $('html, body').animate({ scrollTop: scrollTo }, 300);
      } else {
        $('html, body').scrollTop(scrollTo);
      }
    }
  
    function getNewCollectionContent(url) {
      $('#CollectionAjaxResult').load(url + ' #CollectionAjaxContent', function() {
        isAnimating = false;
        theme.reinitSection('collection-template');
        theme.collectionTemplate.reinit();
      }.bind(this));
    }
  
    function reinit() {
      settings.combineTags = $(selectors.sidebar).data('combine-tags');
  
      updateScroll(false);
      initTagClicks();
      syncOutOfStockToggle();

      AOS.refreshHard();
  
      // Setup page transition classes
      theme.pageTransitions();
  
      // Reload quick shop buttons
      theme.initQuickShop(true);
  
      // Refresh currency
      if ($('body').hasClass('currencies-enabled')) {
        theme.currencySwitcher.ajaxrefresh();
      }
  
      // Refresh reviews app
      if (window.SPR) {
        SPR.initDomEls();SPR.loadBadges();
      }
  
      // Reload products inside each quick shop
      sections.register('product-template', theme.Product);
    }
  
    return {
      init: init,
      reinit: reinit
    };
  })();
  
  theme.customerTemplates = (function() {
  
    function initEventListeners() {
      // Show reset password form
      $('#RecoverPassword').on('click', function(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
  
      // Hide reset password form
      $('#HideRecoverPasswordLink').on('click', function(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
    }
  
    /**
     *
     *  Show/Hide recover password form
     *
     */
    function toggleRecoverPasswordForm() {
      $('#RecoverPasswordForm').toggleClass('hide');
      $('#CustomerLoginForm').toggleClass('hide');
    }
  
    /**
     *
     *  Show reset password success message
     *
     */
    function resetPasswordSuccess() {
      var $formState = $('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!$formState.length) {
        return;
      }
  
      // show success message
      $('#ResetSuccess').removeClass('hide');
    }
  
    /**
     *
     *  Show/hide customer address forms
     *
     */
    function customerAddressForm() {
      var $newAddressForm = $('#AddressNewForm');
      var $addressForms = $('.js-address-form');
  
      if (!$newAddressForm.length || !$addressForms.length) {
        return;
      }
  
      if (Shopify) {
        $('.js-address-country').each(function() {
          var $container = $(this);
          var countryId = $container.data('country-id');
          var provinceId = $container.data('province-id');
          var provinceContainerId = $container.data('province-container-id');
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }
  
      // Toggle new/edit address forms
      $('.address-new-toggle').on('click', function() {
        $newAddressForm.toggleClass('hide');
      });
  
      $('.address-edit-toggle').on('click', function() {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
      });
  
      $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
  
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
          Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
      });
    }
  
    /**
     *
     *  Check URL for reset password hash
     *
     */
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    return {
      init: function() {
        checkUrlHash();
        initEventListeners();
        resetPasswordSuccess();
        customerAddressForm();
      }
    };
  })();
  

  theme.Product = (function() {
  
    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable',
      zoomInit: 'photo-zoom-init'
    };
  
    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      currentSlide: '.slick-current',
      zoomImage: '.photo-zoom-link__initial'
    };
  
    var youtubeReady;
    var videos = {};
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      height: '480',
      width: '850',
      playerVars :{
        autohide: 0,
        autoplay: 1,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      },
      events: {
        onReady: onVideoPlayerReady,
        onStateChange: onVideoStateChange
      }
    };
  
    var vimeoReady;
    var vimeoPlayers = [];
    var vimeoVideoOptions = {
      byline: false,
      title: false,
      portrait: false,
      loop: true
    };
  
    function onVideoPlayerReady(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];
  
      setParentAsLoading($player);
  
      if (videos[playerId].style === 'muted') {
        youtubePlayers[playerId].mute().playVideo().pauseVideo();
      } else {
        setParentAsLoaded($player);
      }
  
      // If first slide or only photo, start video
      if ($player.closest(selectors.currentSlide).length || $player.data('image-count') === 1) {
        if (videos[playerId].style === 'muted') {
          youtubePlayers[playerId].playVideo();
          initCheckVisibility(playerId);
        }
      }
    }
  
    function initCheckVisibility(playerId) {
      // Add out of view pausing
      videoVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
    }
  
    function videoVisibilityCheck(id) {
      var playerId;
  
      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        playerId = id.data.id;
      }
  
      if (theme.isElementVisible($('#' + playerId))) {
        if (videos[playerId] && videos[playerId].style === 'unmuted') {
          return;
        }
        playVisibleVideo(playerId);
      } else {
        pauseHiddenVideo(playerId);
      }
    }
  
    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }
  
    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }
  
    function onVideoStateChange(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];
  
      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          player.playVideo();
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }
  
    function setParentAsLoading($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.loading);
    }
  
    function setParentAsLoaded($el) {
      $el
        .closest(selectors.videoParent)
        .removeClass(classes.loading)
        .addClass(classes.loaded);
    }
  
    function setVideoToBeInteractedWith($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.interactable);
    }
  
    function Product(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
  
      this.inModal = $container.closest('.modal').length;
      this.$modal;
  
      this.settings = {
        enableHistoryState: $container.data('enable-history-state') || false,
        namespace: '.product-' + sectionId,
        zoom: $container.data('image-zoom') || false,
        inventory: $container.data('inventory') || false,
        modalInit: false,
        lazyLoadModalContent: $container.data('lazyload-content') || false,
        slickMainInitialized: false,
        slickThumbInitialized: false,
        hasImages: true,
        hasMultipleImages: false,
        imageSize: '620x'
      };
  
      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.$modal = $('#QuickShopModal-' + sectionId);
      }
  
      this.selectors = {
        variantsJson: 'VariantsJson-' + sectionId,
  
        video: 'ProductVideo-' + sectionId,
        photoThumbs: '.product__thumb-' + sectionId,
        thumbSlider: '#ProductThumbs-' + sectionId,
        //turn off slickslide for product photos
        mainSlider: '#ProductPhotos-' + sectionId,
        productImageMain: '.product-image-main--' + sectionId,
  
        priceWrapper: '.product__price-wrap-' + sectionId,
        price: '#ProductPrice-' + sectionId,
        comparePrice: '#ComparePrice-' + sectionId,
        savePrice: '#SavePrice-' + sectionId,
        priceA11y: '#PriceA11y-' + sectionId,
        comparePriceA11y: '#ComparePriceA11y-' + sectionId,
        sku: '#Sku-' + sectionId,
        inventory: '#ProductInventory-' + sectionId,
  
        addToCart: '#AddToCart-' + sectionId,
        addToCartText: '#AddToCartText-' + sectionId,
  
        originalSelectorId: '#ProductSelect-' + sectionId,
        singleOptionSelector: '.variant__input-' + sectionId,
        variantColorSwatch: '.variant__input--color-swatch-' + sectionId,
  
        modalFormHolder: '#ProductFormHolder-' + sectionId,
        formContainer: '#AddToCartForm-' + sectionId,
      };
  
      this.$mainSlider = $(this.selectors.mainSlider);
      this.$thumbSlider = $(this.selectors.thumbSlider);
      this.$firstProductImage = this.$mainSlider.find('img').first();
  
      if (!this.$firstProductImage.length) {
        this.settings.hasImages = false;
      }
  
      this.init();
    }
  
    Product.prototype = $.extend({}, Product.prototype, {
      init: function() {
        if (this.inModal) {
          this.$container.addClass(classes.isModal);
          $('body').on('modalOpen.QuickShopModal-' + this.sectionId, this.openModalProduct.bind(this));
          $('body').on('modalClose.QuickShopModal-' + this.sectionId, this.closeModalProduct.bind(this));
        }
  
        if (!this.inModal) {
          this.stringOverrides();
          this.formSetup();
          this.productSetup();
  
          this.checkIfVideos();
          this.createImageCarousels();
  
          // Add product id to recently viewed array
          this.addIdToRecentlyViewed();
        }

      },
  
      formSetup: function() {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.initVariants();
      },
  
      productSetup: function() {
        this.setImageSizes();
        this.initImageSwitch();
      },
  
      addIdToRecentlyViewed: function() {
        var handle = this.$container.attr('data-product-handle');
        var url = this.$container.attr('data-product-url');
        var aspectRatio = this.$container.attr('data-aspect-ratio');
        var featuredImage = this.$container.attr('data-img-url');
  
        // Remove current product if already in set of recent
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }
  
        // Add it back to the end
        theme.recentlyViewed.recent[handle] = {
          url: url,
          aspectRatio: aspectRatio,
          featuredImage: featuredImage
        };
  
        $.cookie('theme-recent', JSON.stringify(theme.recentlyViewed.recent), { path: '/', expires: 10000 });
      },
  
      stringOverrides: function() {
        theme.productStrings = theme.productStrings || {};
        $.extend(theme.strings, theme.productStrings);
      },
  
      setImageSizes: function() {
        if (!this.settings.hasImages) {
          return;
        }
  
        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.$firstProductImage[0].currentSrc;
  
        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
  
        if (this.settings.zoom) {
          this.settings.imageZoomSize = theme.Images.imageSize(this.$firstProductImage.parent().data('zoom-size'));
        }
      },
  
      initVariants: function() {
        if (!document.getElementById(this.selectors.variantsJson)) {
          return;
        }
  
        this.variantsObject = JSON.parse(document.getElementById(this.selectors.variantsJson).innerHTML);
        this._isSubscriptionSelected = false;

        var options = {
          $container: this.$container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject
        };
  
        if ($(this.selectors.variantColorSwatch).length) {
          $(this.selectors.variantColorSwatch).on('change', function(evt) {
            var $el = $(evt.currentTarget);
            var color = $el.data('color-name');
            var index = $el.data('color-index');
            this.updateColorName(color, index);
          }.bind(this));
        }
  
        this.variants = new slate.Variants(options);
        this.$container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
        //update product descriptionmetadata on variant change
        this.$container.on('variantChange' + this.settings.namespace, this.updateMetadata.bind(this));
        //hiding flavor on sample selection
        this.$container.on('variantChange' + this.settings.namespace, this.sampleSelection.bind(this));

        //redirects lytes limited flavors to limited edition page
        this.$container.on('variantChange' + this.settings.namespace, this.limitedFlavors.bind(this));
        //redirects staple flavors selection back to main lytes page
        this.$container.on('variantChange' + this.settings.namespace, this.stapleFlavors.bind(this));
        //redirects variety pack selection to build-your-bundle page
        this.$container.on('variantChange' + this.settings.namespace, this.varietyPack.bind(this));
        this.$container.on('updateCartButton' + this.settings.namespace, this.updateCartButton.bind(this));
        
        this.$container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
        this.$container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
        if ($(this.selectors.sku).length) {
          this.$container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }
        if (this.settings.inventory) {
          this.$container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }

        // Fire updateCartButton on initial load so that if the page loads
        // with an out-of-stock variant selected, the Klaviyo BIS button shows
        var initialVariant = this.variants.currentVariant;

        // Check if page loaded with a redirect variant (back-button + reload)
        var _isRedirectVariant = function(v) {
          if (!v) return false;
          var t = v.title.toLowerCase();
          return t.includes('limited flavors') || t.includes('staple flavors') || t.includes('variety pack');
        };

        var self = this;

        // Check URL ?variant= param — _updateHistoryState pushState overwrites
        // our replaceState, so the URL may have a redirect variant even though
        // the DOM selector was reset before navigation.
        var urlVariant = null;
        var urlParams = new URLSearchParams(window.location.search);
        var urlVariantId = urlParams.get('variant');
        if (urlVariantId) {
          urlVariantId = parseInt(urlVariantId, 10);
          for (var i = 0; i < this.variantsObject.length; i++) {
            if (this.variantsObject[i].id === urlVariantId) {
              urlVariant = this.variantsObject[i];
              break;
            }
          }
        }

        var needsReset = _isRedirectVariant(initialVariant) || _isRedirectVariant(urlVariant);

        console.log('[REDIRECT-DEBUG] initVariants running');
        console.log('[REDIRECT-DEBUG] initialVariant:', initialVariant ? { id: initialVariant.id, title: initialVariant.title } : null);
        console.log('[REDIRECT-DEBUG] urlVariantId:', urlVariantId, 'urlVariant:', urlVariant ? { id: urlVariant.id, title: urlVariant.title } : null);
        console.log('[REDIRECT-DEBUG] needsReset:', needsReset);
        console.log('[REDIRECT-DEBUG] window.location.href:', window.location.href);

        // Only call appstleInit if Appstle hasn't already rendered its widget.
        // On bfcache restore, Appstle's JS listeners survive intact and will
        // recreate the widget when variantChange fires — so we just check existence.
        var _tryAppstleInit = function() {
          var existing = document.querySelector('[id*="appstle"]');
          console.log('[REDIRECT-DEBUG] _tryAppstleInit — existing:', !!existing, 'appstleInit:', typeof window.appstleInit);
          if (existing) {
            console.log('[REDIRECT-DEBUG] Appstle widget already in DOM, skipping init');
            return;
          }
          if (window.appstleInit) {
            console.log('[REDIRECT-DEBUG] No widget found, calling appstleInit()');
            window.appstleInit();
          }
        };

        // Resets selectors, triggers variant change, and reinits Appstle
        var _resetAndReinit = function(source) {
          console.log('[REDIRECT-DEBUG] _resetAndReinit called from:', source);
          self._resetSelectorsToDefault();
          var $sel = $(self.selectors.singleOptionSelector, self.$container);
          console.log('[REDIRECT-DEBUG] triggering change on first selector');
          $sel.first().trigger('change');

          var masterSelect = $(self.selectors.originalSelectorId, self.$container);
          console.log('[REDIRECT-DEBUG] master select value after reset:', masterSelect.val());
          console.log('[REDIRECT-DEBUG] URL after reset:', window.location.href);

          // Explicitly refresh metadata + cart button — the variantChange
          // event chain does not reliably propagate on bfcache restore
          var resetVariant = self.variants._getVariantFromOptions();
          console.log('[REDIRECT-DEBUG] _resetAndReinit variant for metadata:', resetVariant ? { id: resetVariant.id, title: resetVariant.title } : null);
          if (resetVariant) {
            self.updateMetadata({ variant: resetVariant });
            self.updateCartButton({ variant: resetVariant });
          }

          // Do NOT call appstleInit() here — bfcache preserves Appstle's
          // listeners, so calling it again would register duplicates.
          // Instead, dispatch a native change on the master select so Appstle's
          // surviving listener detects the variant and renders the widget.
          // (jQuery .val() doesn't fire native change events.)
          setTimeout(function() {
            if (!document.querySelector('[id*="appstle"]')) {
              var master = $(self.selectors.originalSelectorId, self.$container)[0];
              if (master) {
                console.log('[REDIRECT-DEBUG] No Appstle widget — dispatching change on master select');
                master.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          }, 500);
        };

        if (needsReset) {
          console.log('[REDIRECT-DEBUG] >>> REDIRECT VARIANT DETECTED — resetting');
          this._resetSelectorsToDefault();
          $(this.selectors.singleOptionSelector, this.$container).first().trigger('change');

          var masterVal = $(this.selectors.originalSelectorId, this.$container).val();
          console.log('[REDIRECT-DEBUG] master select after reset:', masterVal);
          console.log('[REDIRECT-DEBUG] URL after reset:', window.location.href);

          // Reinit Appstle after its script has loaded (only if not already rendered)
          if (document.readyState === 'complete') {
            setTimeout(function() { _tryAppstleInit(); }, 500);
          } else {
            window.addEventListener('load', function() {
              setTimeout(function() { _tryAppstleInit(); }, 500);
            });
          }
        } else if (initialVariant) {
          console.log('[REDIRECT-DEBUG] normal variant, firing initial updateCartButton');
          console.log('[initVariants] firing initial updateCartButton for variant:', initialVariant.id, initialVariant.title, 'available:', initialVariant.available);
          this.updateCartButton({ variant: initialVariant });
        }

        // Handle bfcache restore (back-button from redirect page)
        window.addEventListener('pageshow', function(event) {
          console.log('[REDIRECT-DEBUG] pageshow fired, persisted:', event.persisted);
          if (event.persisted) {
            var v = self.variants._getVariantFromOptions();
            console.log('[REDIRECT-DEBUG] pageshow variant from selectors:', v ? { id: v.id, title: v.title } : null);

            // Also check URL for redirect variant — in _onSelectChange,
            // _updateHistoryState() runs AFTER our limitedFlavors/varietyPack
            // handlers and overwrites the clean replaceState URL with
            // ?variant=<redirect-id>. So the URL may still reference a
            // redirect variant even though the selectors were reset.
            var urlParams = new URLSearchParams(window.location.search);
            var urlVarId = urlParams.get('variant');
            var urlVar = null;
            if (urlVarId) {
              urlVarId = parseInt(urlVarId, 10);
              for (var i = 0; i < self.variantsObject.length; i++) {
                if (self.variantsObject[i].id === urlVarId) {
                  urlVar = self.variantsObject[i];
                  break;
                }
              }
            }
            console.log('[REDIRECT-DEBUG] pageshow URL variant:', urlVar ? { id: urlVar.id, title: urlVar.title } : null);

            if (_isRedirectVariant(v) || _isRedirectVariant(urlVar)) {
              // Redirect variant detected — reset selectors, clean URL, refresh all
              _resetAndReinit('pageshow-bfcache');
            } else {
              // Non-redirect bfcache restore — still need to refresh everything
              // because metadata / cart-button state may be stale from before the redirect
              console.log('[REDIRECT-DEBUG] pageshow — non-redirect, refreshing state directly');
              var $sel = $(self.selectors.singleOptionSelector, self.$container);
              $sel.first().trigger('change');

              // Explicitly refresh metadata + cart button (event chain unreliable on bfcache)
              var currentVar = self.variants._getVariantFromOptions();
              console.log('[REDIRECT-DEBUG] pageshow non-redirect variant for metadata:', currentVar ? { id: currentVar.id, title: currentVar.title } : null);
              if (currentVar) {
                self.updateMetadata({ variant: currentVar });
                self.updateCartButton({ variant: currentVar });
              }
              // Same as _resetAndReinit: dispatch native change on master select
              // so Appstle's surviving bfcache listeners render the widget.
              setTimeout(function() {
                if (!document.querySelector('[id*="appstle"]')) {
                  var master = $(self.selectors.originalSelectorId, self.$container)[0];
                  if (master) {
                    console.log('[REDIRECT-DEBUG] No Appstle widget (non-redirect) — dispatching change on master select');
                    master.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                }
              }, 500);
            }
          }
        });

        this._initSellingPlanObserver();
      },

      updateMetadata: function(evt) {
        var variant = evt.variant;
        var $meta = $('.product-metadata');

        if (!variant || !variant.id) { $meta.html('').hide(); return; }

        var windowVariant = window.productVariants && window.productVariants[variant.id];
        if (!windowVariant || (!windowVariant.metafield_servings && windowVariant.metafield_size === 'N/A')) {
          $meta.html('').hide(); return;
        }

        var servings = windowVariant.metafield_servings || 0;
        var size = (windowVariant.metafield_size && windowVariant.metafield_size !== 'N/A' && windowVariant.metafield_size !== '0') ? windowVariant.metafield_size : '';
        var originalPrice = variant.price; // cents
        var displayPrice = originalPrice;
        var isSubscribed = this._isSubscriptionSelected;

        if (isSubscribed && variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
          displayPrice = variant.selling_plan_allocations[0].price;
        }

        var perServing = servings ? (Math.floor(displayPrice / servings) / 100).toFixed(2) : '0.00';

        var html;
        if (isSubscribed && displayPrice < originalPrice) {
          var origPerServing = servings ? (Math.floor(originalPrice / servings) / 100).toFixed(2) : '0.00';
          html = '<s class="meta-original-price">$' + origPerServing + '/serving</s> '
               + '<span class="meta-sub-price">$' + perServing + '/serving</span>, '
               + (servings || '0') + ' servings' + (size ? ', ' + size : '');
        } else {
          html = '$' + perServing + '/serving, ' + (servings || '0') + ' servings' + (size ? ', ' + size : '');
        }

        $meta.html(html).show();
      },

      _initSellingPlanObserver: function() {
        var self = this;
        var $form = $(this.selectors.formContainer);
        if (!$form.length) return;
        var formEl = $form[0];

        function readSelection() {
          // Appstle can update its radio before it clears the hidden plan input.
          var checked = formEl.querySelector('.appstle_input_wrapper input[type="radio"]:checked')
              || document.querySelector('#appstle-widget-template .appstle_input_wrapper input[type="radio"]:checked');
          if (checked) return !checked.closest('.appstle_onetime_block');
          var input = formEl.querySelector('input[name="selling_plan"]')
              || document.querySelector('form[action*="/cart/add"] input[name="selling_plan"]');
          var value = input ? input.value : '';
          return !!(value && value !== '0');
        }

        function syncSelection(initial) {
          var subscribed = readSelection();
          var changed = subscribed !== self._isSubscriptionSelected;
          self._isSubscriptionSelected = subscribed;
          if (changed) {
            var variant = self.variants.currentVariant || self.variants._getVariantFromOptions();
            if (variant) self.updateMetadata({ variant: variant });
          }
          if (initial === true || changed) {
            window.__athSubscribed = subscribed;
            document.dispatchEvent(new CustomEvent('subscription:change', { detail: { subscribed: subscribed } }));
          }
        }

        // Read the actual purchase selection, including a one-time default.
        syncSelection(true);
        // Appstle also changes input.value without a native change event.
        setInterval(function() { syncSelection(false); }, 300);
        document.addEventListener('change', function(event) {
          var target = event.target;
          if (target && (formEl.contains(target) || target.closest && target.closest('#appstle-widget-template'))) {
            syncSelection(false);
          }
        });
      },

      // Variant change functions
      updateColorName: function(color, index) {
        // Updates on radio button change, not variant.js
        $('#VariantColorLabel-' + this.sectionId + '-' + index).text(color);
      },

      _resetSelectorsToDefault: function() {
        console.log('[REDIRECT-DEBUG] _resetSelectorsToDefault called');
        var $selectors = $(this.selectors.singleOptionSelector, this.$container);
        console.log('[REDIRECT-DEBUG] found', $selectors.length, 'selectors to reset');
        $selectors.each(function(i) {
          console.log('[REDIRECT-DEBUG] resetting selector[' + i + '] from selectedIndex', this.selectedIndex, 'value:', $(this).val(), 'to index 0');
          this.selectedIndex = 0;
          console.log('[REDIRECT-DEBUG] selector[' + i + '] now selectedIndex:', this.selectedIndex, 'value:', $(this).val());
        });
        if (window.history && window.history.replaceState) {
          console.log('[REDIRECT-DEBUG] replaceState to:', window.location.pathname);
          window.history.replaceState({}, '', window.location.pathname);
        }
      },

      limitedFlavors: function(evt){
        var variant = evt.variant;
        console.log('[REDIRECT-DEBUG] limitedFlavors handler called, variant:', variant ? { id: variant.id, title: variant.title } : null);
        if(variant){
          if(variant.title.toLowerCase().includes('limited flavors')){
            console.log('[REDIRECT-DEBUG] >>> REDIRECTING to limited flavors page');
            this._resetSelectorsToDefault();
            window.location.href="/products/lytes-zero-sugar-electrolytes-limited-flavors"
          }
        }
      },

      stapleFlavors: function(evt){
        var variant = evt.variant;
        console.log('[REDIRECT-DEBUG] stapleFlavors handler called, variant:', variant ? { id: variant.id, title: variant.title } : null);
        if(variant){
          if(variant.title.toLowerCase().includes('staple flavors')){
            console.log('[REDIRECT-DEBUG] >>> REDIRECTING to main lytes page');
            this._resetSelectorsToDefault();
            window.location.href="/products/lytes"
          }
        }
      },

      varietyPack: function(evt){
        var variant = evt.variant;
        console.log('[REDIRECT-DEBUG] varietyPack handler called, variant:', variant ? { id: variant.id, title: variant.title } : null);
        if(variant){
          if(variant.title.toLowerCase().includes('variety pack')){
            console.log('[REDIRECT-DEBUG] >>> REDIRECTING to variety pack page');
            this._resetSelectorsToDefault();
            window.location.href="/pages/build-your-bundle"
          }
        }
      },

      sampleSelection: function(evt) {
        // hides flavor if variant is a lytes sample pack
        var variant = evt.variant;
        if (variant) {
          console.log('[sampleSelection] hiding klaviyo-bis-trigger, variant:', variant.id, variant.title, 'available:', variant.available);
          $('.klaviyo-bis-trigger').hide();
          // if sample pack selected auto-toggle mixed flavor
          if (variant.id == 43162740621488 || variant.id == 43908693360816 || variant.id == 44128282214576 || variant.id == 44367445491888) {
            //re-enable the mixed flavor choice by setting disabled to false
            $('.variant-input-wrap>select#SingleOptionSelector-6800249913520-option-1>option:eq(3)').prop('disabled', false);
            $('.klaviyo-bis-trigger').hide();
            setTimeout(function(){
              $('select.product-single__variants>option[value="44019907428528"]').prop('selected',true);
              //added to put other sample flavors OOS
              $('.variant-input-wrap>select#SingleOptionSelector-6800249913520-option-1>option:eq(3)').prop('selected', true);
              $('select#SingleOptionSelector-6800249913520-option-1').trigger('click');
              $('select#SingleOptionSelector-6800249913520-option-1').trigger('change');
              var url = new URL(location);
              url.searchParams.set('variant','44019907428528');
              history.pushState({},'',url);
              $('.variant-wrapper-last').hide();
              $('.klaviyo-bis-trigger').hide();
              
              console.log('ran sampleSelection');  
            }, 250);
            // else if 1-pack mixed
          } else if (variant.id == 44019907330224) {
            setTimeout(function(){
              $('.variant-input-wrap>select#SingleOptionSelector-6800249913520-option-1>option:eq(0)').prop('selected', true);
              $('select.product-single__variants>option[value="40290744959152"]').prop('selected',true);

              $('select#SingleOptionSelector-6800249913520-option-1').trigger('click');
              $('select#SingleOptionSelector-6800249913520-option-1').trigger('change');
              
              $('.variant-wrapper-last').show();
              $('.klaviyo-bis-trigger').hide();
            }, 250);
            // else if 2-pack mixed
          } else if (variant.id == 44019907362992) {
            setTimeout(function(){
              $('.variant-input-wrap>select#SingleOptionSelector-6800249913520-option-1>option:eq(0)').prop('selected', true);
              $('select.product-single__variants>option[value="40290744991920"]').prop('selected',true);

              $('select#SingleOptionSelector-6800249913520-option-1').trigger('click');
              $('select#SingleOptionSelector-6800249913520-option-1').trigger('change');
              
              $('.variant-wrapper-last').show();
              $('.klaviyo-bis-trigger').hide();
            }, 250);
            // else if 3-pack mixed
          } else if (variant.id == 44019907395760) {
            setTimeout(function(){
              $('.variant-input-wrap>select#SingleOptionSelector-6800249913520-option-1>option:eq(0)').prop('selected', true);
              $('select.product-single__variants>option[value="40290745024688"]').prop('selected',true);

              $('select#SingleOptionSelector-6800249913520-option-1').trigger('click');
              $('select#SingleOptionSelector-6800249913520-option-1').trigger('change');
              
              $('.variant-wrapper-last').show();
              $('.klaviyo-bis-trigger').hide();
            }, 250);
          } else if ($('.variant-wrapper-last').css('display') == 'none'){
            $('.variant-wrapper-last').show();
            // disable mixed flavor option on variant change
            $('.variant-input-wrap>select#SingleOptionSelector-6800249913520-option-1>option:eq(3)').prop('disabled', true);
          }
        }
      },
  
      updateCartButton: function(evt) {
        var variant = evt.variant;

        if (variant) {
          console.log('[updateCartButton] variant:', variant.id, variant.title, 'available:', variant.available);
          console.log('[updateCartButton] klaviyo-bis-trigger display:', $('.klaviyo-bis-trigger').css('display'), 'opacity:', $('.klaviyo-bis-trigger').css('opacity'));
          if (variant.available) {
            // Hide klaviyo back-in-stock trigger for available variants
            // Delayed to run after Klaviyo's onsite.js re-shows it
            $('.klaviyo-bis-trigger').hide();
            setTimeout(function(){ $('.klaviyo-bis-trigger').hide(); }, 200);
            if((variant.inventory_quantity < 1) && (variant.inventory_management == 'shopify') && (variant.inventory_policy == 'deny')){
            	// Available but backordered, enable the submit button and change text
            	$(this.selectors.addToCart).removeClass(classes.disabled).prop('disabled', false);
            	$(this.selectors.addToCartText).html('BACKORDERED');
            	$('.add-to-cart').show();

                // Update ships-by date
                // Function to format date like "Tue, Jun 24"
                $('.ships-by').show();
                $('.ships-by').removeClass('backorder');
                $('.ships-by').html('Ships By <span class="ships-by-date"></span>');
                function formatDate(date) {
                  const options = { weekday: 'short', month: 'short', day: 'numeric' };
                  return date.toLocaleDateString('en-US', options);
                }
                $('.ships-by-date').each(function() {
                  const $shipsByDate = $(this);
                  const now = new Date();
                  const startDate = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
                  const endDate = new Date(startDate.getTime() + 1 * 24 * 60 * 60 * 1000);
                  if (endDate.getDay() === 0) { // Sunday
                    endDate.setDate(endDate.getDate() + 1); // Move to Monday
                  }
                  const formattedRange = `${formatDate(startDate)} - ${formatDate(endDate)}`;
                  $shipsByDate.text(formattedRange);
                });
            } else if ((variant.inventory_quantity < 1) && (variant.inventory_management == 'shopify')) {
                // Available but backordered, enable the submit button and change text
            	$(this.selectors.addToCart).removeClass(classes.disabled).prop('disabled', false);
            	$(this.selectors.addToCartText).html('BACKORDERED');
            	$('.add-to-cart').show();
              
                // Update ships-by date
                // Function to format date like "Tue, Jun 24"
                $('.ships-by').show();
                $('.ships-by').removeClass('backorder');
                $('.ships-by').html('Ships By <span class="ships-by-date"></span>');
                function formatDate(date) {
                  const options = { weekday: 'short', month: 'short', day: 'numeric' };
                  return date.toLocaleDateString('en-US', options);
                }
                $('.ships-by-date').each(function() {
                  const $shipsByDate = $(this);
                  const now = new Date();
                  const startDate = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
                  const endDate = new Date(startDate.getTime() + 1 * 24 * 60 * 60 * 1000);
                  if (endDate.getDay() === 0) { // Sunday
                    endDate.setDate(endDate.getDate() + 1); // Move to Monday
                  }
                  const formattedRange = `${formatDate(startDate)} - ${formatDate(endDate)}`;
                  $shipsByDate.text(formattedRange);
                });
                
            } else {
            	// Available, enable the submit button and change text
            	$(this.selectors.addToCart).removeClass(classes.disabled).prop('disabled', false);
            	$(this.selectors.addToCartText).html(theme.strings.addToCart);
                $('.add-to-cart').attr('data-variantid', variant.id);
                $('.add-to-cart').data('variantid', variant.id);
            	$('.add-to-cart').show();
              
              // Update ships-by date
              // Function to format date like "Tue, Jun 24"
              $('.ships-by').show();
              $('.ships-by').removeClass('backorder');
              $('.ships-by').html('Ships By <span class="ships-by-date"></span>');
              function formatDate(date) {
                const options = { weekday: 'short', month: 'short', day: 'numeric' };
                return date.toLocaleDateString('en-US', options);
              }
              $('.ships-by-date').each(function() {
                const $shipsByDate = $(this);
                const now = new Date();
                const startDate = new Date(now.getTime());
                const endDate = new Date(startDate.getTime() + 1 * 24 * 60 * 60 * 1000);
                if (endDate.getDay() === 0) { // Sunday
                  endDate.setDate(endDate.getDate() + 1); // Move to Monday
                }
                const formattedRange = `${formatDate(startDate)} - ${formatDate(endDate)}`;
                $shipsByDate.text(formattedRange);
              });
            }
          } else {
            // Sold out, disable the submit button and change text
            $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
            $(this.selectors.addToCartText).html(theme.strings.soldOut);
            $('.add-to-cart').hide();
            $('.ships-by').addClass('backorder');
            $('.ships-by').html('Backordered <span class="ships-by-date"></span>');
            console.log('[updateCartButton] SOLD OUT - showing klaviyo-bis-trigger in 50ms');
            setTimeout(()=> {
              console.log('[updateCartButton] showing klaviyo-bis-trigger now');
              $('.klaviyo-bis-trigger').css({'opacity':'1','margin-top':'10px'}).show();
            }, 50);
          }
        } else {
          // The variant doesn't exist, disable submit button
          $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
          $(this.selectors.addToCartText).html(theme.strings.unavailable);
        }
      },
  
      updatePrice: function(evt) {
        var variant = evt.variant;
  
        if (variant) {
          // Regular price
          $(this.selectors.price).html(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)).show();
  
          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));
            $(this.selectors.priceWrapper).removeClass('hide');
            $(this.selectors.price).addClass(classes.onSale);
            $(this.selectors.comparePriceA11y).attr('aria-hidden', 'false');
            $(this.selectors.priceA11y).attr('aria-hidden', 'false');
  
            var savings = variant.compare_at_price - variant.price;
            $(this.selectors.savePrice)
              .removeClass('hide')
              .html(theme.strings.savePrice.replace('[saved_amount]', theme.Currency.formatMoney(savings, theme.settings.moneyFormat)));
          } else {
            $(this.selectors.priceWrapper).addClass('hide');
            $(this.selectors.price).removeClass(classes.onSale);
            $(this.selectors.comparePriceA11y).attr('aria-hidden', 'true');
            $(this.selectors.priceA11y).attr('aria-hidden', 'true');
            $(this.selectors.savePrice).addClass('hide')
          }
  
          if ($('body').hasClass('currencies-enabled')) {
            theme.currencySwitcher.ajaxrefresh();
          }
        }
      },
  
      updateSku: function(evt) {
        var variant = evt.variant;
        var newSku = '';
  
        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }
  
          $(this.selectors.sku).html(newSku);
        }
      },
  
      updateInventory: function(evt) {
        var variant = evt.variant;
        var showInventory = false;
        var quantity = 0;
        var $inventoryLabel = $(this.selectors.inventory);
  
        if (variant && variant.inventory_management === 'shopify') {
          showInventory = true;
          quantity = window.inventories[this.sectionId][variant.id];
  
          if (quantity === 0 || quantity > 10) {
            showInventory = false;
          }
        }
  
        if (!showInventory) {
          $inventoryLabel.addClass('hide');
        } else {
          $inventoryLabel
            .removeClass('hide')
            .text(theme.strings.stockLabel.replace('[count]', quantity));
        }
      },
  
      updateVariantImage: function(evt) {
        var variant = evt.variant;
        if (!variant) return;

        console.log('[updateVariantImage] variant.title:', variant.title);
        console.log('[updateVariantImage] variant.featured_image:', variant.featured_image);
        console.log('[updateVariantImage] currentFlavor:', this.currentFlavor);

        var match = variant.title.match(/\/([^\/]+)$/);
        var newFlavor = match ? match[1].trim() : variant.title.trim();

        console.log('[updateVariantImage] regex match:', match);
        console.log('[updateVariantImage] newFlavor:', newFlavor);

        var flavorChanged = newFlavor && newFlavor !== this.currentFlavor;
        console.log('[updateVariantImage] flavorChanged:', flavorChanged);

        if (flavorChanged){
          this.currentFlavor = newFlavor;
          console.log('Flavor changed → rebuilding sliders for:', newFlavor);

          // Destroy current sliders
          if (this.$mainSlider.hasClass('slick-initialized')){
            this.$mainSlider.slick('unslick');
          }
          this.settings.slickMainInitialized = false;
          this.$mainSlider.empty();
          
          if (this.$thumbSlider.hasClass('slick-initialized')) {
           this.$thumbSlider.slick('unslick');
          }
          this.settings.slickThumbInitialized = false;
          this.$thumbSlider.empty();

          var mainSelectors = [
            '.main-product-image[data-flavor*="' + newFlavor + '"]',
            '.main-product-image[data-flavor*="' + newFlavor + ' SFP"]',
            '.main-product-image[data-flavor*="Spotlight"]',
            '.main-product-image[data-flavor*="review"]',
            '.main-product-image[data-flavor*="key benefits"]',
            '.main-product-image[data-flavor*="Aminos"]'
          ];

          var thumbSelectors = [
            '.product__thumb-item[data-flavor*="' + newFlavor + '"]',
            '.product__thumb-item[data-flavor*="' + newFlavor + ' SFP"]',
            '.product__thumb-item[data-flavor*="Spotlight"]',
            '.product__thumb-item[data-flavor*="review"]',
            '.product__thumb-item[data-flavor*="key benefits"]',
            '.product__thumb-item[data-flavor*="Aminos"]'
          ];

          var combinedMainSelectors = mainSelectors.join(', ');
          var combinedThumbSelectors = thumbSelectors.join(', ');

          this.$mainSlider.append(this.$mainSliderClone.find(combinedMainSelectors).clone(true, true));
          this.$thumbSlider.append(this.$thumbSliderClone.find(combinedThumbSelectors).clone(true, true));

          // Fix data-index
          this.$mainSlider.children().each(function(i) {
            $(this).data('index', i);
            $(this).attr('data-index', i);
          });
          this.$thumbSlider.children().each(function(i) {
            $(this).data('index', i);
            $(this).attr('data-index', i);
          });


          var $newImage = $('.product__thumb[data-id="' + variant.featured_image.id + '"]');
          var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item')); 

          var sliderArgs = this.setSliderArgs();
          sliderArgs.main.initialSlide = imageIndex;
          sliderArgs.thumbs.initialSlide = imageIndex;
          this.initSliders(sliderArgs);

          if (theme.config.bpSmall) {
            this.$thumbSlider.prepend(`
              <div class="arrow-prev arrows">
                <img src="https://cdn.shopify.com/s/files/1/0711/2801/files/thumbnail-arrow-left.svg?v=1763060628" width="20" height="20">
              </div>
              <div class="arrow-next arrows">
                <img src="https://cdn.shopify.com/s/files/1/0711/2801/files/thumbnail-arrow-right.svg?v=1763060628" width="20" height="20">
              </div>
            `);
          }
          

        } else {

          var $newImage = $('.product__thumb[data-id="' + variant.featured_image.id + '"]');
          var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item'));

          // If there is no index, slider is not initalized
          if (typeof imageIndex === 'undefined') {
            console.log('imageIndex is undefined');
            return;
          }
          // undefined because slides are not added      
          this.$mainSlider.slick('slickGoTo', imageIndex);
        }

        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
        var zoomSizedImgUrl;
  
        if (this.settings.zoom) {
          zoomSizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize);
        }
      },
  
      // Image/thumbnail toggling
      initImageSwitch: function() {
        console.log('8544 initImageSwitch');
        if (!$(this.selectors.photoThumbs).length) {
          return;
        }
  
        var self = this;
  
        $(this.selectors.photoThumbs).on('click', function(evt) {
          evt.preventDefault();
        });
      },
  
      checkIfVideos: function() {
        var $productVideos = this.$mainSlider.find(selectors.productVideo);
  
        // Stop if there are 0 videos
        if (!$productVideos.length) {
          return false;
        }
  
        var videoTypes = [];
  
        $productVideos.each(function() {
          var type = $(this).data('video-type');
  
          if (videoTypes.indexOf(type) < 0) {
            videoTypes.push(type);
          }
        });
  
        // Load YouTube API if not already loaded
        if (videoTypes.indexOf('youtube') > -1) {
          if (!theme.config.youTubeReady) {
            window.loadYouTube();
            $('body').on('youTubeReady' + this.settings.namespace, function() {
              this.loadYoutubeVideos($productVideos);
            }.bind(this));
          } else {
            this.loadYoutubeVideos($productVideos);
          }
        }
  
        // Load Vimeo API if not already loaded
        if (videoTypes.indexOf('vimeo') > -1) {
          if (!vimeoReady) {
            window.loadVimeo();
            $('body').on('vimeoReady' + this.settings.namespace, function() {
              this.loadVimeoVideos($productVideos);
            }.bind(this))
          } else {
            this.loadVimeoVideos($productVideos);
          }
        }
  
        // Add mp4 video players
        if (videoTypes.indexOf('mp4') > -1) {
          this.loadMp4Videos($productVideos);
        }
  
        return videoTypes;
      },
  
      loadMp4Videos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'mp4') {
            return;
          }
  
          var id = $el.attr('id');
          var videoId = $el.data('video-id');
  
          videos[this.id] = {
            type: 'mp4',
            divId: id,
            style: $el.data('video-style')
          };
        });
      },
  
      loadVimeoVideos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'vimeo') {
            return;
          }
  
          var id = $el.attr('id');
          var videoId = $el.data('video-id');
  
          videos[this.id] = {
            type: 'vimeo',
            divId: id,
            id: videoId,
            style: $el.data('video-style'),
            width: $el.data('video-width'),
            height: $el.data('video-height')
          };
        });
  
        // Create a new player for each Vimeo video
        for (var key in videos) {
          if (videos[key].type != 'vimeo') {
            continue;
          }
  
          var args = $.extend({}, vimeoVideoOptions, videos[key]);
          vimeoPlayers[key] = new Vimeo.Player(videos[key].divId, args);
        }
  
        vimeoReady = true;
      },
  
      autoplayVimeoVideo: function(id) {
        // Do not autoplay on mobile though
        if (!theme.config.bpSmall) {
          this.requestToPlayVimeoVideo(id);
        } else {
          // Set as loaded on mobile so you can see the image
          var $player = $('#' + id);
          setParentAsLoaded($player);
        }
      },
  
      requestToPlayVimeoVideo: function(id) {
        // The slider may initialize and attempt to play the video before
        // the API is even ready, because it sucks.
  
        var $player = $('#' + id);
        setParentAsLoading($player);
  
        if (!vimeoReady) {
          // Wait for the trigger, then play it
          $('body').on('vimeoReady' + this.settings.namespace, function() {
            this.playVimeoVideo(id);
          }.bind(this))
          return;
        }
  
        this.playVimeoVideo(id);
      },
  
      playVimeoVideo: function(id) {
        vimeoPlayers[id].play();
  
        if (videos[id].style === 'muted') {
          vimeoPlayers[id].setVolume(0);
        }
  
        var $player = $('#' + id);
        setParentAsLoaded($player);
      },
  
      stopVimeoVideo: function(id) {
        if (!theme.config.vimeoReady) {
          return;
        }
  
        if (id) {
          vimeoPlayers[id].pause();
        } else {
          for (key in vimeoPlayers) {
            if (typeof vimeoPlayers[key].pause === 'function') {
              vimeoPlayers[key].pause();
            }
          }
        }
      },
  
      loadYoutubeVideos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'youtube') {
            return;
          }
  
          var id = $el.attr('id');
          var videoId = $el.data('youtube-id');
  
          videos[this.id] = {
            type: 'youtube',
            id: id,
            videoId: videoId,
            style: $el.data('video-style'),
            width: $el.data('video-width'),
            height: $el.data('video-height'),
            attemptedToPlay: false
          };
        });
  
        // Create a player for each YouTube video
        for (var key in videos) {
          if (videos[key].type === 'youtube') {
            if (videos.hasOwnProperty(key)) {
              var args = $.extend({}, youtubeVideoOptions, videos[key]);
  
              if (args.style === 'muted') {
                // default youtubeVideoOptions, no need to change anything
              } else {
                args.playerVars.controls = 1;
                args.playerVars.autoplay = 0;
              }
  
              youtubePlayers[key] = new YT.Player(key, args);
            }
          }
        }
  
        youtubeReady = true;
      },
  
      requestToPlayYoutubeVideo: function(id, forcePlay) {
        if (!theme.config.youTubeReady) {
          return;
        }
  
        var $player = $('#' + id);
        setParentAsLoading($player);
  
        // If video is requested too soon, player might not be ready.
        // Set arbitrary timeout to request it again in a second
        if (typeof youtubePlayers[id].playVideo != 'function') {
          var o = this;
          setTimeout(function() {
            o.playYoutubeVideo(id, forcePlay);
          }, 1000);
          return;
        }
  
        this.playYoutubeVideo(id, forcePlay);
      },
  
      playYoutubeVideo: function (id, forcePlay) {
        var $player = $('#' + id);
        setParentAsLoaded($player);
        if (typeof youtubePlayers[id].playVideo === 'function') {
          youtubePlayers[id].playVideo();
        }
  
        // forcePlay is sent as true from beforeSlideChange so the visibility
        // check isn't fooled by the next slide positioning
        if (!forcePlay) {
          initCheckVisibility(id);
        }
      },
  
      stopYoutubeVideo: function(id) {
        if (!theme.config.youTubeReady) {
          return;
        }
  
        if (id && youtubePlayers[id]) {
          if (typeof youtubePlayers[id].pauseVideo === 'function') {
            youtubePlayers[id].pauseVideo();
          }
          $(window).off('scroll.' + id);
        } else {
          for (key in youtubePlayers) {
            if (typeof youtubePlayers[key].pauseVideo === 'function') {
              youtubePlayers[key].pauseVideo();
              $(window).off('scroll.' + key);
            }
          }
        }
      },
  
      playMp4Video: function(id) {
        var $player = $('#' + id);
        setParentAsLoaded($player);
  
        $player[0].play();
      },
  
      stopMp4Video: function(id) {
        if (id) {
          $('#' + id)[0].pause();
        } else {
          // loop through all mp4 videos to stop them
          for (var key in videos) {
            if (videos[key].type === 'mp4') {
              var player = $('#' + videos[key].divId)[0];
              if (typeof player.pause === 'function') {
                player.pause();
              }
            }
          }
        }
      },
  
      // Init zoom for each image in the main carousel
      initZoom: function($image) {
        var largeImage = $image.parent().data('zoom-size');
        if (!largeImage || theme.config.bpSmall) {
          return;
        }

        var $parent = $image.parent();
        var zoomReady = false;
        var zoomLoading = false;
        var pendingClick = null;

        var startZoomLoad = function(evt) {
          if (evt.type === 'click' && !zoomReady) {
            evt.preventDefault();
            pendingClick = {
              pageX: evt.pageX,
              pageY: evt.pageY
            };
          }

          if (zoomReady || zoomLoading) {
            return;
          }

          zoomLoading = true;

          // Start the large request only after the customer shows zoom intent.
          var zoomImg = new Image();
          zoomImg.onload = function() {
            $parent.zoom({
              on: 'click',
              url: largeImage,
              duration: 180,
              touch: false,
              callback: function() {
                zoomReady = true;
                zoomLoading = false;
                $parent.off('.productZoomIntent');

                if (pendingClick) {
                  var queuedClick = pendingClick;
                  pendingClick = null;
                  setTimeout(function() {
                    $parent.trigger($.Event('click', queuedClick));
                  }, 0);
                }
              },
              onZoomIn: function() {
                $(this).addClass('photo-zoom-linked');
              },
              onZoomOut: function() {
                $(this).removeClass('photo-zoom-linked');
              }
            });
          };
          zoomImg.onerror = function() {
            zoomLoading = false;
            pendingClick = null;
          };
          zoomImg.src = largeImage;
        };

        // Rebinding by namespace removes stale closures copied by flavor sliders.
        $parent
          .off('.productZoomIntent')
          .on(
            'mouseenter.productZoomIntent pointerenter.productZoomIntent focusin.productZoomIntent touchstart.productZoomIntent click.productZoomIntent',
            startZoomLoad
          );
      },
  
      createImageCarousels: function() {
        if (!this.$thumbSlider.length || $(this.selectors.photoThumbs).length < 2) {
          // Init zoom since the carousel won't do it (single-image fallback)
          if (this.settings.zoom) {
            this.initZoom($(this.selectors.productImageMain).find('.photo-zoom-link img').first());
          }

          // Single product image. Init video if it exists
          var $video = $(this.selectors.productImageMain).find(selectors.productVideo);
          if ($video.length) {
            this.initVideo($video);
          }
          return;
        }
  
        this.settings.hasMultipleImages = true;
  
        // Set starting slide (for both sliders)
        var $activeSlide = this.$mainSlider.find('.starting-slide');
        var startIndex = this._slideIndex($activeSlide);
        
        // Lame way to prevent duplicate event listeners
        this.$mainSlider.off('init');
        this.$mainSlider.off('beforeChange');
        this.$mainSlider.on('init', this.mainSlideInit.bind(this));
        this.$mainSlider.on('beforeChange', this.beforeSlideChange.bind(this));
        this.$mainSlider.on('afterChange', this.afterSlideChange.bind(this));
        
        // Default (mobile) slider settings
        this.mainSliderArgs = {
          infinite: false,
          arrows: false,
          dots: false,
          draggable: true,
          swipe: false,
          adaptiveHeight: true,
          initialSlide: startIndex
        };
        
        this.thumbSliderArgs = {
          initialSlide: startIndex
        };
        
        // Init sliders
        var sliderArgs = this.setSliderArgs();
        this.initSliders(sliderArgs);
        
        // Create clones
        if (!this.$mainSliderClone) {
          this.$mainSliderClone = this.$mainSlider.clone(true, true);
          this.$thumbSliderClone = this.$thumbSlider.clone(true, true);
          this.currentFlavor = null;
        }
        
        // Track current flavor so we know when it actually changes
        this.currentFlavor = null;  

        // Filter based upon starting Flavor
        var startingFlavor = $activeSlide.data('flavor');
        console.log('8877 init startingFlavor: ', startingFlavor);

        var mainSelectors = [
          '.main-product-image[data-flavor*="' + startingFlavor + '"]',
          '.main-product-image[data-flavor*="' + startingFlavor + ' SFP"]',
          '.main-product-image[data-flavor*="Spotlight"]',
          '.main-product-image[data-flavor*="review"]',
          '.main-product-image[data-flavor*="key benefits"]',
          '.main-product-image[data-flavor*="Aminos"]'
        ];

        var thumbSelectors = [
          '.product__thumb-item[data-flavor*="' + startingFlavor + '"]',
          '.product__thumb-item[data-flavor*="' + startingFlavor + ' SFP"]',
          '.product__thumb-item[data-flavor*="Spotlight"]',
          '.product__thumb-item[data-flavor*="review"]',
          '.product__thumb-item[data-flavor*="key benefits"]',
          '.product__thumb-item[data-flavor*="Aminos"]'
        ];

        var combinedMainSelectors = mainSelectors.join(', ');
        var combinedThumbSelectors = thumbSelectors.join(', ');
        
        //manually destroy sliders
        this.$mainSlider.slick('unslick');
        this.settings.slickMainInitialized = false;
        this.$mainSlider.empty();

        this.$thumbSlider.slick('unslick');
        this.settings.slickThumbInitialized = false;
        this.$thumbSlider.empty();

        //append elements from cloned slider while maintaining original
        this.$mainSlider.append(this.$mainSliderClone.find(combinedMainSelectors).clone(true, true));
        this.$thumbSlider.append(this.$thumbSliderClone.find(combinedThumbSelectors).clone(true,true));

        // Strip zoom-init class so zoom re-initializes on the new DOM
        // (cloned elements carry the class but not the zoom plugin binding)
        this.$mainSlider.find('.' + classes.zoomInit).removeClass(classes.zoomInit);

        // Update data-index on main slider elements to new sequential indices
        this.$mainSlider.children().each(function(i) {
          $(this).data('index', i);
          $(this).attr('data-index', i);
        });
        // Update data-index on thumb slider elements to new sequential indices
        this.$thumbSlider.children().each(function(i) {
          $(this).data('index', i);
          $(this).attr('data-index', i);
        });
        
        // Set starting slide
        var $activeSlide = this.$mainSlider.find('.starting-slide');
        var startIndex = this._slideIndex($activeSlide);

        // Reset (mobile) slider settings
        this.mainSliderArgs = {
          infinite: false,
          arrows: false,
          dots: false,
          draggable: true,
          swipe: false,
          adaptiveHeight: true,
          initialSlide: startIndex
        };
        
        this.thumbSliderArgs = {
          initialSlide: startIndex
        };

        // Re-Init sliders
        var sliderArgs = this.setSliderArgs();
        this.initSliders(sliderArgs);

        this.currentFlavor = startingFlavor;
  
        // Re-init slider when a breakpoint is hit
        $('body').on('matchSmall', function() {
          this.$thumbSlider.data('position', 'below');
          var sliderArgs = this.setSliderArgs();
          this.initSliders(sliderArgs);
          if($('.arrows')){
            $('.arrows').remove();
          }
          this.$thumbSlider.prepend(`
            <div class="arrow-prev arrows">
              <img src="https://cdn.shopify.com/s/files/1/0711/2801/files/thumbnail-arrow-left.svg?v=1763060628" width="20" height="20">
            </div>
            <div class="arrow-next arrows">
              <img src="https://cdn.shopify.com/s/files/1/0711/2801/files/thumbnail-arrow-right.svg?v=1763060628" width="20" height="20">
            </div>
          `);
              
        }.bind(this));

        //re-init slider on matchLarge
        $('body').on('matchLarge', function() {
          this.$thumbSlider.data('position', 'beside');
          var sliderArgs = this.setSliderArgs();
          this.initSliders(sliderArgs);
          if($('.arrows')) {
            console.log('removing arrows');
            $('.arrows').remove();
          }
        }.bind(this));
  
        // Too many thumbnails can cause the AOS calculations to be off
        // so refresh that when the slider is ready
        if (AOS) {
          AOS.refresh();
        }

        if (theme.config.bpSmall) {
          this.$thumbSlider.prepend(`
            <div class="arrow-prev arrows">
              <img src="https://cdn.shopify.com/s/files/1/0711/2801/files/thumbnail-arrow-left.svg?v=1763060628" width="20" height="20">
            </div>
            <div class="arrow-next arrows">
              <img src="https://cdn.shopify.com/s/files/1/0711/2801/files/thumbnail-arrow-right.svg?v=1763060628" width="20" height="20">
            </div>
          `);
        }

        //create listeners for arrows
        $('body').on('click', '.arrow-next', function(){
          var totalSlides = this.$thumbSlider.find('.product__thumb-item').length;
          var $currentSlide = this.$thumbSlider.find(selectors.currentSlide);
          var $currentSlideIndex = $currentSlide.data('index');
          var nextIndex = $currentSlideIndex + 1;

          while (nextIndex < totalSlides) {
            var $nextSlide = this.$thumbSlider.find('.product__thumb-item[data-slick-index="' + nextIndex + '"]');
            if (!$nextSlide.hasClass('hide')) {
              break; // found visible slide
            }
            
            nextIndex++;
          }

          if (nextIndex >= totalSlides) {
            nextIndex = 0;
          }

          this.$mainSlider.slick('slickGoTo', nextIndex);
        }.bind(this));

        $('body').on('click', '.arrow-prev', function(){
          console.log('arrow prev');
          var totalSlides = this.$thumbSlider.find('.product__thumb-item').length;
          var $currentSlide = this.$thumbSlider.find(selectors.currentSlide);
          var currentIndex = $currentSlide.data('index');  // ensure number
          var prevIndex = currentIndex - 1;

          // Keep decrementing until we find a visible slide or hit the beginning
          while (prevIndex >= 0) {
            var $prevSlide = this.$thumbSlider.find('.product__thumb-item[data-slick-index="' + prevIndex + '"]');
            
            if (!$prevSlide.hasClass('hide')) {
              break; // found visible slide
            }
            
            prevIndex--;
          }

          // If we went before 0 (no previous visible slide), stay on current visible slide
          if (prevIndex < 0) {
            prevIndex = currentIndex;  // stay put
          }

          this.$mainSlider.slick('slickGoTo', prevIndex);
        }.bind(this));

      },
  
      initSliders: function(args) {
        // Custom controls live beside Slick's list. Remove them before teardown
        // so Slick never mistakes them for thumbnail slides during a rebuild.
        this.$thumbSlider.find('.arrows').remove();
        this.destroyImageCarousels();

        // A previously corrupted Slick instance can re-append cached controls
        // while it is being destroyed, so clear them once more before init.
        this.$thumbSlider.find('.arrows').remove();
  
        this.$mainSlider.slick(args.main);

        if (theme.config.bpSmall) {
          this.$thumbSlider.data('position', 'below');
        } else {
          this.$thumbSlider.data('position', 'beside');
        }
        this.$thumbSlider.slick(args.thumbs);
        
        this.settings.slickThumbInitialized = true;
        this.settings.slickMainInitialized = true;
      },
  
      setSliderArgs: function() {
        var args = {};
        // moved thumbs to bottom on mobile -- changed data to responsive
        var thumbnailsVertical = this.$thumbSlider.data('position') === 'beside' ? true : false;

        if (theme.config.bpSmall) {
          args.main = $.extend({}, this.mainSliderArgs, {
            asNavFor: this.selectors.thumbSlider,
            adaptiveHeight: true,
            dots: false,
            arrows: false,
            infinite: false,
            fade: true,
            draggable: false,
            swipe: false,
            slidesToShow:1
          });
          args.thumbs = $.extend({}, this.thumbSliderArgs, {
            asNavFor: this.selectors.mainSlider,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            vertical: false,
            verticalSwiping: false,
            focusOnSelect: true,
            infinite: false,
            draggable: false,
            swipe: true,
            centerMode: false,
            centerPadding: '0px'
          });
        } else {
          args.main = $.extend({}, this.mainSliderArgs, {
            asNavFor: this.selectors.thumbSlider,
            adaptiveHeight: false,
            dots: false,
            infinite: false,
            fade: true,
            slidesToShow:1
          });
          args.thumbs = $.extend({}, this.thumbSliderArgs, {
            asNavFor: this.selectors.mainSlider,
            arrows: false,
            dots: false,
            vertical: true,
            verticalSwiping: false,
            focusOnSelect: true,
            infinite: false,
            draggable: false,
            fade: false
          });
        }
        return args;
      },
  
      destroyImageCarousels: function() {
        if (this.$mainSlider && this.settings.slickMainInitialized) {
          this.$mainSlider.slick('unslick');
          this.settings.slickMainInitialized = false;
        }
  
        if (this.$thumbSlider && this.settings.slickThumbInitialized) {
          this.$thumbSlider.slick('unslick');
          this.settings.slickThumbInitialized = false;
        }
      },
  
      mainSlideInit: function(event, slick) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(selectors.currentSlide);

        // Init zoom on current slide
        if (this.settings.zoom && !$currentSlide.hasClass(classes.zoomInit)) {
          var $image = $currentSlide.addClass(classes.zoomInit).find('img');
          this.initZoom($image);
        }

        var $video = $currentSlide.find(selectors.productVideo);
  
        if (!$video.length) {
          return;
        }
  
        this.initVideo($video);
      },
  
      initVideo: function($video) {
        var videoType = $video.data('video-type');
        var divId = $video.attr('id');
  
        if (videoType === 'mp4' && videos[divId].style === 'muted') {
          this.playMp4Video(divId);
        }
  
        if (videoType === 'youtube') {
          if (youtubeReady && videos[divId].style === 'muted') {
            this.requestToPlayYoutubeVideo(divId);
          }
        }
  
        if (videoType === 'vimeo') {
          if (vimeoReady) {
            this.playOrShowVimeo(divId);
          } else {
            $('body').on('vimeoReady' + this.settings.namespace, function() {
              this.playOrShowVimeo(divId);
            }.bind(this))
          }
        }
  
        // Hacky way to trigger resetting the slider layout in modals
        if (this.inModal) {
          this.resizeSlides();
        }
      },
  
      playOrShowVimeo: function(id) {
        if (videos[id] && videos[id].style === 'muted') {
          this.autoplayVimeoVideo(id);
        } else if (videos[id] && videos[id].style === 'unmuted') {
          setParentAsLoaded($('#' + id));
        }
      },
  
      getVideoType: function($video) {
        return $video.data('video-type');
      },
  
      getVideoId: function($video) {
        return $video.attr('id');
      },
  
      beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(selectors.currentSlide);
        var $prevVideo = $currentSlide.find('.product__video');
        var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
        var $nextVideo = $nextSlide.find('.product__video');

        // Pause any existing slide video
        if (currentSlide !== nextSlide && $prevVideo.length) {
          var prevVideoType = this.getVideoType($prevVideo);
          var prevVideoId = this.getVideoId($prevVideo);
  
          if (prevVideoId) {
            if (prevVideoType === 'youtube') {
              this.stopYoutubeVideo(prevVideoId);
            }
  
            if (prevVideoType === 'mp4') {
              this.stopMp4Video(prevVideoId);
            }
  
            if (prevVideoType === 'vimeo') {
              this.stopVimeoVideo(prevVideoId);
            }
          }
        }
  
        // Prep next slide video
        if ($nextVideo.length) {
          var nextVideoType = this.getVideoType($nextVideo);
          var nextVideoId = this.getVideoId($nextVideo);
  
          // Prep Vimeo with a backup in case the API isn't ready
          if (nextVideoId && nextVideoType === 'vimeo') {
            if (vimeoReady) {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.autoplayVimeoVideo(nextVideoId);
              }
            } else {
              $('body').on('vimeoReady' + this.settings.namespace, function() {
                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                  this.autoplayVimeoVideo(nextVideoId);
                }
              }.bind(this))
            }
          }
  
          // Prep YouTube with a backup in case API isn't ready
          if (nextVideoId && nextVideoType === 'youtube') {
            if (youtubeReady) {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.requestToPlayYoutubeVideo(nextVideoId, true);
              }
            } else {
              $('body').on('youTubeReady' + this.settings.namespace, function() {
                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                  this.requestToPlayYoutubeVideo(nextVideoId, true);
                }
              }.bind(this))
            }
          }
  
          // Autoplay muted MP4 videos
          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
            if (nextVideoType === 'mp4') {
              this.playMp4Video(nextVideoId);
            }
          }
  
          // Set unmuted videos to loaded state
          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style != 'muted') {
            setParentAsLoaded($('#' + nextVideoId));
          }
        }
  
        // Layload zoom image
        if (this.settings.zoom) {
          if ($nextSlide.hasClass(classes.zoomInit)) {
            return;
          }
          var $image = $nextSlide.addClass(classes.zoomInit).find('img').addClass('lazyload');
          this.initZoom($image);
        }
      },

      afterSlideChange: function(event, slick, currentSlide, nextSlide) {
        var slickTrack = this.$thumbSlider.find('.slick-track');
        var currentTransform = slickTrack.css('transform');
        var match = currentTransform.match(/matrix\(([^,]+),([^,]+),([^,]+),([^,]+),([^,]+)/);
        // setTimeout(function() {
        //   if (match) {
        //     var currentX = parseFloat(match[5]);
  
        //     var newX = currentX + 260;
  
        //     slickTrack.css('transform', 'translate3d(' + newX + 'px, 0px, 0px)');
        //     console.log('currentX: ' + currentX + ' newX: ' + newX);
        //   } else {
        //     console.log('could not parse the current transform value');
        //   }
        // }, 500);
      },
  
      resizeSlides: function() {
        if (!this.settings.hasMultipleImages) {
          return;
        }
  
        $(window).trigger('resize');
        setTimeout(function() {
          this.$mainSlider.slick('setPosition');
          this.$thumbSlider.slick('setPosition');
        }.bind(this), 500); // same timing as modal open transition
      },
  
      //changed from 'index' to 'slick-index' to match featured image 11-14, changed back to index -- slick-index wasn't being added in time
      _slideIndex: function($el) {
        return $el.data('index');
      },
  
      // Ajax cart and qty
      initQtySelector: function() {
        this.$container.find('.js-qty').each(function() {
          new theme.QtySelector($(this), {
            namespace: '.product'
          });
        });
      },
  
      initAjaxProductForm: function() {
        if (theme.settings.cartType === 'drawer') {
          new theme.AjaxProduct($(this.selectors.formContainer));
        }
      },
  
      openModalProduct: function() {
        if (!this.settings.modalInit) {
          var $formHolder = $(this.selectors.modalFormHolder);
          var url = $formHolder.data('url');
  
          $formHolder.load(url + ' #AddToCartForm-' + this.sectionId, function() {
            $formHolder.addClass('is-active');
            this.formSetup();
            if (Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
          }.bind(this));
  
          this.productSetup();
          this.loadModalContent();
          this.createImageCarousels();
          this.settings.modalInit = true;
        }
  
        this.resizeSlides();
  
        // Add product id to recently viewed array
        this.addIdToRecentlyViewed();
      },
  
      closeModalProduct: function() {
        this.stopYoutubeVideo();
        this.stopVimeoVideo();
        this.stopMp4Video();
      },
  
      loadModalContent: function() {
        // Load videos if they exist
        var videoTypes = this.checkIfVideos();
  
        // Lazyload mp4 videos similar to images
        if (videoTypes && videoTypes.indexOf('mp4') > -1) {
          this.$modal.find('.product__video[data-video-type="mp4"]').each(function(i, video) {
            var $el = $(video);
            var src = $el.data('video-src');
            var source = document.createElement('source');
            source.setAttribute('src', src);
            $el.append(source);
          }.bind(this));
        }
      },
  
      onUnload: function() {
        this.$container.off(this.settings.namespace);
        $('body').off(this.settings.namespace);
        this.destroyImageCarousels();
      }
    });
  
    return Product;
  })();
  
  theme.CollectionHeader = (function() {
  
    var selectors = {
      hero: '.collection-hero',
      parallaxContainer: '.parallax-container'
    };
  
    function CollectionHeader(container) {
      var $container = $(container);
      this.namespace = '.collection-header';
  
      var $heroImageContainer = $container.find(selectors.hero);
      if ($heroImageContainer.length) {
        if ($container.data('parallax')) {
          var $parallaxContainer = $container.find(selectors.parallaxContainer);
          var args = {
            namespace: this.namespace
          };
          theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer, args);
        }
      }
    }
  
    CollectionHeader.prototype = $.extend({}, CollectionHeader.prototype, {
      onUnload: function() {
        theme.parallaxSections[this.namespace].destroy();
        delete theme.parallaxSections[this.namespace];
      }
    });
  
    return CollectionHeader;
  })();
  
  theme.CollectionSidebar = (function() {
    var drawerStyle = false;
  
    function CollectionSidebar(container) {
      this.$container = $(container);
      this.init();
    }
  
    CollectionSidebar.prototype = $.extend({}, CollectionSidebar.prototype, {
      init: function() {
        // Force close the drawer if it exists
        this.onUnload();
  
        drawerStyle = this.$container.data('style') === 'drawer';
        theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
      },
  
      forceReload: function() {
        this.init();
      },
  
      onSelect: function() {
        if (theme.FilterDrawer) {
          if (!drawerStyle) {
            theme.FilterDrawer.close();
            return;
          }
  
          if (drawerStyle || theme.config.bpSmall) {
            theme.FilterDrawer.open();
          }
        }
      },
  
      onDeselect: function() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      },
  
      onUnload: function() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      }
    });
  
    return CollectionSidebar;
  })();
  
  theme.Collection = (function() {
  
    var selectors = {
      colorSwatchImage: '.grid-product__color-image',
      colorSwatch: '.color-swatch--with-image'
    };
  
    function Collection(container) {
      this.container = container;
      this.sectionId = $(container).attr('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
  
      this.init();
    }
  
    Collection.prototype = $.extend({}, Collection.prototype, {
      init: function() {
        // init is called on load and when tags are selected
        this.$container = $(this.container);
        var sectionId = this.sectionId = this.$container.attr('data-section-id');
        this.namespace = '.collection-' + sectionId;
  
        this.sortBy();
        this.colorSwatchHovering();
  
        theme.reinitSection('collection-sidebar');
      },
  
      sortBy: function() {
        var $sortBy = $('#SortBy');
  
        if (!$sortBy.length) {
          return;
        }
  
        $sortBy.on('change' + this.namespace, function() {
          location.href = '?sort_by=' + $(this).val();
        });
      },
  
      colorSwatchHovering: function() {
        var $colorImage = $(selectors.colorSwatchImage);
        if (!$colorImage.length) {
          return;
        }
  
        var $swatches = this.$container.find(selectors.colorSwatch);
  
        $swatches.on({
          mouseenter: function (evt) {
            $el = $(evt.currentTarget);
            var id = $el.data('variant-id');
            var image = $el.data('variant-image');
            $('.grid-product__color-image--' + id)
              .css('background-image', 'url(' + image + ')')
              .addClass('is-active');
          },
          mouseleave: function (evt) {
            $el = $(evt.currentTarget);
            var id = $el.data('variant-id');
            $('.grid-product__color-image--' + id).removeClass('is-active');
          }
        });
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        $(window).off(this.namespace);
        this.$container.off(this.namespace);
        $(selectors.colorSwatch).off(this.namespace);
      }
    });
  
    return Collection;
  })();
  
  theme.HeaderSection = (function() {
  
    var selectors = {
      drawer: '#NavDrawer',
      mobileSubNavToggle: '.mobile-nav__toggle-btn',
      hasSublist: '.mobile-nav__has-sublist'
    };
  
    var classes = {
      navExpanded: 'mobile-nav--expanded'
    };
  
    function Header(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
  
      // Reload any slideshow if when the header is reloaded to make sure the
      // sticky header works as expected
      theme.reinitSection('slideshow-section');
  
      theme.currencySwitcher.init()
      this.initDrawers();
      theme.headerNav.init();
      theme.announcementBar.init();
  
      // Set a timer to resize the header in case the logo changes size
      if (Shopify.designMode) {
        setTimeout(function() {
          $('body').trigger('resize');
        }, 500);
      }
    }
  
    Header.prototype = $.extend({}, Header.prototype, {
      initDrawers: function() {
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
        if (theme.settings.cartType === 'drawer') {
          new theme.CartDrawer();
        }
  
        this.drawerMenuButtons();
      },
  
      drawerMenuButtons: function() {
        $(selectors.drawer).find('.js-drawer-close').on('click', function(evt){
          evt.preventDefault();
          theme.NavDrawer.close();
        });
  
        var $mobileSubNavToggle = $(selectors.mobileSubNavToggle);
  
        $mobileSubNavToggle.attr('aria-expanded', 'false');
        $mobileSubNavToggle.each(function (i, el) {
          var $el = $(el);
          $el.attr('aria-controls', $el.attr('data-aria-controls'));
        });
  
        $mobileSubNavToggle.on('click', function() {
          var $el = $(this);
          var currentlyExpanded = $el.attr('aria-expanded');
          var toggleState = false;
  
          // Updated aria-expanded value based on state pre-click
          if (currentlyExpanded === 'true') {
            $el.attr('aria-expanded', 'false');
          } else {
            $el.attr('aria-expanded', 'true');
            toggleState = true;
          }
  
          // Toggle class that expands/collapses sublist
          $el.closest(selectors.hasSublist).toggleClass(classes.navExpanded, toggleState);
        });
      },
  
      onBlockSelect: function(evt) {
        theme.announcementBar.onBlockSelect(evt.detail.blockId);
      },
  
      onDeselect: function() {
        theme.announcementBar.onBlockDeselect();
      },
  
      onUnload: function() {
        theme.NavDrawer.close();
        theme.headerNav.unload();
        theme.announcementBar.unload();
      }
    });
  
    return Header;
  
  })();
  
  theme.FeaturedContentSection = (function() {
  
    function FeaturedContent() {
      $('.rte').find('a:not(:has(img))').addClass('text-link');
    }
  
    return FeaturedContent;
  })();
  
  theme.slideshows = {};
  
  theme.SlideshowSection = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function SlideshowSection(container) {
      var $container = this.$container = $(container);
      var $section = $container.parent();
      var sectionId = $container.attr('data-section-id');
      var slideshow = this.slideshow = '#Slideshow-' + sectionId;
      this.namespace = '.' + sectionId;
  
      var $imageContainer = $(container).find('.hero');
      if ($imageContainer.length) {
        theme.loadImageSection($imageContainer);
      }
  
      this.init();
  
      if ($container.data('parallax')) {
        var args = {
          namespace: this.namespace
        };
        theme.parallaxSections[this.namespace] = new theme.Parallax($container.find(selectors.parallaxContainer), args);
      }
    }
  
    SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {
      init: function() {
        // Prevent slideshows from initializing on top of themselves
        this.onUnload();
  
        var $slideshow = $(this.slideshow);
        var args = {
          autoplay: $slideshow.data('autoplay'),
          arrows: $slideshow.data('arrows'),
          dots: $slideshow.data('dots'),
          fade: true,
          speed: 500 // same as $slideshowImageAnimationSpeed in CSS
        };
  
        theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, args);
      },
  
      forceReload: function() {
        this.init();
      },
  
      onUnload: function() {
        if (theme.parallaxSections[this.namespace]) {
          theme.parallaxSections[this.namespace].destroy();
          delete theme.parallaxSections[this.namespace];
        }
        if (theme.slideshows[this.slideshow]) {
          theme.slideshows[this.slideshow].destroy();
          delete theme.slideshows[this.slideshow];
        }
      },
  
      onSelect: function() {
        $(this.slideshow).slick('slickPause');
      },
  
      onDeselect: function() {
        $(this.slideshow).slick('slickPlay');
      },
  
      onBlockSelect: function(evt) {
        var $slideshow = $(this.slideshow);
  
        // Ignore the cloned version
        var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');
  
        // Go to selected slide, pause autoplay
        $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
      },
  
      onBlockDeselect: function() {
        $(this.slideshow).slick('slickPlay');
      }
    });
  
    return SlideshowSection;
  })();
  
  theme.VideoSection = (function() {
    var youtubeReady;
    var videos = [];
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque',
      },
      events: {
        onReady: onVideoPlayerReady,
        onStateChange: onVideoStateChange
      }
    };
  
    var vimeoReady = false;
    var vimeoVideoOptions = {
      byline: false,
      title: false,
      portrait: false,
      loop: true
    };
  
    var selectors = {
      videoParent: '.video-parent-section'
    };
  
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    };
  
    function videoSection(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      var youtubePlayerId = this.youtubePlayerId = 'YouTubeVideo-' + this.sectionId;
      this.namespace = '.' + youtubePlayerId;
      var vimeoPlayerId = this.vimeoPlayerId = 'Vimeo-' + this.sectionId;
      var $vimeoTrigger = this.$vimeoTrigger = $('#VimeoTrigger-' + this.sectionId);
      var mp4Video = 'Mp4Video-' + this.sectionId;
  
      var $youtubeDiv = $('#' + youtubePlayerId);
      var $vimeoDiv = $('#' + vimeoPlayerId);
      var $mp4Div = $('#' + mp4Video);
  
      this.vimeoPlayer = [];
  
      if ($youtubeDiv.length) {
        this.youtubeVideoId = $youtubeDiv.data('video-id');
        this.initYoutubeVideo();
      }
  
      if ($vimeoDiv.length) {
        this.vimeoVideoId = $vimeoDiv.data('video-id');
        this.initVimeoVideo();
      }
  
      if ($mp4Div.length) {
        setParentAsLoaded($mp4Div);
  
        startMp4Playback(mp4Video).then(function() {
          // Video played as expected, don't do anything
        }).catch(function(error) {
          // Video cannot be played with autoplay, so let
          // user interact with video element itself
          setVideoToBeInteractedWith($mp4Div);
        })
      }
    }
  
    function startMp4Playback(mp4Video) {
      return document.querySelector('#' + mp4Video).play();
    }
  
    function onVideoPlayerReady(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];
  
      setParentAsLoading($player);
  
      youtubePlayers[playerId].mute();
  
      // Remove from tabindex because YouTube iframes are annoying and you can focus
      // on the YouTube logo and it breaks
      $player.attr('tabindex', '-1');
  
      // Add out of view pausing
      videoVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
    }
  
    function videoVisibilityCheck(id) {
      var playerId;
  
      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        playerId = id.data ? id.data.id : false;
      }
  
      if (playerId) {
        if (theme.isElementVisible($('#' + playerId))) {
          playVisibleVideo(playerId);
        } else {
          pauseHiddenVideo(playerId);
        }
      }
    }
  
    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }
  
    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }
  
    function onVideoStateChange(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];
  
      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          player.playVideo();
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }
  
    function setParentAsLoading($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.loading);
    }
  
    function setParentAsLoaded($el) {
      $el
        .closest(selectors.videoParent)
        .removeClass(classes.loading)
        .addClass(classes.loaded);
    }
  
    function setVideoToBeInteractedWith($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.interactable);
    }
  
    videoSection.prototype = $.extend({}, videoSection.prototype, {
      initYoutubeVideo: function() {
        videos[this.youtubePlayerId] = {
          id: this.youtubePlayerId,
          videoId: this.youtubeVideoId,
          type: 'youtube',
          attemptedToPlay: false
        };
  
        if (!youtubeReady) {
          window.loadYouTube();
          $('body').on('youTubeReady' + this.namespace, this.loadYoutubeVideo.bind(this));
        } else {
          this.loadYoutubeVideo();
        }
      },
  
      loadYoutubeVideo: function() {
        var args = $.extend({}, youtubeVideoOptions, videos[this.youtubePlayerId]);
        args.playerVars.controls = 0;
        youtubePlayers[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, args);
  
        youtubeReady = true;
      },
  
      initVimeoVideo: function() {
        videos[this.vimeoPlayerId] = {
          divId: this.vimeoPlayerId,
          id: this.vimeoVideoId,
          type: 'vimeo'
        };
  
        var $player = $('#' + this.vimeoPlayerId);
        setParentAsLoading($player);
  
        // Button to play video on mobile
        this.$vimeoTrigger.on('click', + this.namespace, function(evt) {
          // $(evt.currentTarget).addClass('hide');
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        }.bind(this));
  
        if (!vimeoReady) {
          window.loadVimeo();
          $('body').on('vimeoReady' + this.namespace, this.loadVimeoVideo.bind(this));
        } else {
          this.loadVimeoVideo();
        }
      },
  
      loadVimeoVideo: function() {
        var args = $.extend({}, vimeoVideoOptions, videos[this.vimeoPlayerId]);
        this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(videos[this.vimeoPlayerId].divId, args);
  
        vimeoReady = true;
  
        // Only autoplay on larger screens
        if (!theme.config.bpSmall) {
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        } else {
          var $player = $('#' + this.vimeoPlayerId);
          setParentAsLoaded($player);
        }
      },
  
      requestToPlayVimeoVideo: function(id) {
        // The slider may initialize and attempt to play the video before
        // the API is even ready, because it sucks.
  
        if (!vimeoReady) {
          // Wait for the trigger, then play it
          $('body').on('vimeoReady' + this.namespace, function() {
            this.playVimeoVideo(id);
          }.bind(this))
          return;
        }
  
        this.playVimeoVideo(id);
      },
  
      playVimeoVideo: function(id) {
        this.vimeoPlayer[id].play();
        this.vimeoPlayer[id].setVolume(0);
  
        var $player = $('#' + id);
        setParentAsLoaded($player);
      },
  
      onUnload: function(evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        var playerId = 'YouTubeVideo-' + sectionId;
        youtubePlayers[playerId].destroy();
        $(window).off('scroll' + this.namespace);
        $('body').off('vimeoReady' + this.namespace);
      }
    });
  
    return videoSection;
  })();
  
  theme.BackgroundImage = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function backgroundImage(container) {
      var $container = $(container);
      var sectionId = $container.attr('data-section-id');
      this.namespace = '.' + sectionId;
  
      if (!$container.length) {
        return;
      }
  
      if ($container.data('parallax')) {
        var $parallaxContainer = $container.find(selectors.parallaxContainer);
        var args = {
          namespace: this.namespace,
          desktopOnly: true
        };
  
        theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer, args);
      }
    }
  
    backgroundImage.prototype = $.extend({}, backgroundImage.prototype, {
      onUnload: function(evt) {
        theme.parallaxSections[this.namespace].destroy();
        delete theme.parallaxSections[this.namespace];
      }
    });
  
    return backgroundImage;
  })();
  
  theme.Testimonials = (function() {
    var slideCount = 0;
    var defaults = {
      accessibility: false,
      arrows: false,
      dots: true,
      autoplay: false,
      touchThreshold: 20,
      slidesToShow: 3,
      slidesToScroll: 3
    };
  
    function Testimonials(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      var wrapper = this.wrapper = '.testimonials-wrapper';
      var slider = this.slider = '#Testimonials-' + sectionId;
      var $slider = $(slider);
  
      this.sliderActive = false;
      var mobileOptions = $.extend({}, defaults, {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
      });
  
      slideCount = $slider.data('count');
  
      // Override slidesToShow/Scroll if there are not enough blocks
      if (slideCount < defaults.slidesToShow) {
        defaults.slidesToShow = slideCount;
        defaults.slidesToScroll = slideCount;
      }
  
      $slider.on('init', this.a11y.bind(this));
  
      if (theme.config.bpSmall) {
        this.init($slider, mobileOptions);
      } else {
        this.init($slider, defaults);
      }
  
      $('body').on('matchSmall', function() {
        this.init($slider, mobileOptions);
      }.bind(this));
  
      $('body').on('matchLarge', function() {
        this.init($slider, defaults);
      }.bind(this));
    }
  
    Testimonials.prototype = $.extend({}, Testimonials.prototype, {
      onUnload: function() {
        $(this.slider, this.wrapper).slick('unslick');
      },
  
      onBlockSelect: function(evt) {
        // Ignore the cloned version
        var $slide = $('.testimonials-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');
  
        // Go to selected slide, pause autoplay
        $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
      },
  
      init: function(obj, args) {
        if (this.sliderActive) {
          obj.slick('unslick');
          this.sliderActive = false;
        }
  
        obj.slick(args);
        this.sliderActive = true;
  
        if (AOS) {
          AOS.refresh();
        }
      },
  
      a11y: function(event, obj) {
        var $list = obj.$list;
        var $wrapper = $(this.wrapper, this.$container);
  
        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');
  
        // When an element in the slider is focused set aria-live
        $wrapper.on('focusin', function(evt) {
          if ($wrapper.has(evt.target).length) {
            $list.attr('aria-live', 'polite');
          }
        });
  
        // Remove aria-live
        $wrapper.on('focusout', function(evt) {
          if ($wrapper.has(evt.target).length) {
            $list.removeAttr('aria-live');
          }
        });
      }
    });
  
    return Testimonials;
  })();

  theme.IngredientCarousel = (function() {
    function IngredientCarousel(container) {
      this.$container = $(container);
      this.sectionId = this.$container.attr('data-section-id');
      this.namespace = '.ingredientCarousel-' + this.sectionId;
      this.$slider = this.$container.find('[data-ingredient-carousel-slider]');
      this.$previous = this.$container.find('[data-ingredient-carousel-prev]');
      this.$next = this.$container.find('[data-ingredient-carousel-next]');

      if (!this.$slider.length) {
        return;
      }

      this.init();
    }

    IngredientCarousel.prototype = $.extend({}, IngredientCarousel.prototype, {
      init: function() {
        var blockCount = Number(this.$slider.attr('data-count')) || 0;
        if (!(blockCount > 1) || !$.fn.slick) {
          return;
        }

        var reducedMotion = window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var options = {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: false,
          infinite: true,
          arrows: true,
          dots: true,
          autoplay: false,
          swipe: true,
          draggable: true,
          accessibility: true,
          speed: reducedMotion ? 0 : 300,
          prevArrow: this.$previous,
          nextArrow: this.$next,
          responsive: [
            {
              breakpoint: 960,
              settings: {
                adaptiveHeight: true
              }
            }
          ]
        };

        this.$slider.slick(options);
        this.initialized = true;
        this.updateDotLabels();
        this.refreshAOS();

        var self = this;
        this.$slider.on('reInit' + this.namespace, function() {
          self.updateDotLabels();
          self.refreshAOS();
        });
      },

      updateDotLabels: function() {
        if (!this.$slider.hasClass('slick-initialized')) {
          return;
        }

        var slick = this.$slider.slick('getSlick');
        if (!slick || !slick.$dots) {
          return;
        }

        slick.$dots.find('button').each(function(index) {
          var $slide = $(slick.$slides.get(index));
          var heading = $slide.attr('data-ingredient-heading') || ('Ingredient ' + (index + 1));
          var label = 'Go to ingredient ' + (index + 1) + ': ' + heading;
          $(this).attr('aria-label', label);
        });
      },

      refreshAOS: function() {
        if (window.AOS && typeof window.AOS.refresh === 'function') {
          window.AOS.refresh();
        }
      },

      onBlockSelect: function(evt) {
        if (!this.initialized || !this.$slider.hasClass('slick-initialized')) {
          return;
        }

        var $slide = this.$container.find(
          '.ingredient-carousel__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
        );
        var slideIndex = $slide.data('slick-index');
        if (typeof slideIndex === 'number') {
          this.$slider.slick('slickGoTo', slideIndex);
        }
      },

      onUnload: function() {
        this.$slider.off(this.namespace);
        if (this.$slider.hasClass('slick-initialized')) {
          this.$slider.slick('unslick');
        }
        this.initialized = false;
      }
    });

    return IngredientCarousel;
  })();

  theme.Instagram = (function() {
    var isInit = false;
  
    function Instagram(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      this.namespace = '.instagram-' + sectionId;
      this.$target = $('#Instafeed-' + sectionId);
  
      if (!this.$target.length) {
        return;
      }
  
      this.checkVisibility();
      $(window).on('scroll' + this.namespace, $.throttle(100, this.checkVisibility.bind(this)));
    }
  
    Instagram.prototype = $.extend({}, Instagram.prototype, {
      checkVisibility: function() {
        if (isInit) {
          $(window).off('scroll' + this.namespace);
          return;
        }
  
        if (theme.isElementVisible(this.$container)) {
          this.init();
        }
      },
  
      init: function() {
        isInit = true;
  
        var userId = this.$target.data('user-id');
        var clientId = this.$target.data('client-id');
        var count = parseInt(this.$target.data('count'));
        var gridItemWidth = this.$target.data('grid-item-width');
  
        // Ask for 2 more images than we'll actually show because
        // Instagram sometimes doesn't send enough
        var feed = this.feed = new Instafeed({
          target: this.$target[0],
          accessToken: clientId,
          get: 'user',
          userId: userId,
          limit: count + 2,
          template: '<div class="grid__item '+ gridItemWidth +'"><div class="image-wrap"><a href="{{link}}" target="_blank" style="background-image: url({{image}}); display: block; padding-bottom: 100%; background-size: cover; background-position: center;"></a></div></div>',
          resolution: 'standard_resolution'
        });
  
        feed.run();
      }
    });
  
    return Instagram;
  })();
  
  
  theme.NewsletterPopup = (function() {
    function NewsletterPopup(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      this.cookieName = 'newsletter-' + sectionId;
  
      if (!$container.length) {
        return;
      }
  
      this.data = {
        secondsBeforeShow: $container.data('delay-seconds'),
        daysBeforeReappear: $container.data('delay-days'),
        cookie: $.cookie(this.cookieName),
        testMode: $container.data('test-mode')
      };
  
      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');
  
      // Open modal if errors or success message exist
      if ($container.find('.errors').length || $container.find('.note--success').length) {
        this.modal.open();
      }
  
      // Set cookie as opened if success message
      if ($container.find('.note--success').length) {
        this.closePopup(true);
        return;
      }
  
      $('body').on('modalClose.' + $container.attr('id'), this.closePopup.bind(this));
  
      if (!this.data.cookie || this.data.testMode) {
        this.initPopupDelay();
      }
    }
  
    NewsletterPopup.prototype = $.extend({}, NewsletterPopup.prototype, {
      initPopupDelay: function() {
        setTimeout(function() {
          this.modal.open();
        }.bind(this), this.data.secondsBeforeShow * 1000);
      },
  
      closePopup: function(success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode) {
          $.removeCookie(this.cookieName, { path: '/' });
          return;
        }
  
        var expiry = success ? 200 : this.data.daysBeforeReappear;
  
        $.cookie(this.cookieName, 'opened', { path: '/', expires: expiry });
      },
  
      onLoad: function() {
        this.modal.open();
      },
  
      onSelect: function() {
        this.modal.open();
      },
  
      onDeselect: function() {
        this.modal.close();
      },
  
      onUnload: function() {}
    });
  
    return NewsletterPopup;
  })();
  
  theme.FadingImages = (function() {
  
    var classes = {
      activeImage: 'active-image',
      finishedImage: 'finished-image',
      activeTitles: 'active-titles',
      finishedTitles: 'finished-titles',
      compensation: 'compensation'
    };
  
    function FadingImages(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      var namespace = this.namespace = '.fading-images-' + sectionId;
  
      if (!$container.length) {
        return;
      }
  
      var $imageContainer = $container.find('.fading-images');
      theme.loadImageSection($imageContainer);
  
      this.data = {
        isInit: false,
        interval: $container.data('interval'),
        block_count: $container.data('count'),
        finish_interval: 1000,
        timer_offset: 400,
        active_image: 1,
        active_title: 1,
        removed_compensation: false
      };
  
      this.selectors = {
        $allTitles: $container.find('.fading-images-overlay__titles')
      };
  
      this.checkVisibility();
      $(window).on('scroll' + this.namespace, $.throttle(100, this.checkVisibility.bind(this)));
    }
  
    FadingImages.prototype = $.extend({}, FadingImages.prototype, {
      checkVisibility: function() {
        if (this.data.isInit) {
          $(window).off('scroll' + this.namespace);
          return;
        }
  
        if (theme.isElementVisible(this.$container)) {
          this.startImages();
          this.startTitles();
          this.data.isInit = true;
        }
      },
  
      nextImage: function() {
        var $container = this.$container;
  
        if (!this.data.removed_compensation) {
          $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').removeClass(classes.compensation);
          this.data.removed_compensation = true;
        }
  
        $container
          .find('.fading-images__item[data-slide-index=' + this.data.active_image + ']')
          .removeClass(classes.activeImage)
          .addClass(classes.finishedImage);
  
        var target_image = this.data.active_image;
        window.setTimeout(function() {
          $container.find('.fading-images__item[data-slide-index=' + target_image + ']').removeClass(classes.finishedImage);
        }, this.data.finish_interval);
  
        this.data.active_image++;
        if (this.data.active_image > this.data.block_count) {
          this.data.active_image = 1;
        }
  
        $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').addClass(classes.activeImage);
      },
  
      nextTitle: function() {
        var $container = this.$container;
        var $allTitles = this.selectors.$allTitles;
  
        this.selectors.$allTitles.removeClass(classes.activeTitles).addClass(classes.finishedTitles);
  
        this.data.active_title++;
        if (this.data.active_title > this.data.block_count) {
          this.data.active_title = 1;
        }
  
        var target_title = this.data.active_title;
        window.setTimeout(function() {
          var newText1 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title1');
          var newText2 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title2');
          $container.find('.fading-images-overlay__title--1').text(newText1);
          $container.find('.fading-images-overlay__title--2').text(newText2);
          $allTitles.removeClass(classes.finishedTitles).addClass(classes.activeTitles);
        }, this.data.finish_interval - 200);
      },
  
      startImages: function() {
        // Prep and show first image
        this.$container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').addClass(classes.activeImage).addClass(classes.compensation);
  
        // Begin timer
        var o = this;
        window.setTimeout(function() {
          var fading_images_timer = window.setInterval(o.nextImage.bind(o), o.data.interval);
        }, this.data.timer_offset);
      },
  
      startTitles: function() {
        var $container = this.$container;
        var $allTitles = this.selectors.$allTitles;
        // Prep and show first titles
        var target_title = this.data.active_title;
        window.setTimeout(function() {
          var newText1 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title1');
          var newText2 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title2');
          $container.find('.fading-images-overlay__title--1').text(newText1);
          $container.find('.fading-images-overlay__title--2').text(newText2);
          $allTitles.addClass(classes.activeTitles);
        }, 750);
  
        // Begin timer
        var fading_titles_timer = window.setInterval(this.nextTitle.bind(this), this.data.interval);
      },
  
      onUnload: function() {
        $(window).off('scroll' + this.namespace);
      }
    });
  
    return FadingImages;
  })();
  
  theme.Maps = (function() {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];
  
    var errors = {
      addressNoResults: theme.strings.addressNoResults,
      addressQueryLimit: theme.strings.addressQueryLimit,
      addressError: theme.strings.addressError,
      authError: theme.strings.authError
    };
  
    var selectors = {
      section: '[data-section-type="map"]',
      map: '[data-map]',
      mapOverlay: '[data-map-overlay]'
    };
  
    var classes = {
      mapError: 'map-section--load-error',
      errorMsg: 'map-section__error errors text-center'
    };
  
    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function() {
      if (!Shopify.designMode) {
        return;
      }
  
      $(selectors.section).addClass(classes.mapError);
      $(selectors.map).remove();
      $(selectors.mapOverlay).after(
        '<div class="' +
          classes.errorMsg +
          '">' +
          theme.strings.authError +
          '</div>'
      );
    };
  
    function Map(container) {
      this.$container = $(container);
      this.sectionId = this.$container.attr('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.$map = this.$container.find(selectors.map);
      this.key = this.$map.data('api-key');
  
      if (!this.key) {
        return;
      }
  
      // Lazyload API
      this.checkVisibility();
      $(window).on('scroll' + this.namespace, $.throttle(50, this.checkVisibility.bind(this)));
    }
  
    function initAllMaps() {
      // API has loaded, load all Map instances in queue
      $.each(mapsToLoad, function(index, instance) {
        instance.createMap();
      });
    }
  
    function geolocate($map) {
      var deferred = $.Deferred();
      var geocoder = new google.maps.Geocoder();
      var address = $map.data('address-setting');
  
      geocoder.geocode({ address: address }, function(results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          deferred.reject(status);
        }
  
        deferred.resolve(results);
      });
  
      return deferred;
    }
  
    Map.prototype = $.extend({}, Map.prototype, {
      prepMapApi: function() {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);
  
          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined') {
              $.getScript(
                'https://maps.googleapis.com/maps/api/js?key=' + this.key
              ).then(function() {
                apiStatus = 'loaded';
                initAllMaps();
              });
            }
          }
        }
      },
  
      createMap: function() {
        var $map = this.$map;
  
        return geolocate($map)
          .then(
            function(results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };
  
              var map = (this.map = new google.maps.Map($map[0], mapOptions));
              var center = (this.center = map.getCenter());
  
              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });
  
              google.maps.event.addDomListener(
                window,
                'resize',
                $.debounce(250, function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  $map.removeAttr('style');
                })
              );
            }.bind(this)
          )
          .fail(function() {
            var errorMessage;
  
            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }
  
            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              $map
                .parent()
                .addClass(classes.mapError)
                .html(
                  '<div class="' +
                    classes.errorMsg +
                    '">' +
                    errorMessage +
                    '</div>'
                );
            }
          });
      },
  
      checkVisibility: function() {
        if (theme.isElementVisible(this.$container, 600)) {
          this.prepMapApi();
          $(window).off(this.namespace);
        }
      },
  
      onUnload: function() {
        if (this.$map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        google.maps.event.clearListeners(this.map, 'resize');
      }
    });
  
    return Map;
  })();
  
  theme.Blog = (function() {
  
    function Blog(container) {
      this.tagFilters();
    }
  
    Blog.prototype = $.extend({}, Blog.prototype, {
      tagFilters: function() {
        var $filterBy = $('#BlogTagFilter');
  
        if (!$filterBy.length) {
          return;
        }
  
        $filterBy.on('change', function() {
          location.href = $(this).val();
        });
      },
  
      onUnload: function() {
  
      }
    });
  
    return Blog;
  })();
  
  theme.Photoswipe = (function() {
    var selectors = {
      photoswipeImg: '.photoswipe__image'
    }
  
    function Photoswipe(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      this.namespace = '.photoswipe-' + this.sectionId;
      var $images = this.$images = $container.find(selectors.photoswipeImg);
      this.gallery;
  
      if (!$container.length) {
        return;
      }
  
      this.init();
    }
  
    Photoswipe.prototype = $.extend({}, Photoswipe.prototype, {
      init: function() {
        var haveImages = false;
        var items = [];
        var options = {};
  
        this.$images.each(function() {
          var haveImages = true;
          var smallSrc = $(this).prop('currentSrc') || $(this).prop('src');
          var item = {
            msrc: smallSrc,
            src: $(this).data('photoswipe-src'),
            w: $(this).data('photoswipe-width'),
            h: $(this).data('photoswipe-height'),
            el: $(this)[0]
          };
  
          items.push(item);
        });
  
        this.$images.on('click' + this.namespace, function(evt) {
          index = $(evt.currentTarget).data('index');
          this.initGallery(items, index);
        }.bind(this));
      },
  
      initGallery: function(items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
  
        var options = {
          history: false,
          index: index - 1,
          getThumbBoundsFn: function(index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
          }
        }
  
        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        this.gallery.init();
      },
  
      onUnload: function() {
        this.$images.off('click' + this.namespace);
        this.gallery.destroy()
      }
    });
  
    return Photoswipe;
  })();
  
  

  theme.config = {
    bpSmall: false,
    hasSessionStorage: true,
    mediaQuerySmall: 'screen and (max-width: 767px)',
    mediaQueryMediumUp: 'screen and (min-width: 768px)',
    youTubeReady: false,
    vimeoReady: false,
    vimeoLoading: false,
    isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
    isIpad: /ipad/.test(window.navigator.userAgent.toLowerCase()),
    stickyHeader: false,
    recentlyViewed: []
  };

  if (theme.config.isIpad) {
    document.documentElement.className += ' js-ipad';
  }

  theme.recentlyViewed = {
    recent: {}, // will store handle+url of recent products
    productInfo: {} // will store product data to reduce API calls
  };

  window.onYouTubeIframeAPIReady = function() {
    theme.config.youTubeReady = true;
    $('body').trigger('youTubeReady');
  }

  window.loadYouTube = function() {
    if (theme.config.youtubeReady) {
      return;
    }

    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  window.loadVimeo = function() {
    if (theme.config.vimeoLoading) {
      return;
    }

    if (!theme.config.vimeoReady) {
      theme.config.vimeoLoading = true;
      var tag = document.createElement('script');
      tag.src = "https://player.vimeo.com/api/player.js";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // Because there's no way to check for the Vimeo API being loaded
      // asynchronously, we use this terrible timeout to wait for it being ready
      checkIfVimeoIsReady()
        .then(function() {
          theme.config.vimeoReady = true;
          theme.config.vimeoLoading = false;
          $('body').trigger('vimeoReady');
        })
        .fail(function() {
          // No vimeo API to talk to
        });
    }
  }

  function checkIfVimeoIsReady() {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (!Vimeo) {
        return;
      }

      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  theme.init = function() {
    theme.setGlobals();
    theme.pageTransitions();
    theme.collectionTemplate.init();
    theme.initQuickShop();
    theme.videoModal();
    theme.customerTemplates.init();
    theme.collapsibles.init();

    slate.rte.wrapTable();
    slate.rte.wrapVideo();

    AOS.init({
      easing: 'ease-out-quad',
      once: true,
      offset: 60,
      disableMutationObserver: true
    });

    $(document.documentElement).on('keyup.tab', function(evt) {
      if (evt.keyCode === 9) {
        $(document.documentElement).addClass('tab-outline');
        $(document.documentElement).off('keyup.tab');
      }
    });

    // Change email icon to submit text
    $('.footer__newsletter-input').on('keyup', function() {
      $(this).addClass('footer__newsletter-input--active');
    });
  };

  theme.setGlobals = function() {
    theme.config.hasSessionStorage = theme.isSessionStorageSupported();
    theme.recentlyViewed.handleCookie = $.cookie('theme-recent');
    if (theme.recentlyViewed.handleCookie) {
      theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.handleCookie);
    }

    theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage['recent-products'] ? JSON.parse(sessionStorage['recent-products']) : {};

    if (theme.config.isTouch) {
      $('body').addClass('supports-touch');
    }

    enquire.register(theme.config.mediaQuerySmall, {
      match: function() {
        theme.config.bpSmall = true;
        $('body').trigger('matchSmall');
      },
      unmatch: function() {
        theme.config.bpSmall = false;
        $('body').trigger('unmatchSmall');
      }
    });

    enquire.register(theme.config.mediaQueryMediumUp, {
      match: function() {
        $('body').trigger('matchLarge');
      },
      unmatch: function() {
        $('body').trigger('unmatchLarge');
      }
    });
  };

  theme.loadImageSection = function($container) {
    // Wait until images inside container have lazyloaded class
    function setAsLoaded() {
      $container.removeClass('loading loading--delayed').addClass('loaded');
    }

    function checkForLazyloadedImage() {
      return $container.find('.lazyloaded').length;
    }

    // If it has SVGs it's in the onboarding state so set as loaded
    if ($container.find('svg').length) {
      setAsLoaded();
      return;
    };

    if (checkForLazyloadedImage() > 0) {
      setAsLoaded();
      return;
    }

    var interval = setInterval(function() {
      if (checkForLazyloadedImage() > 0) {
        clearInterval(interval);
        setAsLoaded();
      }
    }, 80);
  }

  theme.isSessionStorageSupported = function() {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage = window.sessionStorage;
    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.isElementVisible = function($el, threshold) {
    var rect = $el[0].getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    threshold = threshold ? threshold : 0;

    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (windowHeight + threshold) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  theme.pageTransitions = function() {
    if ($('body').data('transitions') == true) {
      var namespace = '.page-transition';

      // Hack test to fix Safari page cache issue.
      // window.onpageshow doesn't always run when navigating
      // back to the page, so the unloading class remains, leaving
      // a white page. Setting a timeout to remove that class when leaving
      // the page actually finishes running when they come back.
      if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
        $('a').off(namespace).on('click' + namespace, function() {
          window.setTimeout(function() {
            $('body').removeClass('unloading');
          }, 1200);
        });
      }

      // Add disable transition class to malito, anchor, and YouTube links
      $('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]').each(function() {
        $(this).addClass('js-no-transition');
      });

      $('a:not(.js-no-transition)').off(namespace).on('click' + namespace, function(evt) {
        if (evt.metaKey) return true;
        evt.preventDefault();
        $('body').addClass('unloading');
        var src = $(this).attr('href');
        window.setTimeout(function() {
          location.href = src;
        }, 50);
      });

      // iOS caches the page state, so close the drawer when navigating away
      $('a.mobile-nav__link').off(namespace).on('click' + namespace, function() {
        theme.NavDrawer.close();
      });
    }
  };

  theme.reinitSection = function(section) {
    for (var i = 0; i < sections.instances.length; i++) {
      var instance = sections.instances[i];
      if (instance['type'] === section) {
        if (typeof instance.forceReload === 'function') {
          instance.forceReload();
        }
      }
    }
  }

  window.onpageshow = function(evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      $('body').removeClass('unloading');
    }
  };

  $(document).ready(function() {
    theme.init();

    window.sections = new theme.Sections();
    sections.register('header-section', theme.HeaderSection);
    sections.register('slideshow-section', theme.SlideshowSection);
    sections.register('video-section', theme.VideoSection);
    sections.register('background-image', theme.BackgroundImage);
    sections.register('recently-viewed', theme.RecentlyViewed);
    sections.register('product', theme.Product);
    sections.register('product-template', theme.Product);
    sections.register('collection-header', theme.CollectionHeader);
    sections.register('collection-sidebar', theme.CollectionSidebar);
    sections.register('collection-template', theme.Collection);
    sections.register('featured-content-section', theme.FeaturedContentSection);
    sections.register('testimonials', theme.Testimonials);
    sections.register('ingredient-carousel', theme.IngredientCarousel);
    sections.register('instagram', theme.Instagram);
    sections.register('newsletter-popup', theme.NewsletterPopup);
    sections.register('fading-images', theme.FadingImages);
    sections.register('map', theme.Maps);
    sections.register('blog', theme.Blog);
    sections.register('photoswipe', theme.Photoswipe);
  });
})(theme.jQuery);
